import * as we from "react";
import Yt, { Children as $n, isValidElement as ur, createContext as Nn, useContext as vt, useRef as ae, useEffect as xe, useCallback as R, useState as he, useMemo as _e, useId as Rt, useLayoutEffect as Is, useReducer as n0, useInsertionEffect as Eh, forwardRef as vn, createElement as Hl, cloneElement as kt, memo as r0, useSyncExternalStore as o0, Fragment as Ul, PureComponent as s0 } from "react";
import { __unsafe_useEmotionCache as i0, Global as sa, ThemeProvider as a0, ThemeContext as c0, keyframes as Mn } from "@emotion/react";
import l0 from "@emotion/styled";
import { createPortal as Ah } from "react-dom";
function u0(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function ia(e) {
  return e != null && typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
}
function d0() {
  return !!(globalThis != null && globalThis.document);
}
function Ih(e) {
  return e.parentElement && Ih(e.parentElement) ? !0 : e.hidden;
}
function f0(e) {
  const t = e.getAttribute("contenteditable");
  return t !== "false" && t != null;
}
function p0(e) {
  return !!e.getAttribute("disabled") || !!e.getAttribute("aria-disabled");
}
function h0(e) {
  var t;
  return ((t = Rh(e)) == null ? void 0 : t.defaultView) ?? window;
}
function Rh(e) {
  return ia(e) ? e.ownerDocument : document;
}
function m0(e) {
  return e.view ?? window;
}
function g0(e) {
  return Rh(e).activeElement;
}
function y0(e) {
  const t = m0(e);
  return typeof t.PointerEvent < "u" && e instanceof t.PointerEvent ? e.pointerType === "mouse" : e instanceof t.MouseEvent;
}
function $h(e) {
  return !!e.touches;
}
function b0(e) {
  return $h(e) && e.touches.length > 1;
}
function v0(e, t = "page") {
  const n = e.touches[0] || e.changedTouches[0];
  return { x: n[`${t}X`], y: n[`${t}Y`] };
}
function x0(e, t = "page") {
  return {
    x: e[`${t}X`],
    y: e[`${t}Y`]
  };
}
function Nh(e, t = "page") {
  return $h(e) ? v0(e, t) : x0(e, t);
}
function S0(e) {
  return (t) => {
    const n = y0(t);
    (!n || n && t.button === 0) && e(t);
  };
}
function w0(e, t = !1) {
  function n(o) {
    e(o, { point: Nh(o) });
  }
  return t ? S0(n) : n;
}
function ki(e, t, n, r) {
  return u0(e, t, w0(n, t === "pointerdown"), r);
}
function k0(e, ...t) {
  if (e == null)
    throw new TypeError("Cannot convert undefined or null to object");
  const n = { ...e };
  for (const r of t)
    if (r != null)
      for (const o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (o in n && delete n[o], n[o] = r[o]);
  return n;
}
const ye = (e) => e ? "" : void 0, wt = (e) => e ? !0 : void 0;
function Yc(e) {
  return Array.isArray(e);
}
function lt(e) {
  const t = typeof e;
  return e != null && (t === "object" || t === "function") && !Yc(e);
}
function P0(e) {
  const t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
function C0(e) {
  const t = parseFloat(e.toString()), n = e.toString().replace(String(t), "");
  return { unitless: !n, value: t, unit: n };
}
function Xc(e) {
  if (e == null)
    return e;
  const { unitless: t } = C0(e);
  return t || typeof e == "number" ? `${e}px` : e;
}
const Mh = (e, t) => parseInt(e[1], 10) > parseInt(t[1], 10) ? 1 : -1, Gl = (e) => Object.fromEntries(Object.entries(e).sort(Mh));
function Pd(e) {
  const t = Gl(e);
  return Object.assign(Object.values(t), t);
}
function _0(e) {
  const t = Object.keys(Gl(e));
  return new Set(t);
}
function Cd(e) {
  if (!e)
    return e;
  e = Xc(e) ?? e;
  const t = -0.02;
  return typeof e == "number" ? `${e + t}` : e.replace(/(\d+\.?\d*)/u, (n) => `${parseFloat(n) + t}`);
}
function Yo(e, t) {
  const n = ["@media screen"];
  return e && n.push("and", `(min-width: ${Xc(e)})`), t && n.push("and", `(max-width: ${Xc(t)})`), n.join(" ");
}
function T0(e) {
  if (!e)
    return null;
  e.base = e.base ?? "0px";
  const t = Pd(e), n = Object.entries(e).sort(Mh).map(([s, i], a, c) => {
    let [, l] = c[a + 1] ?? [];
    return l = parseFloat(l) > 0 ? Cd(l) : void 0, {
      _minW: Cd(i),
      breakpoint: s,
      minW: i,
      maxW: l,
      maxWQuery: Yo(null, l),
      minWQuery: Yo(i),
      minMaxQuery: Yo(i, l)
    };
  }), r = _0(e), o = Array.from(r.values());
  return {
    keys: r,
    normalized: t,
    isResponsive(s) {
      const i = Object.keys(s);
      return i.length > 0 && i.every((a) => r.has(a));
    },
    asObject: Gl(e),
    asArray: Pd(e),
    details: n,
    get(s) {
      return n.find((i) => i.breakpoint === s);
    },
    media: [
      null,
      ...t.map((s) => Yo(s)).slice(1)
    ],
    /**
     * Converts the object responsive syntax to array syntax
     *
     * @example
     * toArrayValue({ base: 1, sm: 2, md: 3 }) // => [1, 2, 3]
     */
    toArrayValue(s) {
      if (!lt(s))
        throw new Error("toArrayValue: value must be an object");
      const i = o.map((a) => s[a] ?? null);
      for (; P0(i) === null; )
        i.pop();
      return i;
    },
    /**
     * Converts the array responsive syntax to object syntax
     *
     * @example
     * toObjectValue([1, 2, 3]) // => { base: 1, sm: 2, md: 3 }
     */
    toObjectValue(s) {
      if (!Array.isArray(s))
        throw new Error("toObjectValue: value must be an array");
      return s.reduce(
        (i, a, c) => {
          const l = o[c];
          return l != null && a != null && (i[l] = a), i;
        },
        {}
      );
    }
  };
}
function aa(...e) {
  return function(...n) {
    e.forEach((r) => r == null ? void 0 : r(...n));
  };
}
function re(...e) {
  return function(n) {
    e.some((r) => (r == null || r(n), n == null ? void 0 : n.defaultPrevented));
  };
}
function Yn(e) {
  return $n.toArray(e).filter(
    (t) => ur(t)
  );
}
function Io(e) {
  const t = Object.assign({}, e);
  for (let n in t)
    t[n] === void 0 && delete t[n];
  return t;
}
function E0(e, t) {
  return `${e} returned \`undefined\`. Seems you forgot to wrap component within ${t}`;
}
function Ee(e = {}) {
  const {
    name: t,
    strict: n = !0,
    hookName: r = "useContext",
    providerName: o = "Provider",
    errorMessage: s,
    defaultValue: i
  } = e, a = Nn(i);
  a.displayName = t;
  function c() {
    var u;
    const l = vt(a);
    if (!l && n) {
      const d = new Error(
        s ?? E0(r, o)
      );
      throw d.name = "ContextError", (u = Error.captureStackTrace) == null || u.call(Error, d, c), d;
    }
    return l;
  }
  return [a.Provider, c, a];
}
const W = (...e) => e.filter(Boolean).join(" "), jh = (e) => e.hasAttribute("tabindex"), A0 = (e) => jh(e) && e.tabIndex === -1;
function Vi(e) {
  if (!ia(e) || Ih(e) || p0(e))
    return !1;
  const { localName: t } = e;
  if (["input", "select", "textarea", "button"].indexOf(t) >= 0)
    return !0;
  const r = {
    a: () => e.hasAttribute("href"),
    audio: () => e.hasAttribute("controls"),
    video: () => e.hasAttribute("controls")
  };
  return t in r ? r[t]() : f0(e) ? !0 : jh(e);
}
function I0(e) {
  return e ? ia(e) && Vi(e) && !A0(e) : !1;
}
const R0 = [
  "input:not(:disabled):not([disabled])",
  "select:not(:disabled):not([disabled])",
  "textarea:not(:disabled):not([disabled])",
  "embed",
  "iframe",
  "object",
  "a[href]",
  "area[href]",
  "button:not(:disabled):not([disabled])",
  "[tabindex]",
  "audio[controls]",
  "video[controls]",
  "*[tabindex]:not([aria-disabled])",
  "*[contenteditable]"
], $0 = R0.join(), N0 = (e) => e.offsetWidth > 0 && e.offsetHeight > 0;
function Dh(e) {
  const t = Array.from(
    e.querySelectorAll($0)
  );
  return t.unshift(e), t.filter((n) => Vi(n) && N0(n));
}
function M0(e, t, n, r) {
  const o = typeof t == "string" ? t.split(".") : [t];
  for (r = 0; r < o.length && e; r += 1)
    e = e[o[r]];
  return e === void 0 ? n : e;
}
const j0 = (e) => {
  const t = /* @__PURE__ */ new WeakMap();
  return (r, o, s, i) => {
    if (typeof r > "u")
      return e(r, o, s);
    t.has(r) || t.set(r, /* @__PURE__ */ new Map());
    const a = t.get(r);
    if (a.has(o))
      return a.get(o);
    const c = e(r, o, s, i);
    return a.set(o, c), c;
  };
}, Oh = j0(M0), D0 = (e) => e.default || e;
function ql(e) {
  const { wasSelected: t, enabled: n, isSelected: r, mode: o = "unmount" } = e;
  return !!(!n || r || o === "keepMounted" && t);
}
function O0(e) {
  const t = parseFloat(e);
  return typeof t != "number" || Number.isNaN(t) ? 0 : t;
}
function Kl(e, t) {
  let n = O0(e);
  const r = 10 ** (t ?? 10);
  return n = Math.round(n * r) / r, t ? n.toFixed(t) : n.toString();
}
function Zc(e) {
  if (!Number.isFinite(e))
    return 0;
  let t = 1, n = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, n += 1;
  return n;
}
function zi(e, t, n) {
  return (e - t) * 100 / (n - t);
}
function Fh(e, t, n) {
  return (n - t) * e + t;
}
function Jc(e, t, n) {
  const r = Math.round((e - t) / n) * n + t, o = Zc(n);
  return Kl(r, o);
}
function lo(e, t, n) {
  return e == null ? e : (n < t && console.warn("clamp: max cannot be less than min"), Math.min(Math.max(e, t), n));
}
function Rs(e, t = []) {
  const n = Object.assign({}, e);
  for (const r of t)
    r in n && delete n[r];
  return n;
}
function Bh(e, t) {
  const n = {};
  for (const r of t)
    r in e && (n[r] = e[r]);
  return n;
}
const Lh = Object.freeze([
  "base",
  "sm",
  "md",
  "lg",
  "xl",
  "2xl"
]);
function Cn(e, t) {
  return Array.isArray(e) ? e.map((n) => n === null ? null : t(n)) : lt(e) ? Object.keys(e).reduce((n, r) => (n[r] = t(e[r]), n), {}) : e != null ? t(e) : null;
}
function F0(e, t = Lh) {
  const n = {};
  return e.forEach((r, o) => {
    const s = t[o];
    r != null && (n[s] = r);
  }), n;
}
const B0 = (e) => typeof e == "function";
function Et(e, ...t) {
  return B0(e) ? e(...t) : e;
}
function L0(e) {
  const t = e.ownerDocument.defaultView || window, { overflow: n, overflowX: r, overflowY: o } = t.getComputedStyle(e);
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function V0(e) {
  return e.localName === "html" ? e : e.assignedSlot || e.parentElement || e.ownerDocument.documentElement;
}
function Vh(e) {
  return ["html", "body", "#document"].includes(e.localName) ? e.ownerDocument.body : ia(e) && L0(e) ? e : Vh(V0(e));
}
function zh(e, t) {
  const n = {}, r = {};
  for (const [o, s] of Object.entries(e))
    t.includes(o) ? n[o] = s : r[o] = s;
  return [n, r];
}
function z0(e, ...t) {
  const n = Object.getOwnPropertyDescriptors(e), r = Object.keys(n), o = (i) => {
    const a = {};
    for (let c = 0; c < i.length; c++) {
      const l = i[c];
      n[l] && (Object.defineProperty(a, l, n[l]), delete n[l]);
    }
    return a;
  }, s = (i) => o(Array.isArray(i) ? i : r.filter(i));
  return t.map(s).concat(o(r));
}
function _d(e, t, n = {}) {
  const { stop: r, getKey: o } = n;
  function s(i, a = []) {
    if (lt(i) || Array.isArray(i)) {
      const c = {};
      for (const [l, u] of Object.entries(i)) {
        const d = (o == null ? void 0 : o(l)) ?? l, f = [...a, d];
        if (r != null && r(i, f))
          return t(i, a);
        c[d] = s(u, f);
      }
      return c;
    }
    return t(i, a);
  }
  return s(e);
}
const $s = (e) => {
  const { condition: t, message: n } = e;
  t && process.env.NODE_ENV !== "production" && console.warn(n);
};
var ni = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ca(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Wi = { exports: {} };
Wi.exports;
(function(e, t) {
  var n = 200, r = "__lodash_hash_undefined__", o = 800, s = 16, i = 9007199254740991, a = "[object Arguments]", c = "[object Array]", l = "[object AsyncFunction]", u = "[object Boolean]", d = "[object Date]", f = "[object Error]", p = "[object Function]", m = "[object GeneratorFunction]", g = "[object Map]", y = "[object Number]", S = "[object Null]", b = "[object Object]", v = "[object Proxy]", k = "[object RegExp]", w = "[object Set]", _ = "[object String]", C = "[object Undefined]", I = "[object WeakMap]", $ = "[object ArrayBuffer]", N = "[object DataView]", z = "[object Float32Array]", Q = "[object Float64Array]", U = "[object Int8Array]", q = "[object Int16Array]", le = "[object Int32Array]", Z = "[object Uint8Array]", j = "[object Uint8ClampedArray]", K = "[object Uint16Array]", ne = "[object Uint32Array]", B = /[\\^$.*+?()[\]{}|]/g, O = /^\[object .+?Constructor\]$/, ee = /^(?:0|[1-9]\d*)$/, D = {};
  D[z] = D[Q] = D[U] = D[q] = D[le] = D[Z] = D[j] = D[K] = D[ne] = !0, D[a] = D[c] = D[$] = D[u] = D[N] = D[d] = D[f] = D[p] = D[g] = D[y] = D[b] = D[k] = D[w] = D[_] = D[I] = !1;
  var V = typeof ni == "object" && ni && ni.Object === Object && ni, Y = typeof self == "object" && self && self.Object === Object && self, J = V || Y || Function("return this")(), se = t && !t.nodeType && t, ue = se && !0 && e && !e.nodeType && e, G = ue && ue.exports === se, H = G && V.process, de = function() {
    try {
      var x = ue && ue.require && ue.require("util").types;
      return x || H && H.binding && H.binding("util");
    } catch {
    }
  }(), L = de && de.isTypedArray;
  function me(x, A, F) {
    switch (F.length) {
      case 0:
        return x.call(A);
      case 1:
        return x.call(A, F[0]);
      case 2:
        return x.call(A, F[0], F[1]);
      case 3:
        return x.call(A, F[0], F[1], F[2]);
    }
    return x.apply(A, F);
  }
  function oe(x, A) {
    for (var F = -1, ge = Array(x); ++F < x; )
      ge[F] = A(F);
    return ge;
  }
  function $e(x) {
    return function(A) {
      return x(A);
    };
  }
  function Oe(x, A) {
    return x == null ? void 0 : x[A];
  }
  function ce(x, A) {
    return function(F) {
      return x(A(F));
    };
  }
  var Ne = Array.prototype, Ie = Function.prototype, Re = Object.prototype, Xe = J["__core-js_shared__"], tt = Ie.toString, it = Re.hasOwnProperty, At = function() {
    var x = /[^.]+$/.exec(Xe && Xe.keys && Xe.keys.IE_PROTO || "");
    return x ? "Symbol(src)_1." + x : "";
  }(), Vt = Re.toString, qt = tt.call(Object), Nt = RegExp(
    "^" + tt.call(it).replace(B, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), te = G ? J.Buffer : void 0, We = J.Symbol, ie = J.Uint8Array, be = te ? te.allocUnsafe : void 0, gt = ce(Object.getPrototypeOf, Object), Dt = Object.create, pe = Re.propertyIsEnumerable, Pe = Ne.splice, ve = We ? We.toStringTag : void 0, Be = function() {
    try {
      var x = za(Object, "defineProperty");
      return x({}, "", {}), x;
    } catch {
    }
  }(), He = te ? te.isBuffer : void 0, xt = Math.max, Ot = Date.now, _t = za(J, "Map"), Dn = za(Object, "create"), jo = function() {
    function x() {
    }
    return function(A) {
      if (!yr(A))
        return {};
      if (Dt)
        return Dt(A);
      x.prototype = A;
      var F = new x();
      return x.prototype = void 0, F;
    };
  }();
  function Sn(x) {
    var A = -1, F = x == null ? 0 : x.length;
    for (this.clear(); ++A < F; ) {
      var ge = x[A];
      this.set(ge[0], ge[1]);
    }
  }
  function Da() {
    this.__data__ = Dn ? Dn(null) : {}, this.size = 0;
  }
  function Ks(x) {
    var A = this.has(x) && delete this.__data__[x];
    return this.size -= A ? 1 : 0, A;
  }
  function Oa(x) {
    var A = this.__data__;
    if (Dn) {
      var F = A[x];
      return F === r ? void 0 : F;
    }
    return it.call(A, x) ? A[x] : void 0;
  }
  function Ys(x) {
    var A = this.__data__;
    return Dn ? A[x] !== void 0 : it.call(A, x);
  }
  function Xs(x, A) {
    var F = this.__data__;
    return this.size += this.has(x) ? 0 : 1, F[x] = Dn && A === void 0 ? r : A, this;
  }
  Sn.prototype.clear = Da, Sn.prototype.delete = Ks, Sn.prototype.get = Oa, Sn.prototype.has = Ys, Sn.prototype.set = Xs;
  function pn(x) {
    var A = -1, F = x == null ? 0 : x.length;
    for (this.clear(); ++A < F; ) {
      var ge = x[A];
      this.set(ge[0], ge[1]);
    }
  }
  function Fa() {
    this.__data__ = [], this.size = 0;
  }
  function Zs(x) {
    var A = this.__data__, F = Qt(A, x);
    if (F < 0)
      return !1;
    var ge = A.length - 1;
    return F == ge ? A.pop() : Pe.call(A, F, 1), --this.size, !0;
  }
  function Js(x) {
    var A = this.__data__, F = Qt(A, x);
    return F < 0 ? void 0 : A[F][1];
  }
  function Ba(x) {
    return Qt(this.__data__, x) > -1;
  }
  function La(x, A) {
    var F = this.__data__, ge = Qt(F, x);
    return ge < 0 ? (++this.size, F.push([x, A])) : F[ge][1] = A, this;
  }
  pn.prototype.clear = Fa, pn.prototype.delete = Zs, pn.prototype.get = Js, pn.prototype.has = Ba, pn.prototype.set = La;
  function Xn(x) {
    var A = -1, F = x == null ? 0 : x.length;
    for (this.clear(); ++A < F; ) {
      var ge = x[A];
      this.set(ge[0], ge[1]);
    }
  }
  function Va() {
    this.size = 0, this.__data__ = {
      hash: new Sn(),
      map: new (_t || pn)(),
      string: new Sn()
    };
  }
  function P(x) {
    var A = ei(this, x).delete(x);
    return this.size -= A ? 1 : 0, A;
  }
  function X(x) {
    return ei(this, x).get(x);
  }
  function fe(x) {
    return ei(this, x).has(x);
  }
  function Te(x, A) {
    var F = ei(this, x), ge = F.size;
    return F.set(x, A), this.size += F.size == ge ? 0 : 1, this;
  }
  Xn.prototype.clear = Va, Xn.prototype.delete = P, Xn.prototype.get = X, Xn.prototype.has = fe, Xn.prototype.set = Te;
  function Me(x) {
    var A = this.__data__ = new pn(x);
    this.size = A.size;
  }
  function Ze() {
    this.__data__ = new pn(), this.size = 0;
  }
  function Fe(x) {
    var A = this.__data__, F = A.delete(x);
    return this.size = A.size, F;
  }
  function je(x) {
    return this.__data__.get(x);
  }
  function It(x) {
    return this.__data__.has(x);
  }
  function ut(x, A) {
    var F = this.__data__;
    if (F instanceof pn) {
      var ge = F.__data__;
      if (!_t || ge.length < n - 1)
        return ge.push([x, A]), this.size = ++F.size, this;
      F = this.__data__ = new Xn(ge);
    }
    return F.set(x, A), this.size = F.size, this;
  }
  Me.prototype.clear = Ze, Me.prototype.delete = Fe, Me.prototype.get = je, Me.prototype.has = It, Me.prototype.set = ut;
  function ft(x, A) {
    var F = Ua(x), ge = !F && Ha(x), ze = !F && !ge && bd(x), Qe = !F && !ge && !ze && xd(x), at = F || ge || ze || Qe, Le = at ? oe(x.length, String) : [], ct = Le.length;
    for (var en in x)
      (A || it.call(x, en)) && !(at && // Safari 9 has enumerable `arguments.length` in strict mode.
      (en == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      ze && (en == "offset" || en == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      Qe && (en == "buffer" || en == "byteLength" || en == "byteOffset") || // Skip index properties.
      gd(en, ct))) && Le.push(en);
    return Le;
  }
  function Mt(x, A, F) {
    (F !== void 0 && !ti(x[A], F) || F === void 0 && !(A in x)) && Tt(x, A, F);
  }
  function Zn(x, A, F) {
    var ge = x[A];
    (!(it.call(x, A) && ti(ge, F)) || F === void 0 && !(A in x)) && Tt(x, A, F);
  }
  function Qt(x, A) {
    for (var F = x.length; F--; )
      if (ti(x[F][0], A))
        return F;
    return -1;
  }
  function Tt(x, A, F) {
    A == "__proto__" && Be ? Be(x, A, {
      configurable: !0,
      enumerable: !0,
      value: F,
      writable: !0
    }) : x[A] = F;
  }
  var Do = Fv();
  function Hr(x) {
    return x == null ? x === void 0 ? C : S : ve && ve in Object(x) ? Bv(x) : Uv(x);
  }
  function Qs(x) {
    return Oo(x) && Hr(x) == a;
  }
  function _v(x) {
    if (!yr(x) || Wv(x))
      return !1;
    var A = qa(x) ? Nt : O;
    return A.test(Yv(x));
  }
  function Tv(x) {
    return Oo(x) && vd(x.length) && !!D[Hr(x)];
  }
  function Ev(x) {
    if (!yr(x))
      return Hv(x);
    var A = yd(x), F = [];
    for (var ge in x)
      ge == "constructor" && (A || !it.call(x, ge)) || F.push(ge);
    return F;
  }
  function md(x, A, F, ge, ze) {
    x !== A && Do(A, function(Qe, at) {
      if (ze || (ze = new Me()), yr(Qe))
        Av(x, A, at, F, md, ge, ze);
      else {
        var Le = ge ? ge(Wa(x, at), Qe, at + "", x, A, ze) : void 0;
        Le === void 0 && (Le = Qe), Mt(x, at, Le);
      }
    }, Sd);
  }
  function Av(x, A, F, ge, ze, Qe, at) {
    var Le = Wa(x, F), ct = Wa(A, F), en = at.get(ct);
    if (en) {
      Mt(x, F, en);
      return;
    }
    var Kt = Qe ? Qe(Le, ct, F + "", x, A, at) : void 0, Fo = Kt === void 0;
    if (Fo) {
      var Ka = Ua(ct), Ya = !Ka && bd(ct), kd = !Ka && !Ya && xd(ct);
      Kt = ct, Ka || Ya || kd ? Ua(Le) ? Kt = Le : Xv(Le) ? Kt = jv(Le) : Ya ? (Fo = !1, Kt = $v(ct, !0)) : kd ? (Fo = !1, Kt = Mv(ct, !0)) : Kt = [] : Zv(ct) || Ha(ct) ? (Kt = Le, Ha(Le) ? Kt = Jv(Le) : (!yr(Le) || qa(Le)) && (Kt = Lv(ct))) : Fo = !1;
    }
    Fo && (at.set(ct, Kt), ze(Kt, ct, ge, Qe, at), at.delete(ct)), Mt(x, F, Kt);
  }
  function Iv(x, A) {
    return qv(Gv(x, A, wd), x + "");
  }
  var Rv = Be ? function(x, A) {
    return Be(x, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e0(A),
      writable: !0
    });
  } : wd;
  function $v(x, A) {
    if (A)
      return x.slice();
    var F = x.length, ge = be ? be(F) : new x.constructor(F);
    return x.copy(ge), ge;
  }
  function Nv(x) {
    var A = new x.constructor(x.byteLength);
    return new ie(A).set(new ie(x)), A;
  }
  function Mv(x, A) {
    var F = A ? Nv(x.buffer) : x.buffer;
    return new x.constructor(F, x.byteOffset, x.length);
  }
  function jv(x, A) {
    var F = -1, ge = x.length;
    for (A || (A = Array(ge)); ++F < ge; )
      A[F] = x[F];
    return A;
  }
  function Dv(x, A, F, ge) {
    var ze = !F;
    F || (F = {});
    for (var Qe = -1, at = A.length; ++Qe < at; ) {
      var Le = A[Qe], ct = ge ? ge(F[Le], x[Le], Le, F, x) : void 0;
      ct === void 0 && (ct = x[Le]), ze ? Tt(F, Le, ct) : Zn(F, Le, ct);
    }
    return F;
  }
  function Ov(x) {
    return Iv(function(A, F) {
      var ge = -1, ze = F.length, Qe = ze > 1 ? F[ze - 1] : void 0, at = ze > 2 ? F[2] : void 0;
      for (Qe = x.length > 3 && typeof Qe == "function" ? (ze--, Qe) : void 0, at && Vv(F[0], F[1], at) && (Qe = ze < 3 ? void 0 : Qe, ze = 1), A = Object(A); ++ge < ze; ) {
        var Le = F[ge];
        Le && x(A, Le, ge, Qe);
      }
      return A;
    });
  }
  function Fv(x) {
    return function(A, F, ge) {
      for (var ze = -1, Qe = Object(A), at = ge(A), Le = at.length; Le--; ) {
        var ct = at[x ? Le : ++ze];
        if (F(Qe[ct], ct, Qe) === !1)
          break;
      }
      return A;
    };
  }
  function ei(x, A) {
    var F = x.__data__;
    return zv(A) ? F[typeof A == "string" ? "string" : "hash"] : F.map;
  }
  function za(x, A) {
    var F = Oe(x, A);
    return _v(F) ? F : void 0;
  }
  function Bv(x) {
    var A = it.call(x, ve), F = x[ve];
    try {
      x[ve] = void 0;
      var ge = !0;
    } catch {
    }
    var ze = Vt.call(x);
    return ge && (A ? x[ve] = F : delete x[ve]), ze;
  }
  function Lv(x) {
    return typeof x.constructor == "function" && !yd(x) ? jo(gt(x)) : {};
  }
  function gd(x, A) {
    var F = typeof x;
    return A = A ?? i, !!A && (F == "number" || F != "symbol" && ee.test(x)) && x > -1 && x % 1 == 0 && x < A;
  }
  function Vv(x, A, F) {
    if (!yr(F))
      return !1;
    var ge = typeof A;
    return (ge == "number" ? Ga(F) && gd(A, F.length) : ge == "string" && A in F) ? ti(F[A], x) : !1;
  }
  function zv(x) {
    var A = typeof x;
    return A == "string" || A == "number" || A == "symbol" || A == "boolean" ? x !== "__proto__" : x === null;
  }
  function Wv(x) {
    return !!At && At in x;
  }
  function yd(x) {
    var A = x && x.constructor, F = typeof A == "function" && A.prototype || Re;
    return x === F;
  }
  function Hv(x) {
    var A = [];
    if (x != null)
      for (var F in Object(x))
        A.push(F);
    return A;
  }
  function Uv(x) {
    return Vt.call(x);
  }
  function Gv(x, A, F) {
    return A = xt(A === void 0 ? x.length - 1 : A, 0), function() {
      for (var ge = arguments, ze = -1, Qe = xt(ge.length - A, 0), at = Array(Qe); ++ze < Qe; )
        at[ze] = ge[A + ze];
      ze = -1;
      for (var Le = Array(A + 1); ++ze < A; )
        Le[ze] = ge[ze];
      return Le[A] = F(at), me(x, this, Le);
    };
  }
  function Wa(x, A) {
    if (!(A === "constructor" && typeof x[A] == "function") && A != "__proto__")
      return x[A];
  }
  var qv = Kv(Rv);
  function Kv(x) {
    var A = 0, F = 0;
    return function() {
      var ge = Ot(), ze = s - (ge - F);
      if (F = ge, ze > 0) {
        if (++A >= o)
          return arguments[0];
      } else
        A = 0;
      return x.apply(void 0, arguments);
    };
  }
  function Yv(x) {
    if (x != null) {
      try {
        return tt.call(x);
      } catch {
      }
      try {
        return x + "";
      } catch {
      }
    }
    return "";
  }
  function ti(x, A) {
    return x === A || x !== x && A !== A;
  }
  var Ha = Qs(function() {
    return arguments;
  }()) ? Qs : function(x) {
    return Oo(x) && it.call(x, "callee") && !pe.call(x, "callee");
  }, Ua = Array.isArray;
  function Ga(x) {
    return x != null && vd(x.length) && !qa(x);
  }
  function Xv(x) {
    return Oo(x) && Ga(x);
  }
  var bd = He || t0;
  function qa(x) {
    if (!yr(x))
      return !1;
    var A = Hr(x);
    return A == p || A == m || A == l || A == v;
  }
  function vd(x) {
    return typeof x == "number" && x > -1 && x % 1 == 0 && x <= i;
  }
  function yr(x) {
    var A = typeof x;
    return x != null && (A == "object" || A == "function");
  }
  function Oo(x) {
    return x != null && typeof x == "object";
  }
  function Zv(x) {
    if (!Oo(x) || Hr(x) != b)
      return !1;
    var A = gt(x);
    if (A === null)
      return !0;
    var F = it.call(A, "constructor") && A.constructor;
    return typeof F == "function" && F instanceof F && tt.call(F) == qt;
  }
  var xd = L ? $e(L) : Tv;
  function Jv(x) {
    return Dv(x, Sd(x));
  }
  function Sd(x) {
    return Ga(x) ? ft(x, !0) : Ev(x);
  }
  var Qv = Ov(function(x, A, F, ge) {
    md(x, A, F, ge);
  });
  function e0(x) {
    return function() {
      return x;
    };
  }
  function wd(x) {
    return x;
  }
  function t0() {
    return !1;
  }
  e.exports = Qv;
})(Wi, Wi.exports);
var W0 = Wi.exports;
const sn = /* @__PURE__ */ ca(W0);
function nt(e, t = []) {
  const n = ae(e);
  return xe(() => {
    n.current = e;
  }), R((...r) => {
    var o;
    return (o = n.current) == null ? void 0 : o.call(n, ...r);
  }, t);
}
function _r(e, t, n, r) {
  const o = nt(n);
  return xe(() => {
    const s = typeof e == "function" ? e() : e ?? document;
    if (!(!n || !s))
      return s.addEventListener(t, o, r), () => {
        s.removeEventListener(t, o, r);
      };
  }, [t, e, r, o, n]), () => {
    const s = typeof e == "function" ? e() : e ?? document;
    s == null || s.removeEventListener(t, o, r);
  };
}
function Wh(e) {
  const { isOpen: t, ref: n } = e, [r, o] = he(t), [s, i] = he(!1);
  return xe(() => {
    s || (o(t), i(!0));
  }, [t, s, r]), _r(
    () => n.current,
    "animationend",
    () => {
      o(t);
    }
  ), {
    present: !(t ? !1 : !r),
    onComplete() {
      var u;
      const c = h0(n.current), l = new c.CustomEvent("animationend", { bubbles: !0 });
      (u = n.current) == null || u.dispatchEvent(l);
    }
  };
}
function J5(e = !1) {
  const [t, n] = he(e), r = _e(
    () => ({
      on: () => n(!0),
      off: () => n(!1),
      toggle: () => n((o) => !o)
    }),
    []
  );
  return [t, r];
}
var H0 = function() {
  var e = document.getSelection();
  if (!e.rangeCount)
    return function() {
    };
  for (var t = document.activeElement, n = [], r = 0; r < e.rangeCount; r++)
    n.push(e.getRangeAt(r));
  switch (t.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      t.blur();
      break;
    default:
      t = null;
      break;
  }
  return e.removeAllRanges(), function() {
    e.type === "Caret" && e.removeAllRanges(), e.rangeCount || n.forEach(function(o) {
      e.addRange(o);
    }), t && t.focus();
  };
}, U0 = H0, Td = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
}, G0 = "Copy to clipboard: #{key}, Enter";
function q0(e) {
  var t = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return e.replace(/#{\s*key\s*}/g, t);
}
function K0(e, t) {
  var n, r, o, s, i, a, c = !1;
  t || (t = {}), n = t.debug || !1;
  try {
    o = U0(), s = document.createRange(), i = document.getSelection(), a = document.createElement("span"), a.textContent = e, a.ariaHidden = "true", a.style.all = "unset", a.style.position = "fixed", a.style.top = 0, a.style.clip = "rect(0, 0, 0, 0)", a.style.whiteSpace = "pre", a.style.webkitUserSelect = "text", a.style.MozUserSelect = "text", a.style.msUserSelect = "text", a.style.userSelect = "text", a.addEventListener("copy", function(u) {
      if (u.stopPropagation(), t.format)
        if (u.preventDefault(), typeof u.clipboardData > "u") {
          n && console.warn("unable to use e.clipboardData"), n && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var d = Td[t.format] || Td.default;
          window.clipboardData.setData(d, e);
        } else
          u.clipboardData.clearData(), u.clipboardData.setData(t.format, e);
      t.onCopy && (u.preventDefault(), t.onCopy(u.clipboardData));
    }), document.body.appendChild(a), s.selectNodeContents(a), i.addRange(s);
    var l = document.execCommand("copy");
    if (!l)
      throw new Error("copy command was unsuccessful");
    c = !0;
  } catch (u) {
    n && console.error("unable to copy using execCommand: ", u), n && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), c = !0;
    } catch (d) {
      n && console.error("unable to copy using clipboardData: ", d), n && console.error("falling back to prompt"), r = q0("message" in t ? t.message : G0), window.prompt(r, e);
    }
  } finally {
    i && (typeof i.removeRange == "function" ? i.removeRange(s) : i.removeAllRanges()), a && document.body.removeChild(a), o();
  }
  return c;
}
var Y0 = K0;
const Ed = /* @__PURE__ */ ca(Y0);
function Q5(e, t = {}) {
  const [n, r] = he(!1), [o, s] = he(e);
  xe(() => s(e), [e]);
  const { timeout: i = 1500, ...a } = typeof t == "number" ? { timeout: t } : t, c = R(
    (l) => {
      const u = typeof l == "string" ? l : o;
      "clipboard" in navigator ? navigator.clipboard.writeText(u).then(() => r(!0)).catch(() => r(Ed(u, a))) : r(Ed(u, a));
    },
    [o, a]
  );
  return xe(() => {
    let l = null;
    return n && (l = window.setTimeout(() => {
      r(!1);
    }, i)), () => {
      l && window.clearTimeout(l);
    };
  }, [i, n]), {
    value: o,
    setValue: s,
    onCopy: c,
    hasCopied: n
  };
}
function eL(e) {
  const t = ae(null);
  return t.current === null && (t.current = typeof e == "function" ? e() : e), t.current;
}
function tL(e, t) {
  const n = typeof e < "u", r = n ? e : t;
  return _e(() => [n, r], [n, r]);
}
function dr(e) {
  const {
    value: t,
    defaultValue: n,
    onChange: r,
    shouldUpdate: o = (f, p) => f !== p
  } = e, s = nt(r), i = nt(o), [a, c] = he(n), l = t !== void 0, u = l ? t : a, d = nt(
    (f) => {
      const m = typeof f == "function" ? f(u) : f;
      i(u, m) && (l || c(m), s(m));
    },
    [l, s, u, i]
  );
  return [u, d];
}
function X0(e = {}) {
  const {
    onChange: t,
    precision: n,
    defaultValue: r,
    value: o,
    step: s = 1,
    min: i = Number.MIN_SAFE_INTEGER,
    max: a = Number.MAX_SAFE_INTEGER,
    keepWithinRange: c = !0
  } = e, l = nt(t), [u, d] = he(() => r == null ? "" : Xa(r, s, n) ?? ""), f = typeof o < "u", p = f ? o : u, m = Hh(er(p), s), g = n ?? m, y = R(
    (N) => {
      N !== p && (f || d(N.toString()), l == null || l(N.toString(), er(N)));
    },
    [l, f, p]
  ), S = R(
    (N) => {
      let z = N;
      return c && (z = lo(z, i, a)), Kl(z, g);
    },
    [g, c, a, i]
  ), b = R(
    (N = s) => {
      let z;
      p === "" ? z = er(N) : z = er(p) + N, z = S(z), y(z);
    },
    [S, s, y, p]
  ), v = R(
    (N = s) => {
      let z;
      p === "" ? z = er(-N) : z = er(p) - N, z = S(z), y(z);
    },
    [S, s, y, p]
  ), k = R(() => {
    let N;
    r == null ? N = "" : N = Xa(r, s, n) ?? i, y(N);
  }, [r, n, s, y, i]), w = R(
    (N) => {
      const z = Xa(N, s, g) ?? i;
      y(z);
    },
    [g, s, y, i]
  ), _ = er(p);
  return {
    isOutOfRange: _ > a || _ < i,
    isAtMax: _ === a,
    isAtMin: _ === i,
    precision: g,
    value: p,
    valueAsNumber: _,
    update: y,
    reset: k,
    increment: b,
    decrement: v,
    clamp: S,
    cast: w,
    setValue: d
  };
}
function er(e) {
  return parseFloat(e.toString().replace(/[^\w.-]+/g, ""));
}
function Hh(e, t) {
  return Math.max(Zc(t), Zc(e));
}
function Xa(e, t, n) {
  const r = er(e);
  if (Number.isNaN(r))
    return;
  const o = Hh(r, t);
  return Kl(r, n ?? o);
}
function Yl(e = {}) {
  const {
    onClose: t,
    onOpen: n,
    isOpen: r,
    id: o
  } = e, s = nt(n), i = nt(t), [a, c] = he(e.defaultIsOpen || !1), l = r !== void 0 ? r : a, u = r !== void 0, d = Rt(), f = o ?? `disclosure-${d}`, p = R(() => {
    u || c(!1), i == null || i();
  }, [u, i]), m = R(() => {
    u || c(!0), s == null || s();
  }, [u, s]), g = R(() => {
    l ? p() : m();
  }, [l, m, p]);
  function y(b = {}) {
    return {
      ...b,
      "aria-expanded": l,
      "aria-controls": f,
      onClick(v) {
        var k;
        (k = b.onClick) == null || k.call(b, v), g();
      }
    };
  }
  function S(b = {}) {
    return {
      ...b,
      hidden: !l,
      id: f
    };
  }
  return {
    isOpen: l,
    onOpen: m,
    onClose: p,
    onToggle: g,
    isControlled: u,
    getButtonProps: y,
    getDisclosureProps: S
  };
}
const an = globalThis != null && globalThis.document ? Is : xe, bn = (e, t) => {
  const n = ae(!1), r = ae(!1);
  xe(() => {
    if (n.current && r.current)
      return e();
    r.current = !0;
  }, t), xe(() => (n.current = !0, () => {
    n.current = !1;
  }), []);
};
function Z0(e) {
  const t = e.current;
  if (!t)
    return !1;
  const n = g0(t);
  return !n || t.contains(n) ? !1 : !!I0(n);
}
function Uh(e, t) {
  const { shouldFocus: n, visible: r, focusRef: o } = t, s = n && !r;
  bn(() => {
    if (!s || Z0(e))
      return;
    const i = (o == null ? void 0 : o.current) || e.current;
    let a;
    if (i)
      return a = requestAnimationFrame(() => {
        i.focus({ preventScroll: !0 });
      }), () => {
        cancelAnimationFrame(a);
      };
  }, [s, e, o]);
}
const J0 = {
  preventScroll: !0,
  shouldFocus: !1
};
function Q0(e, t = J0) {
  const { focusRef: n, preventScroll: r, shouldFocus: o, visible: s } = t, i = ex(e) ? e.current : e, a = o && s, c = ae(a), l = ae(s);
  an(() => {
    !l.current && s && (c.current = a), l.current = s;
  }, [s, a]);
  const u = R(() => {
    if (!(!s || !i || !c.current) && (c.current = !1, !i.contains(document.activeElement)))
      if (n != null && n.current)
        requestAnimationFrame(() => {
          var d;
          (d = n.current) == null || d.focus({ preventScroll: r });
        });
      else {
        const d = Dh(i);
        d.length > 0 && requestAnimationFrame(() => {
          d[0].focus({ preventScroll: r });
        });
      }
  }, [s, r, i, n]);
  bn(() => {
    u();
  }, [u]), _r(i, "transitionend", u);
}
function ex(e) {
  return "current" in e;
}
function tx(e) {
  return "current" in e;
}
const Gh = () => typeof window < "u";
function nx() {
  const e = navigator.userAgentData;
  return (e == null ? void 0 : e.platform) ?? navigator.platform;
}
const rx = (e) => Gh() && e.test(navigator.vendor), ox = (e) => Gh() && e.test(nx()), sx = () => ox(/mac|iphone|ipad|ipod/i), ix = () => sx() && rx(/apple/i);
function qh(e) {
  const { ref: t, elements: n, enabled: r } = e, o = () => {
    var s;
    return ((s = t.current) == null ? void 0 : s.ownerDocument) ?? document;
  };
  _r(o, "pointerdown", (s) => {
    var l, u;
    if (!ix() || !r)
      return;
    const i = ((u = (l = s.composedPath) == null ? void 0 : l.call(s)) == null ? void 0 : u[0]) ?? s.target, c = (n ?? [t]).some((d) => {
      const f = tx(d) ? d.current : d;
      return (f == null ? void 0 : f.contains(i)) || f === i;
    });
    o().activeElement !== i && c && (s.preventDefault(), i.focus());
  });
}
function ax(e, t) {
  const n = Rt();
  return _e(
    () => e || [t, n].filter(Boolean).join("-"),
    [e, t, n]
  );
}
function cx(e, ...t) {
  const n = ax(e);
  return _e(() => t.map((r) => `${r}-${n}`), [n, t]);
}
function nL(e) {
  const [t, n] = he(null);
  return { ref: R(
    (o) => {
      n(o ? e : null);
    },
    [e]
  ), id: t, isRendered: !!t };
}
function lx(e, t) {
  const n = nt(e);
  xe(() => {
    let r = null;
    const o = () => n();
    return t !== null && (r = window.setInterval(o, t)), () => {
      r && window.clearInterval(r);
    };
  }, [t, n]);
}
function Kh(e) {
  const t = ae(null);
  return t.current = e, t;
}
function ux(e, t) {
  if (e != null) {
    if (typeof e == "function") {
      e(t);
      return;
    }
    try {
      e.current = t;
    } catch {
      throw new Error(`Cannot assign value '${t}' to ref '${e}'`);
    }
  }
}
function De(...e) {
  return (t) => {
    e.forEach((n) => {
      ux(n, t);
    });
  };
}
function dx(...e) {
  return _e(() => De(...e), e);
}
function Yh(e) {
  const { ref: t, handler: n, enabled: r = !0 } = e, o = nt(n), i = ae({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }).current;
  xe(() => {
    if (!r)
      return;
    const a = (d) => {
      Za(d, t) && (i.isPointerDown = !0);
    }, c = (d) => {
      if (i.ignoreEmulatedMouseEvents) {
        i.ignoreEmulatedMouseEvents = !1;
        return;
      }
      i.isPointerDown && n && Za(d, t) && (i.isPointerDown = !1, o(d));
    }, l = (d) => {
      i.ignoreEmulatedMouseEvents = !0, n && i.isPointerDown && Za(d, t) && (i.isPointerDown = !1, o(d));
    }, u = Xh(t.current);
    return u.addEventListener("mousedown", a, !0), u.addEventListener("mouseup", c, !0), u.addEventListener("touchstart", a, !0), u.addEventListener("touchend", l, !0), () => {
      u.removeEventListener("mousedown", a, !0), u.removeEventListener("mouseup", c, !0), u.removeEventListener("touchstart", a, !0), u.removeEventListener("touchend", l, !0);
    };
  }, [n, t, o, i, r]);
}
function Za(e, t) {
  var r, o;
  const n = ((r = e.composedPath) == null ? void 0 : r.call(e)[0]) ?? e.target;
  return n && !Xh(n).contains(n) ? !1 : !((o = t.current) != null && o.contains(n));
}
function Xh(e) {
  return (e == null ? void 0 : e.ownerDocument) ?? document;
}
function fx(e) {
  const t = ae(void 0);
  return xe(() => {
    t.current = e;
  }, [e]), t.current;
}
function px(e, t) {
  if (!e) {
    t(void 0);
    return;
  }
  t({ width: e.offsetWidth, height: e.offsetHeight });
  const n = e.ownerDocument.defaultView ?? window, r = new n.ResizeObserver((o) => {
    if (!Array.isArray(o) || !o.length)
      return;
    const [s] = o;
    let i, a;
    if ("borderBoxSize" in s) {
      const c = s.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
      i = l.inlineSize, a = l.blockSize;
    } else
      i = e.offsetWidth, a = e.offsetHeight;
    t({ width: i, height: a });
  });
  return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
}
const hx = globalThis != null && globalThis.document ? Is : xe;
function mx(e, t) {
  var o;
  if (!e || !e.parentElement)
    return;
  const n = ((o = e.ownerDocument) == null ? void 0 : o.defaultView) ?? window, r = new n.MutationObserver(() => {
    t();
  });
  return r.observe(e.parentElement, { childList: !0 }), () => {
    r.disconnect();
  };
}
function gx(e) {
  const {
    getNodes: t,
    observeMutation: n = !0,
    enabled: r = !0,
    fallback: o = []
  } = e, [s, i] = he(o), [a, c] = he(0);
  return hx(() => {
    if (!r)
      return;
    const l = t(), u = l.map(
      (d, f) => px(d, (p) => {
        i((m) => [
          ...m.slice(0, f),
          p,
          ...m.slice(f + 1)
        ]);
      })
    );
    if (n) {
      const d = l[0];
      u.push(
        mx(d, () => {
          c((f) => f + 1);
        })
      );
    }
    return () => {
      u.forEach((d) => {
        d == null || d();
      });
    };
  }, [a, r]), s;
}
function yx(e) {
  return typeof e == "object" && e !== null && "current" in e;
}
function rL(e, t) {
  const { observeMutation: n = !1, enabled: r, fallback: o } = t ?? {}, [s] = gx({
    observeMutation: n,
    enabled: r,
    fallback: o ? [o] : void 0,
    getNodes() {
      return [yx(e) ? e.current : e];
    }
  });
  return s;
}
function bx(e, t) {
  const n = nt(e);
  xe(() => {
    if (t == null)
      return;
    let r = null;
    return r = window.setTimeout(() => {
      n();
    }, t), () => {
      r && window.clearTimeout(r);
    };
  }, [t, n]);
}
const Zh = 1 / 60 * 1e3, vx = typeof performance < "u" ? () => performance.now() : () => Date.now(), Jh = typeof window < "u" ? (e) => window.requestAnimationFrame(e) : (e) => setTimeout(() => e(vx()), Zh);
function xx(e) {
  let t = [], n = [], r = 0, o = !1, s = !1;
  const i = /* @__PURE__ */ new WeakSet(), a = {
    schedule: (c, l = !1, u = !1) => {
      const d = u && o, f = d ? t : n;
      return l && i.add(c), f.indexOf(c) === -1 && (f.push(c), d && o && (r = t.length)), c;
    },
    cancel: (c) => {
      const l = n.indexOf(c);
      l !== -1 && n.splice(l, 1), i.delete(c);
    },
    process: (c) => {
      if (o) {
        s = !0;
        return;
      }
      if (o = !0, [t, n] = [n, t], n.length = 0, r = t.length, r)
        for (let l = 0; l < r; l++) {
          const u = t[l];
          u(c), i.has(u) && (a.schedule(u), e());
        }
      o = !1, s && (s = !1, a.process(c));
    }
  };
  return a;
}
const Sx = 40;
let Qc = !0, gs = !1, el = !1;
const uo = {
  delta: 0,
  timestamp: 0
}, Ns = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], la = Ns.reduce((e, t) => (e[t] = xx(() => gs = !0), e), {}), wx = Ns.reduce((e, t) => {
  const n = la[t];
  return e[t] = (r, o = !1, s = !1) => (gs || Cx(), n.schedule(r, o, s)), e;
}, {}), kx = Ns.reduce((e, t) => (e[t] = la[t].cancel, e), {});
Ns.reduce((e, t) => (e[t] = () => la[t].process(uo), e), {});
const Px = (e) => la[e].process(uo), Qh = (e) => {
  gs = !1, uo.delta = Qc ? Zh : Math.max(Math.min(e - uo.timestamp, Sx), 1), uo.timestamp = e, el = !0, Ns.forEach(Px), el = !1, gs && (Qc = !1, Jh(Qh));
}, Cx = () => {
  gs = !0, Qc = !0, el || Jh(Qh);
}, Ad = () => uo;
var _x = Object.defineProperty, Tx = (e, t, n) => t in e ? _x(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, hn = (e, t, n) => (Tx(e, typeof t != "symbol" ? t + "" : t, n), n);
class Ex {
  constructor(t, n, r) {
    if (hn(this, "history", []), hn(this, "startEvent", null), hn(this, "lastEvent", null), hn(this, "lastEventInfo", null), hn(this, "handlers", {}), hn(this, "removeListeners", () => {
    }), hn(this, "threshold", 3), hn(this, "win"), hn(this, "updatePoint", () => {
      if (!(this.lastEvent && this.lastEventInfo))
        return;
      const a = Ja(this.lastEventInfo, this.history), c = this.startEvent !== null, l = $x(a.offset, { x: 0, y: 0 }) >= this.threshold;
      if (!c && !l)
        return;
      const { timestamp: u } = Ad();
      this.history.push({ ...a.point, timestamp: u });
      const { onStart: d, onMove: f } = this.handlers;
      c || (d == null || d(this.lastEvent, a), this.startEvent = this.lastEvent), f == null || f(this.lastEvent, a);
    }), hn(this, "onPointerMove", (a, c) => {
      this.lastEvent = a, this.lastEventInfo = c, wx.update(this.updatePoint, !0);
    }), hn(this, "onPointerUp", (a, c) => {
      const l = Ja(c, this.history), { onEnd: u, onSessionEnd: d } = this.handlers;
      d == null || d(a, l), this.end(), !(!u || !this.startEvent) && (u == null || u(a, l));
    }), this.win = t.view ?? window, b0(t))
      return;
    this.handlers = n, r && (this.threshold = r), t.stopPropagation(), t.preventDefault();
    const o = { point: Nh(t) }, { timestamp: s } = Ad();
    this.history = [{ ...o.point, timestamp: s }];
    const { onSessionStart: i } = n;
    i == null || i(t, Ja(o, this.history)), this.removeListeners = Rx(
      ki(this.win, "pointermove", this.onPointerMove),
      ki(this.win, "pointerup", this.onPointerUp),
      ki(this.win, "pointercancel", this.onPointerUp)
    );
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    var t;
    (t = this.removeListeners) == null || t.call(this), kx.update(this.updatePoint);
  }
}
function Id(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function Ja(e, t) {
  return {
    point: e.point,
    delta: Id(e.point, t[t.length - 1]),
    offset: Id(e.point, t[0]),
    velocity: Ix(t, 0.1)
  };
}
const Ax = (e) => e * 1e3;
function Ix(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const o = e[e.length - 1];
  for (; n >= 0 && (r = e[n], !(o.timestamp - r.timestamp > Ax(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const s = (o.timestamp - r.timestamp) / 1e3;
  if (s === 0)
    return { x: 0, y: 0 };
  const i = {
    x: (o.x - r.x) / s,
    y: (o.y - r.y) / s
  };
  return i.x === 1 / 0 && (i.x = 0), i.y === 1 / 0 && (i.y = 0), i;
}
function Rx(...e) {
  return (t) => e.reduce((n, r) => r(n), t);
}
function Qa(e, t) {
  return Math.abs(e - t);
}
function Rd(e) {
  return "x" in e && "y" in e;
}
function $x(e, t) {
  if (typeof e == "number" && typeof t == "number")
    return Qa(e, t);
  if (Rd(e) && Rd(t)) {
    const n = Qa(e.x, t.x), r = Qa(e.y, t.y);
    return Math.sqrt(n ** 2 + r ** 2);
  }
  return 0;
}
function em(e, t) {
  const {
    onPan: n,
    onPanStart: r,
    onPanEnd: o,
    onPanSessionStart: s,
    onPanSessionEnd: i,
    threshold: a
  } = t, c = !!(n || r || o || s || i), l = ae(null), u = Kh({
    onSessionStart: s,
    onSessionEnd: i,
    onStart: r,
    onMove: n,
    onEnd(d, f) {
      l.current = null, o == null || o(d, f);
    }
  });
  xe(() => {
    var d;
    (d = l.current) == null || d.updateHandlers(u.current);
  }), xe(() => {
    const d = e.current;
    if (!d || !c)
      return;
    function f(p) {
      l.current = new Ex(p, u.current, a);
    }
    return ki(d, "pointerdown", f);
  }, [e, c, u, a]), xe(() => () => {
    var d;
    (d = l.current) == null || d.end(), l.current = null;
  }, []);
}
const St = {
  open: (e, t) => `${e}[data-open], ${e}[open], ${e}[data-state=open] ${t}`,
  closed: (e, t) => `${e}[data-closed], ${e}[data-state=closed] ${t}`,
  hover: (e, t) => `${e}:hover ${t}, ${e}[data-hover] ${t}`,
  focus: (e, t) => `${e}:focus ${t}, ${e}[data-focus] ${t}`,
  focusVisible: (e, t) => `${e}:focus-visible ${t}`,
  focusWithin: (e, t) => `${e}:focus-within ${t}`,
  active: (e, t) => `${e}:active ${t}, ${e}[data-active] ${t}`,
  disabled: (e, t) => `${e}:disabled ${t}, ${e}[data-disabled] ${t}`,
  invalid: (e, t) => `${e}:invalid ${t}, ${e}[data-invalid] ${t}`,
  checked: (e, t) => `${e}:checked ${t}, ${e}[data-checked] ${t}`,
  indeterminate: (e, t) => `${e}:indeterminate ${t}, ${e}[aria-checked=mixed] ${t}, ${e}[data-indeterminate] ${t}`,
  readOnly: (e, t) => `${e}:read-only ${t}, ${e}[readonly] ${t}, ${e}[data-read-only] ${t}`,
  expanded: (e, t) => `${e}:read-only ${t}, ${e}[aria-expanded=true] ${t}, ${e}[data-expanded] ${t}`,
  placeholderShown: (e, t) => `${e}:placeholder-shown ${t}`
}, wn = (e) => tm((t) => e(t, "&"), "[role=group]", "[data-group]", ".group"), On = (e) => tm((t) => e(t, "~ &"), "[data-peer]", ".peer"), tm = (e, ...t) => t.map(e).join(", "), fo = {
  /**
   * Styles for CSS selector `&:hover`
   */
  _hover: "&:hover, &[data-hover]",
  /**
   * Styles for CSS Selector `&:active`
   */
  _active: "&:active, &[data-active]",
  /**
   * Styles for CSS selector `&:focus`
   *
   */
  _focus: "&:focus, &[data-focus]",
  /**
   * Styles for the highlighted state.
   */
  _highlighted: "&[data-highlighted]",
  /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */
  _focusWithin: "&:focus-within, &[data-focus-within]",
  /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */
  _focusVisible: "&:focus-visible, &[data-focus-visible]",
  /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   * - `&[disabled]`
   */
  _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
  /**
   * Styles for CSS Selector `&:readonly`
   */
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */
  _before: "&::before",
  /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */
  _after: "&::after",
  /**
   * Styles for CSS selector `&:empty`
   */
  _empty: "&:empty, &[data-empty]",
  /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */
  _expanded: "&[aria-expanded=true], &[data-expanded], &[data-state=expanded]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */
  _checked: "&[aria-checked=true], &[data-checked], &[data-state=checked]",
  /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */
  _valid: "&[data-valid], &[data-state=valid]",
  /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */
  _loading: "&[data-loading], &[aria-busy=true]",
  /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */
  _selected: "&[aria-selected=true], &[data-selected]",
  /**
   * Styles for CSS Selector `[hidden=true]`
   */
  _hidden: "&[hidden], &[data-hidden]",
  /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */
  _autofill: "&:-webkit-autofill",
  /**
   * Styles for CSS Selector `&:nth-child(even)`
   */
  _even: "&:nth-of-type(even)",
  /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */
  _odd: "&:nth-of-type(odd)",
  /**
   * Styles for CSS Selector `&:first-of-type`
   */
  _first: "&:first-of-type",
  /**
   * Styles for CSS selector `&::first-letter`
   *
   * NOTE: This selector is only applied for block-level elements and not preceded by an image or table.
   * @example
   * ```jsx
   * <Text _firstLetter={{ textDecoration: 'underline' }}>Once upon a time</Text>
   * ```
   */
  _firstLetter: "&::first-letter",
  /**
   * Styles for CSS Selector `&:last-of-type`
   */
  _last: "&:last-of-type",
  /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */
  _notFirst: "&:not(:first-of-type)",
  /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */
  _notLast: "&:not(:last-of-type)",
  /**
   * Styles for CSS Selector `&:visited`
   */
  _visited: "&:visited",
  /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */
  _activeLink: "&[aria-current=page]",
  /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */
  _activeStep: "&[aria-current=step]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate], &[data-state=indeterminate]",
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is open
   */
  _groupOpen: wn(St.open),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is closed
   */
  _groupClosed: wn(St.closed),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */
  _groupHover: wn(St.hover),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */
  _peerHover: On(St.hover),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */
  _groupFocus: wn(St.focus),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */
  _peerFocus: On(St.focus),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */
  _groupFocusVisible: wn(St.focusVisible),
  /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */
  _peerFocusVisible: On(St.focusVisible),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */
  _groupActive: wn(St.active),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */
  _peerActive: On(St.active),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */
  _groupDisabled: wn(St.disabled),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */
  _peerDisabled: On(St.disabled),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */
  _groupInvalid: wn(St.invalid),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */
  _peerInvalid: On(St.invalid),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */
  _groupChecked: wn(St.checked),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */
  _peerChecked: On(St.checked),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */
  _groupFocusWithin: wn(St.focusWithin),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */
  _peerFocusWithin: On(St.focusWithin),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */
  _peerPlaceholderShown: On(St.placeholderShown),
  /**
   * Styles for CSS Selector `&::placeholder`.
   */
  _placeholder: "&::placeholder, &[data-placeholder]",
  /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */
  _placeholderShown: "&:placeholder-shown, &[data-placeholder-shown]",
  /**
   * Styles for CSS Selector `&:fullscreen`.
   */
  _fullScreen: "&:fullscreen, &[data-fullscreen]",
  /**
   * Styles for CSS Selector `&::selection`
   */
  _selection: "&::selection",
  /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */
  _mediaDark: "@media (prefers-color-scheme: dark)",
  /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
  /**
   * Styles for the CSS Selector `&[data-orientation=horizontal]`
   */
  _horizontal: "&[data-orientation=horizontal]",
  /**
   * Styles for the CSS Selector `&[data-orientation=vertical]`
   */
  _vertical: "&[data-orientation=vertical]",
  /**
   * Styles for the CSS Selector `&[data-open], &[open], &[data-state=open]`
   */
  _open: "&[data-open], &[open], &[data-state=open]",
  /**
   * Styles for the CSS Selector `&[data-closed], &[data-state=closed]`
   */
  _closed: "&[data-closed], &[data-state=closed]",
  /**
   * Styles for the CSS Selector `&[data-complete]`
   */
  _complete: "&[data-complete]",
  /**
   * Styles for the CSS Selector `&[data-incomplete]`
   */
  _incomplete: "&[data-incomplete]",
  /**
   * Styles for the CSS Selector `&[data-current]`
   */
  _current: "&[data-current]"
}, nm = Object.keys(
  fo
), Nx = (e) => /!(important)?$/.test(e), $d = (e) => typeof e == "string" ? e.replace(/!(important)?$/, "").trim() : e, Mx = (e, t) => (n) => {
  const r = String(t), o = Nx(r), s = $d(r), i = e ? `${e}.${s}` : s;
  let a = lt(n.__cssMap) && i in n.__cssMap ? n.__cssMap[i].varRef : t;
  return a = $d(a), o ? `${a} !important` : a;
};
function Xl(e) {
  const { scale: t, transform: n, compose: r } = e;
  return (s, i) => {
    const a = Mx(t, s)(i);
    let c = (n == null ? void 0 : n(a, i)) ?? a;
    return r && (c = r(c, i)), c;
  };
}
const ri = (...e) => (t) => e.reduce((n, r) => r(n), t);
function tn(e, t) {
  return (n) => {
    const r = { property: n, scale: e };
    return r.transform = Xl({
      scale: e,
      transform: t
    }), r;
  };
}
const jx = ({ rtl: e, ltr: t }) => (n) => n.direction === "rtl" ? e : t;
function Dx(e) {
  const { property: t, scale: n, transform: r } = e;
  return {
    scale: n,
    property: jx(t),
    transform: n ? Xl({
      scale: n,
      compose: r
    }) : r
  };
}
const rm = [
  "rotate(var(--chakra-rotate, 0))",
  "scaleX(var(--chakra-scale-x, 1))",
  "scaleY(var(--chakra-scale-y, 1))",
  "skewX(var(--chakra-skew-x, 0))",
  "skewY(var(--chakra-skew-y, 0))"
];
function Ox() {
  return [
    "translateX(var(--chakra-translate-x, 0))",
    "translateY(var(--chakra-translate-y, 0))",
    ...rm
  ].join(" ");
}
function Fx() {
  return [
    "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
    ...rm
  ].join(" ");
}
const Bx = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: [
    "var(--chakra-blur)",
    "var(--chakra-brightness)",
    "var(--chakra-contrast)",
    "var(--chakra-grayscale)",
    "var(--chakra-hue-rotate)",
    "var(--chakra-invert)",
    "var(--chakra-saturate)",
    "var(--chakra-sepia)",
    "var(--chakra-drop-shadow)"
  ].join(" ")
}, Lx = {
  backdropFilter: [
    "var(--chakra-backdrop-blur)",
    "var(--chakra-backdrop-brightness)",
    "var(--chakra-backdrop-contrast)",
    "var(--chakra-backdrop-grayscale)",
    "var(--chakra-backdrop-hue-rotate)",
    "var(--chakra-backdrop-invert)",
    "var(--chakra-backdrop-opacity)",
    "var(--chakra-backdrop-saturate)",
    "var(--chakra-backdrop-sepia)"
  ].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function Vx(e) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": e,
    boxShadow: [
      "var(--chakra-ring-offset-shadow)",
      "var(--chakra-ring-shadow)",
      "var(--chakra-shadow, 0 0 #0000)"
    ].join(", ")
  };
}
const zx = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
}, tl = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
}, Wx = new Set(Object.values(tl)), nl = /* @__PURE__ */ new Set([
  "none",
  "-moz-initial",
  "inherit",
  "initial",
  "revert",
  "unset"
]), Hx = (e) => e.trim();
function Ux(e, t) {
  if (e == null || nl.has(e))
    return e;
  if (!(rl(e) || nl.has(e)))
    return `url('${e}')`;
  const o = /(^[a-z-A-Z]+)\((.*)\)/g.exec(e), s = o == null ? void 0 : o[1], i = o == null ? void 0 : o[2];
  if (!s || !i)
    return e;
  const a = s.includes("-gradient") ? s : `${s}-gradient`, [c, ...l] = i.split(",").map(Hx).filter(Boolean);
  if ((l == null ? void 0 : l.length) === 0)
    return e;
  const u = c in tl ? tl[c] : c;
  l.unshift(u);
  const d = l.map((f) => {
    if (Wx.has(f))
      return f;
    const p = f.indexOf(" "), [m, g] = p !== -1 ? [f.substr(0, p), f.substr(p + 1)] : [f], y = rl(g) ? g : g && g.split(" "), S = `colors.${m}`, b = S in t.__cssMap ? t.__cssMap[S].varRef : m;
    return y ? [
      b,
      ...Array.isArray(y) ? y : [y]
    ].join(" ") : b;
  });
  return `${a}(${d.join(", ")})`;
}
const rl = (e) => typeof e == "string" && e.includes("(") && e.includes(")"), Gx = (e, t) => Ux(e, t ?? {});
function qx(e) {
  return /^var\(--.+\)$/.test(e);
}
const Kx = (e) => {
  const t = parseFloat(e.toString()), n = e.toString().replace(String(t), "");
  return { unitless: !n, value: t, unit: n };
}, kn = (e) => (t) => `${e}(${t})`, Ve = {
  filter(e) {
    return e !== "auto" ? e : Bx;
  },
  backdropFilter(e) {
    return e !== "auto" ? e : Lx;
  },
  ring(e) {
    return Vx(Ve.px(e));
  },
  bgClip(e) {
    return e === "text" ? { color: "transparent", backgroundClip: "text" } : { backgroundClip: e };
  },
  transform(e) {
    return e === "auto" ? Ox() : e === "auto-gpu" ? Fx() : e;
  },
  vh(e) {
    return e === "$100vh" ? "var(--chakra-vh)" : e;
  },
  px(e) {
    if (e == null)
      return e;
    const { unitless: t } = Kx(e);
    return t || typeof e == "number" ? `${e}px` : e;
  },
  fraction(e) {
    return typeof e != "number" || e > 1 ? e : `${e * 100}%`;
  },
  float(e, t) {
    const n = { left: "right", right: "left" };
    return t.direction === "rtl" ? n[e] : e;
  },
  degree(e) {
    if (qx(e) || e == null)
      return e;
    const t = typeof e == "string" && !e.endsWith("deg");
    return typeof e == "number" || t ? `${e}deg` : e;
  },
  gradient: Gx,
  blur: kn("blur"),
  opacity: kn("opacity"),
  brightness: kn("brightness"),
  contrast: kn("contrast"),
  dropShadow: kn("drop-shadow"),
  grayscale: kn("grayscale"),
  hueRotate: (e) => kn("hue-rotate")(Ve.degree(e)),
  invert: kn("invert"),
  saturate: kn("saturate"),
  sepia: kn("sepia"),
  bgImage(e) {
    return e == null || rl(e) || nl.has(e) ? e : `url(${e})`;
  },
  outline(e) {
    const t = String(e) === "0" || String(e) === "none";
    return e !== null && t ? { outline: "2px solid transparent", outlineOffset: "2px" } : { outline: e };
  },
  flexDirection(e) {
    const { space: t, divide: n } = zx[e] ?? {}, r = { flexDirection: e };
    return t && (r[t] = 1), n && (r[n] = 1), r;
  }
}, T = {
  borderWidths: tn("borderWidths"),
  borderStyles: tn("borderStyles"),
  colors: tn("colors"),
  borders: tn("borders"),
  gradients: tn("gradients", Ve.gradient),
  radii: tn("radii", Ve.px),
  space: tn("space", ri(Ve.vh, Ve.px)),
  spaceT: tn("space", ri(Ve.vh, Ve.px)),
  degreeT(e) {
    return { property: e, transform: Ve.degree };
  },
  prop(e, t, n) {
    return {
      property: e,
      scale: t,
      ...t && {
        transform: Xl({ scale: t, transform: n })
      }
    };
  },
  propT(e, t) {
    return { property: e, transform: t };
  },
  sizes: tn("sizes", ri(Ve.vh, Ve.px)),
  sizesT: tn("sizes", ri(Ve.vh, Ve.fraction)),
  shadows: tn("shadows"),
  logical: Dx,
  blur: tn("blur", Ve.blur)
}, Pi = {
  background: T.colors("background"),
  backgroundColor: T.colors("backgroundColor"),
  backgroundImage: T.gradients("backgroundImage"),
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0,
  backgroundAttachment: !0,
  backgroundClip: { transform: Ve.bgClip },
  bgSize: T.prop("backgroundSize"),
  bgPosition: T.prop("backgroundPosition"),
  bg: T.colors("background"),
  bgColor: T.colors("backgroundColor"),
  bgPos: T.prop("backgroundPosition"),
  bgRepeat: T.prop("backgroundRepeat"),
  bgAttachment: T.prop("backgroundAttachment"),
  bgGradient: T.gradients("backgroundImage"),
  bgClip: { transform: Ve.bgClip }
};
Object.assign(Pi, {
  bgImage: Pi.backgroundImage,
  bgImg: Pi.backgroundImage
});
const Ue = {
  border: T.borders("border"),
  borderWidth: T.borderWidths("borderWidth"),
  borderStyle: T.borderStyles("borderStyle"),
  borderColor: T.colors("borderColor"),
  borderRadius: T.radii("borderRadius"),
  borderTop: T.borders("borderTop"),
  borderBlockStart: T.borders("borderBlockStart"),
  borderTopLeftRadius: T.radii("borderTopLeftRadius"),
  borderStartStartRadius: T.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: T.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: T.radii("borderTopRightRadius"),
  borderStartEndRadius: T.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: T.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: T.borders("borderRight"),
  borderInlineEnd: T.borders("borderInlineEnd"),
  borderBottom: T.borders("borderBottom"),
  borderBlockEnd: T.borders("borderBlockEnd"),
  borderBottomLeftRadius: T.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: T.radii("borderBottomRightRadius"),
  borderLeft: T.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: T.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: T.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: T.borders(["borderLeft", "borderRight"]),
  borderInline: T.borders("borderInline"),
  borderY: T.borders(["borderTop", "borderBottom"]),
  borderBlock: T.borders("borderBlock"),
  borderTopWidth: T.borderWidths("borderTopWidth"),
  borderBlockStartWidth: T.borderWidths("borderBlockStartWidth"),
  borderTopColor: T.colors("borderTopColor"),
  borderBlockStartColor: T.colors("borderBlockStartColor"),
  borderTopStyle: T.borderStyles("borderTopStyle"),
  borderBlockStartStyle: T.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: T.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: T.borderWidths("borderBlockEndWidth"),
  borderBottomColor: T.colors("borderBottomColor"),
  borderBlockEndColor: T.colors("borderBlockEndColor"),
  borderBottomStyle: T.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: T.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: T.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: T.borderWidths("borderInlineStartWidth"),
  borderLeftColor: T.colors("borderLeftColor"),
  borderInlineStartColor: T.colors("borderInlineStartColor"),
  borderLeftStyle: T.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: T.borderStyles("borderInlineStartStyle"),
  borderRightWidth: T.borderWidths("borderRightWidth"),
  borderInlineEndWidth: T.borderWidths("borderInlineEndWidth"),
  borderRightColor: T.colors("borderRightColor"),
  borderInlineEndColor: T.colors("borderInlineEndColor"),
  borderRightStyle: T.borderStyles("borderRightStyle"),
  borderInlineEndStyle: T.borderStyles("borderInlineEndStyle"),
  borderTopRadius: T.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: T.radii([
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ]),
  borderLeftRadius: T.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: T.radii([
    "borderTopRightRadius",
    "borderBottomRightRadius"
  ])
};
Object.assign(Ue, {
  rounded: Ue.borderRadius,
  roundedTop: Ue.borderTopRadius,
  roundedTopLeft: Ue.borderTopLeftRadius,
  roundedTopRight: Ue.borderTopRightRadius,
  roundedTopStart: Ue.borderStartStartRadius,
  roundedTopEnd: Ue.borderStartEndRadius,
  roundedBottom: Ue.borderBottomRadius,
  roundedBottomLeft: Ue.borderBottomLeftRadius,
  roundedBottomRight: Ue.borderBottomRightRadius,
  roundedBottomStart: Ue.borderEndStartRadius,
  roundedBottomEnd: Ue.borderEndEndRadius,
  roundedLeft: Ue.borderLeftRadius,
  roundedRight: Ue.borderRightRadius,
  roundedStart: Ue.borderInlineStartRadius,
  roundedEnd: Ue.borderInlineEndRadius,
  borderStart: Ue.borderInlineStart,
  borderEnd: Ue.borderInlineEnd,
  borderTopStartRadius: Ue.borderStartStartRadius,
  borderTopEndRadius: Ue.borderStartEndRadius,
  borderBottomStartRadius: Ue.borderEndStartRadius,
  borderBottomEndRadius: Ue.borderEndEndRadius,
  borderStartRadius: Ue.borderInlineStartRadius,
  borderEndRadius: Ue.borderInlineEndRadius,
  borderStartWidth: Ue.borderInlineStartWidth,
  borderEndWidth: Ue.borderInlineEndWidth,
  borderStartColor: Ue.borderInlineStartColor,
  borderEndColor: Ue.borderInlineEndColor,
  borderStartStyle: Ue.borderInlineStartStyle,
  borderEndStyle: Ue.borderInlineEndStyle
});
const Yx = {
  color: T.colors("color"),
  textColor: T.colors("color"),
  fill: T.colors("fill"),
  stroke: T.colors("stroke"),
  accentColor: T.colors("accentColor"),
  textFillColor: T.colors("textFillColor")
}, Hi = {
  alignItems: !0,
  alignContent: !0,
  justifyItems: !0,
  justifyContent: !0,
  flexWrap: !0,
  flexDirection: { transform: Ve.flexDirection },
  flex: !0,
  flexFlow: !0,
  flexGrow: !0,
  flexShrink: !0,
  flexBasis: T.sizes("flexBasis"),
  justifySelf: !0,
  alignSelf: !0,
  order: !0,
  placeItems: !0,
  placeContent: !0,
  placeSelf: !0,
  gap: T.space("gap"),
  rowGap: T.space("rowGap"),
  columnGap: T.space("columnGap")
};
Object.assign(Hi, {
  flexDir: Hi.flexDirection
});
const rn = {
  width: T.sizesT("width"),
  inlineSize: T.sizesT("inlineSize"),
  height: T.sizes("height"),
  blockSize: T.sizes("blockSize"),
  boxSize: T.sizes(["width", "height"]),
  minWidth: T.sizes("minWidth"),
  minInlineSize: T.sizes("minInlineSize"),
  minHeight: T.sizes("minHeight"),
  minBlockSize: T.sizes("minBlockSize"),
  maxWidth: T.sizes("maxWidth"),
  maxInlineSize: T.sizes("maxInlineSize"),
  maxHeight: T.sizes("maxHeight"),
  maxBlockSize: T.sizes("maxBlockSize"),
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  overscrollBehavior: !0,
  overscrollBehaviorX: !0,
  overscrollBehaviorY: !0,
  display: !0,
  aspectRatio: !0,
  hideFrom: {
    scale: "breakpoints",
    transform: (e, t) => {
      var o, s;
      return { [`@media screen and (min-width: ${((s = (o = t.__breakpoints) == null ? void 0 : o.get(e)) == null ? void 0 : s.minW) ?? e})`]: { display: "none" } };
    }
  },
  hideBelow: {
    scale: "breakpoints",
    transform: (e, t) => {
      var o, s;
      return { [`@media screen and (max-width: ${((s = (o = t.__breakpoints) == null ? void 0 : o.get(e)) == null ? void 0 : s._minW) ?? e})`]: { display: "none" } };
    }
  },
  verticalAlign: !0,
  boxSizing: !0,
  boxDecorationBreak: !0,
  float: T.propT("float", Ve.float),
  objectFit: !0,
  objectPosition: !0,
  visibility: !0,
  isolation: !0
};
Object.assign(rn, {
  w: rn.width,
  h: rn.height,
  minW: rn.minWidth,
  maxW: rn.maxWidth,
  minH: rn.minHeight,
  maxH: rn.maxHeight,
  overscroll: rn.overscrollBehavior,
  overscrollX: rn.overscrollBehaviorX,
  overscrollY: rn.overscrollBehaviorY
});
const Xx = {
  filter: { transform: Ve.filter },
  blur: T.blur("--chakra-blur"),
  brightness: T.propT("--chakra-brightness", Ve.brightness),
  contrast: T.propT("--chakra-contrast", Ve.contrast),
  hueRotate: T.propT("--chakra-hue-rotate", Ve.hueRotate),
  invert: T.propT("--chakra-invert", Ve.invert),
  saturate: T.propT("--chakra-saturate", Ve.saturate),
  dropShadow: T.propT("--chakra-drop-shadow", Ve.dropShadow),
  backdropFilter: { transform: Ve.backdropFilter },
  backdropBlur: T.blur("--chakra-backdrop-blur"),
  backdropBrightness: T.propT(
    "--chakra-backdrop-brightness",
    Ve.brightness
  ),
  backdropContrast: T.propT("--chakra-backdrop-contrast", Ve.contrast),
  backdropHueRotate: T.propT(
    "--chakra-backdrop-hue-rotate",
    Ve.hueRotate
  ),
  backdropInvert: T.propT("--chakra-backdrop-invert", Ve.invert),
  backdropSaturate: T.propT("--chakra-backdrop-saturate", Ve.saturate)
}, Zx = {
  ring: { transform: Ve.ring },
  ringColor: T.colors("--chakra-ring-color"),
  ringOffset: T.prop("--chakra-ring-offset-width"),
  ringOffsetColor: T.colors("--chakra-ring-offset-color"),
  ringInset: T.prop("--chakra-ring-inset")
}, Jx = {
  appearance: !0,
  cursor: !0,
  resize: !0,
  userSelect: !0,
  pointerEvents: !0,
  outline: { transform: Ve.outline },
  outlineOffset: !0,
  outlineColor: T.colors("outlineColor")
}, om = {
  gridGap: T.space("gridGap"),
  gridColumnGap: T.space("gridColumnGap"),
  gridRowGap: T.space("gridRowGap"),
  gridColumn: !0,
  gridRow: !0,
  gridAutoFlow: !0,
  gridAutoColumns: !0,
  gridColumnStart: !0,
  gridColumnEnd: !0,
  gridRowStart: !0,
  gridRowEnd: !0,
  gridAutoRows: !0,
  gridTemplate: !0,
  gridTemplateColumns: !0,
  gridTemplateRows: !0,
  gridTemplateAreas: !0,
  gridArea: !0
};
function Qx(e, t, n, r) {
  const o = typeof t == "string" ? t.split(".") : [t];
  for (r = 0; r < o.length && e; r += 1)
    e = e[o[r]];
  return e === void 0 ? n : e;
}
const eS = (e) => {
  const t = /* @__PURE__ */ new WeakMap();
  return (r, o, s, i) => {
    if (typeof r > "u")
      return e(r, o, s);
    t.has(r) || t.set(r, /* @__PURE__ */ new Map());
    const a = t.get(r);
    if (a.has(o))
      return a.get(o);
    const c = e(r, o, s, i);
    return a.set(o, c), c;
  };
}, tS = eS(Qx), nS = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
}, rS = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
}, ec = (e, t, n) => {
  const r = {}, o = tS(e, t, {});
  for (const s in o)
    s in n && n[s] != null || (r[s] = o[s]);
  return r;
}, oS = {
  srOnly: {
    transform(e) {
      return e === !0 ? nS : e === "focusable" ? rS : {};
    }
  },
  layerStyle: {
    processResult: !0,
    transform: (e, t, n) => ec(t, `layerStyles.${e}`, n)
  },
  textStyle: {
    processResult: !0,
    transform: (e, t, n) => ec(t, `textStyles.${e}`, n)
  },
  apply: {
    processResult: !0,
    transform: (e, t, n) => ec(t, e, n)
  }
}, os = {
  position: !0,
  pos: T.prop("position"),
  zIndex: T.prop("zIndex", "zIndices"),
  inset: T.spaceT("inset"),
  insetX: T.spaceT(["left", "right"]),
  insetInline: T.spaceT("insetInline"),
  insetY: T.spaceT(["top", "bottom"]),
  insetBlock: T.spaceT("insetBlock"),
  top: T.spaceT("top"),
  insetBlockStart: T.spaceT("insetBlockStart"),
  bottom: T.spaceT("bottom"),
  insetBlockEnd: T.spaceT("insetBlockEnd"),
  left: T.spaceT("left"),
  insetInlineStart: T.logical({
    scale: "space",
    property: { ltr: "left", rtl: "right" }
  }),
  right: T.spaceT("right"),
  insetInlineEnd: T.logical({
    scale: "space",
    property: { ltr: "right", rtl: "left" }
  })
};
Object.assign(os, {
  insetStart: os.insetInlineStart,
  insetEnd: os.insetInlineEnd
});
const ol = {
  boxShadow: T.shadows("boxShadow"),
  mixBlendMode: !0,
  blendMode: T.prop("mixBlendMode"),
  backgroundBlendMode: !0,
  bgBlendMode: T.prop("backgroundBlendMode"),
  opacity: !0
};
Object.assign(ol, {
  shadow: ol.boxShadow
});
const st = {
  margin: T.spaceT("margin"),
  marginTop: T.spaceT("marginTop"),
  marginBlockStart: T.spaceT("marginBlockStart"),
  marginRight: T.spaceT("marginRight"),
  marginInlineEnd: T.spaceT("marginInlineEnd"),
  marginBottom: T.spaceT("marginBottom"),
  marginBlockEnd: T.spaceT("marginBlockEnd"),
  marginLeft: T.spaceT("marginLeft"),
  marginInlineStart: T.spaceT("marginInlineStart"),
  marginX: T.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: T.spaceT("marginInline"),
  marginY: T.spaceT(["marginTop", "marginBottom"]),
  marginBlock: T.spaceT("marginBlock"),
  padding: T.space("padding"),
  paddingTop: T.space("paddingTop"),
  paddingBlockStart: T.space("paddingBlockStart"),
  paddingRight: T.space("paddingRight"),
  paddingBottom: T.space("paddingBottom"),
  paddingBlockEnd: T.space("paddingBlockEnd"),
  paddingLeft: T.space("paddingLeft"),
  paddingInlineStart: T.space("paddingInlineStart"),
  paddingInlineEnd: T.space("paddingInlineEnd"),
  paddingX: T.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: T.space("paddingInline"),
  paddingY: T.space(["paddingTop", "paddingBottom"]),
  paddingBlock: T.space("paddingBlock")
};
Object.assign(st, {
  m: st.margin,
  mt: st.marginTop,
  mr: st.marginRight,
  me: st.marginInlineEnd,
  marginEnd: st.marginInlineEnd,
  mb: st.marginBottom,
  ml: st.marginLeft,
  ms: st.marginInlineStart,
  marginStart: st.marginInlineStart,
  mx: st.marginX,
  my: st.marginY,
  p: st.padding,
  pt: st.paddingTop,
  py: st.paddingY,
  px: st.paddingX,
  pb: st.paddingBottom,
  pl: st.paddingLeft,
  ps: st.paddingInlineStart,
  paddingStart: st.paddingInlineStart,
  pr: st.paddingRight,
  pe: st.paddingInlineEnd,
  paddingEnd: st.paddingInlineEnd
});
const sS = {
  scrollBehavior: !0,
  scrollSnapAlign: !0,
  scrollSnapStop: !0,
  scrollSnapType: !0,
  // scroll margin
  scrollMargin: T.spaceT("scrollMargin"),
  scrollMarginTop: T.spaceT("scrollMarginTop"),
  scrollMarginBottom: T.spaceT("scrollMarginBottom"),
  scrollMarginLeft: T.spaceT("scrollMarginLeft"),
  scrollMarginRight: T.spaceT("scrollMarginRight"),
  scrollMarginX: T.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: T.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  // scroll padding
  scrollPadding: T.spaceT("scrollPadding"),
  scrollPaddingTop: T.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: T.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: T.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: T.spaceT("scrollPaddingRight"),
  scrollPaddingX: T.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: T.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
}, iS = {
  fontFamily: T.prop("fontFamily", "fonts"),
  fontSize: T.prop("fontSize", "fontSizes", Ve.px),
  fontWeight: T.prop("fontWeight", "fontWeights"),
  lineHeight: T.prop("lineHeight", "lineHeights"),
  letterSpacing: T.prop("letterSpacing", "letterSpacings"),
  textAlign: !0,
  fontStyle: !0,
  textIndent: !0,
  wordBreak: !0,
  overflowWrap: !0,
  textOverflow: !0,
  textTransform: !0,
  whiteSpace: !0,
  isTruncated: {
    transform(e) {
      if (e === !0)
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
    }
  },
  noOfLines: {
    static: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      //@ts-ignore
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  }
}, aS = {
  textDecorationColor: T.colors("textDecorationColor"),
  textDecoration: !0,
  textDecor: { property: "textDecoration" },
  textDecorationLine: !0,
  textDecorationStyle: !0,
  textDecorationThickness: !0,
  textUnderlineOffset: !0,
  textShadow: T.shadows("textShadow")
}, cS = {
  clipPath: !0,
  transform: T.propT("transform", Ve.transform),
  transformOrigin: !0,
  translateX: T.spaceT("--chakra-translate-x"),
  translateY: T.spaceT("--chakra-translate-y"),
  skewX: T.degreeT("--chakra-skew-x"),
  skewY: T.degreeT("--chakra-skew-y"),
  scaleX: T.prop("--chakra-scale-x"),
  scaleY: T.prop("--chakra-scale-y"),
  scale: T.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: T.degreeT("--chakra-rotate")
}, lS = {
  listStyleType: !0,
  listStylePosition: !0,
  listStylePos: T.prop("listStylePosition"),
  listStyleImage: !0,
  listStyleImg: T.prop("listStyleImage")
}, uS = {
  transition: !0,
  transitionDelay: !0,
  animation: !0,
  willChange: !0,
  transitionDuration: T.prop("transitionDuration", "transition.duration"),
  transitionProperty: T.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: T.prop(
    "transitionTimingFunction",
    "transition.easing"
  )
}, Zl = sn(
  {},
  Pi,
  Ue,
  Yx,
  Hi,
  rn,
  Xx,
  Zx,
  Jx,
  om,
  oS,
  os,
  ol,
  st,
  sS,
  iS,
  aS,
  cS,
  lS,
  uS
), dS = Object.assign({}, st, rn, Hi, om, os), sm = Object.keys(
  dS
), fS = [...Object.keys(Zl), ...nm], pS = { ...Zl, ...fo }, hS = (e) => e in pS, mS = (e) => (t) => {
  if (!t.__breakpoints)
    return e;
  const { isResponsive: n, toArrayValue: r, media: o } = t.__breakpoints, s = {};
  for (const i in e) {
    let a = Et(e[i], t);
    if (a == null)
      continue;
    if (a = lt(a) && n(a) ? r(a) : a, !Array.isArray(a)) {
      s[i] = a;
      continue;
    }
    const c = a.slice(0, o.length).length;
    for (let l = 0; l < c; l += 1) {
      const u = o == null ? void 0 : o[l];
      if (!u) {
        s[i] = a[l];
        continue;
      }
      s[u] = s[u] || {}, a[l] != null && (s[u][i] = a[l]);
    }
  }
  return s;
};
function gS(e) {
  const t = [];
  let n = "", r = !1;
  for (let o = 0; o < e.length; o++) {
    const s = e[o];
    s === "(" ? (r = !0, n += s) : s === ")" ? (r = !1, n += s) : s === "," && !r ? (t.push(n), n = "") : n += s;
  }
  return n = n.trim(), n && t.push(n), t;
}
function yS(e) {
  return /^var\(--.+\)$/.test(e);
}
const bS = (e, t) => e.startsWith("--") && typeof t == "string" && !yS(t), vS = (e, t) => {
  if (t == null)
    return t;
  const n = (i) => {
    var a, c;
    return (c = (a = e.__cssMap) == null ? void 0 : a[i]) == null ? void 0 : c.varRef;
  }, r = (i) => n(i) ?? i, [o, s] = gS(t);
  return t = n(o) ?? r(s) ?? r(t), t;
};
function xS(e) {
  const { configs: t = {}, pseudos: n = {}, theme: r } = e, o = (s, i = !1) => {
    var u;
    const a = Et(s, r), c = mS(a)(r);
    let l = {};
    for (let d in c) {
      const f = c[d];
      let p = Et(f, r);
      d in n && (d = n[d]), bS(d, p) && (p = vS(r, p));
      let m = t[d];
      if (m === !0 && (m = { property: d }), lt(p)) {
        l[d] = l[d] ?? {}, l[d] = sn(
          {},
          l[d],
          o(p, !0)
        );
        continue;
      }
      let g = ((u = m == null ? void 0 : m.transform) == null ? void 0 : u.call(m, p, r, a)) ?? p;
      g = m != null && m.processResult ? o(g, !0) : g;
      const y = Et(m == null ? void 0 : m.property, r);
      if (!i && (m != null && m.static)) {
        const S = Et(m.static, r);
        l = sn({}, l, S);
      }
      if (y && Array.isArray(y)) {
        for (const S of y)
          l[S] = g;
        continue;
      }
      if (y) {
        y === "&" && lt(g) ? l = sn({}, l, g) : l[y] = g;
        continue;
      }
      if (lt(g)) {
        l = sn({}, l, g);
        continue;
      }
      l[d] = g;
    }
    return l;
  };
  return o;
}
const im = (e) => (t) => xS({
  theme: t,
  pseudos: fo,
  configs: Zl
})(e);
function oL(e) {
  return e;
}
function sL(e) {
  return e;
}
function ot(e) {
  return {
    definePartsStyle(t) {
      return t;
    },
    defineMultiStyleConfig(t) {
      return { parts: e, ...t };
    }
  };
}
function SS(e, t, n) {
  var r, o;
  return ((o = (r = e.__cssMap) == null ? void 0 : r[`${t}.${n}`]) == null ? void 0 : o.varRef) ?? n;
}
function wS(e, t) {
  if (Array.isArray(e))
    return e;
  if (lt(e))
    return t(e);
  if (e != null)
    return [e];
}
function kS(e, t) {
  for (let n = t + 1; n < e.length; n++)
    if (e[n] != null)
      return n;
  return -1;
}
function PS(e) {
  const t = e.__breakpoints;
  return function(r, o, s, i) {
    var f, p;
    if (!t)
      return;
    const a = {}, c = wS(s, t.toArrayValue);
    if (!c)
      return a;
    const l = c.length, u = l === 1, d = !!r.parts;
    for (let m = 0; m < l; m++) {
      const g = t.details[m], y = t.details[kS(c, m)], S = Yo(g.minW, y == null ? void 0 : y._minW), b = Et((f = r[o]) == null ? void 0 : f[c[m]], i);
      if (b) {
        if (d) {
          (p = r.parts) == null || p.forEach((v) => {
            sn(a, {
              [v]: u ? b[v] : { [S]: b[v] }
            });
          });
          continue;
        }
        if (!d) {
          u ? sn(a, b) : a[S] = b;
          continue;
        }
        a[S] = b;
      }
    }
    return a;
  };
}
function CS(e) {
  return (t) => {
    const { variant: n, size: r, theme: o } = t, s = PS(o);
    return sn(
      {},
      Et(e.baseStyle ?? {}, t),
      s(e, "sizes", r, t),
      s(e, "variants", n, t)
    );
  };
}
function Ae(e) {
  return Rs(e, ["styleConfig", "size", "variant", "colorScheme"]);
}
function am(e) {
  return lt(e) && e.reference ? e.reference : String(e);
}
const ua = (e, ...t) => t.map(am).join(` ${e} `).replace(/calc/g, ""), Nd = (...e) => `calc(${ua("+", ...e)})`, Md = (...e) => `calc(${ua("-", ...e)})`, sl = (...e) => `calc(${ua("*", ...e)})`, jd = (...e) => `calc(${ua("/", ...e)})`, Dd = (e) => {
  const t = am(e);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : `-${t}` : sl(t, -1);
}, Fn = Object.assign(
  (e) => ({
    add: (...t) => Fn(Nd(e, ...t)),
    subtract: (...t) => Fn(Md(e, ...t)),
    multiply: (...t) => Fn(sl(e, ...t)),
    divide: (...t) => Fn(jd(e, ...t)),
    negate: () => Fn(Dd(e)),
    toString: () => e.toString()
  }),
  {
    add: Nd,
    subtract: Md,
    multiply: sl,
    divide: jd,
    negate: Dd
  }
);
function _S(e, t = "-") {
  return e.replace(/\s+/g, t);
}
function TS(e) {
  const t = _S(e.toString());
  return AS(ES(t));
}
function ES(e) {
  return e.includes("\\.") ? e : !Number.isInteger(parseFloat(e.toString())) ? e.replace(".", "\\.") : e;
}
function AS(e) {
  return e.replace(/[!-,/:-@[-^`{-~]/g, "\\$&");
}
function IS(e, t = "") {
  return [t, e].filter(Boolean).join("-");
}
function RS(e, t) {
  return `var(${e}${t ? `, ${t}` : ""})`;
}
function $S(e, t = "") {
  return TS(`--${IS(e, t)}`);
}
function Se(e, t, n) {
  const r = $S(e, n);
  return {
    variable: r,
    reference: RS(r, t)
  };
}
function NS(e, t) {
  const n = {};
  for (const r of t) {
    if (Array.isArray(r)) {
      const [o, s] = r;
      n[o] = Se(`${e}-${o}`, s);
      continue;
    }
    n[r] = Se(`${e}-${r}`);
  }
  return n;
}
const MS = [
  "colors",
  "borders",
  "borderWidths",
  "borderStyles",
  "fonts",
  "fontSizes",
  "fontWeights",
  "gradients",
  "letterSpacings",
  "lineHeights",
  "radii",
  "space",
  "shadows",
  "sizes",
  "zIndices",
  "transition",
  "blur",
  "breakpoints"
];
function jS(e) {
  return Bh(e, MS);
}
function DS(e) {
  return e.semanticTokens;
}
function OS(e) {
  const { __cssMap: t, __cssVars: n, __breakpoints: r, ...o } = e;
  return o;
}
function FS(e) {
  const t = jS(e), n = DS(e), r = (s) => (
    // @ts-ignore
    nm.includes(s) || s === "default"
  ), o = {};
  return _d(t, (s, i) => {
    s != null && (o[i.join(".")] = { isSemantic: !1, value: s });
  }), _d(
    n,
    (s, i) => {
      s != null && (o[i.join(".")] = { isSemantic: !0, value: s });
    },
    {
      stop: (s) => Object.keys(s).every(r)
    }
  ), o;
}
function Od(e, t) {
  return Se(String(e).replace(/\./g, "-"), void 0, t);
}
function BS(e) {
  var i;
  const t = FS(e), n = (i = e.config) == null ? void 0 : i.cssVarPrefix;
  let r = {};
  const o = {};
  function s(a, c) {
    const u = [String(a).split(".")[0], c].join(".");
    if (!t[u])
      return c;
    const { reference: f } = Od(u, n);
    return f;
  }
  for (const [a, c] of Object.entries(t)) {
    const { isSemantic: l, value: u } = c, { variable: d, reference: f } = Od(a, n);
    if (!l) {
      if (a.startsWith("space")) {
        const m = a.split("."), [g, ...y] = m, S = `${g}.-${y.join(".")}`, b = Fn.negate(u), v = Fn.negate(f);
        o[S] = {
          value: b,
          var: d,
          varRef: v
        };
      }
      r[d] = u, o[a] = {
        value: u,
        var: d,
        varRef: f
      };
      continue;
    }
    const p = lt(u) ? u : { default: u };
    r = sn(
      r,
      Object.entries(p).reduce(
        (m, [g, y]) => {
          if (!y)
            return m;
          const S = s(a, `${y}`);
          if (g === "default")
            return m[d] = S, m;
          const b = (fo == null ? void 0 : fo[g]) ?? g;
          return m[b] = { [d]: S }, m;
        },
        {}
      )
    ), o[a] = {
      value: f,
      var: d,
      varRef: f
    };
  }
  return {
    cssVars: r,
    cssMap: o
  };
}
function LS(e) {
  const t = OS(e), {
    /**
     * This is more like a dictionary of tokens users will type `green.500`,
     * and their equivalent css variable.
     */
    cssMap: n,
    /**
     * The extracted css variables will be stored here, and used in
     * the emotion's <Global/> component to attach variables to `:root`
     */
    cssVars: r
  } = BS(t);
  return Object.assign(t, {
    __cssVars: { ...{
      "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
      "--chakra-ring-offset-width": "0px",
      "--chakra-ring-offset-color": "#fff",
      "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
      "--chakra-ring-offset-shadow": "0 0 #0000",
      "--chakra-ring-shadow": "0 0 #0000",
      "--chakra-space-x-reverse": "0",
      "--chakra-space-y-reverse": "0"
    }, ...r },
    __cssMap: n,
    __breakpoints: T0(t.breakpoints)
  }), t;
}
function qe(e, t = {}) {
  let n = !1;
  function r() {
    if (!n) {
      n = !0;
      return;
    }
    throw new Error(
      "[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?"
    );
  }
  function o(...u) {
    r();
    for (const d of u)
      t[d] = c(d);
    return qe(e, t);
  }
  function s(...u) {
    for (const d of u)
      d in t || (t[d] = c(d));
    return qe(e, t);
  }
  function i() {
    return Object.fromEntries(
      Object.entries(t).map(([d, f]) => [d, f.selector])
    );
  }
  function a() {
    return Object.fromEntries(
      Object.entries(t).map(([d, f]) => [d, f.className])
    );
  }
  function c(u) {
    const p = `chakra-${(["container", "root"].includes(u ?? "") ? [e] : [e, u]).filter(Boolean).join("__")}`;
    return {
      className: p,
      selector: `.${p}`,
      toString: () => u
    };
  }
  return {
    parts: o,
    toPart: c,
    extend: s,
    selectors: i,
    classnames: a,
    get keys() {
      return Object.keys(t);
    },
    __type: {}
  };
}
const VS = qe("accordion").parts(
  "root",
  "container",
  "button",
  "panel",
  "icon"
), zS = qe("alert").parts(
  "title",
  "description",
  "container",
  "icon",
  "spinner"
), WS = qe("avatar").parts(
  "label",
  "badge",
  "container",
  "excessLabel",
  "group"
), HS = qe("breadcrumb").parts(
  "link",
  "item",
  "container",
  "separator"
), iL = qe("button").parts(), US = qe("checkbox").parts(
  "control",
  "icon",
  "container",
  "label"
), aL = qe("progress").parts(
  "track",
  "filledTrack",
  "label"
), GS = qe("drawer").parts(
  "overlay",
  "dialogContainer",
  "dialog",
  "header",
  "closeButton",
  "body",
  "footer"
), qS = qe("editable").parts(
  "preview",
  "input",
  "textarea"
), KS = qe("form").parts(
  "container",
  "requiredIndicator",
  "helperText"
), YS = qe("formError").parts("text", "icon"), XS = qe("input").parts(
  "addon",
  "field",
  "element",
  "group"
), ZS = qe("list").parts("container", "item", "icon"), JS = qe("menu").parts(
  "button",
  "list",
  "item",
  "groupTitle",
  "icon",
  "command",
  "divider"
), QS = qe("modal").parts(
  "overlay",
  "dialogContainer",
  "dialog",
  "header",
  "closeButton",
  "body",
  "footer"
), ew = qe("numberinput").parts(
  "root",
  "field",
  "stepperGroup",
  "stepper"
), cL = qe("pininput").parts("field"), tw = qe("popover").parts(
  "content",
  "header",
  "body",
  "footer",
  "popper",
  "arrow",
  "closeButton"
), nw = qe("progress").parts(
  "label",
  "filledTrack",
  "track"
), rw = qe("radio").parts(
  "container",
  "control",
  "label"
), ow = qe("select").parts("field", "icon"), sw = qe("slider").parts(
  "container",
  "track",
  "thumb",
  "filledTrack",
  "mark"
), iw = qe("stat").parts(
  "container",
  "label",
  "helpText",
  "number",
  "icon"
), aw = qe("switch").parts(
  "container",
  "track",
  "thumb",
  "label"
), cw = qe("table").parts(
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "tfoot",
  "caption"
), lw = qe("tabs").parts(
  "root",
  "tab",
  "tablist",
  "tabpanel",
  "tabpanels",
  "indicator"
), uw = qe("tag").parts(
  "container",
  "label",
  "closeButton"
), dw = qe("card").parts(
  "container",
  "header",
  "body",
  "footer"
), lL = qe("stepper").parts(
  "stepper",
  "step",
  "title",
  "description",
  "indicator",
  "separator",
  "icon",
  "number"
), { definePartsStyle: fw, defineMultiStyleConfig: pw } = ot(VS.keys), hw = {
  borderTopWidth: "1px",
  borderColor: "inherit",
  _last: {
    borderBottomWidth: "1px"
  }
}, mw = {
  transitionProperty: "common",
  transitionDuration: "normal",
  fontSize: "md",
  _focusVisible: {
    boxShadow: "outline"
  },
  _hover: {
    bg: "blackAlpha.50"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  px: "4",
  py: "2"
}, gw = {
  pt: "2",
  px: "4",
  pb: "5"
}, yw = {
  fontSize: "1.25em"
}, bw = fw({
  container: hw,
  button: mw,
  panel: gw,
  icon: yw
}), vw = pw({ baseStyle: bw });
function kr(e, t, n) {
  return Math.min(Math.max(e, n), t);
}
class xw extends Error {
  constructor(t) {
    super(`Failed to parse color: "${t}"`);
  }
}
var Xo = xw;
function Jl(e) {
  if (typeof e != "string")
    throw new Xo(e);
  if (e.trim().toLowerCase() === "transparent")
    return [0, 0, 0, 0];
  let t = e.trim();
  t = Ew.test(e) ? kw(e) : e;
  const n = Pw.exec(t);
  if (n) {
    const i = Array.from(n).slice(1);
    return [...i.slice(0, 3).map((a) => parseInt(ys(a, 2), 16)), parseInt(ys(i[3] || "f", 2), 16) / 255];
  }
  const r = Cw.exec(t);
  if (r) {
    const i = Array.from(r).slice(1);
    return [...i.slice(0, 3).map((a) => parseInt(a, 16)), parseInt(i[3] || "ff", 16) / 255];
  }
  const o = _w.exec(t);
  if (o) {
    const i = Array.from(o).slice(1);
    return [...i.slice(0, 3).map((a) => parseInt(a, 10)), parseFloat(i[3] || "1")];
  }
  const s = Tw.exec(t);
  if (s) {
    const [i, a, c, l] = Array.from(s).slice(1).map(parseFloat);
    if (kr(0, 100, a) !== a)
      throw new Xo(e);
    if (kr(0, 100, c) !== c)
      throw new Xo(e);
    return [...Aw(i, a, c), Number.isNaN(l) ? 1 : l];
  }
  throw new Xo(e);
}
function Sw(e) {
  let t = 5381, n = e.length;
  for (; n; )
    t = t * 33 ^ e.charCodeAt(--n);
  return (t >>> 0) % 2341;
}
const Fd = (e) => parseInt(e.replace(/_/g, ""), 36), ww = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce((e, t) => {
  const n = Fd(t.substring(0, 3)), r = Fd(t.substring(3)).toString(16);
  let o = "";
  for (let s = 0; s < 6 - r.length; s++)
    o += "0";
  return e[n] = `${o}${r}`, e;
}, {});
function kw(e) {
  const t = e.toLowerCase().trim(), n = ww[Sw(t)];
  if (!n)
    throw new Xo(e);
  return `#${n}`;
}
const ys = (e, t) => Array.from(Array(t)).map(() => e).join(""), Pw = new RegExp(`^#${ys("([a-f0-9])", 3)}([a-f0-9])?$`, "i"), Cw = new RegExp(`^#${ys("([a-f0-9]{2})", 3)}([a-f0-9]{2})?$`, "i"), _w = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${ys(",\\s*(\\d+)\\s*", 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, "i"), Tw = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i, Ew = /^[a-z]+$/i, Bd = (e) => Math.round(e * 255), Aw = (e, t, n) => {
  let r = n / 100;
  if (t === 0)
    return [r, r, r].map(Bd);
  const o = (e % 360 + 360) % 360 / 60, s = (1 - Math.abs(2 * r - 1)) * (t / 100), i = s * (1 - Math.abs(o % 2 - 1));
  let a = 0, c = 0, l = 0;
  o >= 0 && o < 1 ? (a = s, c = i) : o >= 1 && o < 2 ? (a = i, c = s) : o >= 2 && o < 3 ? (c = s, l = i) : o >= 3 && o < 4 ? (c = i, l = s) : o >= 4 && o < 5 ? (a = i, l = s) : o >= 5 && o < 6 && (a = s, l = i);
  const u = r - s / 2, d = a + u, f = c + u, p = l + u;
  return [d, f, p].map(Bd);
};
function Iw(e, t, n, r) {
  return `rgba(${kr(0, 255, e).toFixed()}, ${kr(0, 255, t).toFixed()}, ${kr(0, 255, n).toFixed()}, ${parseFloat(kr(0, 1, r).toFixed(3))})`;
}
function Rw(e, t) {
  const [n, r, o, s] = Jl(e);
  return Iw(n, r, o, s - t);
}
function $w(e) {
  const [t, n, r, o] = Jl(e);
  let s = (i) => {
    const a = kr(0, 255, i).toString(16);
    return a.length === 1 ? `0${a}` : a;
  };
  return `#${s(t)}${s(n)}${s(r)}${o < 1 ? s(Math.round(o * 255)) : ""}`;
}
const Nw = (e) => Object.keys(e).length === 0;
function Mw(e, t, n, r, o) {
  for (t = t.split ? t.split(".") : t, r = 0; r < t.length; r++)
    e = e ? e[t[r]] : o;
  return e === o ? n : e;
}
const Bt = (e, t, n) => {
  const r = Mw(e, `colors.${t}`, t);
  try {
    return $w(r), r;
  } catch {
    return n ?? "#000000";
  }
}, jw = (e) => {
  const [t, n, r] = Jl(e);
  return (t * 299 + n * 587 + r * 114) / 1e3;
}, Dw = (e) => (t) => {
  const n = Bt(t, e);
  return jw(n) < 128 ? "dark" : "light";
}, Ow = (e) => (t) => Dw(e)(t) === "dark", xo = (e, t) => (n) => {
  const r = Bt(n, e);
  return Rw(r, 1 - t);
};
function Ld(e = "1rem", t = "rgba(255, 255, 255, 0.15)") {
  return {
    backgroundImage: `linear-gradient(
    45deg,
    ${t} 25%,
    transparent 25%,
    transparent 50%,
    ${t} 50%,
    ${t} 75%,
    transparent 75%,
    transparent
  )`,
    backgroundSize: `${e} ${e}`
  };
}
const Fw = () => `#${Math.floor(Math.random() * 16777215).toString(16).padEnd(6, "0")}`;
function Bw(e) {
  const t = Fw();
  return !e || Nw(e) ? t : e.string && e.colors ? Vw(e.string, e.colors) : e.string && !e.colors ? Lw(e.string) : e.colors && !e.string ? zw(e.colors) : t;
}
function Lw(e) {
  let t = 0;
  if (e.length === 0)
    return t.toString();
  for (let r = 0; r < e.length; r += 1)
    t = e.charCodeAt(r) + ((t << 5) - t), t = t & t;
  let n = "#";
  for (let r = 0; r < 3; r += 1) {
    const o = t >> r * 8 & 255;
    n += `00${o.toString(16)}`.substr(-2);
  }
  return n;
}
function Vw(e, t) {
  let n = 0;
  if (e.length === 0)
    return t[0];
  for (let r = 0; r < e.length; r += 1)
    n = e.charCodeAt(r) + ((n << 5) - n), n = n & n;
  return n = (n % t.length + t.length) % t.length, t[n];
}
function zw(e) {
  return e[Math.floor(Math.random() * e.length)];
}
function ke(e, t) {
  return (n) => n.colorMode === "dark" ? t : e;
}
function Ql(e) {
  const { orientation: t, vertical: n, horizontal: r } = e;
  return t ? t === "vertical" ? n : r : {};
}
function cm(e) {
  return lt(e) && e.reference ? e.reference : String(e);
}
const da = (e, ...t) => t.map(cm).join(` ${e} `).replace(/calc/g, ""), Vd = (...e) => `calc(${da("+", ...e)})`, zd = (...e) => `calc(${da("-", ...e)})`, il = (...e) => `calc(${da("*", ...e)})`, Wd = (...e) => `calc(${da("/", ...e)})`, Hd = (e) => {
  const t = cm(e);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : `-${t}` : il(t, -1);
}, Bn = Object.assign(
  (e) => ({
    add: (...t) => Bn(Vd(e, ...t)),
    subtract: (...t) => Bn(zd(e, ...t)),
    multiply: (...t) => Bn(il(e, ...t)),
    divide: (...t) => Bn(Wd(e, ...t)),
    negate: () => Bn(Hd(e)),
    toString: () => e.toString()
  }),
  {
    add: Vd,
    subtract: zd,
    multiply: il,
    divide: Wd,
    negate: Hd
  }
);
function Ww(e) {
  return !Number.isInteger(parseFloat(e.toString()));
}
function Hw(e, t = "-") {
  return e.replace(/\s+/g, t);
}
function lm(e) {
  const t = Hw(e.toString());
  return t.includes("\\.") ? e : Ww(e) ? t.replace(".", "\\.") : e;
}
function Uw(e, t = "") {
  return [t, lm(e)].filter(Boolean).join("-");
}
function Gw(e, t) {
  return `var(${lm(e)}${t ? `, ${t}` : ""})`;
}
function qw(e, t = "") {
  return `--${Uw(e, t)}`;
}
function Pt(e, t) {
  const n = qw(e, t == null ? void 0 : t.prefix);
  return {
    variable: n,
    reference: Gw(n, Kw(t == null ? void 0 : t.fallback))
  };
}
function Kw(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.reference;
}
const { definePartsStyle: Ms, defineMultiStyleConfig: Yw } = ot(zS.keys), Xt = Se("alert-fg"), Gn = Se("alert-bg"), Xw = Ms({
  container: {
    bg: Gn.reference,
    px: "4",
    py: "3"
  },
  title: {
    fontWeight: "bold",
    lineHeight: "6",
    marginEnd: "2"
  },
  description: {
    lineHeight: "6"
  },
  icon: {
    color: Xt.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "6"
  },
  spinner: {
    color: Xt.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "5"
  }
});
function eu(e) {
  const { theme: t, colorScheme: n } = e, r = xo(`${n}.200`, 0.16)(t);
  return {
    light: `colors.${n}.100`,
    dark: r
  };
}
const Zw = Ms((e) => {
  const { colorScheme: t } = e, n = eu(e);
  return {
    container: {
      [Xt.variable]: `colors.${t}.600`,
      [Gn.variable]: n.light,
      _dark: {
        [Xt.variable]: `colors.${t}.200`,
        [Gn.variable]: n.dark
      }
    }
  };
}), Jw = Ms((e) => {
  const { colorScheme: t } = e, n = eu(e);
  return {
    container: {
      [Xt.variable]: `colors.${t}.600`,
      [Gn.variable]: n.light,
      _dark: {
        [Xt.variable]: `colors.${t}.200`,
        [Gn.variable]: n.dark
      },
      paddingStart: "3",
      borderStartWidth: "4px",
      borderStartColor: Xt.reference
    }
  };
}), Qw = Ms((e) => {
  const { colorScheme: t } = e, n = eu(e);
  return {
    container: {
      [Xt.variable]: `colors.${t}.600`,
      [Gn.variable]: n.light,
      _dark: {
        [Xt.variable]: `colors.${t}.200`,
        [Gn.variable]: n.dark
      },
      pt: "2",
      borderTopWidth: "4px",
      borderTopColor: Xt.reference
    }
  };
}), e1 = Ms((e) => {
  const { colorScheme: t } = e;
  return {
    container: {
      [Xt.variable]: "colors.white",
      [Gn.variable]: `colors.${t}.600`,
      _dark: {
        [Xt.variable]: "colors.gray.900",
        [Gn.variable]: `colors.${t}.200`
      },
      color: Xt.reference
    }
  };
}), t1 = {
  subtle: Zw,
  "left-accent": Jw,
  "top-accent": Qw,
  solid: e1
}, n1 = Yw({
  baseStyle: Xw,
  variants: t1,
  defaultProps: {
    variant: "subtle",
    colorScheme: "blue"
  }
}), um = {
  px: "1px",
  0.5: "0.125rem",
  1: "0.25rem",
  1.5: "0.375rem",
  2: "0.5rem",
  2.5: "0.625rem",
  3: "0.75rem",
  3.5: "0.875rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  12: "3rem",
  14: "3.5rem",
  16: "4rem",
  20: "5rem",
  24: "6rem",
  28: "7rem",
  32: "8rem",
  36: "9rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  60: "15rem",
  64: "16rem",
  72: "18rem",
  80: "20rem",
  96: "24rem"
}, r1 = {
  max: "max-content",
  min: "min-content",
  full: "100%",
  "3xs": "14rem",
  "2xs": "16rem",
  xs: "20rem",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  "2xl": "42rem",
  "3xl": "48rem",
  "4xl": "56rem",
  "5xl": "64rem",
  "6xl": "72rem",
  "7xl": "80rem",
  "8xl": "90rem",
  prose: "60ch"
}, o1 = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
}, dm = {
  ...um,
  ...r1,
  container: o1
}, s1 = (e) => typeof e == "function";
function Lt(e, ...t) {
  return s1(e) ? e(...t) : e;
}
const { definePartsStyle: fm, defineMultiStyleConfig: i1 } = ot(WS.keys), po = Se("avatar-border-color"), ss = Se("avatar-bg"), bs = Se("avatar-font-size"), So = Se("avatar-size"), a1 = {
  borderRadius: "full",
  border: "0.2em solid",
  borderColor: po.reference,
  [po.variable]: "white",
  _dark: {
    [po.variable]: "colors.gray.800"
  }
}, c1 = {
  bg: ss.reference,
  fontSize: bs.reference,
  width: So.reference,
  height: So.reference,
  lineHeight: "1",
  [ss.variable]: "colors.gray.200",
  _dark: {
    [ss.variable]: "colors.whiteAlpha.400"
  }
}, l1 = (e) => {
  const { name: t, theme: n } = e, r = t ? Bw({ string: t }) : "colors.gray.400", o = Ow(r)(n);
  let s = "white";
  return o || (s = "gray.800"), {
    bg: ss.reference,
    fontSize: bs.reference,
    color: s,
    borderColor: po.reference,
    verticalAlign: "top",
    width: So.reference,
    height: So.reference,
    "&:not([data-loaded])": {
      [ss.variable]: r
    },
    [po.variable]: "colors.white",
    _dark: {
      [po.variable]: "colors.gray.800"
    }
  };
}, u1 = {
  fontSize: bs.reference,
  lineHeight: "1"
}, d1 = fm((e) => ({
  badge: Lt(a1, e),
  excessLabel: Lt(c1, e),
  container: Lt(l1, e),
  label: u1
}));
function Jn(e) {
  const t = e !== "100%" ? dm[e] : void 0;
  return fm({
    container: {
      [So.variable]: t ?? e,
      [bs.variable]: `calc(${t ?? e} / 2.5)`
    },
    excessLabel: {
      [So.variable]: t ?? e,
      [bs.variable]: `calc(${t ?? e} / 2.5)`
    }
  });
}
const f1 = {
  "2xs": Jn(4),
  xs: Jn(6),
  sm: Jn(8),
  md: Jn(12),
  lg: Jn(16),
  xl: Jn(24),
  "2xl": Jn(32),
  full: Jn("100%")
}, p1 = i1({
  baseStyle: d1,
  sizes: f1,
  defaultProps: {
    size: "md"
  }
}), mt = NS("badge", ["bg", "color", "shadow"]), h1 = {
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold",
  bg: mt.bg.reference,
  color: mt.color.reference,
  boxShadow: mt.shadow.reference
}, m1 = (e) => {
  const { colorScheme: t, theme: n } = e, r = xo(`${t}.500`, 0.6)(n);
  return {
    [mt.bg.variable]: `colors.${t}.500`,
    [mt.color.variable]: "colors.white",
    _dark: {
      [mt.bg.variable]: r,
      [mt.color.variable]: "colors.whiteAlpha.800"
    }
  };
}, g1 = (e) => {
  const { colorScheme: t, theme: n } = e, r = xo(`${t}.200`, 0.16)(n);
  return {
    [mt.bg.variable]: `colors.${t}.100`,
    [mt.color.variable]: `colors.${t}.800`,
    _dark: {
      [mt.bg.variable]: r,
      [mt.color.variable]: `colors.${t}.200`
    }
  };
}, y1 = (e) => {
  const { colorScheme: t, theme: n } = e, r = xo(`${t}.200`, 0.8)(n);
  return {
    [mt.color.variable]: `colors.${t}.500`,
    _dark: {
      [mt.color.variable]: r
    },
    [mt.shadow.variable]: `inset 0 0 0px 1px ${mt.color.reference}`
  };
}, b1 = {
  solid: m1,
  subtle: g1,
  outline: y1
}, is = {
  baseStyle: h1,
  variants: b1,
  defaultProps: {
    variant: "subtle",
    colorScheme: "gray"
  }
}, { defineMultiStyleConfig: v1, definePartsStyle: x1 } = ot(HS.keys), tc = Se("breadcrumb-link-decor"), S1 = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  outline: "none",
  color: "inherit",
  textDecoration: tc.reference,
  [tc.variable]: "none",
  "&:not([aria-current=page])": {
    cursor: "pointer",
    _hover: {
      [tc.variable]: "underline"
    },
    _focusVisible: {
      boxShadow: "outline"
    }
  }
}, w1 = x1({
  link: S1
}), k1 = v1({
  baseStyle: w1
}), P1 = {
  lineHeight: "1.2",
  borderRadius: "md",
  fontWeight: "semibold",
  transitionProperty: "common",
  transitionDuration: "normal",
  _focusVisible: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    _disabled: {
      bg: "initial"
    }
  }
}, pm = (e) => {
  const { colorScheme: t, theme: n } = e;
  if (t === "gray")
    return {
      color: ke("gray.800", "whiteAlpha.900")(e),
      _hover: {
        bg: ke("gray.100", "whiteAlpha.200")(e)
      },
      _active: { bg: ke("gray.200", "whiteAlpha.300")(e) }
    };
  const r = xo(`${t}.200`, 0.12)(n), o = xo(`${t}.200`, 0.24)(n);
  return {
    color: ke(`${t}.600`, `${t}.200`)(e),
    bg: "transparent",
    _hover: {
      bg: ke(`${t}.50`, r)(e)
    },
    _active: {
      bg: ke(`${t}.100`, o)(e)
    }
  };
}, C1 = (e) => {
  const { colorScheme: t } = e, n = ke("gray.200", "whiteAlpha.300")(e);
  return {
    border: "1px solid",
    borderColor: t === "gray" ? n : "currentColor",
    ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": { marginEnd: "-1px" },
    ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": { marginBottom: "-1px" },
    ...Lt(pm, e)
  };
}, _1 = {
  yellow: {
    bg: "yellow.400",
    color: "black",
    hoverBg: "yellow.500",
    activeBg: "yellow.600"
  },
  cyan: {
    bg: "cyan.400",
    color: "black",
    hoverBg: "cyan.500",
    activeBg: "cyan.600"
  }
}, T1 = (e) => {
  const { colorScheme: t } = e;
  if (t === "gray") {
    const a = ke("gray.100", "whiteAlpha.200")(e);
    return {
      bg: a,
      color: ke("gray.800", "whiteAlpha.900")(e),
      _hover: {
        bg: ke("gray.200", "whiteAlpha.300")(e),
        _disabled: {
          bg: a
        }
      },
      _active: { bg: ke("gray.300", "whiteAlpha.400")(e) }
    };
  }
  const {
    bg: n = `${t}.500`,
    color: r = "white",
    hoverBg: o = `${t}.600`,
    activeBg: s = `${t}.700`
  } = _1[t] ?? {}, i = ke(n, `${t}.200`)(e);
  return {
    bg: i,
    color: ke(r, "gray.800")(e),
    _hover: {
      bg: ke(o, `${t}.300`)(e),
      _disabled: {
        bg: i
      }
    },
    _active: { bg: ke(s, `${t}.400`)(e) }
  };
}, E1 = (e) => {
  const { colorScheme: t } = e;
  return {
    padding: 0,
    height: "auto",
    lineHeight: "normal",
    verticalAlign: "baseline",
    color: ke(`${t}.500`, `${t}.200`)(e),
    _hover: {
      textDecoration: "underline",
      _disabled: {
        textDecoration: "none"
      }
    },
    _active: {
      color: ke(`${t}.700`, `${t}.500`)(e)
    }
  };
}, A1 = {
  bg: "none",
  color: "inherit",
  display: "inline",
  lineHeight: "inherit",
  m: "0",
  p: "0"
}, I1 = {
  ghost: pm,
  outline: C1,
  solid: T1,
  link: E1,
  unstyled: A1
}, R1 = {
  lg: {
    h: "12",
    minW: "12",
    fontSize: "lg",
    px: "6"
  },
  md: {
    h: "10",
    minW: "10",
    fontSize: "md",
    px: "4"
  },
  sm: {
    h: "8",
    minW: "8",
    fontSize: "sm",
    px: "3"
  },
  xs: {
    h: "6",
    minW: "6",
    fontSize: "xs",
    px: "2"
  }
}, $1 = {
  baseStyle: P1,
  variants: I1,
  sizes: R1,
  defaultProps: {
    variant: "solid",
    size: "md",
    colorScheme: "gray"
  }
}, { definePartsStyle: Tr, defineMultiStyleConfig: N1 } = ot(dw.keys), Ui = Se("card-bg"), Wn = Se("card-padding"), hm = Se("card-shadow"), Ci = Se("card-radius"), mm = Se("card-border-width", "0"), gm = Se("card-border-color"), M1 = Tr({
  container: {
    [Ui.variable]: "colors.chakra-body-bg",
    backgroundColor: Ui.reference,
    boxShadow: hm.reference,
    borderRadius: Ci.reference,
    color: "chakra-body-text",
    borderWidth: mm.reference,
    borderColor: gm.reference
  },
  body: {
    padding: Wn.reference,
    flex: "1 1 0%"
  },
  header: {
    padding: Wn.reference
  },
  footer: {
    padding: Wn.reference
  }
}), j1 = {
  sm: Tr({
    container: {
      [Ci.variable]: "radii.base",
      [Wn.variable]: "space.3"
    }
  }),
  md: Tr({
    container: {
      [Ci.variable]: "radii.md",
      [Wn.variable]: "space.5"
    }
  }),
  lg: Tr({
    container: {
      [Ci.variable]: "radii.xl",
      [Wn.variable]: "space.7"
    }
  })
}, D1 = {
  elevated: Tr({
    container: {
      [hm.variable]: "shadows.base",
      _dark: {
        [Ui.variable]: "colors.gray.700"
      }
    }
  }),
  outline: Tr({
    container: {
      [mm.variable]: "1px",
      [gm.variable]: "colors.chakra-border-color"
    }
  }),
  filled: Tr({
    container: {
      [Ui.variable]: "colors.chakra-subtle-bg"
    }
  }),
  unstyled: {
    body: {
      [Wn.variable]: 0
    },
    header: {
      [Wn.variable]: 0
    },
    footer: {
      [Wn.variable]: 0
    }
  }
}, O1 = N1({
  baseStyle: M1,
  variants: D1,
  sizes: j1,
  defaultProps: {
    variant: "elevated",
    size: "md"
  }
}), { definePartsStyle: _i, defineMultiStyleConfig: F1 } = ot(US.keys), as = Se("checkbox-size"), B1 = (e) => {
  const { colorScheme: t } = e;
  return {
    w: as.reference,
    h: as.reference,
    transitionProperty: "box-shadow",
    transitionDuration: "normal",
    border: "2px solid",
    borderRadius: "sm",
    borderColor: "inherit",
    color: "white",
    _checked: {
      bg: ke(`${t}.500`, `${t}.200`)(e),
      borderColor: ke(`${t}.500`, `${t}.200`)(e),
      color: ke("white", "gray.900")(e),
      _hover: {
        bg: ke(`${t}.600`, `${t}.300`)(e),
        borderColor: ke(`${t}.600`, `${t}.300`)(e)
      },
      _disabled: {
        borderColor: ke("gray.200", "transparent")(e),
        bg: ke("gray.200", "whiteAlpha.300")(e),
        color: ke("gray.500", "whiteAlpha.500")(e)
      }
    },
    _indeterminate: {
      bg: ke(`${t}.500`, `${t}.200`)(e),
      borderColor: ke(`${t}.500`, `${t}.200`)(e),
      color: ke("white", "gray.900")(e)
    },
    _disabled: {
      bg: ke("gray.100", "whiteAlpha.100")(e),
      borderColor: ke("gray.100", "transparent")(e)
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    _invalid: {
      borderColor: ke("red.500", "red.300")(e)
    }
  };
}, L1 = {
  _disabled: { cursor: "not-allowed" }
}, V1 = {
  userSelect: "none",
  _disabled: { opacity: 0.4 }
}, z1 = {
  transitionProperty: "transform",
  transitionDuration: "normal"
}, W1 = _i((e) => ({
  icon: z1,
  container: L1,
  control: Lt(B1, e),
  label: V1
})), H1 = {
  sm: _i({
    control: { [as.variable]: "sizes.3" },
    label: { fontSize: "sm" },
    icon: { fontSize: "3xs" }
  }),
  md: _i({
    control: { [as.variable]: "sizes.4" },
    label: { fontSize: "md" },
    icon: { fontSize: "2xs" }
  }),
  lg: _i({
    control: { [as.variable]: "sizes.5" },
    label: { fontSize: "lg" },
    icon: { fontSize: "2xs" }
  })
}, nr = F1({
  baseStyle: W1,
  sizes: H1,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), cs = Pt("close-button-size"), Bo = Pt("close-button-bg"), U1 = {
  w: [cs.reference],
  h: [cs.reference],
  borderRadius: "md",
  transitionProperty: "common",
  transitionDuration: "normal",
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    [Bo.variable]: "colors.blackAlpha.100",
    _dark: {
      [Bo.variable]: "colors.whiteAlpha.100"
    }
  },
  _active: {
    [Bo.variable]: "colors.blackAlpha.200",
    _dark: {
      [Bo.variable]: "colors.whiteAlpha.200"
    }
  },
  _focusVisible: {
    boxShadow: "outline"
  },
  bg: Bo.reference
}, G1 = {
  lg: {
    [cs.variable]: "sizes.10",
    fontSize: "md"
  },
  md: {
    [cs.variable]: "sizes.8",
    fontSize: "xs"
  },
  sm: {
    [cs.variable]: "sizes.6",
    fontSize: "2xs"
  }
}, q1 = {
  baseStyle: U1,
  sizes: G1,
  defaultProps: {
    size: "md"
  }
}, { variants: K1, defaultProps: Y1 } = is, X1 = {
  fontFamily: "mono",
  fontSize: "sm",
  px: "0.2em",
  borderRadius: "sm",
  bg: mt.bg.reference,
  color: mt.color.reference,
  boxShadow: mt.shadow.reference
}, Z1 = {
  baseStyle: X1,
  variants: K1,
  defaultProps: Y1
}, J1 = {
  w: "100%",
  mx: "auto",
  maxW: "prose",
  px: "4"
}, Q1 = {
  baseStyle: J1
}, ek = {
  opacity: 0.6,
  borderColor: "inherit"
}, tk = {
  borderStyle: "solid"
}, nk = {
  borderStyle: "dashed"
}, rk = {
  solid: tk,
  dashed: nk
}, ok = {
  baseStyle: ek,
  variants: rk,
  defaultProps: {
    variant: "solid"
  }
}, { definePartsStyle: al, defineMultiStyleConfig: sk } = ot(GS.keys), nc = Se("drawer-bg"), rc = Se("drawer-box-shadow");
function Ur(e) {
  return al(e === "full" ? {
    dialog: { maxW: "100vw", h: "100vh" }
  } : {
    dialog: { maxW: e }
  });
}
const ik = {
  bg: "blackAlpha.600",
  zIndex: "modal"
}, ak = {
  display: "flex",
  zIndex: "modal",
  justifyContent: "center"
}, ck = (e) => {
  const { isFullHeight: t } = e;
  return {
    ...t && { height: "100vh" },
    zIndex: "modal",
    maxH: "100vh",
    color: "inherit",
    [nc.variable]: "colors.white",
    [rc.variable]: "shadows.lg",
    _dark: {
      [nc.variable]: "colors.gray.700",
      [rc.variable]: "shadows.dark-lg"
    },
    bg: nc.reference,
    boxShadow: rc.reference
  };
}, lk = {
  px: "6",
  py: "4",
  fontSize: "xl",
  fontWeight: "semibold"
}, uk = {
  position: "absolute",
  top: "2",
  insetEnd: "3"
}, dk = {
  px: "6",
  py: "2",
  flex: "1",
  overflow: "auto"
}, fk = {
  px: "6",
  py: "4"
}, pk = al((e) => ({
  overlay: ik,
  dialogContainer: ak,
  dialog: Lt(ck, e),
  header: lk,
  closeButton: uk,
  body: dk,
  footer: fk
})), hk = {
  xs: Ur("xs"),
  sm: Ur("md"),
  md: Ur("lg"),
  lg: Ur("2xl"),
  xl: Ur("4xl"),
  full: Ur("full")
}, mk = sk({
  baseStyle: pk,
  sizes: hk,
  defaultProps: {
    size: "xs"
  }
}), { definePartsStyle: gk, defineMultiStyleConfig: yk } = ot(qS.keys), bk = {
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal"
}, vk = {
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focusVisible: { boxShadow: "outline" },
  _placeholder: { opacity: 0.6 }
}, xk = {
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focusVisible: { boxShadow: "outline" },
  _placeholder: { opacity: 0.6 }
}, Sk = gk({
  preview: bk,
  input: vk,
  textarea: xk
}), wk = yk({
  baseStyle: Sk
}), { definePartsStyle: kk, defineMultiStyleConfig: Pk } = ot(KS.keys), ho = Se("form-control-color"), Ck = {
  marginStart: "1",
  [ho.variable]: "colors.red.500",
  _dark: {
    [ho.variable]: "colors.red.300"
  },
  color: ho.reference
}, _k = {
  mt: "2",
  [ho.variable]: "colors.gray.600",
  _dark: {
    [ho.variable]: "colors.whiteAlpha.600"
  },
  color: ho.reference,
  lineHeight: "normal",
  fontSize: "sm"
}, Tk = kk({
  container: {
    width: "100%",
    position: "relative"
  },
  requiredIndicator: Ck,
  helperText: _k
}), Ek = Pk({
  baseStyle: Tk
}), { definePartsStyle: Ak, defineMultiStyleConfig: Ik } = ot(YS.keys), mo = Se("form-error-color"), Rk = {
  [mo.variable]: "colors.red.500",
  _dark: {
    [mo.variable]: "colors.red.300"
  },
  color: mo.reference,
  mt: "2",
  fontSize: "sm",
  lineHeight: "normal"
}, $k = {
  marginEnd: "0.5em",
  [mo.variable]: "colors.red.500",
  _dark: {
    [mo.variable]: "colors.red.300"
  },
  color: mo.reference
}, Nk = Ak({
  text: Rk,
  icon: $k
}), Mk = Ik({
  baseStyle: Nk
}), jk = {
  fontSize: "md",
  marginEnd: "3",
  mb: "2",
  fontWeight: "medium",
  transitionProperty: "common",
  transitionDuration: "normal",
  opacity: 1,
  _disabled: {
    opacity: 0.4
  }
}, Dk = {
  baseStyle: jk
}, Ok = {
  fontFamily: "heading",
  fontWeight: "bold"
}, Fk = {
  "4xl": {
    fontSize: ["6xl", null, "7xl"],
    lineHeight: 1
  },
  "3xl": {
    fontSize: ["5xl", null, "6xl"],
    lineHeight: 1
  },
  "2xl": {
    fontSize: ["4xl", null, "5xl"],
    lineHeight: [1.2, null, 1]
  },
  xl: {
    fontSize: ["3xl", null, "4xl"],
    lineHeight: [1.33, null, 1.2]
  },
  lg: {
    fontSize: ["2xl", null, "3xl"],
    lineHeight: [1.33, null, 1.2]
  },
  md: {
    fontSize: "xl",
    lineHeight: 1.2
  },
  sm: {
    fontSize: "md",
    lineHeight: 1.2
  },
  xs: {
    fontSize: "sm",
    lineHeight: 1.2
  }
}, Bk = {
  baseStyle: Ok,
  sizes: Fk,
  defaultProps: {
    size: "xl"
  }
}, { definePartsStyle: Vn, defineMultiStyleConfig: Lk } = ot(XS.keys), Qr = Se("input-height"), eo = Se("input-font-size"), to = Se("input-padding"), no = Se("input-border-radius"), Vk = Vn({
  addon: {
    height: Qr.reference,
    fontSize: eo.reference,
    px: to.reference,
    borderRadius: no.reference
  },
  field: {
    width: "100%",
    height: Qr.reference,
    fontSize: eo.reference,
    px: to.reference,
    borderRadius: no.reference,
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  }
}), Qn = {
  lg: {
    [eo.variable]: "fontSizes.lg",
    [to.variable]: "space.4",
    [no.variable]: "radii.md",
    [Qr.variable]: "sizes.12"
  },
  md: {
    [eo.variable]: "fontSizes.md",
    [to.variable]: "space.4",
    [no.variable]: "radii.md",
    [Qr.variable]: "sizes.10"
  },
  sm: {
    [eo.variable]: "fontSizes.sm",
    [to.variable]: "space.3",
    [no.variable]: "radii.sm",
    [Qr.variable]: "sizes.8"
  },
  xs: {
    [eo.variable]: "fontSizes.xs",
    [to.variable]: "space.2",
    [no.variable]: "radii.sm",
    [Qr.variable]: "sizes.6"
  }
}, zk = {
  lg: Vn({
    field: Qn.lg,
    group: Qn.lg
  }),
  md: Vn({
    field: Qn.md,
    group: Qn.md
  }),
  sm: Vn({
    field: Qn.sm,
    group: Qn.sm
  }),
  xs: Vn({
    field: Qn.xs,
    group: Qn.xs
  })
};
function tu(e) {
  const { focusBorderColor: t, errorBorderColor: n } = e;
  return {
    focusBorderColor: t || ke("blue.500", "blue.300")(e),
    errorBorderColor: n || ke("red.500", "red.300")(e)
  };
}
const Wk = Vn((e) => {
  const { theme: t } = e, { focusBorderColor: n, errorBorderColor: r } = tu(e);
  return {
    field: {
      border: "1px solid",
      borderColor: "inherit",
      bg: "inherit",
      _hover: {
        borderColor: ke("gray.300", "whiteAlpha.400")(e)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: Bt(t, r),
        boxShadow: `0 0 0 1px ${Bt(t, r)}`
      },
      _focusVisible: {
        zIndex: 1,
        borderColor: Bt(t, n),
        boxShadow: `0 0 0 1px ${Bt(t, n)}`
      }
    },
    addon: {
      border: "1px solid",
      borderColor: ke("inherit", "whiteAlpha.50")(e),
      bg: ke("gray.100", "whiteAlpha.300")(e)
    }
  };
}), Hk = Vn((e) => {
  const { theme: t } = e, { focusBorderColor: n, errorBorderColor: r } = tu(e);
  return {
    field: {
      border: "2px solid",
      borderColor: "transparent",
      bg: ke("gray.100", "whiteAlpha.50")(e),
      _hover: {
        bg: ke("gray.200", "whiteAlpha.100")(e)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: Bt(t, r)
      },
      _focusVisible: {
        bg: "transparent",
        borderColor: Bt(t, n)
      }
    },
    addon: {
      border: "2px solid",
      borderColor: "transparent",
      bg: ke("gray.100", "whiteAlpha.50")(e)
    }
  };
}), Uk = Vn((e) => {
  const { theme: t } = e, { focusBorderColor: n, errorBorderColor: r } = tu(e);
  return {
    field: {
      borderBottom: "1px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent",
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: Bt(t, r),
        boxShadow: `0px 1px 0px 0px ${Bt(t, r)}`
      },
      _focusVisible: {
        borderColor: Bt(t, n),
        boxShadow: `0px 1px 0px 0px ${Bt(t, n)}`
      }
    },
    addon: {
      borderBottom: "2px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent"
    }
  };
}), Gk = Vn({
  field: {
    bg: "transparent",
    px: "0",
    height: "auto"
  },
  addon: {
    bg: "transparent",
    px: "0",
    height: "auto"
  }
}), qk = {
  outline: Wk,
  filled: Hk,
  flushed: Uk,
  unstyled: Gk
}, Ge = Lk({
  baseStyle: Vk,
  sizes: zk,
  variants: qk,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
}), oc = Se("kbd-bg"), Kk = {
  [oc.variable]: "colors.gray.100",
  _dark: {
    [oc.variable]: "colors.whiteAlpha.100"
  },
  bg: oc.reference,
  borderRadius: "md",
  borderWidth: "1px",
  borderBottomWidth: "3px",
  fontSize: "0.8em",
  fontWeight: "bold",
  lineHeight: "normal",
  px: "0.4em",
  whiteSpace: "nowrap"
}, Yk = {
  baseStyle: Kk
}, Xk = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  cursor: "pointer",
  textDecoration: "none",
  outline: "none",
  color: "inherit",
  _hover: {
    textDecoration: "underline"
  },
  _focusVisible: {
    boxShadow: "outline"
  }
}, Zk = {
  baseStyle: Xk
}, { defineMultiStyleConfig: Jk, definePartsStyle: Qk } = ot(ZS.keys), eP = {
  marginEnd: "2",
  display: "inline",
  verticalAlign: "text-bottom"
}, tP = Qk({
  icon: eP
}), nP = Jk({
  baseStyle: tP
}), { defineMultiStyleConfig: rP, definePartsStyle: oP } = ot(JS.keys), Pn = Se("menu-bg"), sc = Se("menu-shadow"), sP = {
  [Pn.variable]: "#fff",
  [sc.variable]: "shadows.sm",
  _dark: {
    [Pn.variable]: "colors.gray.700",
    [sc.variable]: "shadows.dark-lg"
  },
  color: "inherit",
  minW: "3xs",
  py: "2",
  zIndex: "dropdown",
  borderRadius: "md",
  borderWidth: "1px",
  bg: Pn.reference,
  boxShadow: sc.reference
}, iP = {
  py: "1.5",
  px: "3",
  transitionProperty: "background",
  transitionDuration: "ultra-fast",
  transitionTimingFunction: "ease-in",
  _focus: {
    [Pn.variable]: "colors.gray.100",
    _dark: {
      [Pn.variable]: "colors.whiteAlpha.100"
    }
  },
  _active: {
    [Pn.variable]: "colors.gray.200",
    _dark: {
      [Pn.variable]: "colors.whiteAlpha.200"
    }
  },
  _expanded: {
    [Pn.variable]: "colors.gray.100",
    _dark: {
      [Pn.variable]: "colors.whiteAlpha.100"
    }
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  bg: Pn.reference
}, aP = {
  mx: 4,
  my: 2,
  fontWeight: "semibold",
  fontSize: "sm"
}, cP = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0
}, lP = {
  opacity: 0.6
}, uP = {
  border: 0,
  borderBottom: "1px solid",
  borderColor: "inherit",
  my: "2",
  opacity: 0.6
}, dP = {
  transitionProperty: "common",
  transitionDuration: "normal"
}, fP = oP({
  button: dP,
  list: sP,
  item: iP,
  groupTitle: aP,
  icon: cP,
  command: lP,
  divider: uP
}), pP = rP({
  baseStyle: fP
}), { defineMultiStyleConfig: hP, definePartsStyle: cl } = ot(QS.keys), ic = Se("modal-bg"), ac = Se("modal-shadow"), mP = {
  bg: "blackAlpha.600",
  zIndex: "modal"
}, gP = (e) => {
  const { isCentered: t, scrollBehavior: n } = e;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: t ? "center" : "flex-start",
    overflow: n === "inside" ? "hidden" : "auto",
    overscrollBehaviorY: "none"
  };
}, yP = (e) => {
  const { isCentered: t, scrollBehavior: n } = e;
  return {
    borderRadius: "md",
    color: "inherit",
    my: t ? "auto" : "16",
    mx: t ? "auto" : void 0,
    zIndex: "modal",
    maxH: n === "inside" ? "calc(100% - 7.5rem)" : void 0,
    [ic.variable]: "colors.white",
    [ac.variable]: "shadows.lg",
    _dark: {
      [ic.variable]: "colors.gray.700",
      [ac.variable]: "shadows.dark-lg"
    },
    bg: ic.reference,
    boxShadow: ac.reference
  };
}, bP = {
  px: "6",
  py: "4",
  fontSize: "xl",
  fontWeight: "semibold"
}, vP = {
  position: "absolute",
  top: "2",
  insetEnd: "3"
}, xP = (e) => {
  const { scrollBehavior: t } = e;
  return {
    px: "6",
    py: "2",
    flex: "1",
    overflow: t === "inside" ? "auto" : void 0
  };
}, SP = {
  px: "6",
  py: "4"
}, wP = cl((e) => ({
  overlay: mP,
  dialogContainer: Lt(gP, e),
  dialog: Lt(yP, e),
  header: bP,
  closeButton: vP,
  body: Lt(xP, e),
  footer: SP
}));
function mn(e) {
  return cl(e === "full" ? {
    dialog: {
      maxW: "100vw",
      minH: "$100vh",
      my: "0",
      borderRadius: "0"
    }
  } : {
    dialog: { maxW: e }
  });
}
const kP = {
  xs: mn("xs"),
  sm: mn("sm"),
  md: mn("md"),
  lg: mn("lg"),
  xl: mn("xl"),
  "2xl": mn("2xl"),
  "3xl": mn("3xl"),
  "4xl": mn("4xl"),
  "5xl": mn("5xl"),
  "6xl": mn("6xl"),
  full: mn("full")
}, PP = hP({
  baseStyle: wP,
  sizes: kP,
  defaultProps: { size: "md" }
}), ym = {
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
    3: ".75rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem"
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  fonts: {
    heading: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    body: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'
  },
  fontSizes: {
    "3xs": "0.45rem",
    "2xs": "0.625rem",
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
    "9xl": "8rem"
  }
}, { defineMultiStyleConfig: CP, definePartsStyle: bm } = ot(ew.keys), nu = Pt("number-input-stepper-width"), vm = Pt("number-input-input-padding"), _P = Bn(nu).add("0.5rem").toString(), cc = Pt("number-input-bg"), lc = Pt("number-input-color"), uc = Pt("number-input-border-color"), TP = {
  [nu.variable]: "sizes.6",
  [vm.variable]: _P
}, EP = (e) => {
  var t;
  return ((t = Lt(Ge.baseStyle, e)) == null ? void 0 : t.field) ?? {};
}, AP = {
  width: nu.reference
}, IP = {
  borderStart: "1px solid",
  borderStartColor: uc.reference,
  color: lc.reference,
  bg: cc.reference,
  [lc.variable]: "colors.chakra-body-text",
  [uc.variable]: "colors.chakra-border-color",
  _dark: {
    [lc.variable]: "colors.whiteAlpha.800",
    [uc.variable]: "colors.whiteAlpha.300"
  },
  _active: {
    [cc.variable]: "colors.gray.200",
    _dark: {
      [cc.variable]: "colors.whiteAlpha.300"
    }
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  }
}, RP = bm((e) => ({
  root: TP,
  field: Lt(EP, e) ?? {},
  stepperGroup: AP,
  stepper: IP
}));
function oi(e) {
  var s, i;
  const t = (s = Ge.sizes) == null ? void 0 : s[e], n = {
    lg: "md",
    md: "md",
    sm: "sm",
    xs: "sm"
  }, r = ((i = t.field) == null ? void 0 : i.fontSize) ?? "md", o = ym.fontSizes[r];
  return bm({
    field: {
      ...t.field,
      paddingInlineEnd: vm.reference,
      verticalAlign: "top"
    },
    stepper: {
      fontSize: Bn(o).multiply(0.75).toString(),
      _first: {
        borderTopEndRadius: n[e]
      },
      _last: {
        borderBottomEndRadius: n[e],
        mt: "-1px",
        borderTopWidth: 1
      }
    }
  });
}
const $P = {
  xs: oi("xs"),
  sm: oi("sm"),
  md: oi("md"),
  lg: oi("lg")
}, NP = CP({
  baseStyle: RP,
  sizes: $P,
  variants: Ge.variants,
  defaultProps: Ge.defaultProps
});
var dh;
const MP = {
  ...(dh = Ge.baseStyle) == null ? void 0 : dh.field,
  textAlign: "center"
}, jP = {
  lg: {
    fontSize: "lg",
    w: 12,
    h: 12,
    borderRadius: "md"
  },
  md: {
    fontSize: "md",
    w: 10,
    h: 10,
    borderRadius: "md"
  },
  sm: {
    fontSize: "sm",
    w: 8,
    h: 8,
    borderRadius: "sm"
  },
  xs: {
    fontSize: "xs",
    w: 6,
    h: 6,
    borderRadius: "sm"
  }
};
var fh;
const DP = {
  outline: (e) => {
    var t, n;
    return ((n = Lt((t = Ge.variants) == null ? void 0 : t.outline, e)) == null ? void 0 : n.field) ?? {};
  },
  flushed: (e) => {
    var t, n;
    return ((n = Lt((t = Ge.variants) == null ? void 0 : t.flushed, e)) == null ? void 0 : n.field) ?? {};
  },
  filled: (e) => {
    var t, n;
    return ((n = Lt((t = Ge.variants) == null ? void 0 : t.filled, e)) == null ? void 0 : n.field) ?? {};
  },
  unstyled: ((fh = Ge.variants) == null ? void 0 : fh.unstyled.field) ?? {}
}, OP = {
  baseStyle: MP,
  sizes: jP,
  variants: DP,
  defaultProps: Ge.defaultProps
}, { defineMultiStyleConfig: FP, definePartsStyle: BP } = ot(tw.keys), si = Pt("popper-bg"), LP = Pt("popper-arrow-bg"), Ud = Pt("popper-arrow-shadow-color"), VP = {
  zIndex: "popover"
}, zP = {
  [si.variable]: "colors.white",
  bg: si.reference,
  [LP.variable]: si.reference,
  [Ud.variable]: "colors.gray.200",
  _dark: {
    [si.variable]: "colors.gray.700",
    [Ud.variable]: "colors.whiteAlpha.300"
  },
  width: "xs",
  border: "1px solid",
  borderColor: "inherit",
  borderRadius: "md",
  boxShadow: "sm",
  zIndex: "inherit",
  _focusVisible: {
    outline: 0,
    boxShadow: "outline"
  }
}, WP = {
  px: 3,
  py: 2,
  borderBottomWidth: "1px"
}, HP = {
  px: 3,
  py: 2
}, UP = {
  px: 3,
  py: 2,
  borderTopWidth: "1px"
}, GP = {
  position: "absolute",
  borderRadius: "md",
  top: 1,
  insetEnd: 2,
  padding: 2
}, qP = BP({
  popper: VP,
  content: zP,
  header: WP,
  body: HP,
  footer: UP,
  closeButton: GP
}), KP = FP({
  baseStyle: qP
}), { defineMultiStyleConfig: YP, definePartsStyle: Zo } = ot(nw.keys), XP = (e) => {
  const { colorScheme: t, theme: n, isIndeterminate: r, hasStripe: o } = e, s = ke(
    Ld(),
    Ld("1rem", "rgba(0,0,0,0.1)")
  )(e), i = ke(`${t}.500`, `${t}.200`)(e), a = `linear-gradient(
    to right,
    transparent 0%,
    ${Bt(n, i)} 50%,
    transparent 100%
  )`;
  return {
    ...!r && o && s,
    ...r ? { bgImage: a } : { bgColor: i }
  };
}, ZP = {
  lineHeight: "1",
  fontSize: "0.25em",
  fontWeight: "bold",
  color: "white"
}, JP = (e) => ({
  bg: ke("gray.100", "whiteAlpha.300")(e)
}), QP = (e) => ({
  transitionProperty: "common",
  transitionDuration: "slow",
  ...XP(e)
}), eC = Zo((e) => ({
  label: ZP,
  filledTrack: QP(e),
  track: JP(e)
})), tC = {
  xs: Zo({
    track: { h: "1" }
  }),
  sm: Zo({
    track: { h: "2" }
  }),
  md: Zo({
    track: { h: "3" }
  }),
  lg: Zo({
    track: { h: "4" }
  })
}, nC = YP({
  sizes: tC,
  baseStyle: eC,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: rC, definePartsStyle: Ti } = ot(rw.keys), oC = (e) => {
  var n;
  const t = (n = Lt(nr.baseStyle, e)) == null ? void 0 : n.control;
  return {
    ...t,
    borderRadius: "full",
    _checked: {
      ...t == null ? void 0 : t._checked,
      _before: {
        content: '""',
        display: "inline-block",
        pos: "relative",
        w: "50%",
        h: "50%",
        borderRadius: "50%",
        bg: "currentColor"
      }
    }
  };
}, sC = Ti((e) => {
  var t, n;
  return {
    label: (t = nr.baseStyle) == null ? void 0 : t.call(nr, e).label,
    container: (n = nr.baseStyle) == null ? void 0 : n.call(nr, e).container,
    control: oC(e)
  };
}), iC = {
  md: Ti({
    control: { w: "4", h: "4" },
    label: { fontSize: "md" }
  }),
  lg: Ti({
    control: { w: "5", h: "5" },
    label: { fontSize: "lg" }
  }),
  sm: Ti({
    control: { width: "3", height: "3" },
    label: { fontSize: "sm" }
  })
}, aC = rC({
  baseStyle: sC,
  sizes: iC,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: cC, definePartsStyle: lC } = ot(ow.keys), ii = Se("select-bg");
var ph;
const uC = {
  ...(ph = Ge.baseStyle) == null ? void 0 : ph.field,
  appearance: "none",
  paddingBottom: "1px",
  lineHeight: "normal",
  bg: ii.reference,
  [ii.variable]: "colors.white",
  _dark: {
    [ii.variable]: "colors.gray.700"
  },
  "> option, > optgroup": {
    bg: ii.reference
  }
}, dC = {
  width: "6",
  height: "100%",
  insetEnd: "2",
  position: "relative",
  color: "currentColor",
  fontSize: "xl",
  _disabled: {
    opacity: 0.5
  }
}, fC = lC({
  field: uC,
  icon: dC
}), ai = {
  paddingInlineEnd: "8"
};
var hh, mh, gh, yh, bh, vh, xh, Sh;
const pC = {
  lg: {
    ...(hh = Ge.sizes) == null ? void 0 : hh.lg,
    field: {
      ...(mh = Ge.sizes) == null ? void 0 : mh.lg.field,
      ...ai
    }
  },
  md: {
    ...(gh = Ge.sizes) == null ? void 0 : gh.md,
    field: {
      ...(yh = Ge.sizes) == null ? void 0 : yh.md.field,
      ...ai
    }
  },
  sm: {
    ...(bh = Ge.sizes) == null ? void 0 : bh.sm,
    field: {
      ...(vh = Ge.sizes) == null ? void 0 : vh.sm.field,
      ...ai
    }
  },
  xs: {
    ...(xh = Ge.sizes) == null ? void 0 : xh.xs,
    field: {
      ...(Sh = Ge.sizes) == null ? void 0 : Sh.xs.field,
      ...ai
    },
    icon: {
      insetEnd: "1"
    }
  }
}, hC = cC({
  baseStyle: fC,
  sizes: pC,
  variants: Ge.variants,
  defaultProps: Ge.defaultProps
}), dc = Se("skeleton-start-color"), fc = Se("skeleton-end-color"), mC = {
  [dc.variable]: "colors.gray.100",
  [fc.variable]: "colors.gray.400",
  _dark: {
    [dc.variable]: "colors.gray.800",
    [fc.variable]: "colors.gray.600"
  },
  background: dc.reference,
  borderColor: fc.reference,
  opacity: 0.7,
  borderRadius: "sm"
}, gC = {
  baseStyle: mC
}, pc = Se("skip-link-bg"), yC = {
  borderRadius: "md",
  fontWeight: "semibold",
  _focusVisible: {
    boxShadow: "outline",
    padding: "4",
    position: "fixed",
    top: "6",
    insetStart: "6",
    [pc.variable]: "colors.white",
    _dark: {
      [pc.variable]: "colors.gray.700"
    },
    bg: pc.reference
  }
}, bC = {
  baseStyle: yC
}, { defineMultiStyleConfig: vC, definePartsStyle: fa } = ot(sw.keys), Nr = Se("slider-thumb-size"), vs = Se("slider-track-size"), or = Se("slider-bg"), xC = (e) => {
  const { orientation: t } = e;
  return {
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    _disabled: {
      opacity: 0.6,
      cursor: "default",
      pointerEvents: "none"
    },
    ...Ql({
      orientation: t,
      vertical: {
        h: "100%",
        px: Fn(Nr.reference).divide(2).toString()
      },
      horizontal: {
        w: "100%",
        py: Fn(Nr.reference).divide(2).toString()
      }
    })
  };
}, SC = (e) => ({
  ...Ql({
    orientation: e.orientation,
    horizontal: { h: vs.reference },
    vertical: { w: vs.reference }
  }),
  overflow: "hidden",
  borderRadius: "sm",
  [or.variable]: "colors.gray.200",
  _dark: {
    [or.variable]: "colors.whiteAlpha.200"
  },
  _disabled: {
    [or.variable]: "colors.gray.300",
    _dark: {
      [or.variable]: "colors.whiteAlpha.300"
    }
  },
  bg: or.reference
}), wC = (e) => {
  const { orientation: t } = e;
  return {
    ...Ql({
      orientation: t,
      vertical: { left: "50%" },
      horizontal: { top: "50%" }
    }),
    w: Nr.reference,
    h: Nr.reference,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    outline: 0,
    zIndex: 1,
    borderRadius: "full",
    bg: "white",
    boxShadow: "base",
    border: "1px solid",
    borderColor: "transparent",
    transitionProperty: "transform",
    transitionDuration: "normal",
    _focusVisible: {
      boxShadow: "outline"
    },
    _active: {
      "--slider-thumb-scale": "1.15"
    },
    _disabled: {
      bg: "gray.300"
    }
  };
}, kC = (e) => {
  const { colorScheme: t } = e;
  return {
    width: "inherit",
    height: "inherit",
    [or.variable]: `colors.${t}.500`,
    _dark: {
      [or.variable]: `colors.${t}.200`
    },
    bg: or.reference
  };
}, PC = fa((e) => ({
  container: xC(e),
  track: SC(e),
  thumb: wC(e),
  filledTrack: kC(e)
})), CC = fa({
  container: {
    [Nr.variable]: "sizes.4",
    [vs.variable]: "sizes.1"
  }
}), _C = fa({
  container: {
    [Nr.variable]: "sizes.3.5",
    [vs.variable]: "sizes.1"
  }
}), TC = fa({
  container: {
    [Nr.variable]: "sizes.2.5",
    [vs.variable]: "sizes.0.5"
  }
}), EC = {
  lg: CC,
  md: _C,
  sm: TC
}, AC = vC({
  baseStyle: PC,
  sizes: EC,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), wr = Pt("spinner-size"), IC = {
  width: [wr.reference],
  height: [wr.reference]
}, RC = {
  xs: {
    [wr.variable]: "sizes.3"
  },
  sm: {
    [wr.variable]: "sizes.4"
  },
  md: {
    [wr.variable]: "sizes.6"
  },
  lg: {
    [wr.variable]: "sizes.8"
  },
  xl: {
    [wr.variable]: "sizes.12"
  }
}, $C = {
  baseStyle: IC,
  sizes: RC,
  defaultProps: {
    size: "md"
  }
}, { defineMultiStyleConfig: NC, definePartsStyle: xm } = ot(iw.keys), MC = {
  fontWeight: "medium"
}, jC = {
  opacity: 0.8,
  marginBottom: "2"
}, DC = {
  verticalAlign: "baseline",
  fontWeight: "semibold"
}, OC = {
  marginEnd: 1,
  w: "3.5",
  h: "3.5",
  verticalAlign: "middle"
}, FC = xm({
  container: {},
  label: MC,
  helpText: jC,
  number: DC,
  icon: OC
}), BC = {
  md: xm({
    label: { fontSize: "sm" },
    helpText: { fontSize: "sm" },
    number: { fontSize: "2xl" }
  })
}, LC = NC({
  baseStyle: FC,
  sizes: BC,
  defaultProps: {
    size: "md"
  }
}), { defineMultiStyleConfig: VC, definePartsStyle: Jo } = ot([
  "stepper",
  "step",
  "title",
  "description",
  "indicator",
  "separator",
  "icon",
  "number"
]), Ln = Se("stepper-indicator-size"), ro = Se("stepper-icon-size"), oo = Se("stepper-title-font-size"), Qo = Se("stepper-description-font-size"), Lo = Se("stepper-accent-color"), zC = Jo(({ colorScheme: e }) => ({
  stepper: {
    display: "flex",
    justifyContent: "space-between",
    gap: "4",
    "&[data-orientation=vertical]": {
      flexDirection: "column",
      alignItems: "flex-start"
    },
    "&[data-orientation=horizontal]": {
      flexDirection: "row",
      alignItems: "center"
    },
    [Lo.variable]: `colors.${e}.500`,
    _dark: {
      [Lo.variable]: `colors.${e}.200`
    }
  },
  title: {
    fontSize: oo.reference,
    fontWeight: "medium"
  },
  description: {
    fontSize: Qo.reference,
    color: "chakra-subtle-text"
  },
  number: {
    fontSize: oo.reference
  },
  step: {
    flexShrink: 0,
    position: "relative",
    display: "flex",
    gap: "2",
    "&[data-orientation=horizontal]": {
      alignItems: "center"
    },
    flex: "1",
    "&:last-of-type:not([data-stretch])": {
      flex: "initial"
    }
  },
  icon: {
    flexShrink: 0,
    width: ro.reference,
    height: ro.reference
  },
  indicator: {
    flexShrink: 0,
    borderRadius: "full",
    width: Ln.reference,
    height: Ln.reference,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&[data-status=active]": {
      borderWidth: "2px",
      borderColor: Lo.reference
    },
    "&[data-status=complete]": {
      bg: Lo.reference,
      color: "chakra-inverse-text"
    },
    "&[data-status=incomplete]": {
      borderWidth: "2px"
    }
  },
  separator: {
    bg: "chakra-border-color",
    flex: "1",
    "&[data-status=complete]": {
      bg: Lo.reference
    },
    "&[data-orientation=horizontal]": {
      width: "100%",
      height: "2px",
      marginStart: "2"
    },
    "&[data-orientation=vertical]": {
      width: "2px",
      position: "absolute",
      height: "100%",
      maxHeight: `calc(100% - ${Ln.reference} - 8px)`,
      top: `calc(${Ln.reference} + 4px)`,
      insetStart: `calc(${Ln.reference} / 2 - 1px)`
    }
  }
})), WC = VC({
  baseStyle: zC,
  sizes: {
    xs: Jo({
      stepper: {
        [Ln.variable]: "sizes.4",
        [ro.variable]: "sizes.3",
        [oo.variable]: "fontSizes.xs",
        [Qo.variable]: "fontSizes.xs"
      }
    }),
    sm: Jo({
      stepper: {
        [Ln.variable]: "sizes.6",
        [ro.variable]: "sizes.4",
        [oo.variable]: "fontSizes.sm",
        [Qo.variable]: "fontSizes.xs"
      }
    }),
    md: Jo({
      stepper: {
        [Ln.variable]: "sizes.8",
        [ro.variable]: "sizes.5",
        [oo.variable]: "fontSizes.md",
        [Qo.variable]: "fontSizes.sm"
      }
    }),
    lg: Jo({
      stepper: {
        [Ln.variable]: "sizes.10",
        [ro.variable]: "sizes.6",
        [oo.variable]: "fontSizes.lg",
        [Qo.variable]: "fontSizes.md"
      }
    })
  },
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: HC, definePartsStyle: Ei } = ot(aw.keys), ls = Pt("switch-track-width"), Er = Pt("switch-track-height"), hc = Pt("switch-track-diff"), UC = Bn.subtract(ls, Er), ll = Pt("switch-thumb-x"), Vo = Pt("switch-bg"), GC = (e) => {
  const { colorScheme: t } = e;
  return {
    borderRadius: "full",
    p: "0.5",
    width: [ls.reference],
    height: [Er.reference],
    transitionProperty: "common",
    transitionDuration: "fast",
    [Vo.variable]: "colors.gray.300",
    _dark: {
      [Vo.variable]: "colors.whiteAlpha.400"
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    _checked: {
      [Vo.variable]: `colors.${t}.500`,
      _dark: {
        [Vo.variable]: `colors.${t}.200`
      }
    },
    bg: Vo.reference
  };
}, qC = {
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [Er.reference],
  height: [Er.reference],
  _checked: {
    transform: `translateX(${ll.reference})`
  }
}, KC = Ei((e) => ({
  container: {
    [hc.variable]: UC,
    [ll.variable]: hc.reference,
    _rtl: {
      [ll.variable]: Bn(hc).negate().toString()
    }
  },
  track: GC(e),
  thumb: qC
})), YC = {
  sm: Ei({
    container: {
      [ls.variable]: "1.375rem",
      [Er.variable]: "sizes.3"
    }
  }),
  md: Ei({
    container: {
      [ls.variable]: "1.875rem",
      [Er.variable]: "sizes.4"
    }
  }),
  lg: Ei({
    container: {
      [ls.variable]: "2.875rem",
      [Er.variable]: "sizes.6"
    }
  })
}, XC = HC({
  baseStyle: KC,
  sizes: YC,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: ZC, definePartsStyle: go } = ot(cw.keys), JC = go({
  table: {
    fontVariantNumeric: "lining-nums tabular-nums",
    borderCollapse: "collapse",
    width: "full"
  },
  th: {
    fontFamily: "heading",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "wider",
    textAlign: "start"
  },
  td: {
    textAlign: "start"
  },
  caption: {
    mt: 4,
    fontFamily: "heading",
    textAlign: "center",
    fontWeight: "medium"
  }
}), Gi = {
  "&[data-is-numeric=true]": {
    textAlign: "end"
  }
}, QC = go((e) => {
  const { colorScheme: t } = e;
  return {
    th: {
      color: ke("gray.600", "gray.400")(e),
      borderBottom: "1px",
      borderColor: ke(`${t}.100`, `${t}.700`)(e),
      ...Gi
    },
    td: {
      borderBottom: "1px",
      borderColor: ke(`${t}.100`, `${t}.700`)(e),
      ...Gi
    },
    caption: {
      color: ke("gray.600", "gray.100")(e)
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: { borderBottomWidth: 0 }
        }
      }
    }
  };
}), e_ = go((e) => {
  const { colorScheme: t } = e;
  return {
    th: {
      color: ke("gray.600", "gray.400")(e),
      borderBottom: "1px",
      borderColor: ke(`${t}.100`, `${t}.700`)(e),
      ...Gi
    },
    td: {
      borderBottom: "1px",
      borderColor: ke(`${t}.100`, `${t}.700`)(e),
      ...Gi
    },
    caption: {
      color: ke("gray.600", "gray.100")(e)
    },
    tbody: {
      tr: {
        "&:nth-of-type(odd)": {
          "th, td": {
            borderBottomWidth: "1px",
            borderColor: ke(`${t}.100`, `${t}.700`)(e)
          },
          td: {
            background: ke(`${t}.100`, `${t}.700`)(e)
          }
        }
      }
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: { borderBottomWidth: 0 }
        }
      }
    }
  };
}), t_ = {
  simple: QC,
  striped: e_,
  unstyled: {}
}, n_ = {
  sm: go({
    th: {
      px: "4",
      py: "1",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "4",
      py: "2",
      fontSize: "sm",
      lineHeight: "4"
    },
    caption: {
      px: "4",
      py: "2",
      fontSize: "xs"
    }
  }),
  md: go({
    th: {
      px: "6",
      py: "3",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "6",
      py: "4",
      lineHeight: "5"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "sm"
    }
  }),
  lg: go({
    th: {
      px: "8",
      py: "4",
      lineHeight: "5",
      fontSize: "sm"
    },
    td: {
      px: "8",
      py: "5",
      lineHeight: "6"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "md"
    }
  })
}, r_ = ZC({
  baseStyle: JC,
  variants: t_,
  sizes: n_,
  defaultProps: {
    variant: "simple",
    size: "md",
    colorScheme: "gray"
  }
}), Wt = Se("tabs-color"), gn = Se("tabs-bg"), ci = Se("tabs-border-color"), { defineMultiStyleConfig: o_, definePartsStyle: En } = ot(lw.keys), s_ = (e) => {
  const { orientation: t } = e;
  return {
    display: t === "vertical" ? "flex" : "block"
  };
}, i_ = (e) => {
  const { isFitted: t } = e;
  return {
    flex: t ? 1 : void 0,
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
      zIndex: 1,
      boxShadow: "outline"
    },
    _disabled: {
      cursor: "not-allowed",
      opacity: 0.4
    }
  };
}, a_ = (e) => {
  const { align: t = "start", orientation: n } = e;
  return {
    justifyContent: {
      end: "flex-end",
      center: "center",
      start: "flex-start"
    }[t],
    flexDirection: n === "vertical" ? "column" : "row"
  };
}, c_ = {
  p: 4
}, l_ = En((e) => ({
  root: s_(e),
  tab: i_(e),
  tablist: a_(e),
  tabpanel: c_
})), u_ = {
  sm: En({
    tab: {
      py: 1,
      px: 4,
      fontSize: "sm"
    }
  }),
  md: En({
    tab: {
      fontSize: "md",
      py: 2,
      px: 4
    }
  }),
  lg: En({
    tab: {
      fontSize: "lg",
      py: 3,
      px: 4
    }
  })
}, d_ = En((e) => {
  const { colorScheme: t, orientation: n } = e, r = n === "vertical", o = r ? "borderStart" : "borderBottom", s = r ? "marginStart" : "marginBottom";
  return {
    tablist: {
      [o]: "2px solid",
      borderColor: "inherit"
    },
    tab: {
      [o]: "2px solid",
      borderColor: "transparent",
      [s]: "-2px",
      _selected: {
        [Wt.variable]: `colors.${t}.600`,
        _dark: {
          [Wt.variable]: `colors.${t}.300`
        },
        borderColor: "currentColor"
      },
      _active: {
        [gn.variable]: "colors.gray.200",
        _dark: {
          [gn.variable]: "colors.whiteAlpha.300"
        }
      },
      _disabled: {
        _active: { bg: "none" }
      },
      color: Wt.reference,
      bg: gn.reference
    }
  };
}), f_ = En((e) => {
  const { colorScheme: t } = e;
  return {
    tab: {
      borderTopRadius: "md",
      border: "1px solid",
      borderColor: "transparent",
      mb: "-1px",
      [ci.variable]: "transparent",
      _selected: {
        [Wt.variable]: `colors.${t}.600`,
        [ci.variable]: "colors.white",
        _dark: {
          [Wt.variable]: `colors.${t}.300`,
          [ci.variable]: "colors.gray.800"
        },
        borderColor: "inherit",
        borderBottomColor: ci.reference
      },
      color: Wt.reference
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}), p_ = En((e) => {
  const { colorScheme: t } = e;
  return {
    tab: {
      border: "1px solid",
      borderColor: "inherit",
      [gn.variable]: "colors.gray.50",
      _dark: {
        [gn.variable]: "colors.whiteAlpha.50"
      },
      mb: "-1px",
      _notLast: {
        marginEnd: "-1px"
      },
      _selected: {
        [gn.variable]: "colors.white",
        [Wt.variable]: `colors.${t}.600`,
        _dark: {
          [gn.variable]: "colors.gray.800",
          [Wt.variable]: `colors.${t}.300`
        },
        borderColor: "inherit",
        borderTopColor: "currentColor",
        borderBottomColor: "transparent"
      },
      color: Wt.reference,
      bg: gn.reference
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}), h_ = En((e) => {
  const { colorScheme: t, theme: n } = e;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      color: "gray.600",
      _selected: {
        color: Bt(n, `${t}.700`),
        bg: Bt(n, `${t}.100`)
      }
    }
  };
}), m_ = En((e) => {
  const { colorScheme: t } = e;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      [Wt.variable]: "colors.gray.600",
      _dark: {
        [Wt.variable]: "inherit"
      },
      _selected: {
        [Wt.variable]: "colors.white",
        [gn.variable]: `colors.${t}.600`,
        _dark: {
          [Wt.variable]: "colors.gray.800",
          [gn.variable]: `colors.${t}.300`
        }
      },
      color: Wt.reference,
      bg: gn.reference
    }
  };
}), g_ = En({}), y_ = {
  line: d_,
  enclosed: f_,
  "enclosed-colored": p_,
  "soft-rounded": h_,
  "solid-rounded": m_,
  unstyled: g_
}, b_ = o_({
  baseStyle: l_,
  sizes: u_,
  variants: y_,
  defaultProps: {
    size: "md",
    variant: "line",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: v_, definePartsStyle: Ar } = ot(uw.keys), Gd = Se("tag-bg"), qd = Se("tag-color"), mc = Se("tag-shadow"), Ai = Se("tag-min-height"), Ii = Se("tag-min-width"), Ri = Se("tag-font-size"), $i = Se("tag-padding-inline"), x_ = {
  fontWeight: "medium",
  lineHeight: 1.2,
  outline: 0,
  [qd.variable]: mt.color.reference,
  [Gd.variable]: mt.bg.reference,
  [mc.variable]: mt.shadow.reference,
  color: qd.reference,
  bg: Gd.reference,
  boxShadow: mc.reference,
  borderRadius: "md",
  minH: Ai.reference,
  minW: Ii.reference,
  fontSize: Ri.reference,
  px: $i.reference,
  _focusVisible: {
    [mc.variable]: "shadows.outline"
  }
}, S_ = {
  lineHeight: 1.2,
  overflow: "visible"
}, w_ = {
  fontSize: "lg",
  w: "5",
  h: "5",
  transitionProperty: "common",
  transitionDuration: "normal",
  borderRadius: "full",
  marginStart: "1.5",
  marginEnd: "-1",
  opacity: 0.5,
  _disabled: {
    opacity: 0.4
  },
  _focusVisible: {
    boxShadow: "outline",
    bg: "rgba(0, 0, 0, 0.14)"
  },
  _hover: {
    opacity: 0.8
  },
  _active: {
    opacity: 1
  }
}, k_ = Ar({
  container: x_,
  label: S_,
  closeButton: w_
}), P_ = {
  sm: Ar({
    container: {
      [Ai.variable]: "sizes.5",
      [Ii.variable]: "sizes.5",
      [Ri.variable]: "fontSizes.xs",
      [$i.variable]: "space.2"
    },
    closeButton: {
      marginEnd: "-2px",
      marginStart: "0.35rem"
    }
  }),
  md: Ar({
    container: {
      [Ai.variable]: "sizes.6",
      [Ii.variable]: "sizes.6",
      [Ri.variable]: "fontSizes.sm",
      [$i.variable]: "space.2"
    }
  }),
  lg: Ar({
    container: {
      [Ai.variable]: "sizes.8",
      [Ii.variable]: "sizes.8",
      [Ri.variable]: "fontSizes.md",
      [$i.variable]: "space.3"
    }
  })
}, C_ = {
  subtle: Ar((e) => {
    var t;
    return {
      container: (t = is.variants) == null ? void 0 : t.subtle(e)
    };
  }),
  solid: Ar((e) => {
    var t;
    return {
      container: (t = is.variants) == null ? void 0 : t.solid(e)
    };
  }),
  outline: Ar((e) => {
    var t;
    return {
      container: (t = is.variants) == null ? void 0 : t.outline(e)
    };
  })
}, __ = v_({
  variants: C_,
  baseStyle: k_,
  sizes: P_,
  defaultProps: {
    size: "md",
    variant: "subtle",
    colorScheme: "gray"
  }
});
var wh;
const T_ = {
  ...(wh = Ge.baseStyle) == null ? void 0 : wh.field,
  paddingY: "2",
  minHeight: "20",
  lineHeight: "short",
  verticalAlign: "top"
};
var kh;
const E_ = {
  outline: (e) => {
    var t;
    return ((t = Ge.variants) == null ? void 0 : t.outline(e).field) ?? {};
  },
  flushed: (e) => {
    var t;
    return ((t = Ge.variants) == null ? void 0 : t.flushed(e).field) ?? {};
  },
  filled: (e) => {
    var t;
    return ((t = Ge.variants) == null ? void 0 : t.filled(e).field) ?? {};
  },
  unstyled: ((kh = Ge.variants) == null ? void 0 : kh.unstyled.field) ?? {}
};
var Ph, Ch, _h, Th;
const A_ = {
  xs: ((Ph = Ge.sizes) == null ? void 0 : Ph.xs.field) ?? {},
  sm: ((Ch = Ge.sizes) == null ? void 0 : Ch.sm.field) ?? {},
  md: ((_h = Ge.sizes) == null ? void 0 : _h.md.field) ?? {},
  lg: ((Th = Ge.sizes) == null ? void 0 : Th.lg.field) ?? {}
}, I_ = {
  baseStyle: T_,
  sizes: A_,
  variants: E_,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
}, li = Pt("tooltip-bg"), gc = Pt("tooltip-fg"), R_ = Pt("popper-arrow-bg"), $_ = {
  bg: li.reference,
  color: gc.reference,
  [li.variable]: "colors.gray.700",
  [gc.variable]: "colors.whiteAlpha.900",
  _dark: {
    [li.variable]: "colors.gray.300",
    [gc.variable]: "colors.gray.900"
  },
  [R_.variable]: li.reference,
  px: "2",
  py: "0.5",
  borderRadius: "sm",
  fontWeight: "medium",
  fontSize: "sm",
  boxShadow: "md",
  maxW: "xs",
  zIndex: "tooltip"
}, N_ = {
  baseStyle: $_
}, M_ = {
  Accordion: vw,
  Alert: n1,
  Avatar: p1,
  Badge: is,
  Breadcrumb: k1,
  Button: $1,
  Checkbox: nr,
  CloseButton: q1,
  Code: Z1,
  Container: Q1,
  Divider: ok,
  Drawer: mk,
  Editable: wk,
  Form: Ek,
  FormError: Mk,
  FormLabel: Dk,
  Heading: Bk,
  Input: Ge,
  Kbd: Yk,
  Link: Zk,
  List: nP,
  Menu: pP,
  Modal: PP,
  NumberInput: NP,
  PinInput: OP,
  Popover: KP,
  Progress: nC,
  Radio: aC,
  Select: hC,
  Skeleton: gC,
  SkipLink: bC,
  Slider: AC,
  Spinner: $C,
  Stat: LC,
  Switch: XC,
  Table: r_,
  Tabs: b_,
  Tag: __,
  Textarea: I_,
  Tooltip: N_,
  Card: O1,
  Stepper: WC
}, j_ = {
  none: 0,
  "1px": "1px solid",
  "2px": "2px solid",
  "4px": "4px solid",
  "8px": "8px solid"
}, D_ = {
  base: "0em",
  sm: "30em",
  md: "48em",
  lg: "62em",
  xl: "80em",
  "2xl": "96em"
}, O_ = {
  transparent: "transparent",
  current: "currentColor",
  black: "#000000",
  white: "#FFFFFF",
  whiteAlpha: {
    50: "rgba(255, 255, 255, 0.04)",
    100: "rgba(255, 255, 255, 0.06)",
    200: "rgba(255, 255, 255, 0.08)",
    300: "rgba(255, 255, 255, 0.16)",
    400: "rgba(255, 255, 255, 0.24)",
    500: "rgba(255, 255, 255, 0.36)",
    600: "rgba(255, 255, 255, 0.48)",
    700: "rgba(255, 255, 255, 0.64)",
    800: "rgba(255, 255, 255, 0.80)",
    900: "rgba(255, 255, 255, 0.92)"
  },
  blackAlpha: {
    50: "rgba(0, 0, 0, 0.04)",
    100: "rgba(0, 0, 0, 0.06)",
    200: "rgba(0, 0, 0, 0.08)",
    300: "rgba(0, 0, 0, 0.16)",
    400: "rgba(0, 0, 0, 0.24)",
    500: "rgba(0, 0, 0, 0.36)",
    600: "rgba(0, 0, 0, 0.48)",
    700: "rgba(0, 0, 0, 0.64)",
    800: "rgba(0, 0, 0, 0.80)",
    900: "rgba(0, 0, 0, 0.92)"
  },
  gray: {
    50: "#F7FAFC",
    100: "#EDF2F7",
    200: "#E2E8F0",
    300: "#CBD5E0",
    400: "#A0AEC0",
    500: "#718096",
    600: "#4A5568",
    700: "#2D3748",
    800: "#1A202C",
    900: "#171923"
  },
  red: {
    50: "#FFF5F5",
    100: "#FED7D7",
    200: "#FEB2B2",
    300: "#FC8181",
    400: "#F56565",
    500: "#E53E3E",
    600: "#C53030",
    700: "#9B2C2C",
    800: "#822727",
    900: "#63171B"
  },
  orange: {
    50: "#FFFAF0",
    100: "#FEEBC8",
    200: "#FBD38D",
    300: "#F6AD55",
    400: "#ED8936",
    500: "#DD6B20",
    600: "#C05621",
    700: "#9C4221",
    800: "#7B341E",
    900: "#652B19"
  },
  yellow: {
    50: "#FFFFF0",
    100: "#FEFCBF",
    200: "#FAF089",
    300: "#F6E05E",
    400: "#ECC94B",
    500: "#D69E2E",
    600: "#B7791F",
    700: "#975A16",
    800: "#744210",
    900: "#5F370E"
  },
  green: {
    50: "#F0FFF4",
    100: "#C6F6D5",
    200: "#9AE6B4",
    300: "#68D391",
    400: "#48BB78",
    500: "#38A169",
    600: "#2F855A",
    700: "#276749",
    800: "#22543D",
    900: "#1C4532"
  },
  teal: {
    50: "#E6FFFA",
    100: "#B2F5EA",
    200: "#81E6D9",
    300: "#4FD1C5",
    400: "#38B2AC",
    500: "#319795",
    600: "#2C7A7B",
    700: "#285E61",
    800: "#234E52",
    900: "#1D4044"
  },
  blue: {
    50: "#ebf8ff",
    100: "#bee3f8",
    200: "#90cdf4",
    300: "#63b3ed",
    400: "#4299e1",
    500: "#3182ce",
    600: "#2b6cb0",
    700: "#2c5282",
    800: "#2a4365",
    900: "#1A365D"
  },
  cyan: {
    50: "#EDFDFD",
    100: "#C4F1F9",
    200: "#9DECF9",
    300: "#76E4F7",
    400: "#0BC5EA",
    500: "#00B5D8",
    600: "#00A3C4",
    700: "#0987A0",
    800: "#086F83",
    900: "#065666"
  },
  purple: {
    50: "#FAF5FF",
    100: "#E9D8FD",
    200: "#D6BCFA",
    300: "#B794F4",
    400: "#9F7AEA",
    500: "#805AD5",
    600: "#6B46C1",
    700: "#553C9A",
    800: "#44337A",
    900: "#322659"
  },
  pink: {
    50: "#FFF5F7",
    100: "#FED7E2",
    200: "#FBB6CE",
    300: "#F687B3",
    400: "#ED64A6",
    500: "#D53F8C",
    600: "#B83280",
    700: "#97266D",
    800: "#702459",
    900: "#521B41"
  }
}, F_ = {
  none: "0",
  sm: "0.125rem",
  base: "0.25rem",
  md: "0.375rem",
  lg: "0.5rem",
  xl: "0.75rem",
  "2xl": "1rem",
  "3xl": "1.5rem",
  full: "9999px"
}, B_ = {
  xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
  sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
  inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
  none: "none",
  "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
}, L_ = {
  common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
  colors: "background-color, border-color, color, fill, stroke",
  dimensions: "width, height",
  position: "left, right, top, bottom",
  background: "background-color, background-image, background-position"
}, V_ = {
  "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
  "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
}, z_ = {
  "ultra-fast": "50ms",
  faster: "100ms",
  fast: "150ms",
  normal: "200ms",
  slow: "300ms",
  slower: "400ms",
  "ultra-slow": "500ms"
}, W_ = {
  property: L_,
  easing: V_,
  duration: z_
}, H_ = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 1e3,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
}, U_ = {
  none: 0,
  sm: "4px",
  base: "8px",
  md: "12px",
  lg: "16px",
  xl: "24px",
  "2xl": "40px",
  "3xl": "64px"
}, Sm = {
  breakpoints: D_,
  zIndices: H_,
  radii: F_,
  blur: U_,
  colors: O_,
  ...ym,
  sizes: dm,
  shadows: B_,
  space: um,
  borders: j_,
  transition: W_
}, wm = {
  colors: {
    "chakra-body-text": { _light: "gray.800", _dark: "whiteAlpha.900" },
    "chakra-body-bg": { _light: "white", _dark: "gray.800" },
    "chakra-border-color": { _light: "gray.200", _dark: "whiteAlpha.300" },
    "chakra-inverse-text": { _light: "white", _dark: "gray.800" },
    "chakra-subtle-bg": { _light: "gray.100", _dark: "gray.700" },
    "chakra-subtle-text": { _light: "gray.600", _dark: "gray.400" },
    "chakra-placeholder-color": { _light: "gray.500", _dark: "whiteAlpha.400" }
  }
}, km = {
  global: {
    body: {
      fontFamily: "body",
      color: "chakra-body-text",
      bg: "chakra-body-bg",
      transitionProperty: "background-color",
      transitionDuration: "normal",
      lineHeight: "base"
    },
    "*::placeholder": {
      color: "chakra-placeholder-color"
    },
    "*, *::before, &::after": {
      borderColor: "chakra-border-color"
    }
  }
}, G_ = [
  "borders",
  "breakpoints",
  "colors",
  "components",
  "config",
  "direction",
  "fonts",
  "fontSizes",
  "fontWeights",
  "letterSpacings",
  "lineHeights",
  "radii",
  "shadows",
  "sizes",
  "space",
  "styles",
  "transition",
  "zIndices"
];
function q_(e) {
  return lt(e) ? G_.every(
    (t) => Object.prototype.hasOwnProperty.call(e, t)
  ) : !1;
}
const Pm = "ltr", Cm = {
  useSystemColorMode: !1,
  initialColorMode: "light",
  cssVarPrefix: "chakra"
}, ru = {
  semanticTokens: wm,
  direction: Pm,
  ...Sm,
  components: M_,
  styles: km,
  config: Cm
}, _m = {
  semanticTokens: wm,
  direction: Pm,
  components: {},
  ...Sm,
  styles: km,
  config: Cm
};
var ul = { exports: {} }, zo = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kd;
function K_() {
  if (Kd)
    return zo;
  Kd = 1;
  var e = Yt, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(a, c, l) {
    var u, d = {}, f = null, p = null;
    l !== void 0 && (f = "" + l), c.key !== void 0 && (f = "" + c.key), c.ref !== void 0 && (p = c.ref);
    for (u in c)
      r.call(c, u) && !s.hasOwnProperty(u) && (d[u] = c[u]);
    if (a && a.defaultProps)
      for (u in c = a.defaultProps, c)
        d[u] === void 0 && (d[u] = c[u]);
    return { $$typeof: t, type: a, key: f, ref: p, props: d, _owner: o.current };
  }
  return zo.Fragment = n, zo.jsx = i, zo.jsxs = i, zo;
}
var Wo = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yd;
function Y_() {
  return Yd || (Yd = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Yt, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), m = Symbol.iterator, g = "@@iterator";
    function y(P) {
      if (P === null || typeof P != "object")
        return null;
      var X = m && P[m] || P[g];
      return typeof X == "function" ? X : null;
    }
    var S = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(P) {
      {
        for (var X = arguments.length, fe = new Array(X > 1 ? X - 1 : 0), Te = 1; Te < X; Te++)
          fe[Te - 1] = arguments[Te];
        v("error", P, fe);
      }
    }
    function v(P, X, fe) {
      {
        var Te = S.ReactDebugCurrentFrame, Me = Te.getStackAddendum();
        Me !== "" && (X += "%s", fe = fe.concat([Me]));
        var Ze = fe.map(function(Fe) {
          return String(Fe);
        });
        Ze.unshift("Warning: " + X), Function.prototype.apply.call(console[P], console, Ze);
      }
    }
    var k = !1, w = !1, _ = !1, C = !1, I = !1, $;
    $ = Symbol.for("react.module.reference");
    function N(P) {
      return !!(typeof P == "string" || typeof P == "function" || P === r || P === s || I || P === o || P === l || P === u || C || P === p || k || w || _ || typeof P == "object" && P !== null && (P.$$typeof === f || P.$$typeof === d || P.$$typeof === i || P.$$typeof === a || P.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      P.$$typeof === $ || P.getModuleId !== void 0));
    }
    function z(P, X, fe) {
      var Te = P.displayName;
      if (Te)
        return Te;
      var Me = X.displayName || X.name || "";
      return Me !== "" ? fe + "(" + Me + ")" : fe;
    }
    function Q(P) {
      return P.displayName || "Context";
    }
    function U(P) {
      if (P == null)
        return null;
      if (typeof P.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof P == "function")
        return P.displayName || P.name || null;
      if (typeof P == "string")
        return P;
      switch (P) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case s:
          return "Profiler";
        case o:
          return "StrictMode";
        case l:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof P == "object")
        switch (P.$$typeof) {
          case a:
            var X = P;
            return Q(X) + ".Consumer";
          case i:
            var fe = P;
            return Q(fe._context) + ".Provider";
          case c:
            return z(P, P.render, "ForwardRef");
          case d:
            var Te = P.displayName || null;
            return Te !== null ? Te : U(P.type) || "Memo";
          case f: {
            var Me = P, Ze = Me._payload, Fe = Me._init;
            try {
              return U(Fe(Ze));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, le = 0, Z, j, K, ne, B, O, ee;
    function D() {
    }
    D.__reactDisabledLog = !0;
    function V() {
      {
        if (le === 0) {
          Z = console.log, j = console.info, K = console.warn, ne = console.error, B = console.group, O = console.groupCollapsed, ee = console.groupEnd;
          var P = {
            configurable: !0,
            enumerable: !0,
            value: D,
            writable: !0
          };
          Object.defineProperties(console, {
            info: P,
            log: P,
            warn: P,
            error: P,
            group: P,
            groupCollapsed: P,
            groupEnd: P
          });
        }
        le++;
      }
    }
    function Y() {
      {
        if (le--, le === 0) {
          var P = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, P, {
              value: Z
            }),
            info: q({}, P, {
              value: j
            }),
            warn: q({}, P, {
              value: K
            }),
            error: q({}, P, {
              value: ne
            }),
            group: q({}, P, {
              value: B
            }),
            groupCollapsed: q({}, P, {
              value: O
            }),
            groupEnd: q({}, P, {
              value: ee
            })
          });
        }
        le < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var J = S.ReactCurrentDispatcher, se;
    function ue(P, X, fe) {
      {
        if (se === void 0)
          try {
            throw Error();
          } catch (Me) {
            var Te = Me.stack.trim().match(/\n( *(at )?)/);
            se = Te && Te[1] || "";
          }
        return `
` + se + P;
      }
    }
    var G = !1, H;
    {
      var de = typeof WeakMap == "function" ? WeakMap : Map;
      H = new de();
    }
    function L(P, X) {
      if (!P || G)
        return "";
      {
        var fe = H.get(P);
        if (fe !== void 0)
          return fe;
      }
      var Te;
      G = !0;
      var Me = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ze;
      Ze = J.current, J.current = null, V();
      try {
        if (X) {
          var Fe = function() {
            throw Error();
          };
          if (Object.defineProperty(Fe.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Fe, []);
            } catch (Tt) {
              Te = Tt;
            }
            Reflect.construct(P, [], Fe);
          } else {
            try {
              Fe.call();
            } catch (Tt) {
              Te = Tt;
            }
            P.call(Fe.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Tt) {
            Te = Tt;
          }
          P();
        }
      } catch (Tt) {
        if (Tt && Te && typeof Tt.stack == "string") {
          for (var je = Tt.stack.split(`
`), It = Te.stack.split(`
`), ut = je.length - 1, ft = It.length - 1; ut >= 1 && ft >= 0 && je[ut] !== It[ft]; )
            ft--;
          for (; ut >= 1 && ft >= 0; ut--, ft--)
            if (je[ut] !== It[ft]) {
              if (ut !== 1 || ft !== 1)
                do
                  if (ut--, ft--, ft < 0 || je[ut] !== It[ft]) {
                    var Mt = `
` + je[ut].replace(" at new ", " at ");
                    return P.displayName && Mt.includes("<anonymous>") && (Mt = Mt.replace("<anonymous>", P.displayName)), typeof P == "function" && H.set(P, Mt), Mt;
                  }
                while (ut >= 1 && ft >= 0);
              break;
            }
        }
      } finally {
        G = !1, J.current = Ze, Y(), Error.prepareStackTrace = Me;
      }
      var Zn = P ? P.displayName || P.name : "", Qt = Zn ? ue(Zn) : "";
      return typeof P == "function" && H.set(P, Qt), Qt;
    }
    function me(P, X, fe) {
      return L(P, !1);
    }
    function oe(P) {
      var X = P.prototype;
      return !!(X && X.isReactComponent);
    }
    function $e(P, X, fe) {
      if (P == null)
        return "";
      if (typeof P == "function")
        return L(P, oe(P));
      if (typeof P == "string")
        return ue(P);
      switch (P) {
        case l:
          return ue("Suspense");
        case u:
          return ue("SuspenseList");
      }
      if (typeof P == "object")
        switch (P.$$typeof) {
          case c:
            return me(P.render);
          case d:
            return $e(P.type, X, fe);
          case f: {
            var Te = P, Me = Te._payload, Ze = Te._init;
            try {
              return $e(Ze(Me), X, fe);
            } catch {
            }
          }
        }
      return "";
    }
    var Oe = Object.prototype.hasOwnProperty, ce = {}, Ne = S.ReactDebugCurrentFrame;
    function Ie(P) {
      if (P) {
        var X = P._owner, fe = $e(P.type, P._source, X ? X.type : null);
        Ne.setExtraStackFrame(fe);
      } else
        Ne.setExtraStackFrame(null);
    }
    function Re(P, X, fe, Te, Me) {
      {
        var Ze = Function.call.bind(Oe);
        for (var Fe in P)
          if (Ze(P, Fe)) {
            var je = void 0;
            try {
              if (typeof P[Fe] != "function") {
                var It = Error((Te || "React class") + ": " + fe + " type `" + Fe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof P[Fe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw It.name = "Invariant Violation", It;
              }
              je = P[Fe](X, Fe, Te, fe, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ut) {
              je = ut;
            }
            je && !(je instanceof Error) && (Ie(Me), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Te || "React class", fe, Fe, typeof je), Ie(null)), je instanceof Error && !(je.message in ce) && (ce[je.message] = !0, Ie(Me), b("Failed %s type: %s", fe, je.message), Ie(null));
          }
      }
    }
    var Xe = Array.isArray;
    function tt(P) {
      return Xe(P);
    }
    function it(P) {
      {
        var X = typeof Symbol == "function" && Symbol.toStringTag, fe = X && P[Symbol.toStringTag] || P.constructor.name || "Object";
        return fe;
      }
    }
    function At(P) {
      try {
        return Vt(P), !1;
      } catch {
        return !0;
      }
    }
    function Vt(P) {
      return "" + P;
    }
    function qt(P) {
      if (At(P))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", it(P)), Vt(P);
    }
    var Nt = S.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, We, ie, be;
    be = {};
    function gt(P) {
      if (Oe.call(P, "ref")) {
        var X = Object.getOwnPropertyDescriptor(P, "ref").get;
        if (X && X.isReactWarning)
          return !1;
      }
      return P.ref !== void 0;
    }
    function Dt(P) {
      if (Oe.call(P, "key")) {
        var X = Object.getOwnPropertyDescriptor(P, "key").get;
        if (X && X.isReactWarning)
          return !1;
      }
      return P.key !== void 0;
    }
    function pe(P, X) {
      if (typeof P.ref == "string" && Nt.current && X && Nt.current.stateNode !== X) {
        var fe = U(Nt.current.type);
        be[fe] || (b('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', U(Nt.current.type), P.ref), be[fe] = !0);
      }
    }
    function Pe(P, X) {
      {
        var fe = function() {
          We || (We = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", X));
        };
        fe.isReactWarning = !0, Object.defineProperty(P, "key", {
          get: fe,
          configurable: !0
        });
      }
    }
    function ve(P, X) {
      {
        var fe = function() {
          ie || (ie = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", X));
        };
        fe.isReactWarning = !0, Object.defineProperty(P, "ref", {
          get: fe,
          configurable: !0
        });
      }
    }
    var Be = function(P, X, fe, Te, Me, Ze, Fe) {
      var je = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: P,
        key: X,
        ref: fe,
        props: Fe,
        // Record the component responsible for creating this element.
        _owner: Ze
      };
      return je._store = {}, Object.defineProperty(je._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(je, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Te
      }), Object.defineProperty(je, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Me
      }), Object.freeze && (Object.freeze(je.props), Object.freeze(je)), je;
    };
    function He(P, X, fe, Te, Me) {
      {
        var Ze, Fe = {}, je = null, It = null;
        fe !== void 0 && (qt(fe), je = "" + fe), Dt(X) && (qt(X.key), je = "" + X.key), gt(X) && (It = X.ref, pe(X, Me));
        for (Ze in X)
          Oe.call(X, Ze) && !te.hasOwnProperty(Ze) && (Fe[Ze] = X[Ze]);
        if (P && P.defaultProps) {
          var ut = P.defaultProps;
          for (Ze in ut)
            Fe[Ze] === void 0 && (Fe[Ze] = ut[Ze]);
        }
        if (je || It) {
          var ft = typeof P == "function" ? P.displayName || P.name || "Unknown" : P;
          je && Pe(Fe, ft), It && ve(Fe, ft);
        }
        return Be(P, je, It, Me, Te, Nt.current, Fe);
      }
    }
    var xt = S.ReactCurrentOwner, Ot = S.ReactDebugCurrentFrame;
    function _t(P) {
      if (P) {
        var X = P._owner, fe = $e(P.type, P._source, X ? X.type : null);
        Ot.setExtraStackFrame(fe);
      } else
        Ot.setExtraStackFrame(null);
    }
    var Dn;
    Dn = !1;
    function jo(P) {
      return typeof P == "object" && P !== null && P.$$typeof === t;
    }
    function Sn() {
      {
        if (xt.current) {
          var P = U(xt.current.type);
          if (P)
            return `

Check the render method of \`` + P + "`.";
        }
        return "";
      }
    }
    function Da(P) {
      {
        if (P !== void 0) {
          var X = P.fileName.replace(/^.*[\\\/]/, ""), fe = P.lineNumber;
          return `

Check your code at ` + X + ":" + fe + ".";
        }
        return "";
      }
    }
    var Ks = {};
    function Oa(P) {
      {
        var X = Sn();
        if (!X) {
          var fe = typeof P == "string" ? P : P.displayName || P.name;
          fe && (X = `

Check the top-level render call using <` + fe + ">.");
        }
        return X;
      }
    }
    function Ys(P, X) {
      {
        if (!P._store || P._store.validated || P.key != null)
          return;
        P._store.validated = !0;
        var fe = Oa(X);
        if (Ks[fe])
          return;
        Ks[fe] = !0;
        var Te = "";
        P && P._owner && P._owner !== xt.current && (Te = " It was passed a child from " + U(P._owner.type) + "."), _t(P), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', fe, Te), _t(null);
      }
    }
    function Xs(P, X) {
      {
        if (typeof P != "object")
          return;
        if (tt(P))
          for (var fe = 0; fe < P.length; fe++) {
            var Te = P[fe];
            jo(Te) && Ys(Te, X);
          }
        else if (jo(P))
          P._store && (P._store.validated = !0);
        else if (P) {
          var Me = y(P);
          if (typeof Me == "function" && Me !== P.entries)
            for (var Ze = Me.call(P), Fe; !(Fe = Ze.next()).done; )
              jo(Fe.value) && Ys(Fe.value, X);
        }
      }
    }
    function pn(P) {
      {
        var X = P.type;
        if (X == null || typeof X == "string")
          return;
        var fe;
        if (typeof X == "function")
          fe = X.propTypes;
        else if (typeof X == "object" && (X.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        X.$$typeof === d))
          fe = X.propTypes;
        else
          return;
        if (fe) {
          var Te = U(X);
          Re(fe, P.props, "prop", Te, P);
        } else if (X.PropTypes !== void 0 && !Dn) {
          Dn = !0;
          var Me = U(X);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Me || "Unknown");
        }
        typeof X.getDefaultProps == "function" && !X.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Fa(P) {
      {
        for (var X = Object.keys(P.props), fe = 0; fe < X.length; fe++) {
          var Te = X[fe];
          if (Te !== "children" && Te !== "key") {
            _t(P), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Te), _t(null);
            break;
          }
        }
        P.ref !== null && (_t(P), b("Invalid attribute `ref` supplied to `React.Fragment`."), _t(null));
      }
    }
    var Zs = {};
    function Js(P, X, fe, Te, Me, Ze) {
      {
        var Fe = N(P);
        if (!Fe) {
          var je = "";
          (P === void 0 || typeof P == "object" && P !== null && Object.keys(P).length === 0) && (je += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var It = Da(Me);
          It ? je += It : je += Sn();
          var ut;
          P === null ? ut = "null" : tt(P) ? ut = "array" : P !== void 0 && P.$$typeof === t ? (ut = "<" + (U(P.type) || "Unknown") + " />", je = " Did you accidentally export a JSX literal instead of a component?") : ut = typeof P, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ut, je);
        }
        var ft = He(P, X, fe, Me, Ze);
        if (ft == null)
          return ft;
        if (Fe) {
          var Mt = X.children;
          if (Mt !== void 0)
            if (Te)
              if (tt(Mt)) {
                for (var Zn = 0; Zn < Mt.length; Zn++)
                  Xs(Mt[Zn], P);
                Object.freeze && Object.freeze(Mt);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Xs(Mt, P);
        }
        if (Oe.call(X, "key")) {
          var Qt = U(P), Tt = Object.keys(X).filter(function(Qs) {
            return Qs !== "key";
          }), Do = Tt.length > 0 ? "{key: someKey, " + Tt.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Zs[Qt + Do]) {
            var Hr = Tt.length > 0 ? "{" + Tt.join(": ..., ") + ": ...}" : "{}";
            b(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Do, Qt, Hr, Qt), Zs[Qt + Do] = !0;
          }
        }
        return P === r ? Fa(ft) : pn(ft), ft;
      }
    }
    function Ba(P, X, fe) {
      return Js(P, X, fe, !0);
    }
    function La(P, X, fe) {
      return Js(P, X, fe, !1);
    }
    var Xn = La, Va = Ba;
    Wo.Fragment = r, Wo.jsx = Xn, Wo.jsxs = Va;
  }()), Wo;
}
process.env.NODE_ENV === "production" ? ul.exports = K_() : ul.exports = Y_();
var h = ul.exports;
const Ro = Nn({});
Ro.displayName = "ColorModeContext";
function pa() {
  const e = vt(Ro);
  if (e === void 0)
    throw new Error("useColorMode must be used within a ColorModeProvider");
  return e;
}
function uL(e, t) {
  const { colorMode: n } = pa();
  return n === "dark" ? t : e;
}
const ui = {
  light: "chakra-ui-light",
  dark: "chakra-ui-dark"
};
function X_(e = {}) {
  const { preventTransition: t = !0, nonce: n } = e, r = {
    setDataset: (o) => {
      const s = t ? r.preventTransition() : void 0;
      document.documentElement.dataset.theme = o, document.documentElement.style.colorScheme = o, s == null || s();
    },
    setClassName(o) {
      document.body.classList.add(o ? ui.dark : ui.light), document.body.classList.remove(o ? ui.light : ui.dark);
    },
    query() {
      return window.matchMedia("(prefers-color-scheme: dark)");
    },
    getSystemTheme(o) {
      return r.query().matches ?? o === "dark" ? "dark" : "light";
    },
    addListener(o) {
      const s = r.query(), i = (a) => {
        o(a.matches ? "dark" : "light");
      };
      return typeof s.addListener == "function" ? s.addListener(i) : s.addEventListener("change", i), () => {
        typeof s.removeListener == "function" ? s.removeListener(i) : s.removeEventListener("change", i);
      };
    },
    preventTransition() {
      const o = document.createElement("style");
      return o.appendChild(
        document.createTextNode(
          "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}"
        )
      ), n !== void 0 && (o.nonce = n), document.head.appendChild(o), () => {
        window.getComputedStyle(document.body), requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            document.head.removeChild(o);
          });
        });
      };
    }
  };
  return r;
}
const ou = "chakra-ui-color-mode";
function Z_(e) {
  return {
    ssr: !1,
    type: "localStorage",
    get(t) {
      if (!(globalThis != null && globalThis.document))
        return t;
      let n;
      try {
        n = localStorage.getItem(e) || t;
      } catch {
      }
      return n || t;
    },
    set(t) {
      try {
        localStorage.setItem(e, t);
      } catch {
      }
    }
  };
}
const J_ = Z_(ou);
function Xd(e, t) {
  const n = e.match(new RegExp(`(^| )${t}=([^;]+)`));
  return n == null ? void 0 : n[2];
}
function Tm(e, t) {
  return {
    ssr: !!t,
    type: "cookie",
    get(n) {
      return t ? Xd(t, e) : globalThis != null && globalThis.document && Xd(document.cookie, e) || n;
    },
    set(n) {
      document.cookie = `${e}=${n}; max-age=31536000; path=/`;
    }
  };
}
const dL = Tm(ou), fL = (e) => Tm(ou, e), wo = () => {
}, Q_ = d0() ? Is : xe;
function Zd(e, t) {
  return e.type === "cookie" && e.ssr ? e.get(t) : t;
}
const Em = function(t) {
  const {
    value: n,
    children: r,
    options: {
      useSystemColorMode: o,
      initialColorMode: s,
      disableTransitionOnChange: i
    } = {},
    colorModeManager: a = J_
  } = t, c = i0(), l = s === "dark" ? "dark" : "light", [u, d] = he(
    () => Zd(a, l)
  ), [f, p] = he(
    () => Zd(a)
  ), { getSystemTheme: m, setClassName: g, setDataset: y, addListener: S } = _e(
    () => X_({
      preventTransition: i,
      nonce: c == null ? void 0 : c.nonce
    }),
    [i, c == null ? void 0 : c.nonce]
  ), b = s === "system" && !u ? f : u, v = R(
    (_) => {
      const C = _ === "system" ? m() : _;
      d(C), g(C === "dark"), y(C), a.set(C);
    },
    [a, m, g, y]
  );
  Q_(() => {
    s === "system" && p(m());
  }, []), xe(() => {
    const _ = a.get();
    if (_) {
      v(_);
      return;
    }
    if (s === "system") {
      v("system");
      return;
    }
    v(l);
  }, [a, l, s, v]);
  const k = R(() => {
    v(b === "dark" ? "light" : "dark");
  }, [b, v]);
  xe(() => {
    if (o)
      return S(v);
  }, [o, S, v]);
  const w = _e(
    () => ({
      colorMode: n ?? b,
      toggleColorMode: n ? wo : k,
      setColorMode: n ? wo : v,
      forced: n !== void 0
    }),
    [b, k, v, n]
  );
  return /* @__PURE__ */ h.jsx(Ro.Provider, { value: w, children: r });
};
Em.displayName = "ColorModeProvider";
function eT(e) {
  const t = _e(
    () => ({
      colorMode: "dark",
      toggleColorMode: wo,
      setColorMode: wo,
      forced: !0
    }),
    []
  );
  return /* @__PURE__ */ h.jsx(Ro.Provider, { value: t, ...e });
}
eT.displayName = "DarkMode";
function tT(e) {
  const t = _e(
    () => ({
      colorMode: "light",
      toggleColorMode: wo,
      setColorMode: wo,
      forced: !0
    }),
    []
  );
  return /* @__PURE__ */ h.jsx(Ro.Provider, { value: t, ...e });
}
tT.displayName = "LightMode";
const Am = String.raw, Im = Am`
  :root,
  :host {
    --chakra-vh: 100vh;
  }

  @supports (height: -webkit-fill-available) {
    :root,
    :host {
      --chakra-vh: -webkit-fill-available;
    }
  }

  @supports (height: -moz-fill-available) {
    :root,
    :host {
      --chakra-vh: -moz-fill-available;
    }
  }

  @supports (height: 100dvh) {
    :root,
    :host {
      --chakra-vh: 100dvh;
    }
  }
`, nT = () => /* @__PURE__ */ h.jsx(sa, { styles: Im }), rT = ({ scope: e = "" }) => /* @__PURE__ */ h.jsx(
  sa,
  {
    styles: Am`
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }

      body {
        position: relative;
        min-height: 100%;
        margin: 0;
        font-feature-settings: "kern";
      }

      ${e} :where(*, *::before, *::after) {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
        word-wrap: break-word;
      }

      main {
        display: block;
      }

      ${e} hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      ${e} :where(pre, code, kbd,samp) {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      ${e} a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }

      ${e} abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      ${e} :where(b, strong) {
        font-weight: bold;
      }

      ${e} small {
        font-size: 80%;
      }

      ${e} :where(sub,sup) {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      ${e} sub {
        bottom: -0.25em;
      }

      ${e} sup {
        top: -0.5em;
      }

      ${e} img {
        border-style: none;
      }

      ${e} :where(button, input, optgroup, select, textarea) {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }

      ${e} :where(button, input) {
        overflow: visible;
      }

      ${e} :where(button, select) {
        text-transform: none;
      }

      ${e} :where(
          button::-moz-focus-inner,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner
        ) {
        border-style: none;
        padding: 0;
      }

      ${e} fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      ${e} legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      ${e} progress {
        vertical-align: baseline;
      }

      ${e} textarea {
        overflow: auto;
      }

      ${e} :where([type="checkbox"], [type="radio"]) {
        box-sizing: border-box;
        padding: 0;
      }

      ${e} input[type="number"]::-webkit-inner-spin-button,
      ${e} input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      ${e} input[type="number"] {
        -moz-appearance: textfield;
      }

      ${e} input[type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      ${e} input[type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ${e} ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      ${e} details {
        display: block;
      }

      ${e} summary {
        display: list-item;
      }

      template {
        display: none;
      }

      [hidden] {
        display: none !important;
      }

      ${e} :where(
          blockquote,
          dl,
          dd,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          hr,
          figure,
          p,
          pre
        ) {
        margin: 0;
      }

      ${e} button {
        background: transparent;
        padding: 0;
      }

      ${e} fieldset {
        margin: 0;
        padding: 0;
      }

      ${e} :where(ol, ul) {
        margin: 0;
        padding: 0;
      }

      ${e} textarea {
        resize: vertical;
      }

      ${e} :where(button, [role="button"]) {
        cursor: pointer;
      }

      ${e} button::-moz-focus-inner {
        border: 0 !important;
      }

      ${e} table {
        border-collapse: collapse;
      }

      ${e} :where(h1, h2, h3, h4, h5, h6) {
        font-size: inherit;
        font-weight: inherit;
      }

      ${e} :where(button, input, optgroup, select, textarea) {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      ${e} :where(img, svg, video, canvas, audio, iframe, embed, object) {
        display: block;
      }

      ${e} :where(img, video) {
        max-width: 100%;
        height: auto;
      }

      [data-js-focus-visible]
        :focus:not([data-focus-visible-added]):not(
          [data-focus-visible-disabled]
        ) {
        outline: none;
        box-shadow: none;
      }

      ${e} select::-ms-expand {
        display: none;
      }

      ${Im}
    `
  }
);
function Rm(e) {
  const { cssVarsRoot: t, theme: n, children: r } = e, o = _e(() => LS(n), [n]);
  return /* @__PURE__ */ h.jsxs(a0, { theme: o, children: [
    /* @__PURE__ */ h.jsx(oT, { root: t }),
    r
  ] });
}
function oT({ root: e = ":host, :root" }) {
  const t = [e, "[data-theme]"].join(",");
  return /* @__PURE__ */ h.jsx(sa, { styles: (n) => ({ [t]: n.__cssVars }) });
}
const [pL, hL] = Ee({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
function $m(e) {
  return Ee({
    name: `${e}StylesContext`,
    errorMessage: `useStyles: "styles" is undefined. Seems you forgot to wrap the components in "<${e} />" `
  });
}
function sT() {
  const { colorMode: e } = pa();
  return /* @__PURE__ */ h.jsx(
    sa,
    {
      styles: (t) => {
        const n = Oh(t, "styles.global"), r = Et(n, { theme: t, colorMode: e });
        return r ? im(r)(t) : void 0;
      }
    }
  );
}
const [iT, aT] = Ee({
  strict: !1,
  name: "PortalManagerContext"
});
function Nm(e) {
  const { children: t, zIndex: n } = e;
  return /* @__PURE__ */ h.jsx(iT, { value: { zIndex: n }, children: t });
}
Nm.displayName = "PortalManager";
const su = Nn({
  getDocument() {
    return document;
  },
  getWindow() {
    return window;
  }
});
su.displayName = "EnvironmentContext";
function cT({ defer: e } = {}) {
  const [, t] = n0((n) => n + 1, 0);
  return an(() => {
    e && t();
  }, [e]), vt(su);
}
function Mm(e) {
  const { children: t, environment: n, disabled: r } = e, o = ae(null), s = _e(() => n || {
    getDocument: () => {
      var a;
      return ((a = o.current) == null ? void 0 : a.ownerDocument) ?? document;
    },
    getWindow: () => {
      var a;
      return ((a = o.current) == null ? void 0 : a.ownerDocument.defaultView) ?? window;
    }
  }, [n]), i = !r || !n;
  return /* @__PURE__ */ h.jsxs(su.Provider, { value: s, children: [
    t,
    i && /* @__PURE__ */ h.jsx("span", { id: "__chakra_env", hidden: !0, ref: o })
  ] });
}
Mm.displayName = "EnvironmentProvider";
const lT = (e) => {
  const {
    children: t,
    colorModeManager: n,
    portalZIndex: r,
    resetScope: o,
    resetCSS: s = !0,
    theme: i = {},
    environment: a,
    cssVarsRoot: c,
    disableEnvironment: l,
    disableGlobalStyle: u
  } = e, d = /* @__PURE__ */ h.jsx(
    Mm,
    {
      environment: a,
      disabled: l,
      children: t
    }
  );
  return /* @__PURE__ */ h.jsx(Rm, { theme: i, cssVarsRoot: c, children: /* @__PURE__ */ h.jsxs(
    Em,
    {
      colorModeManager: n,
      options: i.config,
      children: [
        s ? /* @__PURE__ */ h.jsx(rT, { scope: o }) : /* @__PURE__ */ h.jsx(nT, {}),
        !u && /* @__PURE__ */ h.jsx(sT, {}),
        r ? /* @__PURE__ */ h.jsx(Nm, { zIndex: r, children: d }) : d
      ]
    }
  ) });
}, jm = Nn({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
}), ha = Nn({}), js = Nn(null), ma = typeof document < "u", iu = ma ? Is : xe, Dm = Nn({ strict: !1 }), au = (e) => e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), uT = "framerAppearId", Om = "data-" + au(uT);
function dT(e, t, n, r) {
  const { visualElement: o } = vt(ha), s = vt(Dm), i = vt(js), a = vt(jm).reducedMotion, c = ae();
  r = r || s.renderer, !c.current && r && (c.current = r(e, {
    visualState: t,
    parent: o,
    props: n,
    presenceContext: i,
    blockInitialAnimation: i ? i.initial === !1 : !1,
    reducedMotionConfig: a
  }));
  const l = c.current;
  Eh(() => {
    l && l.update(n, i);
  });
  const u = ae(!!(n[Om] && !window.HandoffComplete));
  return iu(() => {
    l && (l.render(), u.current && l.animationState && l.animationState.animateChanges());
  }), xe(() => {
    l && (l.updateFeatures(), !u.current && l.animationState && l.animationState.animateChanges(), u.current && (u.current = !1, window.HandoffComplete = !0));
  }), l;
}
function so(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function fT(e, t, n) {
  return R(
    (r) => {
      r && e.mount && e.mount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : so(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
function xs(e) {
  return typeof e == "string" || Array.isArray(e);
}
function ga(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
const cu = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], lu = ["initial", ...cu];
function ya(e) {
  return ga(e.animate) || lu.some((t) => xs(e[t]));
}
function Fm(e) {
  return !!(ya(e) || e.variants);
}
function pT(e, t) {
  if (ya(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || xs(n) ? n : void 0,
      animate: xs(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function hT(e) {
  const { initial: t, animate: n } = pT(e, vt(ha));
  return _e(() => ({ initial: t, animate: n }), [Jd(t), Jd(n)]);
}
function Jd(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const Qd = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, Ss = {};
for (const e in Qd)
  Ss[e] = {
    isEnabled: (t) => Qd[e].some((n) => !!t[n])
  };
function mT(e) {
  for (const t in e)
    Ss[t] = {
      ...Ss[t],
      ...e[t]
    };
}
const uu = Nn({}), Bm = Nn({}), gT = Symbol.for("motionComponentSymbol");
function yT({ preloadedFeatures: e, createVisualElement: t, useRender: n, useVisualState: r, Component: o }) {
  e && mT(e);
  function s(a, c) {
    let l;
    const u = {
      ...vt(jm),
      ...a,
      layoutId: bT(a)
    }, { isStatic: d } = u, f = hT(a), p = r(a, d);
    if (!d && ma) {
      f.visualElement = dT(o, p, u, t);
      const m = vt(Bm), g = vt(Dm).strict;
      f.visualElement && (l = f.visualElement.loadFeatures(
        // Note: Pass the full new combined props to correctly re-render dynamic feature components.
        u,
        g,
        e,
        m
      ));
    }
    return we.createElement(
      ha.Provider,
      { value: f },
      l && f.visualElement ? we.createElement(l, { visualElement: f.visualElement, ...u }) : null,
      n(o, a, fT(p, f.visualElement, c), p, d, f.visualElement)
    );
  }
  const i = vn(s);
  return i[gT] = o, i;
}
function bT({ layoutId: e }) {
  const t = vt(uu).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function vT(e) {
  function t(r, o = {}) {
    return yT(e(r, o));
  }
  if (typeof Proxy > "u")
    return t;
  const n = /* @__PURE__ */ new Map();
  return new Proxy(t, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, o) => (n.has(o) || n.set(o, t(o)), n.get(o))
  });
}
const xT = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function du(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(xT.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(e))
    )
  );
}
const qi = {};
function ST(e) {
  Object.assign(qi, e);
}
const Ds = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Or = new Set(Ds);
function Lm(e, { layout: t, layoutId: n }) {
  return Or.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!qi[e] || e === "opacity");
}
const Gt = (e) => !!(e && e.getVelocity), wT = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, kT = Ds.length;
function PT(e, { enableHardwareAcceleration: t = !0, allowTransformNone: n = !0 }, r, o) {
  let s = "";
  for (let i = 0; i < kT; i++) {
    const a = Ds[i];
    if (e[a] !== void 0) {
      const c = wT[a] || a;
      s += `${c}(${e[a]}) `;
    }
  }
  return t && !e.z && (s += "translateZ(0)"), s = s.trim(), o ? s = o(e, r ? "" : s) : n && r && (s = "none"), s;
}
const Vm = (e) => (t) => typeof t == "string" && t.startsWith(e), zm = Vm("--"), dl = Vm("var(--"), CT = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g, _T = (e, t) => t && typeof e == "number" ? t.transform(e) : e, ar = (e, t, n) => Math.min(Math.max(n, e), t), Fr = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, us = {
  ...Fr,
  transform: (e) => ar(0, 1, e)
}, di = {
  ...Fr,
  default: 1
}, ds = (e) => Math.round(e * 1e5) / 1e5, ba = /(-)?([\d]*\.?[\d])+/g, Wm = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi, TT = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function Os(e) {
  return typeof e == "string";
}
const Fs = (e) => ({
  test: (t) => Os(t) && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), tr = Fs("deg"), An = Fs("%"), Ce = Fs("px"), ET = Fs("vh"), AT = Fs("vw"), ef = {
  ...An,
  parse: (e) => An.parse(e) / 100,
  transform: (e) => An.transform(e * 100)
}, tf = {
  ...Fr,
  transform: Math.round
}, Hm = {
  // Border props
  borderWidth: Ce,
  borderTopWidth: Ce,
  borderRightWidth: Ce,
  borderBottomWidth: Ce,
  borderLeftWidth: Ce,
  borderRadius: Ce,
  radius: Ce,
  borderTopLeftRadius: Ce,
  borderTopRightRadius: Ce,
  borderBottomRightRadius: Ce,
  borderBottomLeftRadius: Ce,
  // Positioning props
  width: Ce,
  maxWidth: Ce,
  height: Ce,
  maxHeight: Ce,
  size: Ce,
  top: Ce,
  right: Ce,
  bottom: Ce,
  left: Ce,
  // Spacing props
  padding: Ce,
  paddingTop: Ce,
  paddingRight: Ce,
  paddingBottom: Ce,
  paddingLeft: Ce,
  margin: Ce,
  marginTop: Ce,
  marginRight: Ce,
  marginBottom: Ce,
  marginLeft: Ce,
  // Transform props
  rotate: tr,
  rotateX: tr,
  rotateY: tr,
  rotateZ: tr,
  scale: di,
  scaleX: di,
  scaleY: di,
  scaleZ: di,
  skew: tr,
  skewX: tr,
  skewY: tr,
  distance: Ce,
  translateX: Ce,
  translateY: Ce,
  translateZ: Ce,
  x: Ce,
  y: Ce,
  z: Ce,
  perspective: Ce,
  transformPerspective: Ce,
  opacity: us,
  originX: ef,
  originY: ef,
  originZ: Ce,
  // Misc
  zIndex: tf,
  // SVG
  fillOpacity: us,
  strokeOpacity: us,
  numOctaves: tf
};
function fu(e, t, n, r) {
  const { style: o, vars: s, transform: i, transformOrigin: a } = e;
  let c = !1, l = !1, u = !0;
  for (const d in t) {
    const f = t[d];
    if (zm(d)) {
      s[d] = f;
      continue;
    }
    const p = Hm[d], m = _T(f, p);
    if (Or.has(d)) {
      if (c = !0, i[d] = m, !u)
        continue;
      f !== (p.default || 0) && (u = !1);
    } else
      d.startsWith("origin") ? (l = !0, a[d] = m) : o[d] = m;
  }
  if (t.transform || (c || r ? o.transform = PT(e.transform, n, u, r) : o.transform && (o.transform = "none")), l) {
    const { originX: d = "50%", originY: f = "50%", originZ: p = 0 } = a;
    o.transformOrigin = `${d} ${f} ${p}`;
  }
}
const pu = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function Um(e, t, n) {
  for (const r in t)
    !Gt(t[r]) && !Lm(r, n) && (e[r] = t[r]);
}
function IT({ transformTemplate: e }, t, n) {
  return _e(() => {
    const r = pu();
    return fu(r, t, { enableHardwareAcceleration: !n }, e), Object.assign({}, r.vars, r.style);
  }, [t]);
}
function RT(e, t, n) {
  const r = e.style || {}, o = {};
  return Um(o, r, e), Object.assign(o, IT(e, t, n)), e.transformValues ? e.transformValues(o) : o;
}
function $T(e, t, n) {
  const r = {}, o = RT(e, t, n);
  return e.drag && e.dragListener !== !1 && (r.draggable = !1, o.userSelect = o.WebkitUserSelect = o.WebkitTouchCallout = "none", o.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (r.tabIndex = 0), r.style = o, r;
}
const NT = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function Ki(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || NT.has(e);
}
let Gm = (e) => !Ki(e);
function MT(e) {
  e && (Gm = (t) => t.startsWith("on") ? !Ki(t) : e(t));
}
try {
  MT(require("@emotion/is-prop-valid").default);
} catch {
}
function jT(e, t, n) {
  const r = {};
  for (const o in e)
    o === "values" && typeof e.values == "object" || (Gm(o) || n === !0 && Ki(o) || !t && !Ki(o) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && o.startsWith("onDrag")) && (r[o] = e[o]);
  return r;
}
function nf(e, t, n) {
  return typeof e == "string" ? e : Ce.transform(t + n * e);
}
function DT(e, t, n) {
  const r = nf(t, e.x, e.width), o = nf(n, e.y, e.height);
  return `${r} ${o}`;
}
const OT = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, FT = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function BT(e, t, n = 1, r = 0, o = !0) {
  e.pathLength = 1;
  const s = o ? OT : FT;
  e[s.offset] = Ce.transform(-r);
  const i = Ce.transform(t), a = Ce.transform(n);
  e[s.array] = `${i} ${a}`;
}
function hu(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  originX: o,
  originY: s,
  pathLength: i,
  pathSpacing: a = 1,
  pathOffset: c = 0,
  // This is object creation, which we try to avoid per-frame.
  ...l
}, u, d, f) {
  if (fu(e, l, u, f), d) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: p, style: m, dimensions: g } = e;
  p.transform && (g && (m.transform = p.transform), delete p.transform), g && (o !== void 0 || s !== void 0 || m.transform) && (m.transformOrigin = DT(g, o !== void 0 ? o : 0.5, s !== void 0 ? s : 0.5)), t !== void 0 && (p.x = t), n !== void 0 && (p.y = n), r !== void 0 && (p.scale = r), i !== void 0 && BT(p, i, a, c, !1);
}
const qm = () => ({
  ...pu(),
  attrs: {}
}), mu = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function LT(e, t, n, r) {
  const o = _e(() => {
    const s = qm();
    return hu(s, t, { enableHardwareAcceleration: !1 }, mu(r), e.transformTemplate), {
      ...s.attrs,
      style: { ...s.style }
    };
  }, [t]);
  if (e.style) {
    const s = {};
    Um(s, e.style, e), o.style = { ...s, ...o.style };
  }
  return o;
}
function VT(e = !1) {
  return (n, r, o, { latestValues: s }, i) => {
    const c = (du(n) ? LT : $T)(r, s, i, n), u = {
      ...jT(r, typeof n == "string", e),
      ...c,
      ref: o
    }, { children: d } = r, f = _e(() => Gt(d) ? d.get() : d, [d]);
    return Hl(n, {
      ...u,
      children: f
    });
  };
}
function Km(e, { style: t, vars: n }, r, o) {
  Object.assign(e.style, t, o && o.getProjectionStyles(r));
  for (const s in n)
    e.style.setProperty(s, n[s]);
}
const Ym = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function Xm(e, t, n, r) {
  Km(e, t, void 0, r);
  for (const o in t.attrs)
    e.setAttribute(Ym.has(o) ? o : au(o), t.attrs[o]);
}
function gu(e, t) {
  const { style: n } = e, r = {};
  for (const o in n)
    (Gt(n[o]) || t.style && Gt(t.style[o]) || Lm(o, e)) && (r[o] = n[o]);
  return r;
}
function Zm(e, t) {
  const n = gu(e, t);
  for (const r in e)
    if (Gt(e[r]) || Gt(t[r])) {
      const o = Ds.indexOf(r) !== -1 ? "attr" + r.charAt(0).toUpperCase() + r.substring(1) : r;
      n[o] = e[r];
    }
  return n;
}
function yu(e, t, n, r = {}, o = {}) {
  return typeof t == "function" && (t = t(n !== void 0 ? n : e.custom, r, o)), typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function" && (t = t(n !== void 0 ? n : e.custom, r, o)), t;
}
function Jm(e) {
  const t = ae(null);
  return t.current === null && (t.current = e()), t.current;
}
const Yi = (e) => Array.isArray(e), zT = (e) => !!(e && typeof e == "object" && e.mix && e.toValue), WT = (e) => Yi(e) ? e[e.length - 1] || 0 : e;
function Ni(e) {
  const t = Gt(e) ? e.get() : e;
  return zT(t) ? t.toValue() : t;
}
function HT({ scrapeMotionValuesFromProps: e, createRenderState: t, onMount: n }, r, o, s) {
  const i = {
    latestValues: UT(r, o, s, e),
    renderState: t()
  };
  return n && (i.mount = (a) => n(r, a, i)), i;
}
const Qm = (e) => (t, n) => {
  const r = vt(ha), o = vt(js), s = () => HT(e, t, r, o);
  return n ? s() : Jm(s);
};
function UT(e, t, n, r) {
  const o = {}, s = r(e, {});
  for (const f in s)
    o[f] = Ni(s[f]);
  let { initial: i, animate: a } = e;
  const c = ya(e), l = Fm(e);
  t && l && !c && e.inherit !== !1 && (i === void 0 && (i = t.initial), a === void 0 && (a = t.animate));
  let u = n ? n.initial === !1 : !1;
  u = u || i === !1;
  const d = u ? a : i;
  return d && typeof d != "boolean" && !ga(d) && (Array.isArray(d) ? d : [d]).forEach((p) => {
    const m = yu(e, p);
    if (!m)
      return;
    const { transitionEnd: g, transition: y, ...S } = m;
    for (const b in S) {
      let v = S[b];
      if (Array.isArray(v)) {
        const k = u ? v.length - 1 : 0;
        v = v[k];
      }
      v !== null && (o[b] = v);
    }
    for (const b in g)
      o[b] = g[b];
  }), o;
}
const ht = (e) => e;
class rf {
  constructor() {
    this.order = [], this.scheduled = /* @__PURE__ */ new Set();
  }
  add(t) {
    if (!this.scheduled.has(t))
      return this.scheduled.add(t), this.order.push(t), !0;
  }
  remove(t) {
    const n = this.order.indexOf(t);
    n !== -1 && (this.order.splice(n, 1), this.scheduled.delete(t));
  }
  clear() {
    this.order.length = 0, this.scheduled.clear();
  }
}
function GT(e) {
  let t = new rf(), n = new rf(), r = 0, o = !1, s = !1;
  const i = /* @__PURE__ */ new WeakSet(), a = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, l = !1, u = !1) => {
      const d = u && o, f = d ? t : n;
      return l && i.add(c), f.add(c) && d && o && (r = t.order.length), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      n.remove(c), i.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (o) {
        s = !0;
        return;
      }
      if (o = !0, [t, n] = [n, t], n.clear(), r = t.order.length, r)
        for (let l = 0; l < r; l++) {
          const u = t.order[l];
          u(c), i.has(u) && (a.schedule(u), e());
        }
      o = !1, s && (s = !1, a.process(c));
    }
  };
  return a;
}
const fi = [
  "prepare",
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], qT = 40;
function KT(e, t) {
  let n = !1, r = !0;
  const o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, s = fi.reduce((d, f) => (d[f] = GT(() => n = !0), d), {}), i = (d) => s[d].process(o), a = () => {
    const d = performance.now();
    n = !1, o.delta = r ? 1e3 / 60 : Math.max(Math.min(d - o.timestamp, qT), 1), o.timestamp = d, o.isProcessing = !0, fi.forEach(i), o.isProcessing = !1, n && t && (r = !1, e(a));
  }, c = () => {
    n = !0, r = !0, o.isProcessing || e(a);
  };
  return { schedule: fi.reduce((d, f) => {
    const p = s[f];
    return d[f] = (m, g = !1, y = !1) => (n || c(), p.schedule(m, g, y)), d;
  }, {}), cancel: (d) => fi.forEach((f) => s[f].cancel(d)), state: o, steps: s };
}
const { schedule: rt, cancel: qn, state: jt, steps: yc } = KT(typeof requestAnimationFrame < "u" ? requestAnimationFrame : ht, !0), YT = {
  useVisualState: Qm({
    scrapeMotionValuesFromProps: Zm,
    createRenderState: qm,
    onMount: (e, t, { renderState: n, latestValues: r }) => {
      rt.read(() => {
        try {
          n.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
        } catch {
          n.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      }), rt.render(() => {
        hu(n, r, { enableHardwareAcceleration: !1 }, mu(t.tagName), e.transformTemplate), Xm(t, n);
      });
    }
  })
}, XT = {
  useVisualState: Qm({
    scrapeMotionValuesFromProps: gu,
    createRenderState: pu
  })
};
function ZT(e, { forwardMotionProps: t = !1 }, n, r) {
  return {
    ...du(e) ? YT : XT,
    preloadedFeatures: n,
    useRender: VT(t),
    createVisualElement: r,
    Component: e
  };
}
function zn(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
const eg = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1;
function va(e, t = "page") {
  return {
    point: {
      x: e[t + "X"],
      y: e[t + "Y"]
    }
  };
}
const JT = (e) => (t) => eg(t) && e(t, va(t));
function Hn(e, t, n, r) {
  return zn(e, t, JT(n), r);
}
const QT = (e, t) => (n) => t(e(n)), sr = (...e) => e.reduce(QT);
function tg(e) {
  let t = null;
  return () => {
    const n = () => {
      t = null;
    };
    return t === null ? (t = e, n) : !1;
  };
}
const of = tg("dragHorizontal"), sf = tg("dragVertical");
function ng(e) {
  let t = !1;
  if (e === "y")
    t = sf();
  else if (e === "x")
    t = of();
  else {
    const n = of(), r = sf();
    n && r ? t = () => {
      n(), r();
    } : (n && n(), r && r());
  }
  return t;
}
function rg() {
  const e = ng(!0);
  return e ? (e(), !1) : !0;
}
class fr {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
function af(e, t) {
  const n = "pointer" + (t ? "enter" : "leave"), r = "onHover" + (t ? "Start" : "End"), o = (s, i) => {
    if (s.pointerType === "touch" || rg())
      return;
    const a = e.getProps();
    e.animationState && a.whileHover && e.animationState.setActive("whileHover", t), a[r] && rt.update(() => a[r](s, i));
  };
  return Hn(e.current, n, o, {
    passive: !e.getProps()[r]
  });
}
class eE extends fr {
  mount() {
    this.unmount = sr(af(this.node, !0), af(this.node, !1));
  }
  unmount() {
  }
}
class tE extends fr {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = sr(zn(this.node.current, "focus", () => this.onFocus()), zn(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const og = (e, t) => t ? e === t ? !0 : og(e, t.parentElement) : !1;
function bc(e, t) {
  if (!t)
    return;
  const n = new PointerEvent("pointer" + e);
  t(n, va(n));
}
class nE extends fr {
  constructor() {
    super(...arguments), this.removeStartListeners = ht, this.removeEndListeners = ht, this.removeAccessibleListeners = ht, this.startPointerPress = (t, n) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const r = this.node.getProps(), s = Hn(window, "pointerup", (a, c) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: l, onTapCancel: u, globalTapTarget: d } = this.node.getProps();
        rt.update(() => {
          !d && !og(this.node.current, a.target) ? u && u(a, c) : l && l(a, c);
        });
      }, { passive: !(r.onTap || r.onPointerUp) }), i = Hn(window, "pointercancel", (a, c) => this.cancelPress(a, c), { passive: !(r.onTapCancel || r.onPointerCancel) });
      this.removeEndListeners = sr(s, i), this.startPress(t, n);
    }, this.startAccessiblePress = () => {
      const t = (s) => {
        if (s.key !== "Enter" || this.isPressing)
          return;
        const i = (a) => {
          a.key !== "Enter" || !this.checkPressEnd() || bc("up", (c, l) => {
            const { onTap: u } = this.node.getProps();
            u && rt.update(() => u(c, l));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = zn(this.node.current, "keyup", i), bc("down", (a, c) => {
          this.startPress(a, c);
        });
      }, n = zn(this.node.current, "keydown", t), r = () => {
        this.isPressing && bc("cancel", (s, i) => this.cancelPress(s, i));
      }, o = zn(this.node.current, "blur", r);
      this.removeAccessibleListeners = sr(n, o);
    };
  }
  startPress(t, n) {
    this.isPressing = !0;
    const { onTapStart: r, whileTap: o } = this.node.getProps();
    o && this.node.animationState && this.node.animationState.setActive("whileTap", !0), r && rt.update(() => r(t, n));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !rg();
  }
  cancelPress(t, n) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: r } = this.node.getProps();
    r && rt.update(() => r(t, n));
  }
  mount() {
    const t = this.node.getProps(), n = Hn(t.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, { passive: !(t.onTapStart || t.onPointerStart) }), r = zn(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = sr(n, r);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const fl = /* @__PURE__ */ new WeakMap(), vc = /* @__PURE__ */ new WeakMap(), rE = (e) => {
  const t = fl.get(e.target);
  t && t(e);
}, oE = (e) => {
  e.forEach(rE);
};
function sE({ root: e, ...t }) {
  const n = e || document;
  vc.has(n) || vc.set(n, {});
  const r = vc.get(n), o = JSON.stringify(t);
  return r[o] || (r[o] = new IntersectionObserver(oE, { root: e, ...t })), r[o];
}
function iE(e, t, n) {
  const r = sE(t);
  return fl.set(e, n), r.observe(e), () => {
    fl.delete(e), r.unobserve(e);
  };
}
const aE = {
  some: 0,
  all: 1
};
class cE extends fr {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: o = "some", once: s } = t, i = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof o == "number" ? o : aE[o]
    }, a = (c) => {
      const { isIntersecting: l } = c;
      if (this.isInView === l || (this.isInView = l, s && !l && this.hasEnteredView))
        return;
      l && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", l);
      const { onViewportEnter: u, onViewportLeave: d } = this.node.getProps(), f = l ? u : d;
      f && f(c);
    };
    return iE(this.node.current, i, a);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(lE(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function lE({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const uE = {
  inView: {
    Feature: cE
  },
  tap: {
    Feature: nE
  },
  focus: {
    Feature: tE
  },
  hover: {
    Feature: eE
  }
};
function sg(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
function dE(e) {
  const t = {};
  return e.values.forEach((n, r) => t[r] = n.get()), t;
}
function fE(e) {
  const t = {};
  return e.values.forEach((n, r) => t[r] = n.getVelocity()), t;
}
function xa(e, t, n) {
  const r = e.getProps();
  return yu(r, t, n !== void 0 ? n : r.custom, dE(e), fE(e));
}
let Bs = ht, ln = ht;
process.env.NODE_ENV !== "production" && (Bs = (e, t) => {
  !e && typeof console < "u" && console.warn(t);
}, ln = (e, t) => {
  if (!e)
    throw new Error(t);
});
const ir = (e) => e * 1e3, Un = (e) => e / 1e3, pE = {
  current: !1
}, ig = (e) => Array.isArray(e) && typeof e[0] == "number";
function ag(e) {
  return !!(!e || typeof e == "string" && cg[e] || ig(e) || Array.isArray(e) && e.every(ag));
}
const es = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, cg = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: es([0, 0.65, 0.55, 1]),
  circOut: es([0.55, 0, 1, 0.45]),
  backIn: es([0.31, 0.01, 0.66, -0.59]),
  backOut: es([0.33, 1.53, 0.69, 0.99])
};
function lg(e) {
  if (e)
    return ig(e) ? es(e) : Array.isArray(e) ? e.map(lg) : cg[e];
}
function hE(e, t, n, { delay: r = 0, duration: o, repeat: s = 0, repeatType: i = "loop", ease: a, times: c } = {}) {
  const l = { [t]: n };
  c && (l.offset = c);
  const u = lg(a);
  return Array.isArray(u) && (l.easing = u), e.animate(l, {
    delay: r,
    duration: o,
    easing: Array.isArray(u) ? "linear" : u,
    fill: "both",
    iterations: s + 1,
    direction: i === "reverse" ? "alternate" : "normal"
  });
}
function mE(e, { repeat: t, repeatType: n = "loop" }) {
  const r = t && n !== "loop" && t % 2 === 1 ? 0 : e.length - 1;
  return e[r];
}
const ug = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, gE = 1e-7, yE = 12;
function bE(e, t, n, r, o) {
  let s, i, a = 0;
  do
    i = t + (n - t) / 2, s = ug(i, r, o) - e, s > 0 ? n = i : t = i;
  while (Math.abs(s) > gE && ++a < yE);
  return i;
}
function Ls(e, t, n, r) {
  if (e === t && n === r)
    return ht;
  const o = (s) => bE(s, 0, 1, e, n);
  return (s) => s === 0 || s === 1 ? s : ug(o(s), t, r);
}
const vE = Ls(0.42, 0, 1, 1), xE = Ls(0, 0, 0.58, 1), dg = Ls(0.42, 0, 0.58, 1), SE = (e) => Array.isArray(e) && typeof e[0] != "number", fg = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, pg = (e) => (t) => 1 - e(1 - t), bu = (e) => 1 - Math.sin(Math.acos(e)), hg = pg(bu), wE = fg(bu), mg = Ls(0.33, 1.53, 0.69, 0.99), vu = pg(mg), kE = fg(vu), PE = (e) => (e *= 2) < 1 ? 0.5 * vu(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), cf = {
  linear: ht,
  easeIn: vE,
  easeInOut: dg,
  easeOut: xE,
  circIn: bu,
  circInOut: wE,
  circOut: hg,
  backIn: vu,
  backInOut: kE,
  backOut: mg,
  anticipate: PE
}, lf = (e) => {
  if (Array.isArray(e)) {
    ln(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [t, n, r, o] = e;
    return Ls(t, n, r, o);
  } else if (typeof e == "string")
    return ln(cf[e] !== void 0, `Invalid easing type '${e}'`), cf[e];
  return e;
}, xu = (e, t) => (n) => !!(Os(n) && TT.test(n) && n.startsWith(e) || t && Object.prototype.hasOwnProperty.call(n, t)), gg = (e, t, n) => (r) => {
  if (!Os(r))
    return r;
  const [o, s, i, a] = r.match(ba);
  return {
    [e]: parseFloat(o),
    [t]: parseFloat(s),
    [n]: parseFloat(i),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, CE = (e) => ar(0, 255, e), xc = {
  ...Fr,
  transform: (e) => Math.round(CE(e))
}, Pr = {
  test: xu("rgb", "red"),
  parse: gg("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + xc.transform(e) + ", " + xc.transform(t) + ", " + xc.transform(n) + ", " + ds(us.transform(r)) + ")"
};
function _E(e) {
  let t = "", n = "", r = "", o = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), o = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), o = e.substring(4, 5), t += t, n += n, r += r, o += o), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: o ? parseInt(o, 16) / 255 : 1
  };
}
const pl = {
  test: xu("#"),
  parse: _E,
  transform: Pr.transform
}, io = {
  test: xu("hsl", "hue"),
  parse: gg("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + An.transform(ds(t)) + ", " + An.transform(ds(n)) + ", " + ds(us.transform(r)) + ")"
}, Ft = {
  test: (e) => Pr.test(e) || pl.test(e) || io.test(e),
  parse: (e) => Pr.test(e) ? Pr.parse(e) : io.test(e) ? io.parse(e) : pl.parse(e),
  transform: (e) => Os(e) ? e : e.hasOwnProperty("red") ? Pr.transform(e) : io.transform(e)
}, dt = (e, t, n) => -n * e + n * t + e;
function Sc(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function TE({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let o = 0, s = 0, i = 0;
  if (!t)
    o = s = i = n;
  else {
    const a = n < 0.5 ? n * (1 + t) : n + t - n * t, c = 2 * n - a;
    o = Sc(c, a, e + 1 / 3), s = Sc(c, a, e), i = Sc(c, a, e - 1 / 3);
  }
  return {
    red: Math.round(o * 255),
    green: Math.round(s * 255),
    blue: Math.round(i * 255),
    alpha: r
  };
}
const wc = (e, t, n) => {
  const r = e * e;
  return Math.sqrt(Math.max(0, n * (t * t - r) + r));
}, EE = [pl, Pr, io], AE = (e) => EE.find((t) => t.test(e));
function uf(e) {
  const t = AE(e);
  ln(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`);
  let n = t.parse(e);
  return t === io && (n = TE(n)), n;
}
const yg = (e, t) => {
  const n = uf(e), r = uf(t), o = { ...n };
  return (s) => (o.red = wc(n.red, r.red, s), o.green = wc(n.green, r.green, s), o.blue = wc(n.blue, r.blue, s), o.alpha = dt(n.alpha, r.alpha, s), Pr.transform(o));
};
function IE(e) {
  var t, n;
  return isNaN(e) && Os(e) && (((t = e.match(ba)) === null || t === void 0 ? void 0 : t.length) || 0) + (((n = e.match(Wm)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const bg = {
  regex: CT,
  countKey: "Vars",
  token: "${v}",
  parse: ht
}, vg = {
  regex: Wm,
  countKey: "Colors",
  token: "${c}",
  parse: Ft.parse
}, xg = {
  regex: ba,
  countKey: "Numbers",
  token: "${n}",
  parse: Fr.parse
};
function kc(e, { regex: t, countKey: n, token: r, parse: o }) {
  const s = e.tokenised.match(t);
  s && (e["num" + n] = s.length, e.tokenised = e.tokenised.replace(t, r), e.values.push(...s.map(o)));
}
function Xi(e) {
  const t = e.toString(), n = {
    value: t,
    tokenised: t,
    values: [],
    numVars: 0,
    numColors: 0,
    numNumbers: 0
  };
  return n.value.includes("var(--") && kc(n, bg), kc(n, vg), kc(n, xg), n;
}
function Sg(e) {
  return Xi(e).values;
}
function wg(e) {
  const { values: t, numColors: n, numVars: r, tokenised: o } = Xi(e), s = t.length;
  return (i) => {
    let a = o;
    for (let c = 0; c < s; c++)
      c < r ? a = a.replace(bg.token, i[c]) : c < r + n ? a = a.replace(vg.token, Ft.transform(i[c])) : a = a.replace(xg.token, ds(i[c]));
    return a;
  };
}
const RE = (e) => typeof e == "number" ? 0 : e;
function $E(e) {
  const t = Sg(e);
  return wg(e)(t.map(RE));
}
const cr = {
  test: IE,
  parse: Sg,
  createTransformer: wg,
  getAnimatableNone: $E
}, kg = (e, t) => (n) => `${n > 0 ? t : e}`;
function Pg(e, t) {
  return typeof e == "number" ? (n) => dt(e, t, n) : Ft.test(e) ? yg(e, t) : e.startsWith("var(") ? kg(e, t) : _g(e, t);
}
const Cg = (e, t) => {
  const n = [...e], r = n.length, o = e.map((s, i) => Pg(s, t[i]));
  return (s) => {
    for (let i = 0; i < r; i++)
      n[i] = o[i](s);
    return n;
  };
}, NE = (e, t) => {
  const n = { ...e, ...t }, r = {};
  for (const o in n)
    e[o] !== void 0 && t[o] !== void 0 && (r[o] = Pg(e[o], t[o]));
  return (o) => {
    for (const s in r)
      n[s] = r[s](o);
    return n;
  };
}, _g = (e, t) => {
  const n = cr.createTransformer(t), r = Xi(e), o = Xi(t);
  return r.numVars === o.numVars && r.numColors === o.numColors && r.numNumbers >= o.numNumbers ? sr(Cg(r.values, o.values), n) : (Bs(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), kg(e, t));
}, ws = (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
}, df = (e, t) => (n) => dt(e, t, n);
function ME(e) {
  return typeof e == "number" ? df : typeof e == "string" ? Ft.test(e) ? yg : _g : Array.isArray(e) ? Cg : typeof e == "object" ? NE : df;
}
function jE(e, t, n) {
  const r = [], o = n || ME(e[0]), s = e.length - 1;
  for (let i = 0; i < s; i++) {
    let a = o(e[i], e[i + 1]);
    if (t) {
      const c = Array.isArray(t) ? t[i] || ht : t;
      a = sr(c, a);
    }
    r.push(a);
  }
  return r;
}
function Tg(e, t, { clamp: n = !0, ease: r, mixer: o } = {}) {
  const s = e.length;
  if (ln(s === t.length, "Both input and output ranges must be the same length"), s === 1)
    return () => t[0];
  e[0] > e[s - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const i = jE(t, r, o), a = i.length, c = (l) => {
    let u = 0;
    if (a > 1)
      for (; u < e.length - 2 && !(l < e[u + 1]); u++)
        ;
    const d = ws(e[u], e[u + 1], l);
    return i[u](d);
  };
  return n ? (l) => c(ar(e[0], e[s - 1], l)) : c;
}
function DE(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const o = ws(0, t, r);
    e.push(dt(n, 1, o));
  }
}
function OE(e) {
  const t = [0];
  return DE(t, e.length - 1), t;
}
function FE(e, t) {
  return e.map((n) => n * t);
}
function BE(e, t) {
  return e.map(() => t || dg).splice(0, e.length - 1);
}
function Zi({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const o = SE(r) ? r.map(lf) : lf(r), s = {
    done: !1,
    value: t[0]
  }, i = FE(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : OE(t),
    e
  ), a = Tg(i, t, {
    ease: Array.isArray(o) ? o : BE(t, o)
  });
  return {
    calculatedDuration: e,
    next: (c) => (s.value = a(c), s.done = c >= e, s)
  };
}
function Eg(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const LE = 5;
function Ag(e, t, n) {
  const r = Math.max(t - LE, 0);
  return Eg(n - e(r), t - r);
}
const Pc = 1e-3, VE = 0.01, ff = 10, zE = 0.05, WE = 1;
function HE({ duration: e = 800, bounce: t = 0.25, velocity: n = 0, mass: r = 1 }) {
  let o, s;
  Bs(e <= ir(ff), "Spring duration must be 10 seconds or less");
  let i = 1 - t;
  i = ar(zE, WE, i), e = ar(VE, ff, Un(e)), i < 1 ? (o = (l) => {
    const u = l * i, d = u * e, f = u - n, p = hl(l, i), m = Math.exp(-d);
    return Pc - f / p * m;
  }, s = (l) => {
    const d = l * i * e, f = d * n + n, p = Math.pow(i, 2) * Math.pow(l, 2) * e, m = Math.exp(-d), g = hl(Math.pow(l, 2), i);
    return (-o(l) + Pc > 0 ? -1 : 1) * ((f - p) * m) / g;
  }) : (o = (l) => {
    const u = Math.exp(-l * e), d = (l - n) * e + 1;
    return -Pc + u * d;
  }, s = (l) => {
    const u = Math.exp(-l * e), d = (n - l) * (e * e);
    return u * d;
  });
  const a = 5 / e, c = GE(o, s, a);
  if (e = ir(e), isNaN(c))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const l = Math.pow(c, 2) * r;
    return {
      stiffness: l,
      damping: i * 2 * Math.sqrt(r * l),
      duration: e
    };
  }
}
const UE = 12;
function GE(e, t, n) {
  let r = n;
  for (let o = 1; o < UE; o++)
    r = r - e(r) / t(r);
  return r;
}
function hl(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const qE = ["duration", "bounce"], KE = ["stiffness", "damping", "mass"];
function pf(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function YE(e) {
  let t = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!pf(e, KE) && pf(e, qE)) {
    const n = HE(e);
    t = {
      ...t,
      ...n,
      mass: 1
    }, t.isResolvedFromDuration = !0;
  }
  return t;
}
function Ig({ keyframes: e, restDelta: t, restSpeed: n, ...r }) {
  const o = e[0], s = e[e.length - 1], i = { done: !1, value: o }, { stiffness: a, damping: c, mass: l, duration: u, velocity: d, isResolvedFromDuration: f } = YE({
    ...r,
    velocity: -Un(r.velocity || 0)
  }), p = d || 0, m = c / (2 * Math.sqrt(a * l)), g = s - o, y = Un(Math.sqrt(a / l)), S = Math.abs(g) < 5;
  n || (n = S ? 0.01 : 2), t || (t = S ? 5e-3 : 0.5);
  let b;
  if (m < 1) {
    const v = hl(y, m);
    b = (k) => {
      const w = Math.exp(-m * y * k);
      return s - w * ((p + m * y * g) / v * Math.sin(v * k) + g * Math.cos(v * k));
    };
  } else if (m === 1)
    b = (v) => s - Math.exp(-y * v) * (g + (p + y * g) * v);
  else {
    const v = y * Math.sqrt(m * m - 1);
    b = (k) => {
      const w = Math.exp(-m * y * k), _ = Math.min(v * k, 300);
      return s - w * ((p + m * y * g) * Math.sinh(_) + v * g * Math.cosh(_)) / v;
    };
  }
  return {
    calculatedDuration: f && u || null,
    next: (v) => {
      const k = b(v);
      if (f)
        i.done = v >= u;
      else {
        let w = p;
        v !== 0 && (m < 1 ? w = Ag(b, v, k) : w = 0);
        const _ = Math.abs(w) <= n, C = Math.abs(s - k) <= t;
        i.done = _ && C;
      }
      return i.value = i.done ? s : k, i;
    }
  };
}
function hf({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: o = 10, bounceStiffness: s = 500, modifyTarget: i, min: a, max: c, restDelta: l = 0.5, restSpeed: u }) {
  const d = e[0], f = {
    done: !1,
    value: d
  }, p = (I) => a !== void 0 && I < a || c !== void 0 && I > c, m = (I) => a === void 0 ? c : c === void 0 || Math.abs(a - I) < Math.abs(c - I) ? a : c;
  let g = n * t;
  const y = d + g, S = i === void 0 ? y : i(y);
  S !== y && (g = S - d);
  const b = (I) => -g * Math.exp(-I / r), v = (I) => S + b(I), k = (I) => {
    const $ = b(I), N = v(I);
    f.done = Math.abs($) <= l, f.value = f.done ? S : N;
  };
  let w, _;
  const C = (I) => {
    p(f.value) && (w = I, _ = Ig({
      keyframes: [f.value, m(f.value)],
      velocity: Ag(v, I, f.value),
      damping: o,
      stiffness: s,
      restDelta: l,
      restSpeed: u
    }));
  };
  return C(0), {
    calculatedDuration: null,
    next: (I) => {
      let $ = !1;
      return !_ && w === void 0 && ($ = !0, k(I), C(I)), w !== void 0 && I > w ? _.next(I - w) : (!$ && k(I), f);
    }
  };
}
const XE = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: () => rt.update(t, !0),
    stop: () => qn(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => jt.isProcessing ? jt.timestamp : performance.now()
  };
}, mf = 2e4;
function gf(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < mf; )
    t += n, r = e.next(t);
  return t >= mf ? 1 / 0 : t;
}
const ZE = {
  decay: hf,
  inertia: hf,
  tween: Zi,
  keyframes: Zi,
  spring: Ig
};
function Ji({ autoplay: e = !0, delay: t = 0, driver: n = XE, keyframes: r, type: o = "keyframes", repeat: s = 0, repeatDelay: i = 0, repeatType: a = "loop", onPlay: c, onStop: l, onComplete: u, onUpdate: d, ...f }) {
  let p = 1, m = !1, g, y;
  const S = () => {
    y = new Promise((O) => {
      g = O;
    });
  };
  S();
  let b;
  const v = ZE[o] || Zi;
  let k;
  v !== Zi && typeof r[0] != "number" && (process.env.NODE_ENV !== "production" && ln(r.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${r}`), k = Tg([0, 100], r, {
    clamp: !1
  }), r = [0, 100]);
  const w = v({ ...f, keyframes: r });
  let _;
  a === "mirror" && (_ = v({
    ...f,
    keyframes: [...r].reverse(),
    velocity: -(f.velocity || 0)
  }));
  let C = "idle", I = null, $ = null, N = null;
  w.calculatedDuration === null && s && (w.calculatedDuration = gf(w));
  const { calculatedDuration: z } = w;
  let Q = 1 / 0, U = 1 / 0;
  z !== null && (Q = z + i, U = Q * (s + 1) - i);
  let q = 0;
  const le = (O) => {
    if ($ === null)
      return;
    p > 0 && ($ = Math.min($, O)), p < 0 && ($ = Math.min(O - U / p, $)), I !== null ? q = I : q = Math.round(O - $) * p;
    const ee = q - t * (p >= 0 ? 1 : -1), D = p >= 0 ? ee < 0 : ee > U;
    q = Math.max(ee, 0), C === "finished" && I === null && (q = U);
    let V = q, Y = w;
    if (s) {
      const G = Math.min(q, U) / Q;
      let H = Math.floor(G), de = G % 1;
      !de && G >= 1 && (de = 1), de === 1 && H--, H = Math.min(H, s + 1), !!(H % 2) && (a === "reverse" ? (de = 1 - de, i && (de -= i / Q)) : a === "mirror" && (Y = _)), V = ar(0, 1, de) * Q;
    }
    const J = D ? { done: !1, value: r[0] } : Y.next(V);
    k && (J.value = k(J.value));
    let { done: se } = J;
    !D && z !== null && (se = p >= 0 ? q >= U : q <= 0);
    const ue = I === null && (C === "finished" || C === "running" && se);
    return d && d(J.value), ue && K(), J;
  }, Z = () => {
    b && b.stop(), b = void 0;
  }, j = () => {
    C = "idle", Z(), g(), S(), $ = N = null;
  }, K = () => {
    C = "finished", u && u(), Z(), g();
  }, ne = () => {
    if (m)
      return;
    b || (b = n(le));
    const O = b.now();
    c && c(), I !== null ? $ = O - I : (!$ || C === "finished") && ($ = O), C === "finished" && S(), N = $, I = null, C = "running", b.start();
  };
  e && ne();
  const B = {
    then(O, ee) {
      return y.then(O, ee);
    },
    get time() {
      return Un(q);
    },
    set time(O) {
      O = ir(O), q = O, I !== null || !b || p === 0 ? I = O : $ = b.now() - O / p;
    },
    get duration() {
      const O = w.calculatedDuration === null ? gf(w) : w.calculatedDuration;
      return Un(O);
    },
    get speed() {
      return p;
    },
    set speed(O) {
      O === p || !b || (p = O, B.time = Un(q));
    },
    get state() {
      return C;
    },
    play: ne,
    pause: () => {
      C = "paused", I = q;
    },
    stop: () => {
      m = !0, C !== "idle" && (C = "idle", l && l(), j());
    },
    cancel: () => {
      N !== null && le(N), j();
    },
    complete: () => {
      C = "finished";
    },
    sample: (O) => ($ = 0, le(O))
  };
  return B;
}
function JE(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const QE = JE(() => Object.hasOwnProperty.call(Element.prototype, "animate")), eA = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform",
  "backgroundColor"
]), pi = 10, tA = 2e4, nA = (e, t) => t.type === "spring" || e === "backgroundColor" || !ag(t.ease);
function rA(e, t, { onUpdate: n, onComplete: r, ...o }) {
  if (!(QE() && eA.has(t) && !o.repeatDelay && o.repeatType !== "mirror" && o.damping !== 0 && o.type !== "inertia"))
    return !1;
  let i = !1, a, c, l = !1;
  const u = () => {
    c = new Promise((v) => {
      a = v;
    });
  };
  u();
  let { keyframes: d, duration: f = 300, ease: p, times: m } = o;
  if (nA(t, o)) {
    const v = Ji({
      ...o,
      repeat: 0,
      delay: 0
    });
    let k = { done: !1, value: d[0] };
    const w = [];
    let _ = 0;
    for (; !k.done && _ < tA; )
      k = v.sample(_), w.push(k.value), _ += pi;
    m = void 0, d = w, f = _ - pi, p = "linear";
  }
  const g = hE(e.owner.current, t, d, {
    ...o,
    duration: f,
    /**
     * This function is currently not called if ease is provided
     * as a function so the cast is safe.
     *
     * However it would be possible for a future refinement to port
     * in easing pregeneration from Motion One for browsers that
     * support the upcoming `linear()` easing function.
     */
    ease: p,
    times: m
  }), y = () => {
    l = !1, g.cancel();
  }, S = () => {
    l = !0, rt.update(y), a(), u();
  };
  return g.onfinish = () => {
    l || (e.set(mE(d, o)), r && r(), S());
  }, {
    then(v, k) {
      return c.then(v, k);
    },
    attachTimeline(v) {
      return g.timeline = v, g.onfinish = null, ht;
    },
    get time() {
      return Un(g.currentTime || 0);
    },
    set time(v) {
      g.currentTime = ir(v);
    },
    get speed() {
      return g.playbackRate;
    },
    set speed(v) {
      g.playbackRate = v;
    },
    get duration() {
      return Un(f);
    },
    play: () => {
      i || (g.play(), qn(y));
    },
    pause: () => g.pause(),
    stop: () => {
      if (i = !0, g.playState === "idle")
        return;
      const { currentTime: v } = g;
      if (v) {
        const k = Ji({
          ...o,
          autoplay: !1
        });
        e.setWithVelocity(k.sample(v - pi).value, k.sample(v).value, pi);
      }
      S();
    },
    complete: () => {
      l || g.finish();
    },
    cancel: S
  };
}
function oA({ keyframes: e, delay: t, onUpdate: n, onComplete: r }) {
  const o = () => (n && n(e[e.length - 1]), r && r(), {
    time: 0,
    speed: 1,
    duration: 0,
    play: ht,
    pause: ht,
    stop: ht,
    then: (s) => (s(), Promise.resolve()),
    cancel: ht,
    complete: ht
  });
  return t ? Ji({
    keyframes: [0, 1],
    duration: 0,
    delay: t,
    onComplete: o
  }) : o();
}
const sA = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, iA = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), aA = {
  type: "keyframes",
  duration: 0.8
}, cA = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, lA = (e, { keyframes: t }) => t.length > 2 ? aA : Or.has(e) ? e.startsWith("scale") ? iA(t[1]) : sA : cA, ml = (e, t) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(cr.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url(")), uA = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function dA(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(ba) || [];
  if (!r)
    return e;
  const o = n.replace(r, "");
  let s = uA.has(t) ? 1 : 0;
  return r !== n && (s *= 100), t + "(" + s + o + ")";
}
const fA = /([a-z-]*)\(.*?\)/g, gl = {
  ...cr,
  getAnimatableNone: (e) => {
    const t = e.match(fA);
    return t ? t.map(dA).join(" ") : e;
  }
}, pA = {
  ...Hm,
  // Color props
  color: Ft,
  backgroundColor: Ft,
  outlineColor: Ft,
  fill: Ft,
  stroke: Ft,
  // Border props
  borderColor: Ft,
  borderTopColor: Ft,
  borderRightColor: Ft,
  borderBottomColor: Ft,
  borderLeftColor: Ft,
  filter: gl,
  WebkitFilter: gl
}, Su = (e) => pA[e];
function Rg(e, t) {
  let n = Su(e);
  return n !== gl && (n = cr), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const $g = (e) => /^0[^.\s]+$/.test(e);
function hA(e) {
  if (typeof e == "number")
    return e === 0;
  if (e !== null)
    return e === "none" || e === "0" || $g(e);
}
function mA(e, t, n, r) {
  const o = ml(t, n);
  let s;
  Array.isArray(n) ? s = [...n] : s = [null, n];
  const i = r.from !== void 0 ? r.from : e.get();
  let a;
  const c = [];
  for (let l = 0; l < s.length; l++)
    s[l] === null && (s[l] = l === 0 ? i : s[l - 1]), hA(s[l]) && c.push(l), typeof s[l] == "string" && s[l] !== "none" && s[l] !== "0" && (a = s[l]);
  if (o && c.length && a)
    for (let l = 0; l < c.length; l++) {
      const u = c[l];
      s[u] = Rg(t, a);
    }
  return s;
}
function gA({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: o, repeat: s, repeatType: i, repeatDelay: a, from: c, elapsed: l, ...u }) {
  return !!Object.keys(u).length;
}
function wu(e, t) {
  return e[t] || e.default || e;
}
const yA = {
  skipAnimations: !1
}, ku = (e, t, n, r = {}) => (o) => {
  const s = wu(r, e) || {}, i = s.delay || r.delay || 0;
  let { elapsed: a = 0 } = r;
  a = a - ir(i);
  const c = mA(t, e, n, s), l = c[0], u = c[c.length - 1], d = ml(e, l), f = ml(e, u);
  Bs(d === f, `You are trying to animate ${e} from "${l}" to "${u}". ${l} is not an animatable value - to enable this animation set ${l} to a value animatable to ${u} via the \`style\` property.`);
  let p = {
    keyframes: c,
    velocity: t.getVelocity(),
    ease: "easeOut",
    ...s,
    delay: -a,
    onUpdate: (m) => {
      t.set(m), s.onUpdate && s.onUpdate(m);
    },
    onComplete: () => {
      o(), s.onComplete && s.onComplete();
    }
  };
  if (gA(s) || (p = {
    ...p,
    ...lA(e, p)
  }), p.duration && (p.duration = ir(p.duration)), p.repeatDelay && (p.repeatDelay = ir(p.repeatDelay)), !d || !f || pE.current || s.type === !1 || yA.skipAnimations)
    return oA(p);
  if (
    /**
     * If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */
    !r.isHandoff && t.owner && t.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !t.owner.getProps().onUpdate
  ) {
    const m = rA(t, e, p);
    if (m)
      return m;
  }
  return Ji(p);
};
function Qi(e) {
  return !!(Gt(e) && e.add);
}
const Ng = (e) => /^\-?\d*\.?\d+$/.test(e);
function Pu(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Cu(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
class _u {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return Pu(this.subscriptions, t), () => Cu(this.subscriptions, t);
  }
  notify(t, n, r) {
    const o = this.subscriptions.length;
    if (o)
      if (o === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let s = 0; s < o; s++) {
          const i = this.subscriptions[s];
          i && i(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const yf = /* @__PURE__ */ new Set();
function Tu(e, t, n) {
  e || yf.has(t) || (console.warn(t), n && console.warn(n), yf.add(t));
}
const bA = (e) => !isNaN(parseFloat(e));
class vA {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(t, n = {}) {
    this.version = "10.18.0", this.timeDelta = 0, this.lastUpdated = 0, this.canTrackVelocity = !1, this.events = {}, this.updateAndNotify = (r, o = !0) => {
      this.prev = this.current, this.current = r;
      const { delta: s, timestamp: i } = jt;
      this.lastUpdated !== i && (this.timeDelta = s, this.lastUpdated = i, rt.postRender(this.scheduleVelocityCheck)), this.prev !== this.current && this.events.change && this.events.change.notify(this.current), this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()), o && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.scheduleVelocityCheck = () => rt.postRender(this.velocityCheck), this.velocityCheck = ({ timestamp: r }) => {
      r !== this.lastUpdated && (this.prev = this.current, this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()));
    }, this.hasAnimated = !1, this.prev = this.current = t, this.canTrackVelocity = bA(this.current), this.owner = n.owner;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && Tu(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new _u());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), rt.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = t, this.timeDelta = r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t) {
    this.updateAndNotify(t), this.prev = t, this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    return this.canTrackVelocity ? (
      // These casts could be avoided if parseFloat would be typed better
      Eg(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
    ) : 0;
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function ko(e, t) {
  return new vA(e, t);
}
const Mg = (e) => (t) => t.test(e), xA = {
  test: (e) => e === "auto",
  parse: (e) => e
}, jg = [Fr, Ce, An, tr, AT, ET, xA], Ho = (e) => jg.find(Mg(e)), SA = [...jg, Ft, cr], wA = (e) => SA.find(Mg(e));
function kA(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, ko(n));
}
function PA(e, t) {
  const n = xa(e, t);
  let { transitionEnd: r = {}, transition: o = {}, ...s } = n ? e.makeTargetAnimatable(n, !1) : {};
  s = { ...s, ...r };
  for (const i in s) {
    const a = WT(s[i]);
    kA(e, i, a);
  }
}
function CA(e, t, n) {
  var r, o;
  const s = Object.keys(t).filter((a) => !e.hasValue(a)), i = s.length;
  if (i)
    for (let a = 0; a < i; a++) {
      const c = s[a], l = t[c];
      let u = null;
      Array.isArray(l) && (u = l[0]), u === null && (u = (o = (r = n[c]) !== null && r !== void 0 ? r : e.readValue(c)) !== null && o !== void 0 ? o : t[c]), u != null && (typeof u == "string" && (Ng(u) || $g(u)) ? u = parseFloat(u) : !wA(u) && cr.test(l) && (u = Rg(c, l)), e.addValue(c, ko(u, { owner: e })), n[c] === void 0 && (n[c] = u), u !== null && e.setBaseTarget(c, u));
    }
}
function _A(e, t) {
  return t ? (t[e] || t.default || t).from : void 0;
}
function TA(e, t, n) {
  const r = {};
  for (const o in e) {
    const s = _A(o, t);
    if (s !== void 0)
      r[o] = s;
    else {
      const i = n.getValue(o);
      i && (r[o] = i.get());
    }
  }
  return r;
}
function EA({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function AA(e, t) {
  const n = e.get();
  if (Array.isArray(t)) {
    for (let r = 0; r < t.length; r++)
      if (t[r] !== n)
        return !0;
  } else
    return n !== t;
}
function Dg(e, t, { delay: n = 0, transitionOverride: r, type: o } = {}) {
  let { transition: s = e.getDefaultTransition(), transitionEnd: i, ...a } = e.makeTargetAnimatable(t);
  const c = e.getValue("willChange");
  r && (s = r);
  const l = [], u = o && e.animationState && e.animationState.getState()[o];
  for (const d in a) {
    const f = e.getValue(d), p = a[d];
    if (!f || p === void 0 || u && EA(u, d))
      continue;
    const m = {
      delay: n,
      elapsed: 0,
      ...wu(s || {}, d)
    };
    if (window.HandoffAppearAnimations) {
      const S = e.getProps()[Om];
      if (S) {
        const b = window.HandoffAppearAnimations(S, d, f, rt);
        b !== null && (m.elapsed = b, m.isHandoff = !0);
      }
    }
    let g = !m.isHandoff && !AA(f, p);
    if (m.type === "spring" && (f.getVelocity() || m.velocity) && (g = !1), f.animation && (g = !1), g)
      continue;
    f.start(ku(d, f, p, e.shouldReduceMotion && Or.has(d) ? { type: !1 } : m));
    const y = f.animation;
    Qi(c) && (c.add(d), y.then(() => c.remove(d))), l.push(y);
  }
  return i && Promise.all(l).then(() => {
    i && PA(e, i);
  }), l;
}
function yl(e, t, n = {}) {
  const r = xa(e, t, n.custom);
  let { transition: o = e.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (o = n.transitionOverride);
  const s = r ? () => Promise.all(Dg(e, r, n)) : () => Promise.resolve(), i = e.variantChildren && e.variantChildren.size ? (c = 0) => {
    const { delayChildren: l = 0, staggerChildren: u, staggerDirection: d } = o;
    return IA(e, t, l + c, u, d, n);
  } : () => Promise.resolve(), { when: a } = o;
  if (a) {
    const [c, l] = a === "beforeChildren" ? [s, i] : [i, s];
    return c().then(() => l());
  } else
    return Promise.all([s(), i(n.delay)]);
}
function IA(e, t, n = 0, r = 0, o = 1, s) {
  const i = [], a = (e.variantChildren.size - 1) * r, c = o === 1 ? (l = 0) => l * r : (l = 0) => a - l * r;
  return Array.from(e.variantChildren).sort(RA).forEach((l, u) => {
    l.notify("AnimationStart", t), i.push(yl(l, t, {
      ...s,
      delay: n + c(u)
    }).then(() => l.notify("AnimationComplete", t)));
  }), Promise.all(i);
}
function RA(e, t) {
  return e.sortNodePosition(t);
}
function $A(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const o = t.map((s) => yl(e, s, n));
    r = Promise.all(o);
  } else if (typeof t == "string")
    r = yl(e, t, n);
  else {
    const o = typeof t == "function" ? xa(e, t, n.custom) : t;
    r = Promise.all(Dg(e, o, n));
  }
  return r.then(() => e.notify("AnimationComplete", t));
}
const NA = [...cu].reverse(), MA = cu.length;
function jA(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => $A(e, n, r)));
}
function DA(e) {
  let t = jA(e);
  const n = FA();
  let r = !0;
  const o = (c, l) => {
    const u = xa(e, l);
    if (u) {
      const { transition: d, transitionEnd: f, ...p } = u;
      c = { ...c, ...p, ...f };
    }
    return c;
  };
  function s(c) {
    t = c(e);
  }
  function i(c, l) {
    const u = e.getProps(), d = e.getVariantContext(!0) || {}, f = [], p = /* @__PURE__ */ new Set();
    let m = {}, g = 1 / 0;
    for (let S = 0; S < MA; S++) {
      const b = NA[S], v = n[b], k = u[b] !== void 0 ? u[b] : d[b], w = xs(k), _ = b === l ? v.isActive : null;
      _ === !1 && (g = S);
      let C = k === d[b] && k !== u[b] && w;
      if (C && r && e.manuallyAnimateOnMount && (C = !1), v.protectedKeys = { ...m }, // If it isn't active and hasn't *just* been set as inactive
      !v.isActive && _ === null || // If we didn't and don't have any defined prop for this animation type
      !k && !v.prevProp || // Or if the prop doesn't define an animation
      ga(k) || typeof k == "boolean")
        continue;
      let $ = OA(v.prevProp, k) || // If we're making this variant active, we want to always make it active
      b === l && v.isActive && !C && w || // If we removed a higher-priority variant (i is in reverse order)
      S > g && w, N = !1;
      const z = Array.isArray(k) ? k : [k];
      let Q = z.reduce(o, {});
      _ === !1 && (Q = {});
      const { prevResolvedValues: U = {} } = v, q = {
        ...U,
        ...Q
      }, le = (Z) => {
        $ = !0, p.has(Z) && (N = !0, p.delete(Z)), v.needsAnimating[Z] = !0;
      };
      for (const Z in q) {
        const j = Q[Z], K = U[Z];
        if (m.hasOwnProperty(Z))
          continue;
        let ne = !1;
        Yi(j) && Yi(K) ? ne = !sg(j, K) : ne = j !== K, ne ? j !== void 0 ? le(Z) : p.add(Z) : j !== void 0 && p.has(Z) ? le(Z) : v.protectedKeys[Z] = !0;
      }
      v.prevProp = k, v.prevResolvedValues = Q, v.isActive && (m = { ...m, ...Q }), r && e.blockInitialAnimation && ($ = !1), $ && (!C || N) && f.push(...z.map((Z) => ({
        animation: Z,
        options: { type: b, ...c }
      })));
    }
    if (p.size) {
      const S = {};
      p.forEach((b) => {
        const v = e.getBaseTarget(b);
        v !== void 0 && (S[b] = v);
      }), f.push({ animation: S });
    }
    let y = !!f.length;
    return r && (u.initial === !1 || u.initial === u.animate) && !e.manuallyAnimateOnMount && (y = !1), r = !1, y ? t(f) : Promise.resolve();
  }
  function a(c, l, u) {
    var d;
    if (n[c].isActive === l)
      return Promise.resolve();
    (d = e.variantChildren) === null || d === void 0 || d.forEach((p) => {
      var m;
      return (m = p.animationState) === null || m === void 0 ? void 0 : m.setActive(c, l);
    }), n[c].isActive = l;
    const f = i(u, c);
    for (const p in n)
      n[p].protectedKeys = {};
    return f;
  }
  return {
    animateChanges: i,
    setActive: a,
    setAnimateFunction: s,
    getState: () => n
  };
}
function OA(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !sg(t, e) : !1;
}
function br(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function FA() {
  return {
    animate: br(!0),
    whileInView: br(),
    whileHover: br(),
    whileTap: br(),
    whileDrag: br(),
    whileFocus: br(),
    exit: br()
  };
}
class BA extends fr {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = DA(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    this.unmount(), ga(t) && (this.unmount = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
  }
}
let LA = 0;
class VA extends fr {
  constructor() {
    super(...arguments), this.id = LA++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n, custom: r } = this.node.presenceContext, { isPresent: o } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === o)
      return;
    const s = this.node.animationState.setActive("exit", !t, { custom: r ?? this.node.getProps().custom });
    n && !t && s.then(() => n(this.id));
  }
  mount() {
    const { register: t } = this.node.presenceContext || {};
    t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const zA = {
  animation: {
    Feature: BA
  },
  exit: {
    Feature: VA
  }
}, bf = (e, t) => Math.abs(e - t);
function WA(e, t) {
  const n = bf(e.x, t.x), r = bf(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class Og {
  constructor(t, n, { transformPagePoint: r, contextWindow: o, dragSnapToOrigin: s = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const d = _c(this.lastMoveEventInfo, this.history), f = this.startEvent !== null, p = WA(d.offset, { x: 0, y: 0 }) >= 3;
      if (!f && !p)
        return;
      const { point: m } = d, { timestamp: g } = jt;
      this.history.push({ ...m, timestamp: g });
      const { onStart: y, onMove: S } = this.handlers;
      f || (y && y(this.lastMoveEvent, d), this.startEvent = this.lastMoveEvent), S && S(this.lastMoveEvent, d);
    }, this.handlePointerMove = (d, f) => {
      this.lastMoveEvent = d, this.lastMoveEventInfo = Cc(f, this.transformPagePoint), rt.update(this.updatePoint, !0);
    }, this.handlePointerUp = (d, f) => {
      this.end();
      const { onEnd: p, onSessionEnd: m, resumeAnimation: g } = this.handlers;
      if (this.dragSnapToOrigin && g && g(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const y = _c(d.type === "pointercancel" ? this.lastMoveEventInfo : Cc(f, this.transformPagePoint), this.history);
      this.startEvent && p && p(d, y), m && m(d, y);
    }, !eg(t))
      return;
    this.dragSnapToOrigin = s, this.handlers = n, this.transformPagePoint = r, this.contextWindow = o || window;
    const i = va(t), a = Cc(i, this.transformPagePoint), { point: c } = a, { timestamp: l } = jt;
    this.history = [{ ...c, timestamp: l }];
    const { onSessionStart: u } = n;
    u && u(t, _c(a, this.history)), this.removeListeners = sr(Hn(this.contextWindow, "pointermove", this.handlePointerMove), Hn(this.contextWindow, "pointerup", this.handlePointerUp), Hn(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), qn(this.updatePoint);
  }
}
function Cc(e, t) {
  return t ? { point: t(e.point) } : e;
}
function vf(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function _c({ point: e }, t) {
  return {
    point: e,
    delta: vf(e, Fg(t)),
    offset: vf(e, HA(t)),
    velocity: UA(t, 0.1)
  };
}
function HA(e) {
  return e[0];
}
function Fg(e) {
  return e[e.length - 1];
}
function UA(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const o = Fg(e);
  for (; n >= 0 && (r = e[n], !(o.timestamp - r.timestamp > ir(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const s = Un(o.timestamp - r.timestamp);
  if (s === 0)
    return { x: 0, y: 0 };
  const i = {
    x: (o.x - r.x) / s,
    y: (o.y - r.y) / s
  };
  return i.x === 1 / 0 && (i.x = 0), i.y === 1 / 0 && (i.y = 0), i;
}
function Zt(e) {
  return e.max - e.min;
}
function bl(e, t = 0, n = 0.01) {
  return Math.abs(e - t) <= n;
}
function xf(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = dt(t.min, t.max, e.origin), e.scale = Zt(n) / Zt(t), (bl(e.scale, 1, 1e-4) || isNaN(e.scale)) && (e.scale = 1), e.translate = dt(n.min, n.max, e.origin) - e.originPoint, (bl(e.translate) || isNaN(e.translate)) && (e.translate = 0);
}
function fs(e, t, n, r) {
  xf(e.x, t.x, n.x, r ? r.originX : void 0), xf(e.y, t.y, n.y, r ? r.originY : void 0);
}
function Sf(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + Zt(t);
}
function GA(e, t, n) {
  Sf(e.x, t.x, n.x), Sf(e.y, t.y, n.y);
}
function wf(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + Zt(t);
}
function ps(e, t, n) {
  wf(e.x, t.x, n.x), wf(e.y, t.y, n.y);
}
function qA(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? dt(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? dt(n, e, r.max) : Math.min(e, n)), e;
}
function kf(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function KA(e, { top: t, left: n, bottom: r, right: o }) {
  return {
    x: kf(e.x, n, o),
    y: kf(e.y, t, r)
  };
}
function Pf(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function YA(e, t) {
  return {
    x: Pf(e.x, t.x),
    y: Pf(e.y, t.y)
  };
}
function XA(e, t) {
  let n = 0.5;
  const r = Zt(e), o = Zt(t);
  return o > r ? n = ws(t.min, t.max - r, e.min) : r > o && (n = ws(e.min, e.max - o, t.min)), ar(0, 1, n);
}
function ZA(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const vl = 0.35;
function JA(e = vl) {
  return e === !1 ? e = 0 : e === !0 && (e = vl), {
    x: Cf(e, "left", "right"),
    y: Cf(e, "top", "bottom")
  };
}
function Cf(e, t, n) {
  return {
    min: _f(e, t),
    max: _f(e, n)
  };
}
function _f(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const Tf = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), ao = () => ({
  x: Tf(),
  y: Tf()
}), Ef = () => ({ min: 0, max: 0 }), yt = () => ({
  x: Ef(),
  y: Ef()
});
function on(e) {
  return [e("x"), e("y")];
}
function Bg({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function QA({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function eI(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function Tc(e) {
  return e === void 0 || e === 1;
}
function xl({ scale: e, scaleX: t, scaleY: n }) {
  return !Tc(e) || !Tc(t) || !Tc(n);
}
function vr(e) {
  return xl(e) || Lg(e) || e.z || e.rotate || e.rotateX || e.rotateY;
}
function Lg(e) {
  return Af(e.x) || Af(e.y);
}
function Af(e) {
  return e && e !== "0%";
}
function ea(e, t, n) {
  const r = e - n, o = t * r;
  return n + o;
}
function If(e, t, n, r, o) {
  return o !== void 0 && (e = ea(e, o, r)), ea(e, n, r) + t;
}
function Sl(e, t = 0, n = 1, r, o) {
  e.min = If(e.min, t, n, r, o), e.max = If(e.max, t, n, r, o);
}
function Vg(e, { x: t, y: n }) {
  Sl(e.x, t.translate, t.scale, t.originPoint), Sl(e.y, n.translate, n.scale, n.originPoint);
}
function tI(e, t, n, r = !1) {
  const o = n.length;
  if (!o)
    return;
  t.x = t.y = 1;
  let s, i;
  for (let a = 0; a < o; a++) {
    s = n[a], i = s.projectionDelta;
    const c = s.instance;
    c && c.style && c.style.display === "contents" || (r && s.options.layoutScroll && s.scroll && s !== s.root && co(e, {
      x: -s.scroll.offset.x,
      y: -s.scroll.offset.y
    }), i && (t.x *= i.x.scale, t.y *= i.y.scale, Vg(e, i)), r && vr(s.latestValues) && co(e, s.latestValues));
  }
  t.x = Rf(t.x), t.y = Rf(t.y);
}
function Rf(e) {
  return Number.isInteger(e) || e > 1.0000000000001 || e < 0.999999999999 ? e : 1;
}
function rr(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function $f(e, t, [n, r, o]) {
  const s = t[o] !== void 0 ? t[o] : 0.5, i = dt(e.min, e.max, s);
  Sl(e, t[n], t[r], i, t.scale);
}
const nI = ["x", "scaleX", "originX"], rI = ["y", "scaleY", "originY"];
function co(e, t) {
  $f(e.x, t, nI), $f(e.y, t, rI);
}
function zg(e, t) {
  return Bg(eI(e.getBoundingClientRect(), t));
}
function oI(e, t, n) {
  const r = zg(e, n), { scroll: o } = t;
  return o && (rr(r.x, o.offset.x), rr(r.y, o.offset.y)), r;
}
const Wg = ({ current: e }) => e ? e.ownerDocument.defaultView : null, sI = /* @__PURE__ */ new WeakMap();
class iI {
  constructor(t) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = yt(), this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const o = (u) => {
      const { dragSnapToOrigin: d } = this.getProps();
      d ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(va(u, "page").point);
    }, s = (u, d) => {
      const { drag: f, dragPropagation: p, onDragStart: m } = this.getProps();
      if (f && !p && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = ng(f), !this.openGlobalLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), on((y) => {
        let S = this.getAxisMotionValue(y).get() || 0;
        if (An.test(S)) {
          const { projection: b } = this.visualElement;
          if (b && b.layout) {
            const v = b.layout.layoutBox[y];
            v && (S = Zt(v) * (parseFloat(S) / 100));
          }
        }
        this.originPoint[y] = S;
      }), m && rt.update(() => m(u, d), !1, !0);
      const { animationState: g } = this.visualElement;
      g && g.setActive("whileDrag", !0);
    }, i = (u, d) => {
      const { dragPropagation: f, dragDirectionLock: p, onDirectionLock: m, onDrag: g } = this.getProps();
      if (!f && !this.openGlobalLock)
        return;
      const { offset: y } = d;
      if (p && this.currentDirection === null) {
        this.currentDirection = aI(y), this.currentDirection !== null && m && m(this.currentDirection);
        return;
      }
      this.updateAxis("x", d.point, y), this.updateAxis("y", d.point, y), this.visualElement.render(), g && g(u, d);
    }, a = (u, d) => this.stop(u, d), c = () => on((u) => {
      var d;
      return this.getAnimationState(u) === "paused" && ((d = this.getAxisMotionValue(u).animation) === null || d === void 0 ? void 0 : d.play());
    }), { dragSnapToOrigin: l } = this.getProps();
    this.panSession = new Og(t, {
      onSessionStart: o,
      onStart: s,
      onMove: i,
      onSessionEnd: a,
      resumeAnimation: c
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: l,
      contextWindow: Wg(this.visualElement)
    });
  }
  stop(t, n) {
    const r = this.isDragging;
    if (this.cancel(), !r)
      return;
    const { velocity: o } = n;
    this.startAnimation(o);
    const { onDragEnd: s } = this.getProps();
    s && rt.update(() => s(t, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(t, n, r) {
    const { drag: o } = this.getProps();
    if (!r || !hi(t, o, this.currentDirection))
      return;
    const s = this.getAxisMotionValue(t);
    let i = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (i = qA(i, this.constraints[t], this.elastic[t])), s.set(i);
  }
  resolveConstraints() {
    var t;
    const { dragConstraints: n, dragElastic: r } = this.getProps(), o = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (t = this.visualElement.projection) === null || t === void 0 ? void 0 : t.layout, s = this.constraints;
    n && so(n) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : n && o ? this.constraints = KA(o.layoutBox, n) : this.constraints = !1, this.elastic = JA(r), s !== this.constraints && o && this.constraints && !this.hasMutatedConstraints && on((i) => {
      this.getAxisMotionValue(i) && (this.constraints[i] = ZA(o.layoutBox[i], this.constraints[i]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !so(t))
      return !1;
    const r = t.current;
    ln(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: o } = this.visualElement;
    if (!o || !o.layout)
      return !1;
    const s = oI(r, o.root, this.visualElement.getTransformPagePoint());
    let i = YA(o.layout.layoutBox, s);
    if (n) {
      const a = n(QA(i));
      this.hasMutatedConstraints = !!a, a && (i = Bg(a));
    }
    return i;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: o, dragTransition: s, dragSnapToOrigin: i, onDragTransitionEnd: a } = this.getProps(), c = this.constraints || {}, l = on((u) => {
      if (!hi(u, n, this.currentDirection))
        return;
      let d = c && c[u] || {};
      i && (d = { min: 0, max: 0 });
      const f = o ? 200 : 1e6, p = o ? 40 : 1e7, m = {
        type: "inertia",
        velocity: r ? t[u] : 0,
        bounceStiffness: f,
        bounceDamping: p,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...s,
        ...d
      };
      return this.startAxisValueAnimation(u, m);
    });
    return Promise.all(l).then(a);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return r.start(ku(t, r, 0, n));
  }
  stopAnimation() {
    on((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    on((t) => {
      var n;
      return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.pause();
    });
  }
  getAnimationState(t) {
    var n;
    return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = "_drag" + t.toUpperCase(), r = this.visualElement.getProps(), o = r[n];
    return o || this.visualElement.getValue(t, (r.initial ? r.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    on((n) => {
      const { drag: r } = this.getProps();
      if (!hi(n, r, this.currentDirection))
        return;
      const { projection: o } = this.visualElement, s = this.getAxisMotionValue(n);
      if (o && o.layout) {
        const { min: i, max: a } = o.layout.layoutBox[n];
        s.set(t[n] - dt(i, a, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!so(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const o = { x: 0, y: 0 };
    on((i) => {
      const a = this.getAxisMotionValue(i);
      if (a) {
        const c = a.get();
        o[i] = XA({ min: c, max: c }, this.constraints[i]);
      }
    });
    const { transformTemplate: s } = this.visualElement.getProps();
    this.visualElement.current.style.transform = s ? s({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), on((i) => {
      if (!hi(i, t, null))
        return;
      const a = this.getAxisMotionValue(i), { min: c, max: l } = this.constraints[i];
      a.set(dt(c, l, o[i]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    sI.set(this.visualElement, this);
    const t = this.visualElement.current, n = Hn(t, "pointerdown", (c) => {
      const { drag: l, dragListener: u = !0 } = this.getProps();
      l && u && this.start(c);
    }), r = () => {
      const { dragConstraints: c } = this.getProps();
      so(c) && (this.constraints = this.resolveRefConstraints());
    }, { projection: o } = this.visualElement, s = o.addEventListener("measure", r);
    o && !o.layout && (o.root && o.root.updateScroll(), o.updateLayout()), r();
    const i = zn(window, "resize", () => this.scalePositionWithinConstraints()), a = o.addEventListener("didUpdate", ({ delta: c, hasLayoutChanged: l }) => {
      this.isDragging && l && (on((u) => {
        const d = this.getAxisMotionValue(u);
        d && (this.originPoint[u] += c[u].translate, d.set(d.get() + c[u].translate));
      }), this.visualElement.render());
    });
    return () => {
      i(), n(), s(), a && a();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: o = !1, dragConstraints: s = !1, dragElastic: i = vl, dragMomentum: a = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: o,
      dragConstraints: s,
      dragElastic: i,
      dragMomentum: a
    };
  }
}
function hi(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function aI(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class cI extends fr {
  constructor(t) {
    super(t), this.removeGroupControls = ht, this.removeListeners = ht, this.controls = new iI(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || ht;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const Nf = (e) => (t, n) => {
  e && rt.update(() => e(t, n));
};
class lI extends fr {
  constructor() {
    super(...arguments), this.removePointerDownListener = ht;
  }
  onPointerDown(t) {
    this.session = new Og(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: Wg(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: o } = this.node.getProps();
    return {
      onSessionStart: Nf(t),
      onStart: Nf(n),
      onMove: r,
      onEnd: (s, i) => {
        delete this.session, o && rt.update(() => o(s, i));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Hn(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
function Hg() {
  const e = vt(js);
  if (e === null)
    return [!0, null];
  const { isPresent: t, onExitComplete: n, register: r } = e, o = Rt();
  return xe(() => r(o), []), !t && n ? [!1, () => n && n(o)] : [!0];
}
function uI() {
  return dI(vt(js));
}
function dI(e) {
  return e === null ? !0 : e.isPresent;
}
const Mi = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function Mf(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const Uo = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (Ce.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = Mf(e, t.target.x), r = Mf(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, fI = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, o = cr.parse(e);
    if (o.length > 5)
      return r;
    const s = cr.createTransformer(e), i = typeof o[0] != "number" ? 1 : 0, a = n.x.scale * t.x, c = n.y.scale * t.y;
    o[0 + i] /= a, o[1 + i] /= c;
    const l = dt(a, c, 0.5);
    return typeof o[2 + i] == "number" && (o[2 + i] /= l), typeof o[3 + i] == "number" && (o[3 + i] /= l), s(o);
  }
};
class pI extends Yt.Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: o } = this.props, { projection: s } = t;
    ST(hI), s && (n.group && n.group.add(s), r && r.register && o && r.register(s), s.root.didUpdate(), s.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), s.setOptions({
      ...s.options,
      onExitComplete: () => this.safeToRemove()
    })), Mi.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: o, isPresent: s } = this.props, i = r.projection;
    return i && (i.isPresent = s, o || t.layoutDependency !== n || n === void 0 ? i.willUpdate() : this.safeToRemove(), t.isPresent !== s && (s ? i.promote() : i.relegate() || rt.postRender(() => {
      const a = i.getStack();
      (!a || !a.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), queueMicrotask(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: o } = t;
    o && (o.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(o), r && r.deregister && r.deregister(o));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function Ug(e) {
  const [t, n] = Hg(), r = vt(uu);
  return Yt.createElement(pI, { ...e, layoutGroup: r, switchLayoutGroup: vt(Bm), isPresent: t, safeToRemove: n });
}
const hI = {
  borderRadius: {
    ...Uo,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: Uo,
  borderTopRightRadius: Uo,
  borderBottomLeftRadius: Uo,
  borderBottomRightRadius: Uo,
  boxShadow: fI
}, Gg = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], mI = Gg.length, jf = (e) => typeof e == "string" ? parseFloat(e) : e, Df = (e) => typeof e == "number" || Ce.test(e);
function gI(e, t, n, r, o, s) {
  o ? (e.opacity = dt(
    0,
    // TODO Reinstate this if only child
    n.opacity !== void 0 ? n.opacity : 1,
    yI(r)
  ), e.opacityExit = dt(t.opacity !== void 0 ? t.opacity : 1, 0, bI(r))) : s && (e.opacity = dt(t.opacity !== void 0 ? t.opacity : 1, n.opacity !== void 0 ? n.opacity : 1, r));
  for (let i = 0; i < mI; i++) {
    const a = `border${Gg[i]}Radius`;
    let c = Of(t, a), l = Of(n, a);
    if (c === void 0 && l === void 0)
      continue;
    c || (c = 0), l || (l = 0), c === 0 || l === 0 || Df(c) === Df(l) ? (e[a] = Math.max(dt(jf(c), jf(l), r), 0), (An.test(l) || An.test(c)) && (e[a] += "%")) : e[a] = l;
  }
  (t.rotate || n.rotate) && (e.rotate = dt(t.rotate || 0, n.rotate || 0, r));
}
function Of(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const yI = qg(0, 0.5, hg), bI = qg(0.5, 0.95, ht);
function qg(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(ws(e, t, r));
}
function Ff(e, t) {
  e.min = t.min, e.max = t.max;
}
function nn(e, t) {
  Ff(e.x, t.x), Ff(e.y, t.y);
}
function Bf(e, t, n, r, o) {
  return e -= t, e = ea(e, 1 / n, r), o !== void 0 && (e = ea(e, 1 / o, r)), e;
}
function vI(e, t = 0, n = 1, r = 0.5, o, s = e, i = e) {
  if (An.test(t) && (t = parseFloat(t), t = dt(i.min, i.max, t / 100) - i.min), typeof t != "number")
    return;
  let a = dt(s.min, s.max, r);
  e === s && (a -= t), e.min = Bf(e.min, t, n, a, o), e.max = Bf(e.max, t, n, a, o);
}
function Lf(e, t, [n, r, o], s, i) {
  vI(e, t[n], t[r], t[o], t.scale, s, i);
}
const xI = ["x", "scaleX", "originX"], SI = ["y", "scaleY", "originY"];
function Vf(e, t, n, r) {
  Lf(e.x, t, xI, n ? n.x : void 0, r ? r.x : void 0), Lf(e.y, t, SI, n ? n.y : void 0, r ? r.y : void 0);
}
function zf(e) {
  return e.translate === 0 && e.scale === 1;
}
function Kg(e) {
  return zf(e.x) && zf(e.y);
}
function wI(e, t) {
  return e.x.min === t.x.min && e.x.max === t.x.max && e.y.min === t.y.min && e.y.max === t.y.max;
}
function Yg(e, t) {
  return Math.round(e.x.min) === Math.round(t.x.min) && Math.round(e.x.max) === Math.round(t.x.max) && Math.round(e.y.min) === Math.round(t.y.min) && Math.round(e.y.max) === Math.round(t.y.max);
}
function Wf(e) {
  return Zt(e.x) / Zt(e.y);
}
class kI {
  constructor() {
    this.members = [];
  }
  add(t) {
    Pu(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (Cu(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    const n = this.members.findIndex((o) => t === o);
    if (n === 0)
      return !1;
    let r;
    for (let o = n; o >= 0; o--) {
      const s = this.members[o];
      if (s.isPresent !== !1) {
        r = s;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.instance && r.scheduleRender(), t.scheduleRender(), t.resumeFrom = r, n && (t.resumeFrom.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: o } = t.options;
      o === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: n, resumingFrom: r } = t;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function Hf(e, t, n) {
  let r = "";
  const o = e.x.translate / t.x, s = e.y.translate / t.y;
  if ((o || s) && (r = `translate3d(${o}px, ${s}px, 0) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { rotate: c, rotateX: l, rotateY: u } = n;
    c && (r += `rotate(${c}deg) `), l && (r += `rotateX(${l}deg) `), u && (r += `rotateY(${u}deg) `);
  }
  const i = e.x.scale * t.x, a = e.y.scale * t.y;
  return (i !== 1 || a !== 1) && (r += `scale(${i}, ${a})`), r || "none";
}
const PI = (e, t) => e.depth - t.depth;
class CI {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    Pu(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    Cu(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(PI), this.isDirty = !1, this.children.forEach(t);
  }
}
function _I(e, t) {
  const n = performance.now(), r = ({ timestamp: o }) => {
    const s = o - n;
    s >= t && (qn(r), e(s - t));
  };
  return rt.read(r, !0), () => qn(r);
}
function TI(e) {
  window.MotionDebug && window.MotionDebug.record(e);
}
function EI(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
function AI(e, t, n) {
  const r = Gt(e) ? e : ko(e);
  return r.start(ku("", r, t, n)), r.animation;
}
const Uf = ["", "X", "Y", "Z"], II = { visibility: "hidden" }, Gf = 1e3;
let RI = 0;
const xr = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
function Xg({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: o }) {
  return class {
    constructor(i = {}, a = t == null ? void 0 : t()) {
      this.id = RI++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, xr.totalNodes = xr.resolvedTargetDeltas = xr.recalculatedProjection = 0, this.nodes.forEach(MI), this.nodes.forEach(BI), this.nodes.forEach(LI), this.nodes.forEach(jI), TI(xr);
      }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = i, this.root = a ? a.root || a : this, this.path = a ? [...a.path, a] : [], this.parent = a, this.depth = a ? a.depth + 1 : 0;
      for (let c = 0; c < this.path.length; c++)
        this.path[c].shouldResetTransform = !0;
      this.root === this && (this.nodes = new CI());
    }
    addEventListener(i, a) {
      return this.eventHandlers.has(i) || this.eventHandlers.set(i, new _u()), this.eventHandlers.get(i).add(a);
    }
    notifyListeners(i, ...a) {
      const c = this.eventHandlers.get(i);
      c && c.notify(...a);
    }
    hasListeners(i) {
      return this.eventHandlers.has(i);
    }
    /**
     * Lifecycles
     */
    mount(i, a = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = EI(i), this.instance = i;
      const { layoutId: c, layout: l, visualElement: u } = this.options;
      if (u && !u.current && u.mount(i), this.root.nodes.add(this), this.parent && this.parent.children.add(this), a && (l || c) && (this.isLayoutDirty = !0), e) {
        let d;
        const f = () => this.root.updateBlockedByResize = !1;
        e(i, () => {
          this.root.updateBlockedByResize = !0, d && d(), d = _I(f, 250), Mi.hasAnimatedSinceResize && (Mi.hasAnimatedSinceResize = !1, this.nodes.forEach(Kf));
        });
      }
      c && this.root.registerSharedNode(c, this), this.options.animate !== !1 && u && (c || l) && this.addEventListener("didUpdate", ({ delta: d, hasLayoutChanged: f, hasRelativeTargetChanged: p, layout: m }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const g = this.options.transition || u.getDefaultTransition() || UI, { onLayoutAnimationStart: y, onLayoutAnimationComplete: S } = u.getProps(), b = !this.targetLayout || !Yg(this.targetLayout, m) || p, v = !f && p;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || v || f && (b || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(d, v);
          const k = {
            ...wu(g, "layout"),
            onPlay: y,
            onComplete: S
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (k.delay = 0, k.type = !1), this.startAnimation(k);
        } else
          f || Kf(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = m;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const i = this.getStack();
      i && i.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, qn(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(VI), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: i } = this.options;
      return i && i.getProps().transformTemplate;
    }
    willUpdate(i = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (!this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let u = 0; u < this.path.length; u++) {
        const d = this.path[u];
        d.shouldResetTransform = !0, d.updateScroll("snapshot"), d.options.layoutRoot && d.willUpdate(!1);
      }
      const { layoutId: a, layout: c } = this.options;
      if (a === void 0 && !c)
        return;
      const l = this.getTransformTemplate();
      this.prevTransformTemplateValue = l ? l(this.latestValues, "") : void 0, this.updateSnapshot(), i && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(qf);
        return;
      }
      this.isUpdating || this.nodes.forEach(OI), this.isUpdating = !1, this.nodes.forEach(FI), this.nodes.forEach($I), this.nodes.forEach(NI), this.clearAllSnapshots();
      const a = performance.now();
      jt.delta = ar(0, 1e3 / 60, a - jt.timestamp), jt.timestamp = a, jt.isProcessing = !0, yc.update.process(jt), yc.preRender.process(jt), yc.render.process(jt), jt.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, queueMicrotask(() => this.update()));
    }
    clearAllSnapshots() {
      this.nodes.forEach(DI), this.sharedNodes.forEach(zI);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, rt.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      rt.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let c = 0; c < this.path.length; c++)
          this.path[c].updateScroll();
      const i = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = yt(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: a } = this.options;
      a && a.notify("LayoutMeasure", this.layout.layoutBox, i ? i.layoutBox : void 0);
    }
    updateScroll(i = "measure") {
      let a = !!(this.options.layoutScroll && this.instance);
      this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === i && (a = !1), a && (this.scroll = {
        animationId: this.root.animationId,
        phase: i,
        isRoot: r(this.instance),
        offset: n(this.instance)
      });
    }
    resetTransform() {
      if (!o)
        return;
      const i = this.isLayoutDirty || this.shouldResetTransform, a = this.projectionDelta && !Kg(this.projectionDelta), c = this.getTransformTemplate(), l = c ? c(this.latestValues, "") : void 0, u = l !== this.prevTransformTemplateValue;
      i && (a || vr(this.latestValues) || u) && (o(this.instance, l), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(i = !0) {
      const a = this.measurePageBox();
      let c = this.removeElementScroll(a);
      return i && (c = this.removeTransform(c)), GI(c), {
        animationId: this.root.animationId,
        measuredBox: a,
        layoutBox: c,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: i } = this.options;
      if (!i)
        return yt();
      const a = i.measureViewportBox(), { scroll: c } = this.root;
      return c && (rr(a.x, c.offset.x), rr(a.y, c.offset.y)), a;
    }
    removeElementScroll(i) {
      const a = yt();
      nn(a, i);
      for (let c = 0; c < this.path.length; c++) {
        const l = this.path[c], { scroll: u, options: d } = l;
        if (l !== this.root && u && d.layoutScroll) {
          if (u.isRoot) {
            nn(a, i);
            const { scroll: f } = this.root;
            f && (rr(a.x, -f.offset.x), rr(a.y, -f.offset.y));
          }
          rr(a.x, u.offset.x), rr(a.y, u.offset.y);
        }
      }
      return a;
    }
    applyTransform(i, a = !1) {
      const c = yt();
      nn(c, i);
      for (let l = 0; l < this.path.length; l++) {
        const u = this.path[l];
        !a && u.options.layoutScroll && u.scroll && u !== u.root && co(c, {
          x: -u.scroll.offset.x,
          y: -u.scroll.offset.y
        }), vr(u.latestValues) && co(c, u.latestValues);
      }
      return vr(this.latestValues) && co(c, this.latestValues), c;
    }
    removeTransform(i) {
      const a = yt();
      nn(a, i);
      for (let c = 0; c < this.path.length; c++) {
        const l = this.path[c];
        if (!l.instance || !vr(l.latestValues))
          continue;
        xl(l.latestValues) && l.updateSnapshot();
        const u = yt(), d = l.measurePageBox();
        nn(u, d), Vf(a, l.latestValues, l.snapshot ? l.snapshot.layoutBox : void 0, u);
      }
      return vr(this.latestValues) && Vf(a, this.latestValues), a;
    }
    setTargetDelta(i) {
      this.targetDelta = i, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(i) {
      this.options = {
        ...this.options,
        ...i,
        crossfade: i.crossfade !== void 0 ? i.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== jt.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(i = !1) {
      var a;
      const c = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = c.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = c.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = c.isSharedProjectionDirty);
      const l = !!this.resumingFrom || this !== c;
      if (!(i || l && this.isSharedProjectionDirty || this.isProjectionDirty || !((a = this.parent) === null || a === void 0) && a.isProjectionDirty || this.attemptToResolveRelativeTarget))
        return;
      const { layout: d, layoutId: f } = this.options;
      if (!(!this.layout || !(d || f))) {
        if (this.resolvedRelativeTargetAt = jt.timestamp, !this.targetDelta && !this.relativeTarget) {
          const p = this.getClosestProjectingParent();
          p && p.layout && this.animationProgress !== 1 ? (this.relativeParent = p, this.forceRelativeParentToResolveTarget(), this.relativeTarget = yt(), this.relativeTargetOrigin = yt(), ps(this.relativeTargetOrigin, this.layout.layoutBox, p.layout.layoutBox), nn(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = yt(), this.targetWithTransforms = yt()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), GA(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : nn(this.target, this.layout.layoutBox), Vg(this.target, this.targetDelta)) : nn(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const p = this.getClosestProjectingParent();
            p && !!p.resumingFrom == !!this.resumingFrom && !p.options.layoutScroll && p.target && this.animationProgress !== 1 ? (this.relativeParent = p, this.forceRelativeParentToResolveTarget(), this.relativeTarget = yt(), this.relativeTargetOrigin = yt(), ps(this.relativeTargetOrigin, this.target, p.target), nn(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          xr.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || xl(this.parent.latestValues) || Lg(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var i;
      const a = this.getLead(), c = !!this.resumingFrom || this !== a;
      let l = !0;
      if ((this.isProjectionDirty || !((i = this.parent) === null || i === void 0) && i.isProjectionDirty) && (l = !1), c && (this.isSharedProjectionDirty || this.isTransformDirty) && (l = !1), this.resolvedRelativeTargetAt === jt.timestamp && (l = !1), l)
        return;
      const { layout: u, layoutId: d } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || d))
        return;
      nn(this.layoutCorrected, this.layout.layoutBox);
      const f = this.treeScale.x, p = this.treeScale.y;
      tI(this.layoutCorrected, this.treeScale, this.path, c), a.layout && !a.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (a.target = a.layout.layoutBox);
      const { target: m } = a;
      if (!m) {
        this.projectionTransform && (this.projectionDelta = ao(), this.projectionTransform = "none", this.scheduleRender());
        return;
      }
      this.projectionDelta || (this.projectionDelta = ao(), this.projectionDeltaWithTransform = ao());
      const g = this.projectionTransform;
      fs(this.projectionDelta, this.layoutCorrected, m, this.latestValues), this.projectionTransform = Hf(this.projectionDelta, this.treeScale), (this.projectionTransform !== g || this.treeScale.x !== f || this.treeScale.y !== p) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", m)), xr.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(i = !0) {
      if (this.options.scheduleRender && this.options.scheduleRender(), i) {
        const a = this.getStack();
        a && a.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    setAnimationOrigin(i, a = !1) {
      const c = this.snapshot, l = c ? c.latestValues : {}, u = { ...this.latestValues }, d = ao();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !a;
      const f = yt(), p = c ? c.source : void 0, m = this.layout ? this.layout.source : void 0, g = p !== m, y = this.getStack(), S = !y || y.members.length <= 1, b = !!(g && !S && this.options.crossfade === !0 && !this.path.some(HI));
      this.animationProgress = 0;
      let v;
      this.mixTargetDelta = (k) => {
        const w = k / 1e3;
        Yf(d.x, i.x, w), Yf(d.y, i.y, w), this.setTargetDelta(d), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (ps(f, this.layout.layoutBox, this.relativeParent.layout.layoutBox), WI(this.relativeTarget, this.relativeTargetOrigin, f, w), v && wI(this.relativeTarget, v) && (this.isProjectionDirty = !1), v || (v = yt()), nn(v, this.relativeTarget)), g && (this.animationValues = u, gI(u, l, this.latestValues, w, b, S)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = w;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(i) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (qn(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = rt.update(() => {
        Mi.hasAnimatedSinceResize = !0, this.currentAnimation = AI(0, Gf, {
          ...i,
          onUpdate: (a) => {
            this.mixTargetDelta(a), i.onUpdate && i.onUpdate(a);
          },
          onComplete: () => {
            i.onComplete && i.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const i = this.getStack();
      i && i.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(Gf), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const i = this.getLead();
      let { targetWithTransforms: a, target: c, layout: l, latestValues: u } = i;
      if (!(!a || !c || !l)) {
        if (this !== i && this.layout && l && Zg(this.options.animationType, this.layout.layoutBox, l.layoutBox)) {
          c = this.target || yt();
          const d = Zt(this.layout.layoutBox.x);
          c.x.min = i.target.x.min, c.x.max = c.x.min + d;
          const f = Zt(this.layout.layoutBox.y);
          c.y.min = i.target.y.min, c.y.max = c.y.min + f;
        }
        nn(a, c), co(a, u), fs(this.projectionDeltaWithTransform, this.layoutCorrected, a, u);
      }
    }
    registerSharedNode(i, a) {
      this.sharedNodes.has(i) || this.sharedNodes.set(i, new kI()), this.sharedNodes.get(i).add(a);
      const l = a.options.initialPromotionConfig;
      a.promote({
        transition: l ? l.transition : void 0,
        preserveFollowOpacity: l && l.shouldPreserveFollowOpacity ? l.shouldPreserveFollowOpacity(a) : void 0
      });
    }
    isLead() {
      const i = this.getStack();
      return i ? i.lead === this : !0;
    }
    getLead() {
      var i;
      const { layoutId: a } = this.options;
      return a ? ((i = this.getStack()) === null || i === void 0 ? void 0 : i.lead) || this : this;
    }
    getPrevLead() {
      var i;
      const { layoutId: a } = this.options;
      return a ? (i = this.getStack()) === null || i === void 0 ? void 0 : i.prevLead : void 0;
    }
    getStack() {
      const { layoutId: i } = this.options;
      if (i)
        return this.root.sharedNodes.get(i);
    }
    promote({ needsReset: i, transition: a, preserveFollowOpacity: c } = {}) {
      const l = this.getStack();
      l && l.promote(this, c), i && (this.projectionDelta = void 0, this.needsReset = !0), a && this.setOptions({ transition: a });
    }
    relegate() {
      const i = this.getStack();
      return i ? i.relegate(this) : !1;
    }
    resetRotation() {
      const { visualElement: i } = this.options;
      if (!i)
        return;
      let a = !1;
      const { latestValues: c } = i;
      if ((c.rotate || c.rotateX || c.rotateY || c.rotateZ) && (a = !0), !a)
        return;
      const l = {};
      for (let u = 0; u < Uf.length; u++) {
        const d = "rotate" + Uf[u];
        c[d] && (l[d] = c[d], i.setStaticValue(d, 0));
      }
      i.render();
      for (const u in l)
        i.setStaticValue(u, l[u]);
      i.scheduleRender();
    }
    getProjectionStyles(i) {
      var a, c;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return II;
      const l = {
        visibility: ""
      }, u = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, l.opacity = "", l.pointerEvents = Ni(i == null ? void 0 : i.pointerEvents) || "", l.transform = u ? u(this.latestValues, "") : "none", l;
      const d = this.getLead();
      if (!this.projectionDelta || !this.layout || !d.target) {
        const g = {};
        return this.options.layoutId && (g.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, g.pointerEvents = Ni(i == null ? void 0 : i.pointerEvents) || ""), this.hasProjected && !vr(this.latestValues) && (g.transform = u ? u({}, "") : "none", this.hasProjected = !1), g;
      }
      const f = d.animationValues || d.latestValues;
      this.applyTransformsToTarget(), l.transform = Hf(this.projectionDeltaWithTransform, this.treeScale, f), u && (l.transform = u(f, l.transform));
      const { x: p, y: m } = this.projectionDelta;
      l.transformOrigin = `${p.origin * 100}% ${m.origin * 100}% 0`, d.animationValues ? l.opacity = d === this ? (c = (a = f.opacity) !== null && a !== void 0 ? a : this.latestValues.opacity) !== null && c !== void 0 ? c : 1 : this.preserveOpacity ? this.latestValues.opacity : f.opacityExit : l.opacity = d === this ? f.opacity !== void 0 ? f.opacity : "" : f.opacityExit !== void 0 ? f.opacityExit : 0;
      for (const g in qi) {
        if (f[g] === void 0)
          continue;
        const { correct: y, applyTo: S } = qi[g], b = l.transform === "none" ? f[g] : y(f[g], d);
        if (S) {
          const v = S.length;
          for (let k = 0; k < v; k++)
            l[S[k]] = b;
        } else
          l[g] = b;
      }
      return this.options.layoutId && (l.pointerEvents = d === this ? Ni(i == null ? void 0 : i.pointerEvents) || "" : "none"), l;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((i) => {
        var a;
        return (a = i.currentAnimation) === null || a === void 0 ? void 0 : a.stop();
      }), this.root.nodes.forEach(qf), this.root.sharedNodes.clear();
    }
  };
}
function $I(e) {
  e.updateLayout();
}
function NI(e) {
  var t;
  const n = ((t = e.resumeFrom) === null || t === void 0 ? void 0 : t.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && n && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: o } = e.layout, { animationType: s } = e.options, i = n.source !== e.layout.source;
    s === "size" ? on((d) => {
      const f = i ? n.measuredBox[d] : n.layoutBox[d], p = Zt(f);
      f.min = r[d].min, f.max = f.min + p;
    }) : Zg(s, n.layoutBox, r) && on((d) => {
      const f = i ? n.measuredBox[d] : n.layoutBox[d], p = Zt(r[d]);
      f.max = f.min + p, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[d].max = e.relativeTarget[d].min + p);
    });
    const a = ao();
    fs(a, r, n.layoutBox);
    const c = ao();
    i ? fs(c, e.applyTransform(o, !0), n.measuredBox) : fs(c, r, n.layoutBox);
    const l = !Kg(a);
    let u = !1;
    if (!e.resumeFrom) {
      const d = e.getClosestProjectingParent();
      if (d && !d.resumeFrom) {
        const { snapshot: f, layout: p } = d;
        if (f && p) {
          const m = yt();
          ps(m, n.layoutBox, f.layoutBox);
          const g = yt();
          ps(g, r, p.layoutBox), Yg(m, g) || (u = !0), d.options.layoutRoot && (e.relativeTarget = g, e.relativeTargetOrigin = m, e.relativeParent = d);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: n,
      delta: c,
      layoutDelta: a,
      hasLayoutChanged: l,
      hasRelativeTargetChanged: u
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function MI(e) {
  xr.totalNodes++, e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function jI(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function DI(e) {
  e.clearSnapshot();
}
function qf(e) {
  e.clearMeasurements();
}
function OI(e) {
  e.isLayoutDirty = !1;
}
function FI(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function Kf(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function BI(e) {
  e.resolveTargetDelta();
}
function LI(e) {
  e.calcProjection();
}
function VI(e) {
  e.resetRotation();
}
function zI(e) {
  e.removeLeadSnapshot();
}
function Yf(e, t, n) {
  e.translate = dt(t.translate, 0, n), e.scale = dt(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function Xf(e, t, n, r) {
  e.min = dt(t.min, n.min, r), e.max = dt(t.max, n.max, r);
}
function WI(e, t, n, r) {
  Xf(e.x, t.x, n.x, r), Xf(e.y, t.y, n.y, r);
}
function HI(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const UI = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, Zf = (e) => typeof navigator < "u" && navigator.userAgent.toLowerCase().includes(e), Jf = Zf("applewebkit/") && !Zf("chrome/") ? Math.round : ht;
function Qf(e) {
  e.min = Jf(e.min), e.max = Jf(e.max);
}
function GI(e) {
  Qf(e.x), Qf(e.y);
}
function Zg(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !bl(Wf(t), Wf(n), 0.2);
}
const qI = Xg({
  attachResizeListener: (e, t) => zn(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), Ec = {
  current: void 0
}, Jg = Xg({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!Ec.current) {
      const e = new qI({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), Ec.current = e;
    }
    return Ec.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), KI = {
  pan: {
    Feature: lI
  },
  drag: {
    Feature: cI,
    ProjectionNode: Jg,
    MeasureLayout: Ug
  }
}, YI = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function XI(e) {
  const t = YI.exec(e);
  if (!t)
    return [,];
  const [, n, r] = t;
  return [n, r];
}
const ZI = 4;
function wl(e, t, n = 1) {
  ln(n <= ZI, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [r, o] = XI(e);
  if (!r)
    return;
  const s = window.getComputedStyle(t).getPropertyValue(r);
  if (s) {
    const i = s.trim();
    return Ng(i) ? parseFloat(i) : i;
  } else
    return dl(o) ? wl(o, t, n + 1) : o;
}
function JI(e, { ...t }, n) {
  const r = e.current;
  if (!(r instanceof Element))
    return { target: t, transitionEnd: n };
  n && (n = { ...n }), e.values.forEach((o) => {
    const s = o.get();
    if (!dl(s))
      return;
    const i = wl(s, r);
    i && o.set(i);
  });
  for (const o in t) {
    const s = t[o];
    if (!dl(s))
      continue;
    const i = wl(s, r);
    i && (t[o] = i, n || (n = {}), n[o] === void 0 && (n[o] = s));
  }
  return { target: t, transitionEnd: n };
}
const QI = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), Qg = (e) => QI.has(e), eR = (e) => Object.keys(e).some(Qg), mi = (e) => e === Fr || e === Ce, ep = (e, t) => parseFloat(e.split(", ")[t]), tp = (e, t) => (n, { transform: r }) => {
  if (r === "none" || !r)
    return 0;
  const o = r.match(/^matrix3d\((.+)\)$/);
  if (o)
    return ep(o[1], t);
  {
    const s = r.match(/^matrix\((.+)\)$/);
    return s ? ep(s[1], e) : 0;
  }
}, tR = /* @__PURE__ */ new Set(["x", "y", "z"]), nR = Ds.filter((e) => !tR.has(e));
function rR(e) {
  const t = [];
  return nR.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t.length && e.render(), t;
}
const Po = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: tp(4, 13),
  y: tp(5, 14)
};
Po.translateX = Po.x;
Po.translateY = Po.y;
const oR = (e, t, n) => {
  const r = t.measureViewportBox(), o = t.current, s = getComputedStyle(o), { display: i } = s, a = {};
  i === "none" && t.setStaticValue("display", e.display || "block"), n.forEach((l) => {
    a[l] = Po[l](r, s);
  }), t.render();
  const c = t.measureViewportBox();
  return n.forEach((l) => {
    const u = t.getValue(l);
    u && u.jump(a[l]), e[l] = Po[l](c, s);
  }), e;
}, sR = (e, t, n = {}, r = {}) => {
  t = { ...t }, r = { ...r };
  const o = Object.keys(t).filter(Qg);
  let s = [], i = !1;
  const a = [];
  if (o.forEach((c) => {
    const l = e.getValue(c);
    if (!e.hasValue(c))
      return;
    let u = n[c], d = Ho(u);
    const f = t[c];
    let p;
    if (Yi(f)) {
      const m = f.length, g = f[0] === null ? 1 : 0;
      u = f[g], d = Ho(u);
      for (let y = g; y < m && f[y] !== null; y++)
        p ? ln(Ho(f[y]) === p, "All keyframes must be of the same type") : (p = Ho(f[y]), ln(p === d || mi(d) && mi(p), "Keyframes must be of the same dimension as the current value"));
    } else
      p = Ho(f);
    if (d !== p)
      if (mi(d) && mi(p)) {
        const m = l.get();
        typeof m == "string" && l.set(parseFloat(m)), typeof f == "string" ? t[c] = parseFloat(f) : Array.isArray(f) && p === Ce && (t[c] = f.map(parseFloat));
      } else
        d != null && d.transform && (p != null && p.transform) && (u === 0 || f === 0) ? u === 0 ? l.set(p.transform(u)) : t[c] = d.transform(f) : (i || (s = rR(e), i = !0), a.push(c), r[c] = r[c] !== void 0 ? r[c] : t[c], l.jump(f));
  }), a.length) {
    const c = a.indexOf("height") >= 0 ? window.pageYOffset : null, l = oR(t, e, a);
    return s.length && s.forEach(([u, d]) => {
      e.getValue(u).set(d);
    }), e.render(), ma && c !== null && window.scrollTo({ top: c }), { target: l, transitionEnd: r };
  } else
    return { target: t, transitionEnd: r };
};
function iR(e, t, n, r) {
  return eR(t) ? sR(e, t, n, r) : { target: t, transitionEnd: r };
}
const aR = (e, t, n, r) => {
  const o = JI(e, t, r);
  return t = o.target, r = o.transitionEnd, iR(e, t, n, r);
}, kl = { current: null }, ey = { current: !1 };
function cR() {
  if (ey.current = !0, !!ma)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => kl.current = e.matches;
      e.addListener(t), t();
    } else
      kl.current = !1;
}
function lR(e, t, n) {
  const { willChange: r } = t;
  for (const o in t) {
    const s = t[o], i = n[o];
    if (Gt(s))
      e.addValue(o, s), Qi(r) && r.add(o), process.env.NODE_ENV === "development" && Tu(s.version === "10.18.0", `Attempting to mix Framer Motion versions ${s.version} with 10.18.0 may not work as expected.`);
    else if (Gt(i))
      e.addValue(o, ko(s, { owner: e })), Qi(r) && r.remove(o);
    else if (i !== s)
      if (e.hasValue(o)) {
        const a = e.getValue(o);
        !a.hasAnimated && a.set(s);
      } else {
        const a = e.getStaticValue(o);
        e.addValue(o, ko(a !== void 0 ? a : s, { owner: e }));
      }
  }
  for (const o in n)
    t[o] === void 0 && e.removeValue(o);
  return t;
}
const np = /* @__PURE__ */ new WeakMap(), ty = Object.keys(Ss), uR = ty.length, rp = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
], dR = lu.length;
class fR {
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: o, visualState: s }, i = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.scheduleRender = () => rt.render(this.render, !1, !0);
    const { latestValues: a, renderState: c } = s;
    this.latestValues = a, this.baseTarget = { ...a }, this.initialValues = n.initial ? { ...a } : {}, this.renderState = c, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = o, this.options = i, this.isControllingVariants = ya(n), this.isVariantNode = Fm(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: l, ...u } = this.scrapeMotionValuesFromProps(n, {});
    for (const d in u) {
      const f = u[d];
      a[d] !== void 0 && Gt(f) && (f.set(a[d], !1), Qi(l) && l.add(d));
    }
  }
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n) {
    return {};
  }
  mount(t) {
    this.current = t, np.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), ey.current || cR(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : kl.current, process.env.NODE_ENV !== "production" && Tu(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    np.delete(this.current), this.projection && this.projection.unmount(), qn(this.notifyUpdate), qn(this.render), this.valueSubscriptions.forEach((t) => t()), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features)
      this.features[t].unmount();
    this.current = null;
  }
  bindToMotionValue(t, n) {
    const r = Or.has(t), o = n.on("change", (i) => {
      this.latestValues[t] = i, this.props.onUpdate && rt.update(this.notifyUpdate, !1, !0), r && this.projection && (this.projection.isTransformDirty = !0);
    }), s = n.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(t, () => {
      o(), s();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  loadFeatures({ children: t, ...n }, r, o, s) {
    let i, a;
    if (process.env.NODE_ENV !== "production" && o && r) {
      const c = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
      n.ignoreStrict ? Bs(!1, c) : ln(!1, c);
    }
    for (let c = 0; c < uR; c++) {
      const l = ty[c], { isEnabled: u, Feature: d, ProjectionNode: f, MeasureLayout: p } = Ss[l];
      f && (i = f), u(n) && (!this.features[l] && d && (this.features[l] = new d(this)), p && (a = p));
    }
    if ((this.type === "html" || this.type === "svg") && !this.projection && i) {
      this.projection = new i(this.latestValues, this.parent && this.parent.projection);
      const { layoutId: c, layout: l, drag: u, dragConstraints: d, layoutScroll: f, layoutRoot: p } = n;
      this.projection.setOptions({
        layoutId: c,
        layout: l,
        alwaysMeasureLayout: !!u || d && so(d),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof l == "string" ? l : "both",
        initialPromotionConfig: s,
        layoutScroll: f,
        layoutRoot: p
      });
    }
    return a;
  }
  updateFeatures() {
    for (const t in this.features) {
      const n = this.features[t];
      n.isMounted ? n.update() : (n.mount(), n.isMounted = !0);
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : yt();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Make a target animatable by Popmotion. For instance, if we're
   * trying to animate width from 100px to 100vw we need to measure 100vw
   * in pixels to determine what we really need to animate to. This is also
   * pluggable to support Framer's custom value types like Color,
   * and CSS variables.
   */
  makeTargetAnimatable(t, n = !0) {
    return this.makeTargetAnimatableFromInstance(t, this.props, n);
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < rp.length; r++) {
      const o = rp[r];
      this.propEventSubscriptions[o] && (this.propEventSubscriptions[o](), delete this.propEventSubscriptions[o]);
      const s = t["on" + o];
      s && (this.propEventSubscriptions[o] = this.on(o, s));
    }
    this.prevMotionValues = lR(this, this.scrapeMotionValuesFromProps(t, this.prevProps), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(t = !1) {
    if (t)
      return this.parent ? this.parent.getVariantContext() : void 0;
    if (!this.isControllingVariants) {
      const r = this.parent ? this.parent.getVariantContext() || {} : {};
      return this.props.initial !== void 0 && (r.initial = this.props.initial), r;
    }
    const n = {};
    for (let r = 0; r < dR; r++) {
      const o = lu[r], s = this.props[o];
      (xs(s) || s === !1) && (n[o] = s);
    }
    return n;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    n !== this.values.get(t) && (this.removeValue(t), this.bindToMotionValue(t, n)), this.values.set(t, n), this.latestValues[t] = n.get();
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = ko(n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t) {
    var n;
    return this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : (n = this.getBaseTargetFromProps(this.props, t)) !== null && n !== void 0 ? n : this.readValueFromInstance(this.current, t, this.options);
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var n;
    const { initial: r } = this.props, o = typeof r == "string" || typeof r == "object" ? (n = yu(this.props, r)) === null || n === void 0 ? void 0 : n[t] : void 0;
    if (r && o !== void 0)
      return o;
    const s = this.getBaseTargetFromProps(this.props, t);
    return s !== void 0 && !Gt(s) ? s : this.initialValues[t] !== void 0 && o === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new _u()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
}
class ny extends fR {
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  makeTargetAnimatableFromInstance({ transition: t, transitionEnd: n, ...r }, { transformValues: o }, s) {
    let i = TA(r, t || {}, this);
    if (o && (n && (n = o(n)), r && (r = o(r)), i && (i = o(i))), s) {
      CA(this, r, i);
      const a = aR(this, r, i, n);
      n = a.transitionEnd, r = a.target;
    }
    return {
      transition: t,
      transitionEnd: n,
      ...r
    };
  }
}
function pR(e) {
  return window.getComputedStyle(e);
}
class hR extends ny {
  constructor() {
    super(...arguments), this.type = "html";
  }
  readValueFromInstance(t, n) {
    if (Or.has(n)) {
      const r = Su(n);
      return r && r.default || 0;
    } else {
      const r = pR(t), o = (zm(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof o == "string" ? o.trim() : o;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return zg(t, n);
  }
  build(t, n, r, o) {
    fu(t, n, r, o.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n) {
    return gu(t, n);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    Gt(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
  renderInstance(t, n, r, o) {
    Km(t, n, r, o);
  }
}
class mR extends ny {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (Or.has(n)) {
      const r = Su(n);
      return r && r.default || 0;
    }
    return n = Ym.has(n) ? n : au(n), t.getAttribute(n);
  }
  measureInstanceViewportBox() {
    return yt();
  }
  scrapeMotionValuesFromProps(t, n) {
    return Zm(t, n);
  }
  build(t, n, r, o) {
    hu(t, n, r, this.isSVGTag, o.transformTemplate);
  }
  renderInstance(t, n, r, o) {
    Xm(t, n, r, o);
  }
  mount(t) {
    this.isSVGTag = mu(t.tagName), super.mount(t);
  }
}
const gR = (e, t) => du(e) ? new mR(t, { enableHardwareAcceleration: !1 }) : new hR(t, { enableHardwareAcceleration: !0 }), yR = {
  layout: {
    ProjectionNode: Jg,
    MeasureLayout: Ug
  }
}, bR = {
  ...zA,
  ...uE,
  ...KI,
  ...yR
}, xn = /* @__PURE__ */ vT((e, t) => ZT(e, t, bR, gR));
function ry() {
  const e = ae(!1);
  return iu(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function vR() {
  const e = ry(), [t, n] = he(0), r = R(() => {
    e.current && n(t + 1);
  }, [t]);
  return [R(() => rt.postRender(r), [r]), t];
}
class xR extends we.Component {
  getSnapshotBeforeUpdate(t) {
    const n = this.props.childRef.current;
    if (n && t.isPresent && !this.props.isPresent) {
      const r = this.props.sizeRef.current;
      r.height = n.offsetHeight || 0, r.width = n.offsetWidth || 0, r.top = n.offsetTop, r.left = n.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function SR({ children: e, isPresent: t }) {
  const n = Rt(), r = ae(null), o = ae({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  });
  return Eh(() => {
    const { width: s, height: i, top: a, left: c } = o.current;
    if (t || !r.current || !s || !i)
      return;
    r.current.dataset.motionPopId = n;
    const l = document.createElement("style");
    return document.head.appendChild(l), l.sheet && l.sheet.insertRule(`
          [data-motion-pop-id="${n}"] {
            position: absolute !important;
            width: ${s}px !important;
            height: ${i}px !important;
            top: ${a}px !important;
            left: ${c}px !important;
          }
        `), () => {
      document.head.removeChild(l);
    };
  }, [t]), we.createElement(xR, { isPresent: t, childRef: r, sizeRef: o }, we.cloneElement(e, { ref: r }));
}
const Ac = ({ children: e, initial: t, isPresent: n, onExitComplete: r, custom: o, presenceAffectsLayout: s, mode: i }) => {
  const a = Jm(wR), c = Rt(), l = _e(
    () => ({
      id: c,
      initial: t,
      isPresent: n,
      custom: o,
      onExitComplete: (u) => {
        a.set(u, !0);
        for (const d of a.values())
          if (!d)
            return;
        r && r();
      },
      register: (u) => (a.set(u, !1), () => a.delete(u))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    s ? void 0 : [n]
  );
  return _e(() => {
    a.forEach((u, d) => a.set(d, !1));
  }, [n]), we.useEffect(() => {
    !n && !a.size && r && r();
  }, [n]), i === "popLayout" && (e = we.createElement(SR, { isPresent: n }, e)), we.createElement(js.Provider, { value: l }, e);
};
function wR() {
  return /* @__PURE__ */ new Map();
}
function kR(e) {
  return xe(() => () => e(), []);
}
const Sr = (e) => e.key || "";
function PR(e, t) {
  e.forEach((n) => {
    const r = Sr(n);
    t.set(r, n);
  });
}
function CR(e) {
  const t = [];
  return $n.forEach(e, (n) => {
    ur(n) && t.push(n);
  }), t;
}
const pr = ({ children: e, custom: t, initial: n = !0, onExitComplete: r, exitBeforeEnter: o, presenceAffectsLayout: s = !0, mode: i = "sync" }) => {
  ln(!o, "Replace exitBeforeEnter with mode='wait'");
  const a = vt(uu).forceRender || vR()[0], c = ry(), l = CR(e);
  let u = l;
  const d = ae(/* @__PURE__ */ new Map()).current, f = ae(u), p = ae(/* @__PURE__ */ new Map()).current, m = ae(!0);
  if (iu(() => {
    m.current = !1, PR(l, p), f.current = u;
  }), kR(() => {
    m.current = !0, p.clear(), d.clear();
  }), m.current)
    return we.createElement(we.Fragment, null, u.map((b) => we.createElement(Ac, { key: Sr(b), isPresent: !0, initial: n ? void 0 : !1, presenceAffectsLayout: s, mode: i }, b)));
  u = [...u];
  const g = f.current.map(Sr), y = l.map(Sr), S = g.length;
  for (let b = 0; b < S; b++) {
    const v = g[b];
    y.indexOf(v) === -1 && !d.has(v) && d.set(v, void 0);
  }
  return i === "wait" && d.size && (u = []), d.forEach((b, v) => {
    if (y.indexOf(v) !== -1)
      return;
    const k = p.get(v);
    if (!k)
      return;
    const w = g.indexOf(v);
    let _ = b;
    if (!_) {
      const C = () => {
        d.delete(v);
        const I = Array.from(p.keys()).filter(($) => !y.includes($));
        if (I.forEach(($) => p.delete($)), f.current = l.filter(($) => {
          const N = Sr($);
          return (
            // filter out the node exiting
            N === v || // filter out the leftover children
            I.includes(N)
          );
        }), !d.size) {
          if (c.current === !1)
            return;
          a(), r && r();
        }
      };
      _ = we.createElement(Ac, { key: Sr(k), isPresent: !1, onExitComplete: C, custom: t, presenceAffectsLayout: s, mode: i }, k), d.set(v, _);
    }
    u.splice(w, 0, _);
  }), u = u.map((b) => {
    const v = b.key;
    return d.has(v) ? b : we.createElement(Ac, { key: Sr(b), isPresent: !0, presenceAffectsLayout: s, mode: i }, b);
  }), process.env.NODE_ENV !== "production" && i === "wait" && u.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`), we.createElement(we.Fragment, null, d.size ? u : u.map((b) => kt(b)));
}, _R = (e, t) => e.find((n) => n.id === t);
function op(e, t) {
  const n = oy(e, t), r = n ? e[n].findIndex((o) => o.id === t) : -1;
  return {
    position: n,
    index: r
  };
}
function oy(e, t) {
  for (const [n, r] of Object.entries(e))
    if (_R(r, t))
      return n;
}
function TR(e) {
  const t = e.includes("right"), n = e.includes("left");
  let r = "center";
  return t && (r = "flex-end"), n && (r = "flex-start"), {
    display: "flex",
    flexDirection: "column",
    alignItems: r
  };
}
function ER(e) {
  const n = e === "top" || e === "bottom" ? "0 auto" : void 0, r = e.includes("top") ? "env(safe-area-inset-top, 0px)" : void 0, o = e.includes("bottom") ? "env(safe-area-inset-bottom, 0px)" : void 0, s = e.includes("left") ? void 0 : "env(safe-area-inset-right, 0px)", i = e.includes("right") ? void 0 : "env(safe-area-inset-left, 0px)";
  return {
    position: "fixed",
    zIndex: "var(--toast-z-index, 5500)",
    pointerEvents: "none",
    display: "flex",
    flexDirection: "column",
    margin: n,
    top: r,
    bottom: o,
    right: s,
    left: i
  };
}
const AR = /* @__PURE__ */ new Set([
  ...fS,
  "textStyle",
  "layerStyle",
  "apply",
  "noOfLines",
  "focusBorderColor",
  "errorBorderColor",
  "as",
  "__css",
  "css",
  "sx"
]), IR = /* @__PURE__ */ new Set([
  "htmlWidth",
  "htmlHeight",
  "htmlSize",
  "htmlTranslate"
]);
function RR(e) {
  return (IR.has(e) || !AR.has(e)) && e[0] !== "_";
}
const $R = D0(l0), NR = ({ baseStyle: e }) => (t) => {
  const { theme: n, css: r, __css: o, sx: s, ...i } = t, [a] = z0(i, hS), c = Et(e, t), l = k0(
    {},
    o,
    c,
    Io(a),
    s
  ), u = im(l)(t.theme);
  return r ? [u, r] : u;
};
function Ic(e, t) {
  const { baseStyle: n, ...r } = t ?? {};
  r.shouldForwardProp || (r.shouldForwardProp = RR);
  const o = NR({ baseStyle: n }), s = $R(
    e,
    r
  )(o);
  return vn(
    function(c, l) {
      const { children: u, ...d } = c, { colorMode: f, forced: p } = pa();
      return Hl(
        s,
        { ref: l, "data-theme": p ? f : void 0, ...d },
        u
      );
    }
  );
}
function MR() {
  const e = /* @__PURE__ */ new Map();
  return new Proxy(Ic, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply(t, n, r) {
      return Ic(...r);
    },
    /**
     * @example
     * <chakra.div />
     */
    get(t, n) {
      return e.has(n) || e.set(n, Ic(n)), e.get(n);
    }
  });
}
const E = MR(), jR = {
  initial: (e) => {
    const { position: t } = e, n = ["top", "bottom"].includes(t) ? "y" : "x";
    let r = ["top-right", "bottom-right"].includes(t) ? 1 : -1;
    return t === "bottom" && (r = 1), {
      opacity: 0,
      [n]: r * 24
    };
  },
  animate: {
    opacity: 1,
    y: 0,
    x: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    opacity: 0,
    scale: 0.85,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 1, 1]
    }
  }
}, sy = r0((e) => {
  const {
    id: t,
    message: n,
    onCloseComplete: r,
    onRequestRemove: o,
    requestClose: s = !1,
    position: i = "bottom",
    duration: a = 5e3,
    containerStyle: c,
    motionVariants: l = jR,
    toastSpacing: u = "0.5rem"
  } = e, [d, f] = he(a), p = uI();
  bn(() => {
    p || r == null || r();
  }, [p]), bn(() => {
    f(a);
  }, [a]);
  const m = () => f(null), g = () => f(a), y = () => {
    p && o();
  };
  xe(() => {
    p && s && o();
  }, [p, s, o]), bx(y, d);
  const S = _e(
    () => ({
      pointerEvents: "auto",
      maxWidth: 560,
      minWidth: 300,
      margin: u,
      ...c
    }),
    [c, u]
  ), b = _e(() => TR(i), [i]);
  return /* @__PURE__ */ h.jsx(
    xn.div,
    {
      layout: !0,
      className: "chakra-toast",
      variants: l,
      initial: "initial",
      animate: "animate",
      exit: "exit",
      onHoverStart: m,
      onHoverEnd: g,
      custom: { position: i },
      style: b,
      children: /* @__PURE__ */ h.jsx(
        E.div,
        {
          role: "status",
          "aria-atomic": "true",
          className: "chakra-toast__inner",
          __css: S,
          children: Et(n, { id: t, onClose: y })
        }
      )
    }
  );
});
sy.displayName = "ToastComponent";
function M(e) {
  return vn(e);
}
var DR = typeof Element < "u", OR = typeof Map == "function", FR = typeof Set == "function", BR = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function ji(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var n, r, o;
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!ji(e[r], t[r]))
          return !1;
      return !0;
    }
    var s;
    if (OR && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (s = e.entries(); !(r = s.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      for (s = e.entries(); !(r = s.next()).done; )
        if (!ji(r.value[1], t.get(r.value[0])))
          return !1;
      return !0;
    }
    if (FR && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (s = e.entries(); !(r = s.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      return !0;
    }
    if (BR && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (e[r] !== t[r])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function")
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function")
      return e.toString() === t.toString();
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, o[r]))
        return !1;
    if (DR && e instanceof Element)
      return !1;
    for (r = n; r-- !== 0; )
      if (!((o[r] === "_owner" || o[r] === "__v" || o[r] === "__o") && e.$$typeof) && !ji(e[o[r]], t[o[r]]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var LR = function(t, n) {
  try {
    return ji(t, n);
  } catch (r) {
    if ((r.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw r;
  }
};
const VR = /* @__PURE__ */ ca(LR);
function fn() {
  const e = vt(
    c0
  );
  if (!e)
    throw Error(
      "useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`"
    );
  return e;
}
function iy() {
  const e = pa(), t = fn();
  return { ...e, theme: t };
}
function zR(e, t, n) {
  if (t == null)
    return t;
  const r = (o) => {
    var s, i;
    return (i = (s = e.__breakpoints) == null ? void 0 : s.asArray) == null ? void 0 : i[o];
  };
  return r(t) ?? r(n) ?? n;
}
function WR(e, t, n) {
  if (t == null)
    return t;
  const r = (o) => {
    var s, i;
    return (i = (s = e.__cssMap) == null ? void 0 : s[o]) == null ? void 0 : i.value;
  };
  return r(t) ?? r(n) ?? n;
}
function HR(e, t, n) {
  const r = fn();
  return ay(e, t, n)(r);
}
function ay(e, t, n) {
  const r = Array.isArray(t) ? t : [t], o = Array.isArray(n) ? n : [n];
  return (s) => {
    const i = o.filter(Boolean), a = r.map((c, l) => {
      if (e === "breakpoints")
        return zR(s, c, i[l] ?? c);
      const u = `${e}.${c}`;
      return WR(s, u, i[l] ?? c);
    });
    return Array.isArray(t) ? a : a[0];
  };
}
function UR(e) {
  return Object.fromEntries(
    Object.entries(e).filter(([t, n]) => n !== void 0 && t !== "children" && !ur(n))
  );
}
function cy(e, t = {}) {
  const { styleConfig: n, ...r } = t, { theme: o, colorMode: s } = iy(), i = e ? Oh(o, `components.${e}`) : void 0, a = n || i, c = sn(
    { theme: o, colorMode: s },
    (a == null ? void 0 : a.defaultProps) ?? {},
    UR(r),
    (u, d) => u ? void 0 : d
  ), l = ae({});
  if (a) {
    const d = CS(a)(c);
    VR(l.current, d) || (l.current = d);
  }
  return l.current;
}
function Ct(e, t = {}) {
  return cy(e, t);
}
function Je(e, t = {}) {
  return cy(e, t);
}
const sp = {
  path: /* @__PURE__ */ h.jsxs("g", { stroke: "currentColor", strokeWidth: "1.5", children: [
    /* @__PURE__ */ h.jsx(
      "path",
      {
        strokeLinecap: "round",
        fill: "none",
        d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
      }
    ),
    /* @__PURE__ */ h.jsx(
      "path",
      {
        fill: "currentColor",
        strokeLinecap: "round",
        d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
      }
    ),
    /* @__PURE__ */ h.jsx("circle", { fill: "none", strokeMiterlimit: "10", cx: "12", cy: "12", r: "11.25" })
  ] }),
  viewBox: "0 0 24 24"
}, $t = M((e, t) => {
  const {
    as: n,
    viewBox: r,
    color: o = "currentColor",
    focusable: s = !1,
    children: i,
    className: a,
    __css: c,
    ...l
  } = e, u = W("chakra-icon", a), d = Ct("Icon", e), f = {
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color: o,
    ...c,
    ...d
  }, p = {
    ref: t,
    focusable: s,
    className: u,
    __css: f
  }, m = r ?? sp.viewBox;
  if (n && typeof n != "string")
    return /* @__PURE__ */ h.jsx(E.svg, { as: n, ...p, ...l });
  const g = i ?? sp.path;
  return /* @__PURE__ */ h.jsx(E.svg, { verticalAlign: "middle", viewBox: m, ...p, ...l, children: g });
});
$t.displayName = "Icon";
function GR(e) {
  return /* @__PURE__ */ h.jsx($t, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ h.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
    }
  ) });
}
function qR(e) {
  return /* @__PURE__ */ h.jsx($t, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ h.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
    }
  ) });
}
function ip(e) {
  return /* @__PURE__ */ h.jsx($t, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ h.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
    }
  ) });
}
const KR = Mn({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
}), Eu = M((e, t) => {
  const n = Ct("Spinner", e), {
    label: r = "Loading...",
    thickness: o = "2px",
    speed: s = "0.45s",
    emptyColor: i = "transparent",
    className: a,
    ...c
  } = Ae(e), l = W("chakra-spinner", a), u = {
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderRadius: "99999px",
    borderWidth: o,
    borderBottomColor: i,
    borderLeftColor: i,
    animation: `${KR} ${s} linear infinite`,
    ...n
  };
  return /* @__PURE__ */ h.jsx(
    E.div,
    {
      ref: t,
      __css: u,
      className: l,
      ...c,
      children: r && /* @__PURE__ */ h.jsx(E.span, { srOnly: !0, children: r })
    }
  );
});
Eu.displayName = "Spinner";
const [YR, Au] = Ee({
  name: "AlertContext",
  hookName: "useAlertContext",
  providerName: "<Alert />"
}), [XR, Iu] = Ee({
  name: "AlertStylesContext",
  hookName: "useAlertStyles",
  providerName: "<Alert />"
}), ly = {
  info: { icon: qR, colorScheme: "blue" },
  warning: { icon: ip, colorScheme: "orange" },
  success: { icon: GR, colorScheme: "green" },
  error: { icon: ip, colorScheme: "red" },
  loading: { icon: Eu, colorScheme: "blue" }
};
function ZR(e) {
  return ly[e].colorScheme;
}
function JR(e) {
  return ly[e].icon;
}
const uy = M(function(t, n) {
  const { status: r = "info", addRole: o = !0, ...s } = Ae(t), i = t.colorScheme ?? ZR(r), a = Je("Alert", { ...t, colorScheme: i }), c = {
    width: "100%",
    display: "flex",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
    ...a.container
  };
  return /* @__PURE__ */ h.jsx(YR, { value: { status: r }, children: /* @__PURE__ */ h.jsx(XR, { value: a, children: /* @__PURE__ */ h.jsx(
    E.div,
    {
      "data-status": r,
      role: o ? "alert" : void 0,
      ref: n,
      ...s,
      className: W("chakra-alert", t.className),
      __css: c
    }
  ) }) });
});
uy.displayName = "Alert";
function dy(e) {
  const { status: t } = Au(), n = JR(t), r = Iu(), o = t === "loading" ? r.spinner : r.icon;
  return /* @__PURE__ */ h.jsx(
    E.span,
    {
      display: "inherit",
      "data-status": t,
      ...e,
      className: W("chakra-alert__icon", e.className),
      __css: o,
      children: e.children || /* @__PURE__ */ h.jsx(n, { h: "100%", w: "100%" })
    }
  );
}
dy.displayName = "AlertIcon";
const fy = M(
  function(t, n) {
    const r = Iu(), { status: o } = Au();
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ref: n,
        "data-status": o,
        ...t,
        className: W("chakra-alert__title", t.className),
        __css: r.title
      }
    );
  }
);
fy.displayName = "AlertTitle";
const py = M(
  function(t, n) {
    const { status: r } = Au(), o = Iu(), s = {
      display: "inline",
      ...o.description
    };
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ref: n,
        "data-status": r,
        ...t,
        className: W("chakra-alert__desc", t.className),
        __css: s
      }
    );
  }
);
py.displayName = "AlertDescription";
function QR(e) {
  return /* @__PURE__ */ h.jsx($t, { focusable: "false", "aria-hidden": !0, ...e, children: /* @__PURE__ */ h.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
    }
  ) });
}
const Sa = M(
  function(t, n) {
    const r = Ct("CloseButton", t), { children: o, isDisabled: s, __css: i, ...a } = Ae(t), c = {
      outline: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0
    };
    return /* @__PURE__ */ h.jsx(
      E.button,
      {
        type: "button",
        "aria-label": "Close",
        ref: n,
        disabled: s,
        __css: {
          ...c,
          ...r,
          ...i
        },
        ...a,
        children: o || /* @__PURE__ */ h.jsx(QR, { width: "1em", height: "1em" })
      }
    );
  }
);
Sa.displayName = "CloseButton";
const e$ = (e) => {
  const {
    status: t,
    variant: n = "solid",
    id: r,
    title: o,
    isClosable: s,
    onClose: i,
    description: a,
    colorScheme: c,
    icon: l
  } = e, u = r ? {
    root: `toast-${r}`,
    title: `toast-${r}-title`,
    description: `toast-${r}-description`
  } : void 0;
  return /* @__PURE__ */ h.jsxs(
    uy,
    {
      addRole: !1,
      status: t,
      variant: n,
      id: u == null ? void 0 : u.root,
      alignItems: "start",
      borderRadius: "md",
      boxShadow: "lg",
      paddingEnd: 8,
      textAlign: "start",
      width: "auto",
      colorScheme: c,
      children: [
        /* @__PURE__ */ h.jsx(dy, { children: l }),
        /* @__PURE__ */ h.jsxs(E.div, { flex: "1", maxWidth: "100%", children: [
          o && /* @__PURE__ */ h.jsx(fy, { id: u == null ? void 0 : u.title, children: o }),
          a && /* @__PURE__ */ h.jsx(py, { id: u == null ? void 0 : u.description, display: "block", children: a })
        ] }),
        s && /* @__PURE__ */ h.jsx(
          Sa,
          {
            size: "sm",
            onClick: i,
            position: "absolute",
            insetEnd: 1,
            top: 1
          }
        )
      ]
    }
  );
};
function hy(e = {}) {
  const { render: t, toastComponent: n = e$ } = e;
  return (o) => typeof t == "function" ? t({ ...o, ...e }) : /* @__PURE__ */ h.jsx(n, { ...o, ...e });
}
const t$ = {
  top: [],
  "top-left": [],
  "top-right": [],
  "bottom-left": [],
  bottom: [],
  "bottom-right": []
}, _n = n$(t$);
function n$(e) {
  let t = e;
  const n = /* @__PURE__ */ new Set(), r = (o) => {
    t = o(t), n.forEach((s) => s());
  };
  return {
    getState: () => t,
    subscribe: (o) => (n.add(o), () => {
      r(() => e), n.delete(o);
    }),
    /**
     * Delete a toast record at its position
     */
    removeToast: (o, s) => {
      r((i) => ({
        ...i,
        // id may be string or number
        // eslint-disable-next-line eqeqeq
        [s]: i[s].filter((a) => a.id != o)
      }));
    },
    notify: (o, s) => {
      const i = r$(o, s), { position: a, id: c } = i;
      return r((l) => {
        const d = a.includes("top") ? [i, ...l[a] ?? []] : [...l[a] ?? [], i];
        return {
          ...l,
          [a]: d
        };
      }), c;
    },
    update: (o, s) => {
      o && r((i) => {
        const a = { ...i }, { position: c, index: l } = op(a, o);
        return c && l !== -1 && (a[c][l] = {
          ...a[c][l],
          ...s,
          message: hy(s)
        }), a;
      });
    },
    closeAll: ({ positions: o } = {}) => {
      r((s) => (o ?? [
        "bottom",
        "bottom-right",
        "bottom-left",
        "top",
        "top-left",
        "top-right"
      ]).reduce(
        (c, l) => (c[l] = s[l].map((u) => ({
          ...u,
          requestClose: !0
        })), c),
        { ...s }
      ));
    },
    close: (o) => {
      r((s) => {
        const i = oy(s, o);
        return i ? {
          ...s,
          [i]: s[i].map((a) => a.id == o ? {
            ...a,
            requestClose: !0
          } : a)
        } : s;
      });
    },
    isActive: (o) => !!op(_n.getState(), o).position
  };
}
let ap = 0;
function r$(e, t = {}) {
  ap += 1;
  const n = t.id ?? ap, r = t.position ?? "bottom";
  return {
    id: n,
    message: e,
    position: r,
    duration: t.duration,
    onCloseComplete: t.onCloseComplete,
    onRequestRemove: () => _n.removeToast(String(n), r),
    status: t.status,
    requestClose: !1,
    containerStyle: t.containerStyle
  };
}
const [my, o$] = Ee({
  strict: !1,
  name: "PortalContext"
}), Ru = "chakra-portal", s$ = ".chakra-portal", i$ = (e) => /* @__PURE__ */ h.jsx(
  "div",
  {
    className: "chakra-portal-zIndex",
    style: {
      position: "absolute",
      zIndex: e.zIndex,
      top: 0,
      left: 0,
      right: 0
      // NB: Don't add `bottom: 0`, it makes the entire app unusable
      // @see https://github.com/chakra-ui/chakra-ui/issues/3201
    },
    children: e.children
  }
), a$ = (e) => {
  const { appendToParentPortal: t, children: n } = e, [r, o] = he(null), s = ae(null), [, i] = he({});
  xe(() => i({}), []);
  const a = o$(), c = aT();
  an(() => {
    if (!r)
      return;
    const u = r.ownerDocument, d = t ? a ?? u.body : u.body;
    if (!d)
      return;
    s.current = u.createElement("div"), s.current.className = Ru, d.appendChild(s.current), i({});
    const f = s.current;
    return () => {
      d.contains(f) && d.removeChild(f);
    };
  }, [r]);
  const l = c != null && c.zIndex ? /* @__PURE__ */ h.jsx(i$, { zIndex: c == null ? void 0 : c.zIndex, children: n }) : n;
  return s.current ? Ah(
    /* @__PURE__ */ h.jsx(my, { value: s.current, children: l }),
    s.current
  ) : /* @__PURE__ */ h.jsx(
    "span",
    {
      ref: (u) => {
        u && o(u);
      }
    }
  );
}, c$ = (e) => {
  const { children: t, containerRef: n, appendToParentPortal: r } = e, o = n.current, s = o ?? (typeof window < "u" ? document.body : void 0), i = _e(() => {
    const c = o == null ? void 0 : o.ownerDocument.createElement("div");
    return c && (c.className = Ru), c;
  }, [o]), [, a] = he({});
  return an(() => a({}), []), an(() => {
    if (!(!i || !s))
      return s.appendChild(i), () => {
        s.removeChild(i);
      };
  }, [i, s]), s && i ? Ah(
    /* @__PURE__ */ h.jsx(my, { value: r ? i : null, children: t }),
    i
  ) : null;
};
function $o(e) {
  const t = {
    appendToParentPortal: !0,
    ...e
  }, { containerRef: n, ...r } = t;
  return n ? /* @__PURE__ */ h.jsx(c$, { containerRef: n, ...r }) : /* @__PURE__ */ h.jsx(a$, { ...r });
}
$o.className = Ru;
$o.selector = s$;
$o.displayName = "Portal";
const [l$, u$] = Ee({
  name: "ToastOptionsContext",
  strict: !1
}), gy = (e) => {
  const t = o0(
    _n.subscribe,
    _n.getState,
    _n.getState
  ), {
    motionVariants: n,
    component: r = sy,
    portalProps: o,
    animatePresenceProps: s
  } = e, a = Object.keys(t).map((c) => {
    const l = t[c];
    return /* @__PURE__ */ h.jsx(
      "div",
      {
        role: "region",
        "aria-live": "polite",
        "aria-label": `Notifications-${c}`,
        id: `chakra-toast-manager-${c}`,
        style: ER(c),
        children: /* @__PURE__ */ h.jsx(pr, { ...s, initial: !1, children: l.map((u) => /* @__PURE__ */ h.jsx(
          r,
          {
            motionVariants: n,
            ...u
          },
          u.id
        )) })
      },
      c
    );
  });
  return /* @__PURE__ */ h.jsx($o, { ...o, children: a });
}, yy = (e) => function({
  children: n,
  theme: r = e,
  toastOptions: o,
  ...s
}) {
  return /* @__PURE__ */ h.jsxs(lT, { theme: r, ...s, children: [
    /* @__PURE__ */ h.jsx(l$, { value: o == null ? void 0 : o.defaultOptions, children: n }),
    /* @__PURE__ */ h.jsx(gy, { ...o })
  ] });
}, gL = yy(_m), yL = yy(ru);
function cp(e) {
  return e.sort((t, n) => {
    const r = t.compareDocumentPosition(n);
    if (r & Node.DOCUMENT_POSITION_FOLLOWING || r & Node.DOCUMENT_POSITION_CONTAINED_BY)
      return -1;
    if (r & Node.DOCUMENT_POSITION_PRECEDING || r & Node.DOCUMENT_POSITION_CONTAINS)
      return 1;
    if (r & Node.DOCUMENT_POSITION_DISCONNECTED || r & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC)
      throw Error("Cannot sort the given nodes.");
    return 0;
  });
}
const d$ = (e) => typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
function lp(e, t, n) {
  let r = e + 1;
  return n && r >= t && (r = 0), r;
}
function up(e, t, n) {
  let r = e - 1;
  return n && r < 0 && (r = t), r;
}
const Rc = typeof window < "u" ? Is : xe, dp = (e) => e;
var f$ = Object.defineProperty, p$ = (e, t, n) => t in e ? f$(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, pt = (e, t, n) => (p$(e, typeof t != "symbol" ? t + "" : t, n), n);
class h$ {
  constructor() {
    pt(this, "descendants", /* @__PURE__ */ new Map()), pt(this, "register", (t) => {
      if (t != null)
        return d$(t) ? this.registerNode(t) : (n) => {
          this.registerNode(n, t);
        };
    }), pt(this, "unregister", (t) => {
      this.descendants.delete(t);
      const n = cp(Array.from(this.descendants.keys()));
      this.assignIndex(n);
    }), pt(this, "destroy", () => {
      this.descendants.clear();
    }), pt(this, "assignIndex", (t) => {
      this.descendants.forEach((n) => {
        const r = t.indexOf(n.node);
        n.index = r, n.node.dataset.index = n.index.toString();
      });
    }), pt(this, "count", () => this.descendants.size), pt(this, "enabledCount", () => this.enabledValues().length), pt(this, "values", () => Array.from(this.descendants.values()).sort((n, r) => n.index - r.index)), pt(this, "enabledValues", () => this.values().filter((t) => !t.disabled)), pt(this, "item", (t) => {
      if (this.count() !== 0)
        return this.values()[t];
    }), pt(this, "enabledItem", (t) => {
      if (this.enabledCount() !== 0)
        return this.enabledValues()[t];
    }), pt(this, "first", () => this.item(0)), pt(this, "firstEnabled", () => this.enabledItem(0)), pt(this, "last", () => this.item(this.descendants.size - 1)), pt(this, "lastEnabled", () => {
      const t = this.enabledValues().length - 1;
      return this.enabledItem(t);
    }), pt(this, "indexOf", (t) => {
      var n;
      return t ? ((n = this.descendants.get(t)) == null ? void 0 : n.index) ?? -1 : -1;
    }), pt(this, "enabledIndexOf", (t) => t == null ? -1 : this.enabledValues().findIndex((n) => n.node.isSameNode(t))), pt(this, "next", (t, n = !0) => {
      const r = lp(t, this.count(), n);
      return this.item(r);
    }), pt(this, "nextEnabled", (t, n = !0) => {
      const r = this.item(t);
      if (!r)
        return;
      const o = this.enabledIndexOf(r.node), s = lp(
        o,
        this.enabledCount(),
        n
      );
      return this.enabledItem(s);
    }), pt(this, "prev", (t, n = !0) => {
      const r = up(t, this.count() - 1, n);
      return this.item(r);
    }), pt(this, "prevEnabled", (t, n = !0) => {
      const r = this.item(t);
      if (!r)
        return;
      const o = this.enabledIndexOf(r.node), s = up(
        o,
        this.enabledCount() - 1,
        n
      );
      return this.enabledItem(s);
    }), pt(this, "registerNode", (t, n) => {
      if (!t || this.descendants.has(t))
        return;
      const r = Array.from(this.descendants.keys()).concat(t), o = cp(r);
      n != null && n.disabled && (n.disabled = !!n.disabled);
      const s = { node: t, index: -1, ...n };
      this.descendants.set(t, s), this.assignIndex(o);
    });
  }
}
function wa() {
  const [e, t] = Ee({
    name: "DescendantsProvider",
    errorMessage: "useDescendantsContext must be used within DescendantsProvider"
  });
  return [
    // context provider
    e,
    // call this when you need to read from context
    t,
    () => {
      const o = ae(new h$());
      return Rc(() => () => o.current.destroy()), o.current;
    },
    (o) => {
      const s = t(), [i, a] = he(-1), c = ae(null);
      Rc(() => () => {
        c.current && s.unregister(c.current);
      }, []), Rc(() => {
        if (!c.current)
          return;
        const u = Number(c.current.dataset.index);
        i != u && !Number.isNaN(u) && a(u);
      });
      const l = dp(o ? s.register(o) : s.register);
      return {
        descendants: s,
        index: i,
        enabledIndex: s.enabledIndexOf(c.current),
        register: De(l, c)
      };
    }
  ];
}
const [m$, ka] = Ee({
  name: "AccordionStylesContext",
  hookName: "useAccordionStyles",
  providerName: "<Accordion />"
}), [g$, Pa] = Ee({
  name: "AccordionItemContext",
  hookName: "useAccordionItemContext",
  providerName: "<AccordionItem />"
}), [
  y$,
  bL,
  b$,
  v$
] = wa();
function x$(e) {
  const {
    onChange: t,
    defaultIndex: n,
    index: r,
    allowMultiple: o,
    allowToggle: s,
    ...i
  } = e;
  k$(e), P$(e);
  const a = b$(), [c, l] = he(-1);
  xe(() => () => {
    l(-1);
  }, []);
  const [u, d] = dr({
    value: r,
    defaultValue() {
      return o ? n ?? [] : n ?? -1;
    },
    onChange: t
  });
  return {
    index: u,
    setIndex: d,
    htmlProps: i,
    getAccordionItemProps: (p) => {
      let m = !1;
      return p !== null && (m = Array.isArray(u) ? u.includes(p) : u === p), { isOpen: m, onChange: (y) => {
        if (p !== null)
          if (o && Array.isArray(u)) {
            const S = y ? u.concat(p) : u.filter((b) => b !== p);
            d(S);
          } else
            y ? d(p) : s && d(-1);
      } };
    },
    focusedIndex: c,
    setFocusedIndex: l,
    descendants: a
  };
}
const [S$, $u] = Ee({
  name: "AccordionContext",
  hookName: "useAccordionContext",
  providerName: "Accordion"
});
function w$(e) {
  const { isDisabled: t, isFocusable: n, id: r, ...o } = e, { getAccordionItemProps: s, setFocusedIndex: i } = $u(), a = ae(null), c = Rt(), l = r ?? c, u = `accordion-button-${l}`, d = `accordion-panel-${l}`;
  C$(e);
  const { register: f, index: p, descendants: m } = v$({
    disabled: t && !n
  }), { isOpen: g, onChange: y } = s(
    p === -1 ? null : p
  );
  _$({ isOpen: g, isDisabled: t });
  const S = () => {
    y == null || y(!0);
  }, b = () => {
    y == null || y(!1);
  }, v = R(() => {
    y == null || y(!g), i(p);
  }, [p, i, g, y]), k = R(
    (I) => {
      const N = {
        ArrowDown: () => {
          const z = m.nextEnabled(p);
          z == null || z.node.focus();
        },
        ArrowUp: () => {
          const z = m.prevEnabled(p);
          z == null || z.node.focus();
        },
        Home: () => {
          const z = m.firstEnabled();
          z == null || z.node.focus();
        },
        End: () => {
          const z = m.lastEnabled();
          z == null || z.node.focus();
        }
      }[I.key];
      N && (I.preventDefault(), N(I));
    },
    [m, p]
  ), w = R(() => {
    i(p);
  }, [i, p]), _ = R(
    function($ = {}, N = null) {
      return {
        ...$,
        type: "button",
        ref: De(f, a, N),
        id: u,
        disabled: !!t,
        "aria-expanded": !!g,
        "aria-controls": d,
        onClick: re($.onClick, v),
        onFocus: re($.onFocus, w),
        onKeyDown: re($.onKeyDown, k)
      };
    },
    [
      u,
      t,
      g,
      v,
      w,
      k,
      d,
      f
    ]
  ), C = R(
    function($ = {}, N = null) {
      return {
        ...$,
        ref: N,
        role: "region",
        id: d,
        "aria-labelledby": u,
        hidden: !g
      };
    },
    [u, g, d]
  );
  return {
    isOpen: g,
    isDisabled: t,
    isFocusable: n,
    onOpen: S,
    onClose: b,
    getButtonProps: _,
    getPanelProps: C,
    htmlProps: o
  };
}
function k$(e) {
  const t = e.index || e.defaultIndex, n = t != null && !Array.isArray(t) && e.allowMultiple;
  $s({
    condition: !!n,
    message: `If 'allowMultiple' is passed, then 'index' or 'defaultIndex' must be an array. You passed: ${typeof t},`
  });
}
function P$(e) {
  $s({
    condition: !!(e.allowMultiple && e.allowToggle),
    message: "If 'allowMultiple' is passed, 'allowToggle' will be ignored. Either remove 'allowToggle' or 'allowMultiple' depending on whether you want multiple accordions visible or not"
  });
}
function C$(e) {
  $s({
    condition: !!(e.isFocusable && !e.isDisabled),
    message: `Using only 'isFocusable', this prop is reserved for situations where you pass 'isDisabled' but you still want the element to receive focus (A11y). Either remove it or pass 'isDisabled' as well.
    `
  });
}
function _$(e) {
  $s({
    condition: e.isOpen && !!e.isDisabled,
    message: "Cannot open a disabled accordion item"
  });
}
const T$ = M(function({ children: t, reduceMotion: n, ...r }, o) {
  const s = Je("Accordion", r), i = Ae(r), { htmlProps: a, descendants: c, ...l } = x$(i), u = _e(
    () => ({ ...l, reduceMotion: !!n }),
    [l, n]
  );
  return /* @__PURE__ */ h.jsx(y$, { value: c, children: /* @__PURE__ */ h.jsx(S$, { value: u, children: /* @__PURE__ */ h.jsx(m$, { value: s, children: /* @__PURE__ */ h.jsx(
    E.div,
    {
      ref: o,
      ...a,
      className: W("chakra-accordion", r.className),
      __css: s.root,
      children: t
    }
  ) }) }) });
});
T$.displayName = "Accordion";
const E$ = M(
  function(t, n) {
    const { getButtonProps: r } = Pa(), o = r(t, n), i = {
      display: "flex",
      alignItems: "center",
      width: "100%",
      outline: 0,
      ...ka().button
    };
    return /* @__PURE__ */ h.jsx(
      E.button,
      {
        ...o,
        className: W("chakra-accordion__button", t.className),
        __css: i
      }
    );
  }
);
E$.displayName = "AccordionButton";
function A$(e) {
  const { isOpen: t, isDisabled: n } = Pa(), { reduceMotion: r } = $u(), o = W("chakra-accordion__icon", e.className), s = ka(), i = {
    opacity: n ? 0.4 : 1,
    transform: t ? "rotate(-180deg)" : void 0,
    transition: r ? void 0 : "transform 0.2s",
    transformOrigin: "center",
    ...s.icon
  };
  return /* @__PURE__ */ h.jsx(
    $t,
    {
      viewBox: "0 0 24 24",
      "aria-hidden": !0,
      className: o,
      __css: i,
      ...e,
      children: /* @__PURE__ */ h.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
        }
      )
    }
  );
}
A$.displayName = "AccordionIcon";
const I$ = M(
  function(t, n) {
    const { children: r, className: o } = t, { htmlProps: s, ...i } = w$(t), a = ka(), c = {
      ...a.container,
      overflowAnchor: "none"
    }, l = _e(() => i, [i]);
    return /* @__PURE__ */ h.jsx(g$, { value: l, children: /* @__PURE__ */ h.jsx(
      E.div,
      {
        ref: n,
        ...s,
        className: W("chakra-accordion__item", o),
        __css: c,
        children: typeof r == "function" ? r({
          isExpanded: !!i.isOpen,
          isDisabled: !!i.isDisabled
        }) : r
      }
    ) });
  }
);
I$.displayName = "AccordionItem";
const Cr = {
  ease: [0.25, 0.1, 0.25, 1],
  easeIn: [0.4, 0, 1, 1],
  easeOut: [0, 0, 0.2, 1],
  easeInOut: [0.4, 0, 0.2, 1]
}, Go = {
  scale: {
    enter: { scale: 1 },
    exit: { scale: 0.95 }
  },
  fade: {
    enter: { opacity: 1 },
    exit: { opacity: 0 }
  },
  pushLeft: {
    enter: { x: "100%" },
    exit: { x: "-30%" }
  },
  pushRight: {
    enter: { x: "-100%" },
    exit: { x: "30%" }
  },
  pushUp: {
    enter: { y: "100%" },
    exit: { y: "-30%" }
  },
  pushDown: {
    enter: { y: "-100%" },
    exit: { y: "30%" }
  },
  slideLeft: {
    position: { left: 0, top: 0, bottom: 0, width: "100%" },
    enter: { x: 0, y: 0 },
    exit: { x: "-100%", y: 0 }
  },
  slideRight: {
    position: { right: 0, top: 0, bottom: 0, width: "100%" },
    enter: { x: 0, y: 0 },
    exit: { x: "100%", y: 0 }
  },
  slideUp: {
    position: { top: 0, left: 0, right: 0, maxWidth: "100vw" },
    enter: { x: 0, y: 0 },
    exit: { x: 0, y: "-100%" }
  },
  slideDown: {
    position: { bottom: 0, left: 0, right: 0, maxWidth: "100vw" },
    enter: { x: 0, y: 0 },
    exit: { x: 0, y: "100%" }
  }
};
function Pl(e) {
  switch ((e == null ? void 0 : e.direction) ?? "right") {
    case "right":
      return Go.slideRight;
    case "left":
      return Go.slideLeft;
    case "bottom":
      return Go.slideDown;
    case "top":
      return Go.slideUp;
    default:
      return Go.slideRight;
  }
}
const Ir = {
  enter: {
    duration: 0.2,
    ease: Cr.easeOut
  },
  exit: {
    duration: 0.1,
    ease: Cr.easeIn
  }
}, yn = {
  enter: (e, t) => ({
    ...e,
    delay: typeof t == "number" ? t : t == null ? void 0 : t.enter
  }),
  exit: (e, t) => ({
    ...e,
    delay: typeof t == "number" ? t : t == null ? void 0 : t.exit
  })
}, R$ = (e) => e != null && parseInt(e.toString(), 10) > 0, fp = {
  exit: {
    height: { duration: 0.2, ease: Cr.ease },
    opacity: { duration: 0.3, ease: Cr.ease }
  },
  enter: {
    height: { duration: 0.3, ease: Cr.ease },
    opacity: { duration: 0.4, ease: Cr.ease }
  }
}, $$ = {
  exit: ({
    animateOpacity: e,
    startingHeight: t,
    transition: n,
    transitionEnd: r,
    delay: o
  }) => ({
    ...e && { opacity: R$(t) ? 1 : 0 },
    height: t,
    transitionEnd: r == null ? void 0 : r.exit,
    transition: (n == null ? void 0 : n.exit) ?? yn.exit(fp.exit, o)
  }),
  enter: ({
    animateOpacity: e,
    endingHeight: t,
    transition: n,
    transitionEnd: r,
    delay: o
  }) => ({
    ...e && { opacity: 1 },
    height: t,
    transitionEnd: r == null ? void 0 : r.enter,
    transition: (n == null ? void 0 : n.enter) ?? yn.enter(fp.enter, o)
  })
}, by = vn(
  (e, t) => {
    const {
      in: n,
      unmountOnExit: r,
      animateOpacity: o = !0,
      startingHeight: s = 0,
      endingHeight: i = "auto",
      style: a,
      className: c,
      transition: l,
      transitionEnd: u,
      animatePresenceProps: d,
      ...f
    } = e, [p, m] = he(!1);
    xe(() => {
      const v = setTimeout(() => {
        m(!0);
      });
      return () => clearTimeout(v);
    }, []), $s({
      condition: Number(s) > 0 && !!r,
      message: "startingHeight and unmountOnExit are mutually exclusive. You can't use them together"
    });
    const g = parseFloat(s.toString()) > 0, y = {
      startingHeight: s,
      endingHeight: i,
      animateOpacity: o,
      transition: p ? l : { enter: { duration: 0 } },
      transitionEnd: {
        enter: u == null ? void 0 : u.enter,
        exit: r ? u == null ? void 0 : u.exit : {
          ...u == null ? void 0 : u.exit,
          display: g ? "block" : "none"
        }
      }
    }, S = r ? n : !0, b = n || r ? "enter" : "exit";
    return /* @__PURE__ */ h.jsx(
      pr,
      {
        ...d,
        initial: !1,
        custom: y,
        children: S && /* @__PURE__ */ h.jsx(
          xn.div,
          {
            ref: t,
            ...f,
            className: W("chakra-collapse", c),
            style: {
              overflow: "hidden",
              display: "block",
              ...a
            },
            custom: y,
            variants: $$,
            initial: r ? "exit" : !1,
            animate: b,
            exit: "exit"
          }
        )
      }
    );
  }
);
by.displayName = "Collapse";
const N$ = M(
  function(t, n) {
    const { className: r, motionProps: o, ...s } = t, { reduceMotion: i } = $u(), { getPanelProps: a, isOpen: c } = Pa(), l = a(s, n), u = W("chakra-accordion__panel", r), d = ka();
    i || delete l.hidden;
    const f = /* @__PURE__ */ h.jsx(E.div, { ...l, __css: d.panel, className: u });
    return i ? f : /* @__PURE__ */ h.jsx(by, { in: c, ...o, children: f });
  }
);
N$.displayName = "AccordionPanel";
function vL() {
  const { isOpen: e, isDisabled: t, onClose: n, onOpen: r } = Pa();
  return { isOpen: e, onClose: n, isDisabled: t, onOpen: r };
}
const M$ = M(
  function(e, t) {
    const { ratio: n = 4 / 3, children: r, className: o, ...s } = e, i = $n.only(r), a = W("chakra-aspect-ratio", o);
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ref: t,
        position: "relative",
        className: a,
        _before: {
          height: 0,
          content: '""',
          display: "block",
          paddingBottom: Cn(n, (c) => `${1 / c * 100}%`)
        },
        __css: {
          "& > *:not(style)": {
            overflow: "hidden",
            position: "absolute",
            top: "0",
            right: "0",
            bottom: "0",
            left: "0",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%"
          },
          "& > img, & > video": {
            objectFit: "cover"
          }
        },
        ...s,
        children: i
      }
    );
  }
);
M$.displayName = "AspectRatio";
const [j$, vy] = Ee({
  name: "AvatarStylesContext",
  hookName: "useAvatarStyles",
  providerName: "<Avatar/>"
});
function D$(e) {
  const t = e.trim().split(" "), n = t[0] ?? "", r = t.length > 1 ? t[t.length - 1] : "";
  return n && r ? `${n.charAt(0)}${r.charAt(0)}` : n.charAt(0);
}
function xy(e) {
  const { name: t, getInitials: n, ...r } = e, o = vy();
  return /* @__PURE__ */ h.jsx(E.div, { role: "img", "aria-label": t, ...r, __css: o.label, children: t ? n == null ? void 0 : n(t) : null });
}
xy.displayName = "AvatarName";
const Sy = (e) => /* @__PURE__ */ h.jsxs(
  E.svg,
  {
    viewBox: "0 0 128 128",
    color: "#fff",
    width: "100%",
    height: "100%",
    className: "chakra-avatar__svg",
    ...e,
    children: [
      /* @__PURE__ */ h.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M103,102.1388 C93.094,111.92 79.3504,118 64.1638,118 C48.8056,118 34.9294,111.768 25,101.7892 L25,95.2 C25,86.8096 31.981,80 40.6,80 L87.4,80 C96.019,80 103,86.8096 103,95.2 L103,102.1388 Z"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M63.9961647,24 C51.2938136,24 41,34.2938136 41,46.9961647 C41,59.7061864 51.2938136,70 63.9961647,70 C76.6985159,70 87,59.7061864 87,46.9961647 C87,34.2938136 76.6985159,24 63.9961647,24"
        }
      )
    ]
  }
);
function wy(e) {
  const {
    loading: t,
    src: n,
    srcSet: r,
    onLoad: o,
    onError: s,
    crossOrigin: i,
    sizes: a,
    ignoreFallback: c
  } = e, [l, u] = he("pending");
  xe(() => {
    u(n ? "loading" : "pending");
  }, [n]);
  const d = ae(null), f = R(() => {
    if (!n)
      return;
    p();
    const m = new Image();
    m.src = n, i && (m.crossOrigin = i), r && (m.srcset = r), a && (m.sizes = a), t && (m.loading = t), m.onload = (g) => {
      p(), u("loaded"), o == null || o(g);
    }, m.onerror = (g) => {
      p(), u("failed"), s == null || s(g);
    }, d.current = m;
  }, [n, i, r, a, o, s, t]), p = () => {
    d.current && (d.current.onload = null, d.current.onerror = null, d.current = null);
  };
  return an(() => {
    if (!c)
      return l === "loading" && f(), () => {
        p();
      };
  }, [l, f, c]), c ? "loaded" : l;
}
const O$ = (e, t) => e !== "loaded" && t === "beforeLoadOrError" || e === "failed" && t === "onError";
function ky(e) {
  const {
    src: t,
    srcSet: n,
    onError: r,
    onLoad: o,
    getInitials: s,
    name: i,
    borderRadius: a,
    loading: c,
    iconLabel: l,
    icon: u = /* @__PURE__ */ h.jsx(Sy, {}),
    ignoreFallback: d,
    referrerPolicy: f,
    crossOrigin: p
  } = e, g = wy({ src: t, onError: r, crossOrigin: p, ignoreFallback: d }) === "loaded";
  return !t || !g ? i ? /* @__PURE__ */ h.jsx(
    xy,
    {
      className: "chakra-avatar__initials",
      getInitials: s,
      name: i
    }
  ) : kt(u, {
    role: "img",
    "aria-label": l
  }) : /* @__PURE__ */ h.jsx(
    E.img,
    {
      src: t,
      srcSet: n,
      alt: i ?? l,
      onLoad: o,
      referrerPolicy: f,
      crossOrigin: p ?? void 0,
      className: "chakra-avatar__img",
      loading: c,
      __css: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: a
      }
    }
  );
}
ky.displayName = "AvatarImage";
const Py = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  textTransform: "uppercase",
  fontWeight: "medium",
  position: "relative",
  flexShrink: 0
}, F$ = M((e, t) => {
  const n = Je("Avatar", e), [r, o] = he(!1), {
    src: s,
    srcSet: i,
    name: a,
    showBorder: c,
    borderRadius: l = "full",
    onError: u,
    onLoad: d,
    getInitials: f = D$,
    icon: p = /* @__PURE__ */ h.jsx(Sy, {}),
    iconLabel: m = " avatar",
    loading: g,
    children: y,
    borderColor: S,
    ignoreFallback: b,
    crossOrigin: v,
    referrerPolicy: k,
    ...w
  } = Ae(e), _ = {
    borderRadius: l,
    borderWidth: c ? "2px" : void 0,
    ...Py,
    ...n.container
  };
  return S && (_.borderColor = S), /* @__PURE__ */ h.jsx(
    E.span,
    {
      ref: t,
      ...w,
      className: W("chakra-avatar", e.className),
      "data-loaded": ye(r),
      __css: _,
      children: /* @__PURE__ */ h.jsxs(j$, { value: n, children: [
        /* @__PURE__ */ h.jsx(
          ky,
          {
            src: s,
            srcSet: i,
            loading: g,
            onLoad: re(d, () => {
              o(!0);
            }),
            onError: u,
            getInitials: f,
            name: a,
            borderRadius: l,
            icon: p,
            iconLabel: m,
            ignoreFallback: b,
            crossOrigin: v,
            referrerPolicy: k
          }
        ),
        y
      ] })
    }
  );
});
F$.displayName = "Avatar";
const B$ = {
  "top-start": {
    top: "0",
    insetStart: "0",
    transform: "translate(-25%, -25%)"
  },
  "top-end": {
    top: "0",
    insetEnd: "0",
    transform: "translate(25%, -25%)"
  },
  "bottom-start": {
    bottom: "0",
    insetStart: "0",
    transform: "translate(-25%, 25%)"
  },
  "bottom-end": {
    bottom: "0",
    insetEnd: "0",
    transform: "translate(25%, 25%)"
  }
}, L$ = M(
  function(t, n) {
    const { placement: r = "bottom-end", className: o, ...s } = t, i = vy(), c = {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      ...B$[r],
      ...i.badge
    };
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ref: n,
        ...s,
        className: W("chakra-avatar__badge", o),
        __css: c
      }
    );
  }
);
L$.displayName = "AvatarBadge";
const V$ = M(
  function(t, n) {
    const r = Je("Avatar", t), {
      children: o,
      borderColor: s,
      max: i,
      spacing: a = "-0.75rem",
      borderRadius: c = "full",
      ...l
    } = Ae(t), u = Yn(o), d = i != null ? u.slice(0, i) : u, f = i != null ? u.length - i : 0, m = d.reverse().map((S, b) => {
      const k = {
        marginEnd: b === 0 ? 0 : a,
        size: t.size,
        borderColor: S.props.borderColor ?? s,
        showBorder: !0
      };
      return kt(S, Io(k));
    }), g = {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      flexDirection: "row-reverse",
      ...r.group
    }, y = {
      borderRadius: c,
      marginStart: a,
      ...Py,
      ...r.excessLabel
    };
    return /* @__PURE__ */ h.jsxs(
      E.div,
      {
        ref: n,
        role: "group",
        __css: g,
        ...l,
        className: W("chakra-avatar__group", t.className),
        children: [
          f > 0 && /* @__PURE__ */ h.jsx(E.span, { className: "chakra-avatar__excess", __css: y, children: `+${f}` }),
          m
        ]
      }
    );
  }
);
V$.displayName = "AvatarGroup";
const z$ = M(function(t, n) {
  const r = Ct("Badge", t), { className: o, ...s } = Ae(t);
  return /* @__PURE__ */ h.jsx(
    E.span,
    {
      ref: n,
      className: W("chakra-badge", t.className),
      ...s,
      __css: {
        display: "inline-block",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        ...r
      }
    }
  );
});
z$.displayName = "Badge";
const Nu = E("div");
Nu.displayName = "Box";
const Cy = M(
  function(t, n) {
    const { size: r, centerContent: o = !0, ...s } = t, i = o ? { display: "flex", alignItems: "center", justifyContent: "center" } : {};
    return /* @__PURE__ */ h.jsx(
      Nu,
      {
        ref: n,
        boxSize: r,
        __css: {
          ...i,
          flexShrink: 0,
          flexGrow: 0
        },
        ...s
      }
    );
  }
);
Cy.displayName = "Square";
const W$ = M(
  function(t, n) {
    const { size: r, ...o } = t;
    return /* @__PURE__ */ h.jsx(Cy, { size: r, ref: n, borderRadius: "9999px", ...o });
  }
);
W$.displayName = "Circle";
const [H$, Mu] = Ee({
  name: "BreadcrumbStylesContext",
  errorMessage: `useBreadcrumbStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Breadcrumb />" `
}), U$ = M(
  function(t, n) {
    const r = Je("Breadcrumb", t), o = Ae(t), {
      children: s,
      spacing: i = "0.5rem",
      separator: a = "/",
      className: c,
      listProps: l,
      ...u
    } = o, d = Yn(s), f = d.length, p = d.map(
      (g, y) => kt(g, {
        separator: a,
        spacing: i,
        isLastChild: f === y + 1
      })
    ), m = W("chakra-breadcrumb", c);
    return /* @__PURE__ */ h.jsx(
      E.nav,
      {
        ref: n,
        "aria-label": "breadcrumb",
        className: m,
        __css: r.container,
        ...u,
        children: /* @__PURE__ */ h.jsx(H$, { value: r, children: /* @__PURE__ */ h.jsx(
          E.ol,
          {
            className: "chakra-breadcrumb__list",
            ...l,
            __css: {
              display: "flex",
              alignItems: "center",
              ...r.list
            },
            children: p
          }
        ) })
      }
    );
  }
);
U$.displayName = "Breadcrumb";
const _y = M(
  function(t, n) {
    const { isCurrentPage: r, as: o, className: s, href: i, ...a } = t, c = Mu(), l = {
      ref: n,
      as: o,
      className: W("chakra-breadcrumb__link", s),
      ...a
    };
    return r ? /* @__PURE__ */ h.jsx(E.span, { "aria-current": "page", __css: c.link, ...l }) : /* @__PURE__ */ h.jsx(E.a, { __css: c.link, href: i, ...l });
  }
);
_y.displayName = "BreadcrumbLink";
const Cl = M(
  function(t, n) {
    const { spacing: r, ...o } = t, s = Mu(), i = {
      mx: r,
      ...s.separator
    };
    return /* @__PURE__ */ h.jsx(
      E.span,
      {
        ref: n,
        role: "presentation",
        ...o,
        __css: i
      }
    );
  }
);
Cl.displayName = "BreadcrumbSeparator";
const G$ = M(
  function(t, n) {
    const {
      isCurrentPage: r,
      separator: o,
      isLastChild: s,
      spacing: i,
      children: a,
      className: c,
      ...l
    } = t, d = Yn(a).map((g) => g.type === _y ? kt(g, {
      isCurrentPage: r
    }) : g.type === Cl ? kt(g, {
      spacing: i,
      children: g.props.children || o
    }) : g), f = Mu(), p = {
      display: "inline-flex",
      alignItems: "center",
      ...f.item
    }, m = W("chakra-breadcrumb__list-item", c);
    return /* @__PURE__ */ h.jsxs(E.li, { ref: n, className: m, ...l, __css: p, children: [
      d,
      !s && /* @__PURE__ */ h.jsx(Cl, { spacing: i, children: o })
    ] });
  }
);
G$.displayName = "BreadcrumbItem";
const [q$, K$] = Ee({
  strict: !1,
  name: "ButtonGroupContext"
});
function ts(e) {
  const { children: t, className: n, ...r } = e, o = ur(t) ? kt(t, {
    "aria-hidden": !0,
    focusable: !1
  }) : t, s = W("chakra-button__icon", n);
  return /* @__PURE__ */ h.jsx(
    E.span,
    {
      display: "inline-flex",
      alignSelf: "center",
      flexShrink: 0,
      ...r,
      className: s,
      children: o
    }
  );
}
ts.displayName = "ButtonIcon";
function _l(e) {
  const {
    label: t,
    placement: n,
    spacing: r = "0.5rem",
    children: o = /* @__PURE__ */ h.jsx(Eu, { color: "currentColor", width: "1em", height: "1em" }),
    className: s,
    __css: i,
    ...a
  } = e, c = W("chakra-button__spinner", s), l = n === "start" ? "marginEnd" : "marginStart", u = _e(
    () => ({
      display: "flex",
      alignItems: "center",
      position: t ? "relative" : "absolute",
      [l]: t ? r : 0,
      fontSize: "1em",
      lineHeight: "normal",
      ...i
    }),
    [i, t, l, r]
  );
  return /* @__PURE__ */ h.jsx(E.div, { className: c, ...a, __css: u, children: o });
}
_l.displayName = "ButtonSpinner";
function Y$(e) {
  const [t, n] = he(!e);
  return { ref: R((s) => {
    s && n(s.tagName === "BUTTON");
  }, []), type: t ? "button" : void 0 };
}
const Ty = M((e, t) => {
  const n = K$(), r = Ct("Button", { ...n, ...e }), {
    isDisabled: o = n == null ? void 0 : n.isDisabled,
    isLoading: s,
    isActive: i,
    children: a,
    leftIcon: c,
    rightIcon: l,
    loadingText: u,
    iconSpacing: d = "0.5rem",
    type: f,
    spinner: p,
    spinnerPlacement: m = "start",
    className: g,
    as: y,
    shouldWrapChildren: S,
    ...b
  } = Ae(e), v = _e(() => {
    const C = { ...r == null ? void 0 : r._focus, zIndex: 1 };
    return {
      display: "inline-flex",
      appearance: "none",
      alignItems: "center",
      justifyContent: "center",
      userSelect: "none",
      position: "relative",
      whiteSpace: "nowrap",
      verticalAlign: "middle",
      outline: "none",
      ...r,
      ...!!n && { _focus: C }
    };
  }, [r, n]), { ref: k, type: w } = Y$(y), _ = {
    rightIcon: l,
    leftIcon: c,
    iconSpacing: d,
    children: a,
    shouldWrapChildren: S
  };
  return /* @__PURE__ */ h.jsxs(
    E.button,
    {
      disabled: o || s,
      ref: dx(t, k),
      as: y,
      type: f ?? w,
      "data-active": ye(i),
      "data-loading": ye(s),
      __css: v,
      className: W("chakra-button", g),
      ...b,
      children: [
        s && m === "start" && /* @__PURE__ */ h.jsx(
          _l,
          {
            className: "chakra-button__spinner--start",
            label: u,
            placement: "start",
            spacing: d,
            children: p
          }
        ),
        s ? u || /* @__PURE__ */ h.jsx(E.span, { opacity: 0, children: /* @__PURE__ */ h.jsx(pp, { ..._ }) }) : /* @__PURE__ */ h.jsx(pp, { ..._ }),
        s && m === "end" && /* @__PURE__ */ h.jsx(
          _l,
          {
            className: "chakra-button__spinner--end",
            label: u,
            placement: "end",
            spacing: d,
            children: p
          }
        )
      ]
    }
  );
});
Ty.displayName = "Button";
function pp(e) {
  const { leftIcon: t, rightIcon: n, children: r, iconSpacing: o, shouldWrapChildren: s } = e;
  return s ? /* @__PURE__ */ h.jsxs("span", { style: { display: "contents" }, children: [
    t && /* @__PURE__ */ h.jsx(ts, { marginEnd: o, children: t }),
    r,
    n && /* @__PURE__ */ h.jsx(ts, { marginStart: o, children: n })
  ] }) : /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    t && /* @__PURE__ */ h.jsx(ts, { marginEnd: o, children: t }),
    r,
    n && /* @__PURE__ */ h.jsx(ts, { marginStart: o, children: n })
  ] });
}
const X$ = {
  horizontal: {
    "> *:first-of-type:not(:last-of-type)": { borderEndRadius: 0 },
    "> *:not(:first-of-type):not(:last-of-type)": { borderRadius: 0 },
    "> *:not(:first-of-type):last-of-type": { borderStartRadius: 0 }
  },
  vertical: {
    "> *:first-of-type:not(:last-of-type)": { borderBottomRadius: 0 },
    "> *:not(:first-of-type):not(:last-of-type)": { borderRadius: 0 },
    "> *:not(:first-of-type):last-of-type": { borderTopRadius: 0 }
  }
}, Z$ = {
  horizontal: (e) => ({
    "& > *:not(style) ~ *:not(style)": { marginStart: e }
  }),
  vertical: (e) => ({
    "& > *:not(style) ~ *:not(style)": { marginTop: e }
  })
}, J$ = M(
  function(t, n) {
    const {
      size: r,
      colorScheme: o,
      variant: s,
      className: i,
      spacing: a = "0.5rem",
      isAttached: c,
      isDisabled: l,
      orientation: u = "horizontal",
      ...d
    } = t, f = W("chakra-button__group", i), p = _e(
      () => ({ size: r, colorScheme: o, variant: s, isDisabled: l }),
      [r, o, s, l]
    );
    let m = {
      display: "inline-flex",
      ...c ? X$[u] : Z$[u](a)
    };
    const g = u === "vertical";
    return /* @__PURE__ */ h.jsx(q$, { value: p, children: /* @__PURE__ */ h.jsx(
      E.div,
      {
        ref: n,
        role: "group",
        __css: m,
        className: f,
        "data-attached": c ? "" : void 0,
        "data-orientation": u,
        flexDir: g ? "column" : void 0,
        ...d
      }
    ) });
  }
);
J$.displayName = "ButtonGroup";
const Q$ = M(
  (e, t) => {
    const { icon: n, children: r, isRound: o, "aria-label": s, ...i } = e, a = n || r, c = ur(a) ? kt(a, {
      "aria-hidden": !0,
      focusable: !1
    }) : null;
    return /* @__PURE__ */ h.jsx(
      Ty,
      {
        px: "0",
        py: "0",
        borderRadius: o ? "full" : void 0,
        ref: t,
        "aria-label": s,
        ...i,
        children: c
      }
    );
  }
);
Q$.displayName = "IconButton";
const [eN, ju] = $m("Card"), xL = M(function(t, n) {
  const {
    className: r,
    children: o,
    direction: s = "column",
    justify: i,
    align: a,
    ...c
  } = Ae(t), l = Je("Card", t);
  return /* @__PURE__ */ h.jsx(
    E.div,
    {
      ref: n,
      className: W("chakra-card", r),
      __css: {
        display: "flex",
        flexDirection: s,
        justifyContent: i,
        alignItems: a,
        position: "relative",
        minWidth: 0,
        wordWrap: "break-word",
        ...l.container
      },
      ...c,
      children: /* @__PURE__ */ h.jsx(eN, { value: l, children: o })
    }
  );
}), SL = M(
  function(t, n) {
    const { className: r, ...o } = t, s = ju();
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ref: n,
        className: W("chakra-card__body", r),
        __css: s.body,
        ...o
      }
    );
  }
), wL = M(
  function(t, n) {
    const { className: r, justify: o, ...s } = t, i = ju();
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ref: n,
        className: W("chakra-card__footer", r),
        __css: {
          display: "flex",
          justifyContent: o,
          ...i.footer
        },
        ...s
      }
    );
  }
), kL = M(
  function(t, n) {
    const { className: r, ...o } = t, s = ju();
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ref: n,
        className: W("chakra-card__header", r),
        __css: s.header,
        ...o
      }
    );
  }
), tN = E("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
});
tN.displayName = "Center";
const nN = {
  horizontal: {
    insetStart: "50%",
    transform: "translateX(-50%)"
  },
  vertical: {
    top: "50%",
    transform: "translateY(-50%)"
  },
  both: {
    insetStart: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)"
  }
}, PL = M(
  function(t, n) {
    const { axis: r = "both", ...o } = t;
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ref: n,
        __css: nN[r],
        ...o,
        position: "absolute"
      }
    );
  }
), [rN, oN] = Ee({
  name: "CheckboxGroupContext",
  strict: !1
});
function sN(e) {
  return /* @__PURE__ */ h.jsx(
    E.svg,
    {
      width: "1.2em",
      viewBox: "0 0 12 10",
      style: {
        fill: "none",
        strokeWidth: 2,
        stroke: "currentColor",
        strokeDasharray: 16
      },
      ...e,
      children: /* @__PURE__ */ h.jsx("polyline", { points: "1.5 6 4.5 9 10.5 1" })
    }
  );
}
function iN(e) {
  return /* @__PURE__ */ h.jsx(
    E.svg,
    {
      width: "1.2em",
      viewBox: "0 0 24 24",
      style: { stroke: "currentColor", strokeWidth: 4 },
      ...e,
      children: /* @__PURE__ */ h.jsx("line", { x1: "21", x2: "3", y1: "12", y2: "12" })
    }
  );
}
function aN(e) {
  const { isIndeterminate: t, isChecked: n, ...r } = e, o = t ? iN : sN;
  return n || t ? /* @__PURE__ */ h.jsx(
    E.div,
    {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%"
      },
      children: /* @__PURE__ */ h.jsx(o, { ...r })
    }
  ) : null;
}
var cN = () => typeof document < "u", hp = !1, Vs = null, Mr = !1, Tl = !1, El = /* @__PURE__ */ new Set();
function Du(e, t) {
  El.forEach((n) => n(e, t));
}
var lN = typeof window < "u" && window.navigator != null ? /^Mac/.test(window.navigator.platform) : !1;
function uN(e) {
  return !(e.metaKey || !lN && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function mp(e) {
  Mr = !0, uN(e) && (Vs = "keyboard", Du("keyboard", e));
}
function Gr(e) {
  if (Vs = "pointer", e.type === "mousedown" || e.type === "pointerdown") {
    Mr = !0;
    const t = e.composedPath ? e.composedPath()[0] : e.target;
    let n = !1;
    try {
      n = t.matches(":focus-visible");
    } catch {
    }
    if (n)
      return;
    Du("pointer", e);
  }
}
function dN(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : e.detail === 0 && !e.pointerType;
}
function fN(e) {
  dN(e) && (Mr = !0, Vs = "virtual");
}
function pN(e) {
  e.target === window || e.target === document || e.target instanceof Element && e.target.hasAttribute("tabindex") || (!Mr && !Tl && (Vs = "virtual", Du("virtual", e)), Mr = !1, Tl = !1);
}
function hN() {
  Mr = !1, Tl = !0;
}
function gp() {
  return Vs !== "pointer";
}
function mN() {
  if (!cN() || hp)
    return;
  const { focus: e } = HTMLElement.prototype;
  HTMLElement.prototype.focus = function(...n) {
    Mr = !0, e.apply(this, n);
  }, document.addEventListener("keydown", mp, !0), document.addEventListener("keyup", mp, !0), document.addEventListener("click", fN, !0), window.addEventListener("focus", pN, !0), window.addEventListener("blur", hN, !1), typeof PointerEvent < "u" ? (document.addEventListener("pointerdown", Gr, !0), document.addEventListener("pointermove", Gr, !0), document.addEventListener("pointerup", Gr, !0)) : (document.addEventListener("mousedown", Gr, !0), document.addEventListener("mousemove", Gr, !0), document.addEventListener("mouseup", Gr, !0)), hp = !0;
}
function Ey(e) {
  mN(), e(gp());
  const t = () => e(gp());
  return El.add(t), () => {
    El.delete(t);
  };
}
const [gN, Ay] = Ee({
  name: "FormControlStylesContext",
  errorMessage: `useFormControlStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormControl />" `
}), [yN, Br] = Ee({
  strict: !1,
  name: "FormControlContext"
});
function bN(e) {
  const {
    id: t,
    isRequired: n,
    isInvalid: r,
    isDisabled: o,
    isReadOnly: s,
    ...i
  } = e, a = Rt(), c = t || `field-${a}`, l = `${c}-label`, u = `${c}-feedback`, d = `${c}-helptext`, [f, p] = he(!1), [m, g] = he(!1), [y, S] = he(!1), b = R(
    (C = {}, I = null) => ({
      id: d,
      ...C,
      /**
       * Notify the field context when the help text is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: De(I, ($) => {
        $ && g(!0);
      })
    }),
    [d]
  ), v = R(
    (C = {}, I = null) => ({
      ...C,
      ref: I,
      "data-focus": ye(y),
      "data-disabled": ye(o),
      "data-invalid": ye(r),
      "data-readonly": ye(s),
      id: C.id !== void 0 ? C.id : l,
      htmlFor: C.htmlFor !== void 0 ? C.htmlFor : c
    }),
    [c, o, y, r, s, l]
  ), k = R(
    (C = {}, I = null) => ({
      id: u,
      ...C,
      /**
       * Notify the field context when the error message is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: De(I, ($) => {
        $ && p(!0);
      }),
      "aria-live": "polite"
    }),
    [u]
  ), w = R(
    (C = {}, I = null) => ({
      ...C,
      ...i,
      ref: I,
      role: "group",
      "data-focus": ye(y),
      "data-disabled": ye(o),
      "data-invalid": ye(r),
      "data-readonly": ye(s)
    }),
    [i, o, y, r, s]
  ), _ = R(
    (C = {}, I = null) => ({
      ...C,
      ref: I,
      role: "presentation",
      "aria-hidden": !0,
      children: C.children || "*"
    }),
    []
  );
  return {
    isRequired: !!n,
    isInvalid: !!r,
    isReadOnly: !!s,
    isDisabled: !!o,
    isFocused: !!y,
    onFocus: () => S(!0),
    onBlur: () => S(!1),
    hasFeedbackText: f,
    setHasFeedbackText: p,
    hasHelpText: m,
    setHasHelpText: g,
    id: c,
    labelId: l,
    feedbackId: u,
    helpTextId: d,
    htmlProps: i,
    getHelpTextProps: b,
    getErrorMessageProps: k,
    getRootProps: w,
    getLabelProps: v,
    getRequiredIndicatorProps: _
  };
}
const vN = M(
  function(t, n) {
    const r = Je("Form", t), o = Ae(t), {
      getRootProps: s,
      htmlProps: i,
      ...a
    } = bN(o), c = W("chakra-form-control", t.className);
    return /* @__PURE__ */ h.jsx(yN, { value: a, children: /* @__PURE__ */ h.jsx(gN, { value: r, children: /* @__PURE__ */ h.jsx(
      E.div,
      {
        ...s({}, n),
        className: c,
        __css: r.container
      }
    ) }) });
  }
);
vN.displayName = "FormControl";
const xN = M(
  function(t, n) {
    const r = Br(), o = Ay(), s = W("chakra-form__helper-text", t.className);
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ...r == null ? void 0 : r.getHelpTextProps(t, n),
        __css: o.helperText,
        className: s
      }
    );
  }
);
xN.displayName = "FormHelperText";
function Ou(e) {
  const { isDisabled: t, isInvalid: n, isReadOnly: r, isRequired: o, ...s } = Fu(e);
  return {
    ...s,
    disabled: t,
    readOnly: r,
    required: o,
    "aria-invalid": wt(n),
    "aria-required": wt(o),
    "aria-readonly": wt(r)
  };
}
function Fu(e) {
  const t = Br(), {
    id: n,
    disabled: r,
    readOnly: o,
    required: s,
    isRequired: i,
    isInvalid: a,
    isReadOnly: c,
    isDisabled: l,
    onFocus: u,
    onBlur: d,
    ...f
  } = e, p = e["aria-describedby"] ? [e["aria-describedby"]] : [];
  return t != null && t.hasFeedbackText && (t != null && t.isInvalid) && p.push(t.feedbackId), t != null && t.hasHelpText && p.push(t.helpTextId), {
    ...f,
    "aria-describedby": p.join(" ") || void 0,
    id: n ?? (t == null ? void 0 : t.id),
    isDisabled: r ?? l ?? (t == null ? void 0 : t.isDisabled),
    isReadOnly: o ?? c ?? (t == null ? void 0 : t.isReadOnly),
    isRequired: s ?? i ?? (t == null ? void 0 : t.isRequired),
    isInvalid: a ?? (t == null ? void 0 : t.isInvalid),
    onFocus: re(t == null ? void 0 : t.onFocus, u),
    onBlur: re(t == null ? void 0 : t.onBlur, d)
  };
}
const Ca = {
  border: "0",
  clip: "rect(0, 0, 0, 0)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: "0",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};
function Iy(e = {}) {
  const t = Fu(e), {
    isDisabled: n,
    isReadOnly: r,
    isRequired: o,
    isInvalid: s,
    id: i,
    onBlur: a,
    onFocus: c,
    "aria-describedby": l
  } = t, {
    defaultChecked: u,
    isChecked: d,
    isFocusable: f,
    onChange: p,
    isIndeterminate: m,
    name: g,
    value: y,
    tabIndex: S = void 0,
    "aria-label": b,
    "aria-labelledby": v,
    "aria-invalid": k,
    ...w
  } = e, _ = Rs(w, [
    "isDisabled",
    "isReadOnly",
    "isRequired",
    "isInvalid",
    "id",
    "onBlur",
    "onFocus",
    "aria-describedby"
  ]), C = nt(p), I = nt(a), $ = nt(c), [N, z] = he(!1), [Q, U] = he(!1), [q, le] = he(!1), Z = ae(!1);
  xe(() => Ey((oe) => {
    Z.current = oe;
  }), []);
  const j = ae(null), [K, ne] = he(!0), [B, O] = he(!!u), ee = d !== void 0, D = ee ? d : B, V = R(
    (oe) => {
      if (r || n) {
        oe.preventDefault();
        return;
      }
      ee || O(D ? oe.currentTarget.checked : m ? !0 : oe.currentTarget.checked), C == null || C(oe);
    },
    [
      r,
      n,
      D,
      ee,
      m,
      C
    ]
  );
  an(() => {
    j.current && (j.current.indeterminate = !!m);
  }, [m]), bn(() => {
    n && z(!1);
  }, [n, z]), an(() => {
    const oe = j.current;
    if (!(oe != null && oe.form))
      return;
    const $e = () => {
      O(!!u);
    };
    return oe.form.addEventListener("reset", $e), () => {
      var Oe;
      return (Oe = oe.form) == null ? void 0 : Oe.removeEventListener("reset", $e);
    };
  }, []);
  const Y = n && !f, J = R(
    (oe) => {
      oe.key === " " && le(!0);
    },
    [le]
  ), se = R(
    (oe) => {
      oe.key === " " && le(!1);
    },
    [le]
  );
  an(() => {
    if (!j.current)
      return;
    j.current.checked !== D && O(j.current.checked);
  }, [j.current]);
  const ue = R(
    (oe = {}, $e = null) => {
      const Oe = (ce) => {
        N && ce.preventDefault(), le(!0);
      };
      return {
        ...oe,
        ref: $e,
        "data-active": ye(q),
        "data-hover": ye(Q),
        "data-checked": ye(D),
        "data-focus": ye(N),
        "data-focus-visible": ye(N && Z.current),
        "data-indeterminate": ye(m),
        "data-disabled": ye(n),
        "data-invalid": ye(s),
        "data-readonly": ye(r),
        "aria-hidden": !0,
        onMouseDown: re(oe.onMouseDown, Oe),
        onMouseUp: re(oe.onMouseUp, () => le(!1)),
        onMouseEnter: re(
          oe.onMouseEnter,
          () => U(!0)
        ),
        onMouseLeave: re(
          oe.onMouseLeave,
          () => U(!1)
        )
      };
    },
    [
      q,
      D,
      n,
      N,
      Q,
      m,
      s,
      r
    ]
  ), G = R(
    (oe = {}, $e = null) => ({
      ...oe,
      ref: $e,
      "data-active": ye(q),
      "data-hover": ye(Q),
      "data-checked": ye(D),
      "data-focus": ye(N),
      "data-focus-visible": ye(N && Z.current),
      "data-indeterminate": ye(m),
      "data-disabled": ye(n),
      "data-invalid": ye(s),
      "data-readonly": ye(r)
    }),
    [
      q,
      D,
      n,
      N,
      Q,
      m,
      s,
      r
    ]
  ), H = R(
    (oe = {}, $e = null) => ({
      ..._,
      ...oe,
      ref: De($e, (Oe) => {
        Oe && ne(Oe.tagName === "LABEL");
      }),
      onClick: re(oe.onClick, () => {
        var Oe;
        K || ((Oe = j.current) == null || Oe.click(), requestAnimationFrame(() => {
          var ce;
          (ce = j.current) == null || ce.focus({ preventScroll: !0 });
        }));
      }),
      "data-disabled": ye(n),
      "data-checked": ye(D),
      "data-invalid": ye(s)
    }),
    [_, n, D, s, K]
  ), de = R(
    (oe = {}, $e = null) => ({
      ...oe,
      ref: De(j, $e),
      type: "checkbox",
      name: g,
      value: y,
      id: i,
      tabIndex: S,
      onChange: re(oe.onChange, V),
      onBlur: re(
        oe.onBlur,
        I,
        () => z(!1)
      ),
      onFocus: re(
        oe.onFocus,
        $,
        () => z(!0)
      ),
      onKeyDown: re(oe.onKeyDown, J),
      onKeyUp: re(oe.onKeyUp, se),
      required: o,
      checked: D,
      disabled: Y,
      readOnly: r,
      "aria-label": b,
      "aria-labelledby": v,
      "aria-invalid": k ? !!k : s,
      "aria-describedby": l,
      "aria-disabled": n,
      "aria-checked": m ? "mixed" : D,
      style: Ca
    }),
    [
      g,
      y,
      i,
      S,
      V,
      I,
      $,
      J,
      se,
      o,
      D,
      Y,
      r,
      b,
      v,
      k,
      s,
      l,
      n,
      m
    ]
  ), L = R(
    (oe = {}, $e = null) => ({
      ...oe,
      ref: $e,
      onMouseDown: re(oe.onMouseDown, SN),
      "data-disabled": ye(n),
      "data-checked": ye(D),
      "data-invalid": ye(s)
    }),
    [D, n, s]
  );
  return {
    state: {
      isInvalid: s,
      isFocused: N,
      isChecked: D,
      isActive: q,
      isHovered: Q,
      isIndeterminate: m,
      isDisabled: n,
      isReadOnly: r,
      isRequired: o
    },
    getRootProps: H,
    getCheckboxProps: ue,
    getIndicatorProps: G,
    getInputProps: de,
    getLabelProps: L,
    htmlProps: _
  };
}
function SN(e) {
  e.preventDefault(), e.stopPropagation();
}
function wN(e) {
  const [t, n] = he(e), [r, o] = he(!1);
  return e !== t && (o(!0), n(e)), r;
}
const kN = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  verticalAlign: "top",
  userSelect: "none",
  flexShrink: 0
}, PN = {
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  verticalAlign: "top",
  position: "relative"
}, CN = Mn({
  from: {
    opacity: 0,
    strokeDashoffset: 16,
    transform: "scale(0.95)"
  },
  to: {
    opacity: 1,
    strokeDashoffset: 0,
    transform: "scale(1)"
  }
}), _N = Mn({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
}), TN = Mn({
  from: {
    transform: "scaleX(0.65)"
  },
  to: {
    transform: "scaleX(1)"
  }
}), EN = M(
  function(t, n) {
    const r = oN(), o = { ...r, ...t }, s = Je("Checkbox", o), i = Ae(t), {
      spacing: a = "0.5rem",
      className: c,
      children: l,
      iconColor: u,
      iconSize: d,
      icon: f = /* @__PURE__ */ h.jsx(aN, {}),
      isChecked: p,
      isDisabled: m = r == null ? void 0 : r.isDisabled,
      onChange: g,
      inputProps: y,
      ...S
    } = i;
    let b = p;
    r != null && r.value && i.value && (b = r.value.includes(i.value));
    let v = g;
    r != null && r.onChange && i.value && (v = aa(r.onChange, g));
    const {
      state: k,
      getInputProps: w,
      getCheckboxProps: _,
      getLabelProps: C,
      getRootProps: I
    } = Iy({
      ...S,
      isDisabled: m,
      isChecked: b,
      onChange: v
    }), $ = wN(k.isChecked), N = _e(
      () => ({
        animation: $ ? k.isIndeterminate ? `${_N} 20ms linear, ${TN} 200ms linear` : `${CN} 200ms linear` : void 0,
        ...s.icon,
        ...Io({
          fontSize: d,
          color: u
        })
      }),
      [u, d, $, k.isIndeterminate, s.icon]
    ), z = kt(f, {
      __css: N,
      isIndeterminate: k.isIndeterminate,
      isChecked: k.isChecked
    });
    return /* @__PURE__ */ h.jsxs(
      E.label,
      {
        __css: { ...PN, ...s.container },
        className: W("chakra-checkbox", c),
        ...I(),
        children: [
          /* @__PURE__ */ h.jsx(
            "input",
            {
              className: "chakra-checkbox__input",
              ...w(y, n)
            }
          ),
          /* @__PURE__ */ h.jsx(
            E.span,
            {
              __css: { ...kN, ...s.control },
              className: "chakra-checkbox__control",
              ..._(),
              children: z
            }
          ),
          l && /* @__PURE__ */ h.jsx(
            E.span,
            {
              className: "chakra-checkbox__label",
              ...C(),
              __css: {
                marginStart: a,
                ...s.label
              },
              children: l
            }
          )
        ]
      }
    );
  }
);
EN.displayName = "Checkbox";
function yp(e) {
  return e && lt(e) && lt(e.target);
}
function AN(e = {}) {
  const {
    defaultValue: t,
    value: n,
    onChange: r,
    isDisabled: o,
    isNative: s
  } = e, i = nt(r), [a, c] = dr({
    value: n,
    defaultValue: t || [],
    onChange: i
  }), l = R(
    (d) => {
      if (!a)
        return;
      const f = yp(d) ? d.target.checked : !a.includes(d), p = yp(d) ? d.target.value : d, m = f ? [...a, p] : a.filter((g) => String(g) !== String(p));
      c(m);
    },
    [c, a]
  ), u = R(
    (d = {}) => ({
      ...d,
      [s ? "checked" : "isChecked"]: a.some((p) => String(d.value) === String(p)),
      onChange: l
    }),
    [l, s, a]
  );
  return {
    value: a,
    isDisabled: o,
    onChange: l,
    setValue: c,
    getCheckboxProps: u
  };
}
function IN(e) {
  const { colorScheme: t, size: n, variant: r, children: o, isDisabled: s } = e, { value: i, onChange: a } = AN(e), c = _e(
    () => ({
      size: n,
      onChange: a,
      colorScheme: t,
      value: i,
      variant: r,
      isDisabled: s
    }),
    [n, a, t, i, r, s]
  );
  return /* @__PURE__ */ h.jsx(rN, { value: c, children: o });
}
IN.displayName = "CheckboxGroup";
const RN = M(function(t, n) {
  const r = Ct("Code", t), { className: o, ...s } = Ae(t);
  return /* @__PURE__ */ h.jsx(
    E.code,
    {
      ref: n,
      className: W("chakra-code", t.className),
      ...s,
      __css: {
        display: "inline-block",
        ...r
      }
    }
  );
});
RN.displayName = "Code";
const $N = /* @__PURE__ */ new Set(["dark", "light", "system"]);
function NN(e) {
  let t = e;
  return $N.has(t) || (t = "light"), t;
}
function MN(e = {}) {
  const {
    initialColorMode: t = "light",
    type: n = "localStorage",
    storageKey: r = "chakra-ui-color-mode"
  } = e, o = NN(t), s = n === "cookie", i = `(function(){try{var a=function(o){var l="(prefers-color-scheme: dark)",v=window.matchMedia(l).matches?"dark":"light",e=o==="system"?v:o,d=document.documentElement,m=document.body,i="chakra-ui-light",n="chakra-ui-dark",s=e==="dark";return m.classList.add(s?n:i),m.classList.remove(s?i:n),d.style.colorScheme=e,d.dataset.theme=e,e},u=a,h="${o}",r="${r}",t=document.cookie.match(new RegExp("(^| )".concat(r,"=([^;]+)"))),c=t?t[2]:null;c?a(c):document.cookie="".concat(r,"=").concat(a(h),"; max-age=31536000; path=/")}catch(a){}})();
  `, a = `(function(){try{var a=function(c){var v="(prefers-color-scheme: dark)",h=window.matchMedia(v).matches?"dark":"light",r=c==="system"?h:c,o=document.documentElement,s=document.body,l="chakra-ui-light",d="chakra-ui-dark",i=r==="dark";return s.classList.add(i?d:l),s.classList.remove(i?l:d),o.style.colorScheme=r,o.dataset.theme=r,r},n=a,m="${o}",e="${r}",t=localStorage.getItem(e);t?a(t):localStorage.setItem(e,a(m))}catch(a){}})();
  `;
  return `!${s ? i : a}`.trim();
}
function CL(e = {}) {
  const { nonce: t } = e;
  return /* @__PURE__ */ h.jsx(
    "script",
    {
      id: "chakra-script",
      nonce: t,
      dangerouslySetInnerHTML: { __html: MN(e) }
    }
  );
}
const jN = M(
  function(t, n) {
    const { className: r, centerContent: o, ...s } = Ae(t), i = Ct("Container", t);
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ref: n,
        className: W("chakra-container", r),
        ...s,
        __css: {
          ...i,
          ...o && {
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }
        }
      }
    );
  }
);
jN.displayName = "Container";
const DN = (e) => {
  const {
    type: t = "checkbox",
    _hover: n,
    _invalid: r,
    _disabled: o,
    _focus: s,
    _checked: i,
    _child: a = { opacity: 0 },
    _checkedAndChild: c = { opacity: 1 },
    _checkedAndDisabled: l,
    _checkedAndFocus: u,
    _checkedAndHover: d,
    children: f,
    ...p
  } = e, m = `input[type=${t}]:checked:disabled + &`, g = `input[type=${t}]:checked:hover:not(:disabled) + &`, y = `input[type=${t}]:checked:focus + &`, S = `input[type=${t}]:disabled + &`, b = `input[type=${t}]:focus + &`, v = `input[type=${t}]:hover:not(:disabled):not(:checked) + &`, k = `input[type=${t}]:checked + &, input[type=${t}][aria-checked=mixed] + &`, w = `input[type=${t}][aria-invalid=true] + &`, _ = "& > *";
  return /* @__PURE__ */ h.jsx(
    E.div,
    {
      ...p,
      "aria-hidden": !0,
      __css: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        transitionProperty: "common",
        transitionDuration: "fast",
        flexShrink: 0,
        [b]: s,
        [v]: n,
        [S]: o,
        [w]: r,
        [m]: l,
        [y]: u,
        [g]: d,
        [_]: a,
        [k]: {
          ...i,
          [_]: c
        }
      },
      children: f
    }
  );
};
DN.displayName = "ControlBox";
const ON = M(
  function(t, n) {
    const {
      borderLeftWidth: r,
      borderBottomWidth: o,
      borderTopWidth: s,
      borderRightWidth: i,
      borderWidth: a,
      borderStyle: c,
      borderColor: l,
      ...u
    } = Ct("Divider", t), {
      className: d,
      orientation: f = "horizontal",
      __css: p,
      ...m
    } = Ae(t), g = {
      vertical: {
        borderLeftWidth: r || i || a || "1px",
        height: "100%"
      },
      horizontal: {
        borderBottomWidth: o || s || a || "1px",
        width: "100%"
      }
    };
    return /* @__PURE__ */ h.jsx(
      E.hr,
      {
        ref: n,
        "aria-orientation": f,
        ...m,
        __css: {
          ...u,
          border: "0",
          borderColor: l,
          borderStyle: c,
          ...g[f],
          ...p
        },
        className: W("chakra-divider", d)
      }
    );
  }
);
ON.displayName = "Divider";
const [FN, Bu] = Ee({
  name: "EditableStylesContext",
  errorMessage: `useEditableStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Editable />" `
}), [BN, zs] = Ee({
  name: "EditableContext",
  errorMessage: "useEditableContext: context is undefined. Seems you forgot to wrap the editable components in `<Editable />`"
});
function bp(e, t) {
  return e ? e === t || e.contains(t) : !1;
}
function LN(e = {}) {
  const {
    onChange: t,
    onCancel: n,
    onSubmit: r,
    onBlur: o,
    value: s,
    isDisabled: i,
    defaultValue: a,
    startWithEditView: c,
    isPreviewFocusable: l = !0,
    submitOnBlur: u = !0,
    selectAllOnFocus: d = !0,
    placeholder: f,
    onEdit: p,
    finalFocusRef: m,
    ...g
  } = e, y = nt(p), S = !!(c && !i), [b, v] = he(S), [k, w] = dr({
    defaultValue: a || "",
    value: s,
    onChange: t
  }), [_, C] = he(k), I = ae(null), $ = ae(null), N = ae(null), z = ae(null), Q = ae(null);
  qh({
    ref: I,
    enabled: b,
    elements: [z, Q]
  });
  const U = !b && !i;
  an(() => {
    var G, H;
    b && ((G = I.current) == null || G.focus(), d && ((H = I.current) == null || H.select()));
  }, []), bn(() => {
    var G, H, de, L;
    if (!b) {
      m ? (G = m.current) == null || G.focus() : (H = N.current) == null || H.focus();
      return;
    }
    (de = I.current) == null || de.focus(), d && ((L = I.current) == null || L.select()), y == null || y();
  }, [b, y, d]);
  const q = R(() => {
    U && v(!0);
  }, [U]), le = R(() => {
    C(k);
  }, [k]), Z = R(() => {
    v(!1), w(_), n == null || n(_), o == null || o(_);
  }, [n, o, w, _]), j = R(() => {
    v(!1), C(k), r == null || r(k), o == null || o(_);
  }, [k, r, o, _]);
  xe(() => {
    if (b)
      return;
    const G = I.current;
    (G == null ? void 0 : G.ownerDocument.activeElement) === G && (G == null || G.blur());
  }, [b]);
  const K = R(
    (G) => {
      w(G.currentTarget.value);
    },
    [w]
  ), ne = R(
    (G) => {
      const H = G.key, L = {
        Escape: Z,
        Enter: (me) => {
          !me.shiftKey && !me.metaKey && j();
        }
      }[H];
      L && (G.preventDefault(), L(G));
    },
    [Z, j]
  ), B = R(
    (G) => {
      const H = G.key, L = {
        Escape: Z
      }[H];
      L && (G.preventDefault(), L(G));
    },
    [Z]
  ), O = k.length === 0, ee = R(
    (G) => {
      if (!b)
        return;
      const H = G.currentTarget.ownerDocument, de = G.relatedTarget ?? H.activeElement, L = bp(z.current, de), me = bp(Q.current, de);
      !L && !me && (u ? j() : Z());
    },
    [u, j, Z, b]
  ), D = R(
    (G = {}, H = null) => {
      const de = U && l ? 0 : void 0;
      return {
        ...G,
        ref: De(H, $),
        children: O ? f : k,
        hidden: b,
        "aria-disabled": wt(i),
        tabIndex: de,
        onFocus: re(G.onFocus, q, le)
      };
    },
    [
      i,
      b,
      U,
      l,
      O,
      q,
      le,
      f,
      k
    ]
  ), V = R(
    (G = {}, H = null) => ({
      ...G,
      hidden: !b,
      placeholder: f,
      ref: De(H, I),
      disabled: i,
      "aria-disabled": wt(i),
      value: k,
      onBlur: re(G.onBlur, ee),
      onChange: re(G.onChange, K),
      onKeyDown: re(G.onKeyDown, ne),
      onFocus: re(G.onFocus, le)
    }),
    [
      i,
      b,
      ee,
      K,
      ne,
      le,
      f,
      k
    ]
  ), Y = R(
    (G = {}, H = null) => ({
      ...G,
      hidden: !b,
      placeholder: f,
      ref: De(H, I),
      disabled: i,
      "aria-disabled": wt(i),
      value: k,
      onBlur: re(G.onBlur, ee),
      onChange: re(G.onChange, K),
      onKeyDown: re(G.onKeyDown, B),
      onFocus: re(G.onFocus, le)
    }),
    [
      i,
      b,
      ee,
      K,
      B,
      le,
      f,
      k
    ]
  ), J = R(
    (G = {}, H = null) => ({
      "aria-label": "Edit",
      ...G,
      type: "button",
      onClick: re(G.onClick, q),
      ref: De(H, N),
      disabled: i
    }),
    [q, i]
  ), se = R(
    (G = {}, H = null) => ({
      ...G,
      "aria-label": "Submit",
      ref: De(Q, H),
      type: "button",
      onClick: re(G.onClick, j),
      disabled: i
    }),
    [j, i]
  ), ue = R(
    (G = {}, H = null) => ({
      "aria-label": "Cancel",
      id: "cancel",
      ...G,
      ref: De(z, H),
      type: "button",
      onClick: re(G.onClick, Z),
      disabled: i
    }),
    [Z, i]
  );
  return {
    isEditing: b,
    isDisabled: i,
    isValueEmpty: O,
    value: k,
    onEdit: q,
    onCancel: Z,
    onSubmit: j,
    getPreviewProps: D,
    getInputProps: V,
    getTextareaProps: Y,
    getEditButtonProps: J,
    getSubmitButtonProps: se,
    getCancelButtonProps: ue,
    htmlProps: g
  };
}
const VN = M(
  function(t, n) {
    const r = Je("Editable", t), o = Ae(t), { htmlProps: s, ...i } = LN(o), { isEditing: a, onSubmit: c, onCancel: l, onEdit: u } = i, d = W("chakra-editable", t.className), f = Et(t.children, {
      isEditing: a,
      onSubmit: c,
      onCancel: l,
      onEdit: u
    });
    return /* @__PURE__ */ h.jsx(BN, { value: i, children: /* @__PURE__ */ h.jsx(FN, { value: r, children: /* @__PURE__ */ h.jsx(
      E.div,
      {
        ref: n,
        ...s,
        className: d,
        children: f
      }
    ) }) });
  }
);
VN.displayName = "Editable";
const Lu = {
  fontSize: "inherit",
  fontWeight: "inherit",
  textAlign: "inherit",
  bg: "transparent"
}, zN = M(
  function(t, n) {
    const { getInputProps: r } = zs(), o = Bu(), s = r(t, n), i = W("chakra-editable__input", t.className);
    return /* @__PURE__ */ h.jsx(
      E.input,
      {
        ...s,
        __css: {
          outline: 0,
          ...Lu,
          ...o.input
        },
        className: i
      }
    );
  }
);
zN.displayName = "EditableInput";
const WN = M(
  function(t, n) {
    const { getPreviewProps: r } = zs(), o = Bu(), s = r(t, n), i = W("chakra-editable__preview", t.className);
    return /* @__PURE__ */ h.jsx(
      E.span,
      {
        ...s,
        __css: {
          cursor: "text",
          display: "inline-block",
          ...Lu,
          ...o.preview
        },
        className: i
      }
    );
  }
);
WN.displayName = "EditablePreview";
const HN = M(
  function(t, n) {
    const { getTextareaProps: r } = zs(), o = Bu(), s = r(t, n), i = W("chakra-editable__textarea", t.className);
    return /* @__PURE__ */ h.jsx(
      E.textarea,
      {
        ...s,
        __css: {
          outline: 0,
          ...Lu,
          ...o.textarea
        },
        className: i
      }
    );
  }
);
HN.displayName = "EditableTextarea";
function _L() {
  const {
    isEditing: e,
    getEditButtonProps: t,
    getCancelButtonProps: n,
    getSubmitButtonProps: r
  } = zs();
  return {
    isEditing: e,
    getEditButtonProps: t,
    getCancelButtonProps: n,
    getSubmitButtonProps: r
  };
}
function TL() {
  const { isEditing: e, onSubmit: t, onCancel: n, onEdit: r, isDisabled: o } = zs();
  return {
    isEditing: e,
    onSubmit: t,
    onCancel: n,
    onEdit: r,
    isDisabled: o
  };
}
function ns(e) {
  return typeof e == "function";
}
function UN(...e) {
  return (t) => e.reduce((n, r) => r(n), t);
}
const Ry = (e) => function(...n) {
  let r = [...n], o = n[n.length - 1];
  return q_(o) && // this ensures backward compatibility
  // previously only `extendTheme(override, activeTheme?)` was allowed
  r.length > 1 ? r = r.slice(0, r.length - 1) : o = e, UN(
    ...r.map(
      (s) => (i) => ns(s) ? s(i) : Ws(i, s)
    )
  )(o);
}, EL = Ry(ru), AL = Ry(_m);
function Ws(...e) {
  return sn({}, ...e, $y);
}
function $y(e, t, n, r) {
  if ((ns(e) || ns(t)) && Object.prototype.hasOwnProperty.call(r, n))
    return (...o) => {
      const s = ns(e) ? e(...o) : e, i = ns(t) ? t(...o) : t;
      return sn({}, s, i, $y);
    };
  if (lt(e) && Yc(t) || Yc(e) && lt(t))
    return t;
}
function GN({
  colorScheme: e,
  components: t
}) {
  return (n) => {
    let r = Object.keys(n.components || {});
    return Array.isArray(t) ? r = t : lt(t) && (r = Object.keys(t)), Ws(n, {
      components: Object.fromEntries(
        r.map((o) => [o, {
          defaultProps: {
            colorScheme: e
          }
        }])
      )
    });
  };
}
function qN({
  size: e,
  components: t
}) {
  return (n) => {
    let r = Object.keys(n.components || {});
    return Array.isArray(t) ? r = t : lt(t) && (r = Object.keys(t)), Ws(n, {
      components: Object.fromEntries(
        r.map((o) => [o, {
          defaultProps: {
            size: e
          }
        }])
      )
    });
  };
}
function KN({
  variant: e,
  components: t
}) {
  return (n) => {
    let r = Object.keys(n.components || {});
    return Array.isArray(t) ? r = t : lt(t) && (r = Object.keys(t)), Ws(n, {
      components: Object.fromEntries(
        r.map((o) => [o, {
          defaultProps: {
            variant: e
          }
        }])
      )
    });
  };
}
function YN(...e) {
  return (t) => e.reduce((n, r) => r(n), t);
}
function IL({
  defaultProps: { colorScheme: e, variant: t, size: n },
  components: r
}) {
  const o = (i) => i, s = [
    e ? GN({ colorScheme: e, components: r }) : o,
    n ? qN({ size: n, components: r }) : o,
    t ? KN({ variant: t, components: r }) : o
  ];
  return (i) => Ws(YN(...s)(i));
}
const XN = M(function(t, n) {
  const { direction: r, align: o, justify: s, wrap: i, basis: a, grow: c, shrink: l, ...u } = t, d = {
    display: "flex",
    flexDirection: r,
    alignItems: o,
    justifyContent: s,
    flexWrap: i,
    flexBasis: a,
    flexGrow: c,
    flexShrink: l
  };
  return /* @__PURE__ */ h.jsx(E.div, { ref: n, __css: d, ...u });
});
XN.displayName = "Flex";
function ZN(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) !== -1)
        continue;
      n[r] = e[r];
    }
  return n;
}
function ks() {
  return ks = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ks.apply(null, arguments);
}
var Al = { exports: {} }, gi = { exports: {} }, Ke = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vp;
function JN() {
  if (vp)
    return Ke;
  vp = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
  function v(w) {
    if (typeof w == "object" && w !== null) {
      var _ = w.$$typeof;
      switch (_) {
        case t:
          switch (w = w.type, w) {
            case c:
            case l:
            case r:
            case s:
            case o:
            case d:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case a:
                case u:
                case m:
                case p:
                case i:
                  return w;
                default:
                  return _;
              }
          }
        case n:
          return _;
      }
    }
  }
  function k(w) {
    return v(w) === l;
  }
  return Ke.AsyncMode = c, Ke.ConcurrentMode = l, Ke.ContextConsumer = a, Ke.ContextProvider = i, Ke.Element = t, Ke.ForwardRef = u, Ke.Fragment = r, Ke.Lazy = m, Ke.Memo = p, Ke.Portal = n, Ke.Profiler = s, Ke.StrictMode = o, Ke.Suspense = d, Ke.isAsyncMode = function(w) {
    return k(w) || v(w) === c;
  }, Ke.isConcurrentMode = k, Ke.isContextConsumer = function(w) {
    return v(w) === a;
  }, Ke.isContextProvider = function(w) {
    return v(w) === i;
  }, Ke.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === t;
  }, Ke.isForwardRef = function(w) {
    return v(w) === u;
  }, Ke.isFragment = function(w) {
    return v(w) === r;
  }, Ke.isLazy = function(w) {
    return v(w) === m;
  }, Ke.isMemo = function(w) {
    return v(w) === p;
  }, Ke.isPortal = function(w) {
    return v(w) === n;
  }, Ke.isProfiler = function(w) {
    return v(w) === s;
  }, Ke.isStrictMode = function(w) {
    return v(w) === o;
  }, Ke.isSuspense = function(w) {
    return v(w) === d;
  }, Ke.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === r || w === l || w === s || w === o || w === d || w === f || typeof w == "object" && w !== null && (w.$$typeof === m || w.$$typeof === p || w.$$typeof === i || w.$$typeof === a || w.$$typeof === u || w.$$typeof === y || w.$$typeof === S || w.$$typeof === b || w.$$typeof === g);
  }, Ke.typeOf = v, Ke;
}
var Ye = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xp;
function QN() {
  return xp || (xp = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
    function v(L) {
      return typeof L == "string" || typeof L == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      L === r || L === l || L === s || L === o || L === d || L === f || typeof L == "object" && L !== null && (L.$$typeof === m || L.$$typeof === p || L.$$typeof === i || L.$$typeof === a || L.$$typeof === u || L.$$typeof === y || L.$$typeof === S || L.$$typeof === b || L.$$typeof === g);
    }
    function k(L) {
      if (typeof L == "object" && L !== null) {
        var me = L.$$typeof;
        switch (me) {
          case t:
            var oe = L.type;
            switch (oe) {
              case c:
              case l:
              case r:
              case s:
              case o:
              case d:
                return oe;
              default:
                var $e = oe && oe.$$typeof;
                switch ($e) {
                  case a:
                  case u:
                  case m:
                  case p:
                  case i:
                    return $e;
                  default:
                    return me;
                }
            }
          case n:
            return me;
        }
      }
    }
    var w = c, _ = l, C = a, I = i, $ = t, N = u, z = r, Q = m, U = p, q = n, le = s, Z = o, j = d, K = !1;
    function ne(L) {
      return K || (K = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), B(L) || k(L) === c;
    }
    function B(L) {
      return k(L) === l;
    }
    function O(L) {
      return k(L) === a;
    }
    function ee(L) {
      return k(L) === i;
    }
    function D(L) {
      return typeof L == "object" && L !== null && L.$$typeof === t;
    }
    function V(L) {
      return k(L) === u;
    }
    function Y(L) {
      return k(L) === r;
    }
    function J(L) {
      return k(L) === m;
    }
    function se(L) {
      return k(L) === p;
    }
    function ue(L) {
      return k(L) === n;
    }
    function G(L) {
      return k(L) === s;
    }
    function H(L) {
      return k(L) === o;
    }
    function de(L) {
      return k(L) === d;
    }
    Ye.AsyncMode = w, Ye.ConcurrentMode = _, Ye.ContextConsumer = C, Ye.ContextProvider = I, Ye.Element = $, Ye.ForwardRef = N, Ye.Fragment = z, Ye.Lazy = Q, Ye.Memo = U, Ye.Portal = q, Ye.Profiler = le, Ye.StrictMode = Z, Ye.Suspense = j, Ye.isAsyncMode = ne, Ye.isConcurrentMode = B, Ye.isContextConsumer = O, Ye.isContextProvider = ee, Ye.isElement = D, Ye.isForwardRef = V, Ye.isFragment = Y, Ye.isLazy = J, Ye.isMemo = se, Ye.isPortal = ue, Ye.isProfiler = G, Ye.isStrictMode = H, Ye.isSuspense = de, Ye.isValidElementType = v, Ye.typeOf = k;
  }()), Ye;
}
var Sp;
function Ny() {
  return Sp || (Sp = 1, process.env.NODE_ENV === "production" ? gi.exports = JN() : gi.exports = QN()), gi.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var $c, wp;
function eM() {
  if (wp)
    return $c;
  wp = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var i = {}, a = 0; a < 10; a++)
        i["_" + String.fromCharCode(a)] = a;
      var c = Object.getOwnPropertyNames(i).map(function(u) {
        return i[u];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        l[u] = u;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return $c = o() ? Object.assign : function(s, i) {
    for (var a, c = r(s), l, u = 1; u < arguments.length; u++) {
      a = Object(arguments[u]);
      for (var d in a)
        t.call(a, d) && (c[d] = a[d]);
      if (e) {
        l = e(a);
        for (var f = 0; f < l.length; f++)
          n.call(a, l[f]) && (c[l[f]] = a[l[f]]);
      }
    }
    return c;
  }, $c;
}
var Nc, kp;
function Vu() {
  if (kp)
    return Nc;
  kp = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Nc = e, Nc;
}
var Mc, Pp;
function My() {
  return Pp || (Pp = 1, Mc = Function.call.bind(Object.prototype.hasOwnProperty)), Mc;
}
var jc, Cp;
function tM() {
  if (Cp)
    return jc;
  Cp = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Vu(), n = {}, r = My();
    e = function(s) {
      var i = "Warning: " + s;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function o(s, i, a, c, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in s)
        if (r(s, u)) {
          var d;
          try {
            if (typeof s[u] != "function") {
              var f = Error(
                (c || "React class") + ": " + a + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = s[u](i, u, c, a, null, t);
          } catch (m) {
            d = m;
          }
          if (d && !(d instanceof Error) && e(
            (c || "React class") + ": type specification of " + a + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var p = l ? l() : "";
            e(
              "Failed " + a + " type: " + d.message + (p ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, jc = o, jc;
}
var Dc, _p;
function nM() {
  if (_p)
    return Dc;
  _p = 1;
  var e = Ny(), t = eM(), n = Vu(), r = My(), o = tM(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(a) {
    var c = "Warning: " + a;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return Dc = function(a, c) {
    var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(B) {
      var O = B && (l && B[l] || B[u]);
      if (typeof O == "function")
        return O;
    }
    var f = "<<anonymous>>", p = {
      array: S("array"),
      bigint: S("bigint"),
      bool: S("boolean"),
      func: S("function"),
      number: S("number"),
      object: S("object"),
      string: S("string"),
      symbol: S("symbol"),
      any: b(),
      arrayOf: v,
      element: k(),
      elementType: w(),
      instanceOf: _,
      node: N(),
      objectOf: I,
      oneOf: C,
      oneOfType: $,
      shape: Q,
      exact: U
    };
    function m(B, O) {
      return B === O ? B !== 0 || 1 / B === 1 / O : B !== B && O !== O;
    }
    function g(B, O) {
      this.message = B, this.data = O && typeof O == "object" ? O : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function y(B) {
      if (process.env.NODE_ENV !== "production")
        var O = {}, ee = 0;
      function D(Y, J, se, ue, G, H, de) {
        if (ue = ue || f, H = H || se, de !== n) {
          if (c) {
            var L = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw L.name = "Invariant Violation", L;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var me = ue + ":" + se;
            !O[me] && // Avoid spamming the console because they are often not actionable except for lib authors
            ee < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + H + "` prop on `" + ue + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), O[me] = !0, ee++);
          }
        }
        return J[se] == null ? Y ? J[se] === null ? new g("The " + G + " `" + H + "` is marked as required " + ("in `" + ue + "`, but its value is `null`.")) : new g("The " + G + " `" + H + "` is marked as required in " + ("`" + ue + "`, but its value is `undefined`.")) : null : B(J, se, ue, G, H);
      }
      var V = D.bind(null, !1);
      return V.isRequired = D.bind(null, !0), V;
    }
    function S(B) {
      function O(ee, D, V, Y, J, se) {
        var ue = ee[D], G = Z(ue);
        if (G !== B) {
          var H = j(ue);
          return new g(
            "Invalid " + Y + " `" + J + "` of type " + ("`" + H + "` supplied to `" + V + "`, expected ") + ("`" + B + "`."),
            { expectedType: B }
          );
        }
        return null;
      }
      return y(O);
    }
    function b() {
      return y(i);
    }
    function v(B) {
      function O(ee, D, V, Y, J) {
        if (typeof B != "function")
          return new g("Property `" + J + "` of component `" + V + "` has invalid PropType notation inside arrayOf.");
        var se = ee[D];
        if (!Array.isArray(se)) {
          var ue = Z(se);
          return new g("Invalid " + Y + " `" + J + "` of type " + ("`" + ue + "` supplied to `" + V + "`, expected an array."));
        }
        for (var G = 0; G < se.length; G++) {
          var H = B(se, G, V, Y, J + "[" + G + "]", n);
          if (H instanceof Error)
            return H;
        }
        return null;
      }
      return y(O);
    }
    function k() {
      function B(O, ee, D, V, Y) {
        var J = O[ee];
        if (!a(J)) {
          var se = Z(J);
          return new g("Invalid " + V + " `" + Y + "` of type " + ("`" + se + "` supplied to `" + D + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(B);
    }
    function w() {
      function B(O, ee, D, V, Y) {
        var J = O[ee];
        if (!e.isValidElementType(J)) {
          var se = Z(J);
          return new g("Invalid " + V + " `" + Y + "` of type " + ("`" + se + "` supplied to `" + D + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(B);
    }
    function _(B) {
      function O(ee, D, V, Y, J) {
        if (!(ee[D] instanceof B)) {
          var se = B.name || f, ue = ne(ee[D]);
          return new g("Invalid " + Y + " `" + J + "` of type " + ("`" + ue + "` supplied to `" + V + "`, expected ") + ("instance of `" + se + "`."));
        }
        return null;
      }
      return y(O);
    }
    function C(B) {
      if (!Array.isArray(B))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), i;
      function O(ee, D, V, Y, J) {
        for (var se = ee[D], ue = 0; ue < B.length; ue++)
          if (m(se, B[ue]))
            return null;
        var G = JSON.stringify(B, function(de, L) {
          var me = j(L);
          return me === "symbol" ? String(L) : L;
        });
        return new g("Invalid " + Y + " `" + J + "` of value `" + String(se) + "` " + ("supplied to `" + V + "`, expected one of " + G + "."));
      }
      return y(O);
    }
    function I(B) {
      function O(ee, D, V, Y, J) {
        if (typeof B != "function")
          return new g("Property `" + J + "` of component `" + V + "` has invalid PropType notation inside objectOf.");
        var se = ee[D], ue = Z(se);
        if (ue !== "object")
          return new g("Invalid " + Y + " `" + J + "` of type " + ("`" + ue + "` supplied to `" + V + "`, expected an object."));
        for (var G in se)
          if (r(se, G)) {
            var H = B(se, G, V, Y, J + "." + G, n);
            if (H instanceof Error)
              return H;
          }
        return null;
      }
      return y(O);
    }
    function $(B) {
      if (!Array.isArray(B))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var O = 0; O < B.length; O++) {
        var ee = B[O];
        if (typeof ee != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + K(ee) + " at index " + O + "."
          ), i;
      }
      function D(V, Y, J, se, ue) {
        for (var G = [], H = 0; H < B.length; H++) {
          var de = B[H], L = de(V, Y, J, se, ue, n);
          if (L == null)
            return null;
          L.data && r(L.data, "expectedType") && G.push(L.data.expectedType);
        }
        var me = G.length > 0 ? ", expected one of type [" + G.join(", ") + "]" : "";
        return new g("Invalid " + se + " `" + ue + "` supplied to " + ("`" + J + "`" + me + "."));
      }
      return y(D);
    }
    function N() {
      function B(O, ee, D, V, Y) {
        return q(O[ee]) ? null : new g("Invalid " + V + " `" + Y + "` supplied to " + ("`" + D + "`, expected a ReactNode."));
      }
      return y(B);
    }
    function z(B, O, ee, D, V) {
      return new g(
        (B || "React class") + ": " + O + " type `" + ee + "." + D + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + V + "`."
      );
    }
    function Q(B) {
      function O(ee, D, V, Y, J) {
        var se = ee[D], ue = Z(se);
        if (ue !== "object")
          return new g("Invalid " + Y + " `" + J + "` of type `" + ue + "` " + ("supplied to `" + V + "`, expected `object`."));
        for (var G in B) {
          var H = B[G];
          if (typeof H != "function")
            return z(V, Y, J, G, j(H));
          var de = H(se, G, V, Y, J + "." + G, n);
          if (de)
            return de;
        }
        return null;
      }
      return y(O);
    }
    function U(B) {
      function O(ee, D, V, Y, J) {
        var se = ee[D], ue = Z(se);
        if (ue !== "object")
          return new g("Invalid " + Y + " `" + J + "` of type `" + ue + "` " + ("supplied to `" + V + "`, expected `object`."));
        var G = t({}, ee[D], B);
        for (var H in G) {
          var de = B[H];
          if (r(B, H) && typeof de != "function")
            return z(V, Y, J, H, j(de));
          if (!de)
            return new g(
              "Invalid " + Y + " `" + J + "` key `" + H + "` supplied to `" + V + "`.\nBad object: " + JSON.stringify(ee[D], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(B), null, "  ")
            );
          var L = de(se, H, V, Y, J + "." + H, n);
          if (L)
            return L;
        }
        return null;
      }
      return y(O);
    }
    function q(B) {
      switch (typeof B) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !B;
        case "object":
          if (Array.isArray(B))
            return B.every(q);
          if (B === null || a(B))
            return !0;
          var O = d(B);
          if (O) {
            var ee = O.call(B), D;
            if (O !== B.entries) {
              for (; !(D = ee.next()).done; )
                if (!q(D.value))
                  return !1;
            } else
              for (; !(D = ee.next()).done; ) {
                var V = D.value;
                if (V && !q(V[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function le(B, O) {
      return B === "symbol" ? !0 : O ? O["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && O instanceof Symbol : !1;
    }
    function Z(B) {
      var O = typeof B;
      return Array.isArray(B) ? "array" : B instanceof RegExp ? "object" : le(O, B) ? "symbol" : O;
    }
    function j(B) {
      if (typeof B > "u" || B === null)
        return "" + B;
      var O = Z(B);
      if (O === "object") {
        if (B instanceof Date)
          return "date";
        if (B instanceof RegExp)
          return "regexp";
      }
      return O;
    }
    function K(B) {
      var O = j(B);
      switch (O) {
        case "array":
        case "object":
          return "an " + O;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + O;
        default:
          return O;
      }
    }
    function ne(B) {
      return !B.constructor || !B.constructor.name ? f : B.constructor.name;
    }
    return p.checkPropTypes = o, p.resetWarningCache = o.resetWarningCache, p.PropTypes = p, p;
  }, Dc;
}
var Oc, Tp;
function rM() {
  if (Tp)
    return Oc;
  Tp = 1;
  var e = Vu();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Oc = function() {
    function r(i, a, c, l, u, d) {
      if (d !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var s = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return s.PropTypes = s, s;
  }, Oc;
}
if (process.env.NODE_ENV !== "production") {
  var oM = Ny(), sM = !0;
  Al.exports = nM()(oM.isElement, sM);
} else
  Al.exports = rM()();
var et = Al.exports;
const jy = /* @__PURE__ */ ca(et);
var Il = "data-focus-lock", Dy = "data-focus-lock-disabled", iM = "data-no-focus-lock", aM = "data-autofocus-inside", cM = "data-no-autofocus";
function Fc(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function lM(e, t) {
  var n = he(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var uM = typeof window < "u" ? we.useLayoutEffect : we.useEffect, Ep = /* @__PURE__ */ new WeakMap();
function Oy(e, t) {
  var n = lM(t || null, function(r) {
    return e.forEach(function(o) {
      return Fc(o, r);
    });
  });
  return uM(function() {
    var r = Ep.get(n);
    if (r) {
      var o = new Set(r), s = new Set(e), i = n.current;
      o.forEach(function(a) {
        s.has(a) || Fc(a, null);
      }), s.forEach(function(a) {
        o.has(a) || Fc(a, i);
      });
    }
    Ep.set(n, e);
  }, [e]), n;
}
var Bc = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
};
process.env.NODE_ENV !== "production" && jy.node;
var Tn = function() {
  return Tn = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, Tn.apply(this, arguments);
};
function Fy(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function dM(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, s; r < o; r++)
      (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}
function By(e) {
  return e;
}
function Ly(e, t) {
  t === void 0 && (t = By);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(s) {
      var i = t(s, r);
      return n.push(i), function() {
        n = n.filter(function(a) {
          return a !== i;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (r = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(s);
      }
      n = {
        push: function(a) {
          return s(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(s) {
      r = !0;
      var i = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(s), i = n;
      }
      var c = function() {
        var u = i;
        i = [], u.forEach(s);
      }, l = function() {
        return Promise.resolve().then(c);
      };
      l(), n = {
        push: function(u) {
          i.push(u), l();
        },
        filter: function(u) {
          return i = i.filter(u), n;
        }
      };
    }
  };
  return o;
}
function zu(e, t) {
  return t === void 0 && (t = By), Ly(e, t);
}
function Vy(e) {
  e === void 0 && (e = {});
  var t = Ly(null);
  return t.options = Tn({ async: !0, ssr: !1 }, e), t;
}
var zy = function(e) {
  var t = e.sideCar, n = Fy(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return we.createElement(r, Tn({}, n));
};
zy.isSideCarExport = !0;
function fM(e, t) {
  return e.useMedium(t), zy;
}
var Wy = zu({}, function(e) {
  var t = e.target, n = e.currentTarget;
  return {
    target: t,
    currentTarget: n
  };
}), Hy = zu(), pM = zu(), hM = Vy({
  async: !0,
  ssr: typeof document < "u"
}), mM = /* @__PURE__ */ Nn(void 0), gM = [], Uy = /* @__PURE__ */ vn(function(t, n) {
  var r, o = he(), s = o[0], i = o[1], a = ae(), c = ae(!1), l = ae(null), u = he({}), d = u[1], f = t.children, p = t.disabled, m = p === void 0 ? !1 : p, g = t.noFocusGuards, y = g === void 0 ? !1 : g, S = t.persistentFocus, b = S === void 0 ? !1 : S, v = t.crossFrame, k = v === void 0 ? !0 : v, w = t.autoFocus, _ = w === void 0 ? !0 : w, C = t.allowTextSelection, I = t.group, $ = t.className, N = t.whiteList, z = t.hasPositiveIndices, Q = t.shards, U = Q === void 0 ? gM : Q, q = t.as, le = q === void 0 ? "div" : q, Z = t.lockProps, j = Z === void 0 ? {} : Z, K = t.sideCar, ne = t.returnFocus, B = ne === void 0 ? !1 : ne, O = t.focusOptions, ee = t.onActivation, D = t.onDeactivation, V = he({}), Y = V[0], J = R(function(ce) {
    var Ne = ce.captureFocusRestore;
    if (!l.current) {
      var Ie, Re = (Ie = document) == null ? void 0 : Ie.activeElement;
      l.current = Re, Re !== document.body && (l.current = Ne(Re));
    }
    a.current && ee && ee(a.current), c.current = !0, d();
  }, [ee]), se = R(function() {
    c.current = !1, D && D(a.current), d();
  }, [D]), ue = R(function(ce) {
    var Ne = l.current;
    if (Ne) {
      var Ie = (typeof Ne == "function" ? Ne() : Ne) || document.body, Re = typeof B == "function" ? B(Ie) : B;
      if (Re) {
        var Xe = typeof Re == "object" ? Re : void 0;
        l.current = null, ce ? Promise.resolve().then(function() {
          return Ie.focus(Xe);
        }) : Ie.focus(Xe);
      }
    }
  }, [B]), G = R(function(ce) {
    c.current && Wy.useMedium(ce);
  }, []), H = Hy.useMedium, de = R(function(ce) {
    a.current !== ce && (a.current = ce, i(ce));
  }, []);
  process.env.NODE_ENV !== "production" && (typeof C < "u" && console.warn("React-Focus-Lock: allowTextSelection is deprecated and enabled by default"), xe(function() {
    !a.current && typeof le != "string" && console.error("FocusLock: could not obtain ref to internal node");
  }, []));
  var L = ks((r = {}, r[Dy] = m && "disabled", r[Il] = I, r), j), me = y !== !0, oe = me && y !== "tail", $e = Oy([n, de]), Oe = _e(function() {
    return {
      observed: a,
      shards: U,
      enabled: !m,
      active: c.current
    };
  }, [m, c.current, U, s]);
  return /* @__PURE__ */ Yt.createElement(Ul, null, me && [
    /* @__PURE__ */ Yt.createElement("div", {
      key: "guard-first",
      "data-focus-guard": !0,
      tabIndex: m ? -1 : 0,
      style: Bc
    }),
    z ? /* @__PURE__ */ Yt.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": !0,
      tabIndex: m ? -1 : 1,
      style: Bc
    }) : null
  ], !m && /* @__PURE__ */ Yt.createElement(K, {
    id: Y,
    sideCar: hM,
    observed: s,
    disabled: m,
    persistentFocus: b,
    crossFrame: k,
    autoFocus: _,
    whiteList: N,
    shards: U,
    onActivation: J,
    onDeactivation: se,
    returnFocus: ue,
    focusOptions: O,
    noFocusGuards: y
  }), /* @__PURE__ */ Yt.createElement(le, ks({
    ref: $e
  }, L, {
    className: $,
    onBlur: H,
    onFocus: G
  }), /* @__PURE__ */ Yt.createElement(mM.Provider, {
    value: Oe
  }, f)), oe && /* @__PURE__ */ Yt.createElement("div", {
    "data-focus-guard": !0,
    tabIndex: m ? -1 : 0,
    style: Bc
  }));
});
Uy.propTypes = process.env.NODE_ENV !== "production" ? {
  children: et.node,
  disabled: et.bool,
  returnFocus: et.oneOfType([et.bool, et.object, et.func]),
  focusOptions: et.object,
  noFocusGuards: et.bool,
  hasPositiveIndices: et.bool,
  allowTextSelection: et.bool,
  autoFocus: et.bool,
  persistentFocus: et.bool,
  crossFrame: et.bool,
  group: et.string,
  className: et.string,
  whiteList: et.func,
  shards: et.arrayOf(et.any),
  as: et.oneOfType([et.string, et.func, et.object]),
  lockProps: et.object,
  onActivation: et.func,
  onDeactivation: et.func,
  sideCar: et.any.isRequired
} : {};
const Gy = Uy;
function Rl(e, t) {
  return Rl = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, Rl(e, t);
}
function yM(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Rl(e, t);
}
function Ps(e) {
  "@babel/helpers - typeof";
  return Ps = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ps(e);
}
function bM(e, t) {
  if (Ps(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Ps(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function vM(e) {
  var t = bM(e, "string");
  return Ps(t) == "symbol" ? t : t + "";
}
function xM(e, t, n) {
  return (t = vM(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function SM(e, t) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof e != "function")
      throw new Error("Expected reducePropsToState to be a function.");
    if (typeof t != "function")
      throw new Error("Expected handleStateChangeOnClient to be a function.");
  }
  function n(r) {
    return r.displayName || r.name || "Component";
  }
  return function(o) {
    if (process.env.NODE_ENV !== "production" && typeof o != "function")
      throw new Error("Expected WrappedComponent to be a React component.");
    var s = [], i;
    function a() {
      i = e(s.map(function(l) {
        return l.props;
      })), t(i);
    }
    var c = /* @__PURE__ */ function(l) {
      yM(u, l);
      function u() {
        return l.apply(this, arguments) || this;
      }
      u.peek = function() {
        return i;
      };
      var d = u.prototype;
      return d.componentDidMount = function() {
        s.push(this), a();
      }, d.componentDidUpdate = function() {
        a();
      }, d.componentWillUnmount = function() {
        var p = s.indexOf(this);
        s.splice(p, 1), a();
      }, d.render = function() {
        return /* @__PURE__ */ Yt.createElement(o, this.props);
      }, u;
    }(s0);
    return xM(c, "displayName", "SideEffect(" + n(o) + ")"), c;
  };
}
var jn = function(e) {
  for (var t = Array(e.length), n = 0; n < e.length; ++n)
    t[n] = e[n];
  return t;
}, jr = function(e) {
  return Array.isArray(e) ? e : [e];
}, qy = function(e) {
  return Array.isArray(e) ? e[0] : e;
}, wM = function(e) {
  if (e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  var t = window.getComputedStyle(e, null);
  return !t || !t.getPropertyValue ? !1 : t.getPropertyValue("display") === "none" || t.getPropertyValue("visibility") === "hidden";
}, Ky = function(e) {
  return e.parentNode && e.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e.parentNode.host
  ) : e.parentNode;
}, Yy = function(e) {
  return e === document || e && e.nodeType === Node.DOCUMENT_NODE;
}, kM = function(e) {
  return e.hasAttribute("inert");
}, PM = function(e, t) {
  return !e || Yy(e) || !wM(e) && !kM(e) && t(Ky(e));
}, Xy = function(e, t) {
  var n = e.get(t);
  if (n !== void 0)
    return n;
  var r = PM(t, Xy.bind(void 0, e));
  return e.set(t, r), r;
}, CM = function(e, t) {
  return e && !Yy(e) ? EM(e) ? t(Ky(e)) : !1 : !0;
}, Zy = function(e, t) {
  var n = e.get(t);
  if (n !== void 0)
    return n;
  var r = CM(t, Zy.bind(void 0, e));
  return e.set(t, r), r;
}, Jy = function(e) {
  return e.dataset;
}, _M = function(e) {
  return e.tagName === "BUTTON";
}, Qy = function(e) {
  return e.tagName === "INPUT";
}, eb = function(e) {
  return Qy(e) && e.type === "radio";
}, TM = function(e) {
  return !((Qy(e) || _M(e)) && (e.type === "hidden" || e.disabled));
}, EM = function(e) {
  var t = e.getAttribute(cM);
  return ![!0, "true", ""].includes(t);
}, Wu = function(e) {
  var t;
  return !!(e && (!((t = Jy(e)) === null || t === void 0) && t.focusGuard));
}, $l = function(e) {
  return !Wu(e);
}, AM = function(e) {
  return !!e;
}, IM = function(e, t) {
  var n = Math.max(0, e.tabIndex), r = Math.max(0, t.tabIndex), o = n - r, s = e.index - t.index;
  if (o) {
    if (!n)
      return 1;
    if (!r)
      return -1;
  }
  return o || s;
}, RM = function(e) {
  return e.tabIndex < 0 && !e.hasAttribute("tabindex") ? 0 : e.tabIndex;
}, Hu = function(e, t, n) {
  return jn(e).map(function(r, o) {
    var s = RM(r);
    return {
      node: r,
      index: o,
      tabIndex: n && s === -1 ? (r.dataset || {}).focusGuard ? 0 : -1 : s
    };
  }).filter(function(r) {
    return !t || r.tabIndex >= 0;
  }).sort(IM);
}, $M = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
], Uu = $M.join(","), NM = "".concat(Uu, ", [data-focus-guard]"), tb = function(e, t) {
  return jn((e.shadowRoot || e).children).reduce(function(n, r) {
    return n.concat(r.matches(t ? NM : Uu) ? [r] : [], tb(r));
  }, []);
}, MM = function(e, t) {
  var n;
  return e instanceof HTMLIFrameElement && (!((n = e.contentDocument) === null || n === void 0) && n.body) ? Co([e.contentDocument.body], t) : [e];
}, Co = function(e, t) {
  return e.reduce(function(n, r) {
    var o, s = tb(r, t), i = (o = []).concat.apply(o, s.map(function(a) {
      return MM(a, t);
    }));
    return n.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      i,
      // add if node is tabbable itself
      r.parentNode ? jn(r.parentNode.querySelectorAll(Uu)).filter(function(a) {
        return a === r;
      }) : []
    );
  }, []);
}, jM = function(e) {
  var t = e.querySelectorAll("[".concat(aM, "]"));
  return jn(t).map(function(n) {
    return Co([n]);
  }).reduce(function(n, r) {
    return n.concat(r);
  }, []);
}, Gu = function(e, t) {
  return jn(e).filter(function(n) {
    return Xy(t, n);
  }).filter(function(n) {
    return TM(n);
  });
}, Ap = function(e, t) {
  return t === void 0 && (t = /* @__PURE__ */ new Map()), jn(e).filter(function(n) {
    return Zy(t, n);
  });
}, qu = function(e, t, n) {
  return Hu(Gu(Co(e, n), t), !0, n);
}, Cs = function(e, t) {
  return Hu(Gu(Co(e), t), !1);
}, DM = function(e, t) {
  return Gu(jM(e), t);
}, Rr = function(e, t) {
  return e.shadowRoot ? Rr(e.shadowRoot, t) : Object.getPrototypeOf(e).contains !== void 0 && Object.getPrototypeOf(e).contains.call(e, t) ? !0 : jn(e.children).some(function(n) {
    var r;
    if (n instanceof HTMLIFrameElement) {
      var o = (r = n.contentDocument) === null || r === void 0 ? void 0 : r.body;
      return o ? Rr(o, t) : !1;
    }
    return Rr(n, t);
  });
}, OM = function(e) {
  for (var t = /* @__PURE__ */ new Set(), n = e.length, r = 0; r < n; r += 1)
    for (var o = r + 1; o < n; o += 1) {
      var s = e[r].compareDocumentPosition(e[o]);
      (s & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && t.add(o), (s & Node.DOCUMENT_POSITION_CONTAINS) > 0 && t.add(r);
    }
  return e.filter(function(i, a) {
    return !t.has(a);
  });
}, nb = function(e) {
  return e.parentNode ? nb(e.parentNode) : e;
}, Ku = function(e) {
  var t = jr(e);
  return t.filter(Boolean).reduce(function(n, r) {
    var o = r.getAttribute(Il);
    return n.push.apply(n, o ? OM(jn(nb(r).querySelectorAll("[".concat(Il, '="').concat(o, '"]:not([').concat(Dy, '="disabled"])')))) : [r]), n;
  }, []);
}, FM = function(e) {
  try {
    return e();
  } catch {
    return;
  }
}, _s = function(e) {
  if (e === void 0 && (e = document), !(!e || !e.activeElement)) {
    var t = e.activeElement;
    return t.shadowRoot ? _s(t.shadowRoot) : t instanceof HTMLIFrameElement && FM(function() {
      return t.contentWindow.document;
    }) ? _s(t.contentWindow.document) : t;
  }
}, BM = function(e, t) {
  return e === t;
}, LM = function(e, t) {
  return !!jn(e.querySelectorAll("iframe")).some(function(n) {
    return BM(n, t);
  });
}, rb = function(e, t) {
  return t === void 0 && (t = _s(qy(e).ownerDocument)), !t || t.dataset && t.dataset.focusGuard ? !1 : Ku(e).some(function(n) {
    return Rr(n, t) || LM(n, t);
  });
}, VM = function(e) {
  e === void 0 && (e = document);
  var t = _s(e);
  return t ? jn(e.querySelectorAll("[".concat(iM, "]"))).some(function(n) {
    return Rr(n, t);
  }) : !1;
}, zM = function(e, t) {
  return t.filter(eb).filter(function(n) {
    return n.name === e.name;
  }).filter(function(n) {
    return n.checked;
  })[0] || e;
}, Yu = function(e, t) {
  return eb(e) && e.name ? zM(e, t) : e;
}, WM = function(e) {
  var t = /* @__PURE__ */ new Set();
  return e.forEach(function(n) {
    return t.add(Yu(n, e));
  }), e.filter(function(n) {
    return t.has(n);
  });
}, Ip = function(e) {
  return e[0] && e.length > 1 ? Yu(e[0], e) : e[0];
}, Rp = function(e, t) {
  return e.indexOf(Yu(t, e));
}, Nl = "NEW_FOCUS", HM = function(e, t, n, r, o) {
  var s = e.length, i = e[0], a = e[s - 1], c = Wu(r);
  if (!(r && e.indexOf(r) >= 0)) {
    var l = r !== void 0 ? n.indexOf(r) : -1, u = o ? n.indexOf(o) : l, d = o ? e.indexOf(o) : -1;
    if (l === -1)
      return d !== -1 ? d : Nl;
    if (d === -1)
      return Nl;
    var f = l - u, p = n.indexOf(i), m = n.indexOf(a), g = WM(n), y = r !== void 0 ? g.indexOf(r) : -1, S = o ? g.indexOf(o) : y, b = g.filter(function(I) {
      return I.tabIndex >= 0;
    }), v = r !== void 0 ? b.indexOf(r) : -1, k = o ? b.indexOf(o) : v, w = v >= 0 && k >= 0 ? (
      // old/new are tabbables, measure distance in tabbable space
      k - v
    ) : (
      // or else measure in focusable space
      S - y
    );
    if (!f && d >= 0 || t.length === 0)
      return d;
    var _ = Rp(e, t[0]), C = Rp(e, t[t.length - 1]);
    if (l <= p && c && Math.abs(f) > 1)
      return C;
    if (l >= m && c && Math.abs(f) > 1)
      return _;
    if (f && Math.abs(w) > 1)
      return d;
    if (l <= p)
      return C;
    if (l > m)
      return _;
    if (f)
      return Math.abs(f) > 1 ? d : (s + d + f) % s;
  }
}, UM = function(e) {
  return function(t) {
    var n, r = (n = Jy(t)) === null || n === void 0 ? void 0 : n.autofocus;
    return (
      // @ts-expect-error
      t.autofocus || //
      r !== void 0 && r !== "false" || //
      e.indexOf(t) >= 0
    );
  };
}, $p = function(e, t, n) {
  var r = e.map(function(s) {
    var i = s.node;
    return i;
  }), o = Ap(r.filter(UM(n)));
  return o && o.length ? Ip(o) : Ip(Ap(t));
}, Ml = function(e, t) {
  return t === void 0 && (t = []), t.push(e), e.parentNode && Ml(e.parentNode.host || e.parentNode, t), t;
}, Lc = function(e, t) {
  for (var n = Ml(e), r = Ml(t), o = 0; o < n.length; o += 1) {
    var s = n[o];
    if (r.indexOf(s) >= 0)
      return s;
  }
  return !1;
}, ob = function(e, t, n) {
  var r = jr(e), o = jr(t), s = r[0], i = !1;
  return o.filter(Boolean).forEach(function(a) {
    i = Lc(i || a, a) || i, n.filter(Boolean).forEach(function(c) {
      var l = Lc(s, c);
      l && (!i || Rr(l, i) ? i = l : i = Lc(l, i));
    });
  }), i;
}, Np = function(e, t) {
  return e.reduce(function(n, r) {
    return n.concat(DM(r, t));
  }, []);
}, GM = function(e, t) {
  var n = /* @__PURE__ */ new Map();
  return t.forEach(function(r) {
    return n.set(r.node, r);
  }), e.map(function(r) {
    return n.get(r);
  }).filter(AM);
}, qM = function(e, t) {
  var n = _s(jr(e).length > 0 ? document : qy(e).ownerDocument), r = Ku(e).filter($l), o = ob(n || e, e, r), s = /* @__PURE__ */ new Map(), i = Cs(r, s), a = i.filter(function(m) {
    var g = m.node;
    return $l(g);
  });
  if (a[0]) {
    var c = Cs([o], s).map(function(m) {
      var g = m.node;
      return g;
    }), l = GM(c, a), u = l.map(function(m) {
      var g = m.node;
      return g;
    }), d = l.filter(function(m) {
      var g = m.tabIndex;
      return g >= 0;
    }).map(function(m) {
      var g = m.node;
      return g;
    }), f = HM(u, d, c, n, t);
    if (f === Nl) {
      var p = (
        // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        $p(i, d, Np(r, s)) || $p(i, u, Np(r, s))
      );
      if (p)
        return { node: p };
      console.warn("focus-lock: cannot find any node to move focus into");
      return;
    }
    return f === void 0 ? f : l[f];
  }
}, KM = function(e) {
  var t = Ku(e).filter($l), n = ob(e, e, t), r = Hu(Co([n], !0), !0, !0), o = Co(t, !1);
  return r.map(function(s) {
    var i = s.node, a = s.index;
    return {
      node: i,
      index: a,
      lockItem: o.indexOf(i) >= 0,
      guard: Wu(i)
    };
  });
}, Xu = function(e, t) {
  e && ("focus" in e && e.focus(t), "contentWindow" in e && e.contentWindow && e.contentWindow.focus());
}, Vc = 0, zc = !1, sb = function(e, t, n) {
  n === void 0 && (n = {});
  var r = qM(e, t);
  if (!zc && r) {
    if (Vc > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), zc = !0, setTimeout(function() {
        zc = !1;
      }, 1);
      return;
    }
    Vc++, Xu(r.node, n.focusOptions), Vc--;
  }
};
function qo(e) {
  if (!e)
    return null;
  if (typeof WeakRef > "u")
    return function() {
      return e || null;
    };
  var t = e ? new WeakRef(e) : null;
  return function() {
    return (t == null ? void 0 : t.deref()) || null;
  };
}
var YM = function(e) {
  if (!e)
    return null;
  for (var t = [], n = e; n && n !== document.body; )
    t.push({
      current: qo(n),
      parent: qo(n.parentElement),
      left: qo(n.previousElementSibling),
      right: qo(n.nextElementSibling)
    }), n = n.parentElement;
  return {
    element: qo(e),
    stack: t,
    ownerDocument: e.ownerDocument
  };
}, XM = function(e) {
  var t, n, r, o, s;
  if (e)
    for (var i = e.stack, a = e.ownerDocument, c = /* @__PURE__ */ new Map(), l = 0, u = i; l < u.length; l++) {
      var d = u[l], f = (t = d.parent) === null || t === void 0 ? void 0 : t.call(d);
      if (f && a.contains(f)) {
        for (var p = (n = d.left) === null || n === void 0 ? void 0 : n.call(d), m = d.current(), g = f.contains(m) ? m : void 0, y = (r = d.right) === null || r === void 0 ? void 0 : r.call(d), S = qu([f], c), b = (
          // that is element itself
          (s = (o = g ?? // or something in it's place
          (p == null ? void 0 : p.nextElementSibling)) !== null && o !== void 0 ? o : (
            // or somebody to the right, still close enough
            y
          )) !== null && s !== void 0 ? s : (
            // or somebody to the left, something?
            p
          )
        ); b; ) {
          for (var v = 0, k = S; v < k.length; v++) {
            var w = k[v];
            if (b != null && b.contains(w.node))
              return w.node;
          }
          b = b.nextElementSibling;
        }
        if (S.length)
          return S[0].node;
      }
    }
}, ib = function(e) {
  var t = YM(e);
  return function() {
    return XM(t);
  };
}, ZM = function(e, t, n) {
  if (!e || !t)
    return console.error("no element or scope given"), {};
  var r = jr(t);
  if (r.every(function(i) {
    return !Rr(i, e);
  }))
    return console.error("Active element is not contained in the scope"), {};
  var o = n ? qu(r, /* @__PURE__ */ new Map()) : Cs(r, /* @__PURE__ */ new Map()), s = o.findIndex(function(i) {
    var a = i.node;
    return a === e;
  });
  if (s !== -1)
    return {
      prev: o[s - 1],
      next: o[s + 1],
      first: o[0],
      last: o[o.length - 1]
    };
}, JM = function(e, t) {
  var n = t ? qu(jr(e), /* @__PURE__ */ new Map()) : Cs(jr(e), /* @__PURE__ */ new Map());
  return {
    first: n[0],
    last: n[n.length - 1]
  };
}, QM = function(e) {
  return Object.assign({
    scope: document.body,
    cycle: !0,
    onlyTabbable: !0
  }, e);
}, ab = function(e, t, n) {
  t === void 0 && (t = {});
  var r = QM(t), o = ZM(e, r.scope, r.onlyTabbable);
  if (o) {
    var s = n(o, r.cycle);
    s && Xu(s.node, r.focusOptions);
  }
}, ej = function(e, t) {
  t === void 0 && (t = {}), ab(e, t, function(n, r) {
    var o = n.next, s = n.first;
    return o || r && s;
  });
}, tj = function(e, t) {
  t === void 0 && (t = {}), ab(e, t, function(n, r) {
    var o = n.prev, s = n.last;
    return o || r && s;
  });
}, cb = function(e, t, n) {
  var r, o = JM(e, (r = t.onlyTabbable) !== null && r !== void 0 ? r : !0), s = o[n];
  s && Xu(s.node, t.focusOptions);
}, nj = function(e, t) {
  t === void 0 && (t = {}), cb(e, t, "first");
}, rj = function(e, t) {
  t === void 0 && (t = {}), cb(e, t, "last");
};
function Zu(e) {
  setTimeout(e, 1);
}
var oj = function(t) {
  return t && "current" in t ? t.current : t;
}, lb = function() {
  return document && document.activeElement === document.body;
}, sj = function() {
  return lb() || VM();
}, yo = null, zt = null, Mp = function() {
  return null;
}, bo = null, Ts = !1, Ju = !1, ij = function() {
  return !0;
}, aj = function(t) {
  return (yo.whiteList || ij)(t);
}, cj = function(t, n) {
  bo = {
    observerNode: t,
    portaledElement: n
  };
}, lj = function(t) {
  return bo && bo.portaledElement === t;
};
function jp(e, t, n, r) {
  var o = null, s = e;
  do {
    var i = r[s];
    if (i.guard)
      i.node.dataset.focusAutoGuard && (o = i);
    else if (i.lockItem) {
      if (s !== e)
        return;
      o = null;
    } else
      break;
  } while ((s += n) !== t);
  o && (o.node.tabIndex = 0);
}
var uj = function(t) {
  return t ? !!Ts : Ts === "meanwhile";
}, dj = function e(t, n, r) {
  return n && (n.host === t && (!n.activeElement || r.contains(n.activeElement)) || n.parentNode && e(t, n.parentNode, r));
}, fj = function(t, n) {
  return n.some(function(r) {
    return dj(t, r, r);
  });
}, ub = function(t) {
  return Cs(t, /* @__PURE__ */ new Map());
}, pj = function(t) {
  return !ub([t.parentNode]).some(function(n) {
    return n.node === t;
  });
}, ta = function() {
  var t = !1;
  if (yo) {
    var n = yo, r = n.observed, o = n.persistentFocus, s = n.autoFocus, i = n.shards, a = n.crossFrame, c = n.focusOptions, l = n.noFocusGuards, u = r || bo && bo.portaledElement;
    if (lb() && zt && zt !== document.body && (!document.body.contains(zt) || pj(zt))) {
      var d = Mp();
      d && d.focus();
    }
    var f = document && document.activeElement;
    if (u) {
      var p = [u].concat(i.map(oj).filter(Boolean)), m = function() {
        if (!uj(a) || !l || !zt || Ju)
          return !1;
        var v = ub(p), k = v.findIndex(function(w) {
          var _ = w.node;
          return _ === zt;
        });
        return k === 0 || k === v.length - 1;
      };
      if ((!f || aj(f)) && (o || m() || !sj() || !zt && s) && (u && !(rb(p) || f && fj(f, p) || lj(f)) && (document && !zt && f && !s ? (f.blur && f.blur(), document.body.focus()) : (t = sb(p, zt, {
        focusOptions: c
      }), bo = {})), zt = document && document.activeElement, zt !== document.body && (Mp = ib(zt)), Ts = !1), document && f !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
        var g = document && document.activeElement, y = KM(p), S = y.map(function(b) {
          var v = b.node;
          return v;
        }).indexOf(g);
        S > -1 && (y.filter(function(b) {
          var v = b.guard, k = b.node;
          return v && k.dataset.focusAutoGuard;
        }).forEach(function(b) {
          var v = b.node;
          return v.removeAttribute("tabIndex");
        }), jp(S, y.length, 1, y), jp(S, -1, -1, y));
      }
    }
  }
  return t;
}, db = function(t) {
  ta() && t && (t.stopPropagation(), t.preventDefault());
}, Qu = function() {
  return Zu(ta);
}, hj = function(t) {
  var n = t.target, r = t.currentTarget;
  r.contains(n) || cj(r, n);
}, mj = function() {
  return null;
};
process.env.NODE_ENV !== "production" && jy.node.isRequired;
var fb = function() {
  Ju = !0;
}, pb = function() {
  Ju = !1, Ts = "just", Zu(function() {
    Ts = "meanwhile";
  });
}, gj = function() {
  document.addEventListener("focusin", db), document.addEventListener("focusout", Qu), window.addEventListener("focus", fb), window.addEventListener("blur", pb);
}, yj = function() {
  document.removeEventListener("focusin", db), document.removeEventListener("focusout", Qu), window.removeEventListener("focus", fb), window.removeEventListener("blur", pb);
};
function bj(e) {
  return e.filter(function(t) {
    var n = t.disabled;
    return !n;
  });
}
var hb = {
  moveFocusInside: sb,
  focusInside: rb,
  focusNextElement: ej,
  focusPrevElement: tj,
  focusFirstElement: nj,
  focusLastElement: rj,
  captureFocusRestore: ib
};
function vj(e) {
  var t = e.slice(-1)[0];
  t && !yo && gj();
  var n = yo, r = n && t && t.id === n.id;
  yo = t, n && !r && (n.onDeactivation(), e.filter(function(o) {
    var s = o.id;
    return s === n.id;
  }).length || n.returnFocus(!t)), t ? (zt = null, (!r || n.observed !== t.observed) && t.onActivation(hb), ta(), Zu(ta)) : (yj(), zt = null);
}
Wy.assignSyncMedium(hj);
Hy.assignMedium(Qu);
pM.assignMedium(function(e) {
  return e(hb);
});
const xj = SM(bj, vj)(mj);
var mb = /* @__PURE__ */ vn(function(t, n) {
  return /* @__PURE__ */ Yt.createElement(Gy, ks({
    sideCar: xj,
    ref: n
  }, t));
}), gb = Gy.propTypes || {};
gb.sideCar;
var Sj = ZN(gb, ["sideCar"]);
mb.propTypes = process.env.NODE_ENV !== "production" ? Sj : {};
const Dp = mb, wj = Dp.default ?? Dp, yb = (e) => {
  const {
    initialFocusRef: t,
    finalFocusRef: n,
    contentRef: r,
    restoreFocus: o,
    children: s,
    isDisabled: i,
    autoFocus: a,
    persistentFocus: c,
    lockFocusAcrossFrames: l
  } = e, u = R(() => {
    t != null && t.current ? t.current.focus() : r != null && r.current && Dh(r.current).length === 0 && requestAnimationFrame(() => {
      var m;
      (m = r.current) == null || m.focus();
    });
  }, [t, r]), d = R(() => {
    var p;
    (p = n == null ? void 0 : n.current) == null || p.focus();
  }, [n]), f = o && !n;
  return /* @__PURE__ */ h.jsx(
    wj,
    {
      crossFrame: l,
      persistentFocus: c,
      autoFocus: a,
      disabled: i,
      onActivation: u,
      onDeactivation: d,
      returnFocus: f,
      children: s
    }
  );
};
yb.displayName = "FocusLock";
const [kj, Pj] = Ee({
  name: "FormErrorStylesContext",
  errorMessage: `useFormErrorStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormError />" `
}), Cj = M(
  (e, t) => {
    const n = Je("FormError", e), r = Ae(e), o = Br();
    return o != null && o.isInvalid ? /* @__PURE__ */ h.jsx(kj, { value: n, children: /* @__PURE__ */ h.jsx(
      E.div,
      {
        ...o == null ? void 0 : o.getErrorMessageProps(r, t),
        className: W("chakra-form__error-message", e.className),
        __css: {
          display: "flex",
          alignItems: "center",
          ...n.text
        }
      }
    ) }) : null;
  }
);
Cj.displayName = "FormErrorMessage";
const _j = M((e, t) => {
  const n = Pj(), r = Br();
  if (!(r != null && r.isInvalid))
    return null;
  const o = W("chakra-form__error-icon", e.className);
  return /* @__PURE__ */ h.jsx(
    $t,
    {
      ref: t,
      "aria-hidden": !0,
      ...e,
      __css: n.icon,
      className: o,
      children: /* @__PURE__ */ h.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
        }
      )
    }
  );
});
_j.displayName = "FormErrorIcon";
const Tj = M(
  function(t, n) {
    const r = Ct("FormLabel", t), o = Ae(t), {
      className: s,
      children: i,
      requiredIndicator: a = /* @__PURE__ */ h.jsx(bb, {}),
      optionalIndicator: c = null,
      ...l
    } = o, u = Br(), d = (u == null ? void 0 : u.getLabelProps(l, n)) ?? { ref: n, ...l };
    return /* @__PURE__ */ h.jsxs(
      E.label,
      {
        ...d,
        className: W("chakra-form__label", o.className),
        __css: {
          display: "block",
          textAlign: "start",
          ...r
        },
        children: [
          i,
          u != null && u.isRequired ? a : c
        ]
      }
    );
  }
);
Tj.displayName = "FormLabel";
const bb = M(
  function(t, n) {
    const r = Br(), o = Ay();
    if (!(r != null && r.isRequired))
      return null;
    const s = W("chakra-form__required-indicator", t.className);
    return /* @__PURE__ */ h.jsx(
      E.span,
      {
        ...r == null ? void 0 : r.getRequiredIndicatorProps(t, n),
        __css: o.requiredIndicator,
        className: s
      }
    );
  }
);
bb.displayName = "RequiredIndicator";
const vb = M(function(t, n) {
  const {
    templateAreas: r,
    gap: o,
    rowGap: s,
    columnGap: i,
    column: a,
    row: c,
    autoFlow: l,
    autoRows: u,
    templateRows: d,
    autoColumns: f,
    templateColumns: p,
    ...m
  } = t, g = {
    display: "grid",
    gridTemplateAreas: r,
    gridGap: o,
    gridRowGap: s,
    gridColumnGap: i,
    gridAutoColumns: f,
    gridColumn: a,
    gridRow: c,
    gridAutoFlow: l,
    gridAutoRows: u,
    gridTemplateRows: d,
    gridTemplateColumns: p
  };
  return /* @__PURE__ */ h.jsx(E.div, { ref: n, __css: g, ...m });
});
vb.displayName = "Grid";
function Op(e) {
  return Cn(
    e,
    (t) => t === "auto" ? "auto" : `span ${t}/span ${t}`
  );
}
const Ej = M(
  function(t, n) {
    const {
      area: r,
      colSpan: o,
      colStart: s,
      colEnd: i,
      rowEnd: a,
      rowSpan: c,
      rowStart: l,
      ...u
    } = t, d = Io({
      gridArea: r,
      gridColumn: Op(o),
      gridRow: Op(c),
      gridColumnStart: s,
      gridColumnEnd: i,
      gridRowStart: l,
      gridRowEnd: a
    });
    return /* @__PURE__ */ h.jsx(E.div, { ref: n, __css: d, ...u });
  }
);
Ej.displayName = "GridItem";
const Aj = M(
  function(t, n) {
    const { columns: r, spacingX: o, spacingY: s, spacing: i, minChildWidth: a, ...c } = t, l = fn(), u = a ? Rj(a, l) : $j(r);
    return /* @__PURE__ */ h.jsx(
      vb,
      {
        ref: n,
        gap: i,
        columnGap: o,
        rowGap: s,
        templateColumns: u,
        ...c
      }
    );
  }
);
Aj.displayName = "SimpleGrid";
function Ij(e) {
  return typeof e == "number" ? `${e}px` : e;
}
function Rj(e, t) {
  return Cn(e, (n) => {
    const r = ay("sizes", n, Ij(n))(t);
    return n === null ? null : `repeat(auto-fit, minmax(${r}, 1fr))`;
  });
}
function $j(e) {
  return Cn(
    e,
    (t) => t === null ? null : `repeat(${t}, minmax(0, 1fr))`
  );
}
const Nj = M(function(t, n) {
  const r = Ct("Mark", t), o = Ae(t);
  return /* @__PURE__ */ h.jsx(
    Nu,
    {
      ref: n,
      ...o,
      as: "mark",
      __css: { bg: "transparent", whiteSpace: "nowrap", ...r }
    }
  );
}), Mj = (e) => e.replace(/[|\\{}()[\]^$+*?.-]/g, (t) => `\\${t}`);
function jj(e) {
  const t = e.filter((n) => n.length !== 0).map((n) => Mj(n.trim()));
  return t.length ? new RegExp(`(${t.join("|")})`, "ig") : null;
}
function Dj({ text: e, query: t }) {
  const n = jj(Array.isArray(t) ? t : [t]);
  return n ? e.split(n).filter(Boolean).map((o) => ({ text: o, match: n.test(o) })) : [{ text: e, match: !1 }];
}
function Oj(e) {
  const { text: t, query: n } = e;
  return _e(() => Dj({ text: t, query: n }), [t, n]);
}
function RL(e) {
  const { children: t, query: n, styles: r } = e;
  if (typeof t != "string")
    throw new Error("The children prop of Highlight must be a string");
  const o = Oj({ query: n, text: t });
  return /* @__PURE__ */ h.jsx(h.Fragment, { children: o.map((s, i) => s.match ? /* @__PURE__ */ h.jsx(Nj, { sx: r, children: s.text }, i) : /* @__PURE__ */ h.jsx(Ul, { children: s.text }, i)) });
}
function $L(e) {
  const {
    viewBox: t = "0 0 24 24",
    d: n,
    displayName: r,
    defaultProps: o = {}
  } = e, s = $n.toArray(e.path), i = M((a, c) => /* @__PURE__ */ h.jsx($t, { ref: c, viewBox: t, ...o, ...a, children: s.length ? s : /* @__PURE__ */ h.jsx("path", { fill: "currentColor", d: n }) }));
  return i.displayName = r, i;
}
const na = M(function(t, n) {
  const { htmlWidth: r, htmlHeight: o, alt: s, ...i } = t;
  return /* @__PURE__ */ h.jsx("img", { width: r, height: o, ref: n, alt: s, ...i });
});
na.displayName = "NativeImage";
const Fj = M(function(t, n) {
  const {
    fallbackSrc: r,
    fallback: o,
    src: s,
    srcSet: i,
    align: a,
    fit: c,
    loading: l,
    ignoreFallback: u,
    crossOrigin: d,
    fallbackStrategy: f = "beforeLoadOrError",
    referrerPolicy: p,
    ...m
  } = t, g = r !== void 0 || o !== void 0, y = l != null || // use can opt out of fallback image
  u || // if the user doesn't provide any kind of fallback we should ignore it
  !g, S = wy({
    ...t,
    crossOrigin: d,
    ignoreFallback: y
  }), b = O$(S, f), v = {
    ref: n,
    objectFit: c,
    objectPosition: a,
    ...y ? m : Rs(m, ["onError", "onLoad"])
  };
  return b ? o || /* @__PURE__ */ h.jsx(
    E.img,
    {
      as: na,
      className: "chakra-image__placeholder",
      src: r,
      ...v
    }
  ) : /* @__PURE__ */ h.jsx(
    E.img,
    {
      as: na,
      src: s,
      srcSet: i,
      crossOrigin: d,
      loading: l,
      referrerPolicy: p,
      className: "chakra-image",
      ...v
    }
  );
});
Fj.displayName = "Image";
const NL = M((e, t) => /* @__PURE__ */ h.jsx(E.img, { ref: t, as: na, className: "chakra-image", ...e })), ML = M(
  function(t, n) {
    const {
      offsetX: r,
      offsetY: o,
      offset: s = "0",
      placement: i = "top-end",
      ...a
    } = t, c = _e(
      () => ({
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        insetBlockStart: Cn(i, (l) => {
          const [u] = l.split("-");
          return {
            top: o ?? s,
            middle: "50%",
            bottom: "auto"
          }[u];
        }),
        insetBlockEnd: Cn(i, (l) => {
          const [u] = l.split("-");
          return {
            top: "auto",
            middle: "50%",
            bottom: o ?? s
          }[u];
        }),
        insetStart: Cn(i, (l) => {
          const [, u] = l.split("-");
          return {
            start: r ?? s,
            center: "50%",
            end: "auto"
          }[u];
        }),
        insetEnd: Cn(i, (l) => {
          const [, u] = l.split("-");
          return {
            start: "auto",
            center: "50%",
            end: r ?? s
          }[u];
        }),
        translate: Cn(i, (l) => {
          const [u, d] = l.split("-"), f = { start: "-50%", center: "-50%", end: "50%" }, p = { top: "-50%", middle: "-50%", bottom: "50%" };
          return `${f[d]} ${p[u]}`;
        })
      }),
      [s, r, o, i]
    );
    return /* @__PURE__ */ h.jsx(E.div, { ref: n, __css: c, ...a });
  }
), xb = M(
  function(t, n) {
    const { htmlSize: r, ...o } = t, s = Je("Input", o), i = Ae(o), a = Ou(i), c = W("chakra-input", t.className);
    return /* @__PURE__ */ h.jsx(
      E.input,
      {
        size: r,
        ...a,
        __css: s.field,
        ref: n,
        className: c
      }
    );
  }
);
xb.displayName = "Input";
xb.id = "Input";
const [Bj, Sb] = Ee({
  name: "InputGroupStylesContext",
  errorMessage: `useInputGroupStyles returned is 'undefined'. Seems you forgot to wrap the components in "<InputGroup />" `
}), Lj = M(
  function(t, n) {
    const r = Je("Input", t), { children: o, className: s, ...i } = Ae(t), a = W("chakra-input__group", s), c = {}, l = Yn(o), u = r.field;
    l.forEach((f) => {
      r && (u && f.type.id === "InputLeftElement" && (c.paddingStart = u.height ?? u.h), u && f.type.id === "InputRightElement" && (c.paddingEnd = u.height ?? u.h), f.type.id === "InputRightAddon" && (c.borderEndRadius = 0), f.type.id === "InputLeftAddon" && (c.borderStartRadius = 0));
    });
    const d = l.map((f) => {
      var m, g;
      const p = Io({
        size: ((m = f.props) == null ? void 0 : m.size) || t.size,
        variant: ((g = f.props) == null ? void 0 : g.variant) || t.variant
      });
      return f.type.id !== "Input" ? kt(f, p) : kt(f, Object.assign(p, c, f.props));
    });
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        className: a,
        ref: n,
        __css: {
          width: "100%",
          display: "flex",
          position: "relative",
          // Parts of inputs override z-index to ensure that they stack correctly on each other
          // Create a new stacking context so that these overrides don't leak out and conflict with other z-indexes
          isolation: "isolate",
          ...r.group
        },
        "data-group": !0,
        ...i,
        children: /* @__PURE__ */ h.jsx(Bj, { value: r, children: d })
      }
    );
  }
);
Lj.displayName = "InputGroup";
const Vj = {
  left: {
    marginEnd: "-1px",
    borderEndRadius: 0,
    borderEndColor: "transparent"
  },
  right: {
    marginStart: "-1px",
    borderStartRadius: 0,
    borderStartColor: "transparent"
  }
}, zj = E("div", {
  baseStyle: {
    flex: "0 0 auto",
    width: "auto",
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap"
  }
}), ed = M(
  function(t, n) {
    const { placement: r = "left", ...o } = t, s = Vj[r] ?? {}, i = Sb();
    return /* @__PURE__ */ h.jsx(
      zj,
      {
        ref: n,
        ...o,
        __css: {
          ...i.addon,
          ...s
        }
      }
    );
  }
);
ed.displayName = "InputAddon";
const wb = M(
  function(t, n) {
    return /* @__PURE__ */ h.jsx(
      ed,
      {
        ref: n,
        placement: "left",
        ...t,
        className: W("chakra-input__left-addon", t.className)
      }
    );
  }
);
wb.displayName = "InputLeftAddon";
wb.id = "InputLeftAddon";
const kb = M(
  function(t, n) {
    return /* @__PURE__ */ h.jsx(
      ed,
      {
        ref: n,
        placement: "right",
        ...t,
        className: W("chakra-input__right-addon", t.className)
      }
    );
  }
);
kb.displayName = "InputRightAddon";
kb.id = "InputRightAddon";
const Wj = E("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "0",
    zIndex: 2
  }
}), _a = M(
  function(t, n) {
    const { placement: r = "left", ...o } = t, s = Sb(), i = s.field, c = {
      [r === "left" ? "insetStart" : "insetEnd"]: "0",
      width: (i == null ? void 0 : i.height) ?? (i == null ? void 0 : i.h),
      height: (i == null ? void 0 : i.height) ?? (i == null ? void 0 : i.h),
      fontSize: i == null ? void 0 : i.fontSize,
      ...s.element
    };
    return /* @__PURE__ */ h.jsx(Wj, { ref: n, __css: c, ...o });
  }
);
_a.id = "InputElement";
_a.displayName = "InputElement";
const Pb = M(
  function(t, n) {
    const { className: r, ...o } = t, s = W("chakra-input__left-element", r);
    return /* @__PURE__ */ h.jsx(
      _a,
      {
        ref: n,
        placement: "left",
        className: s,
        ...o
      }
    );
  }
);
Pb.id = "InputLeftElement";
Pb.displayName = "InputLeftElement";
const Cb = M(
  function(t, n) {
    const { className: r, ...o } = t, s = W("chakra-input__right-element", r);
    return /* @__PURE__ */ h.jsx(
      _a,
      {
        ref: n,
        placement: "right",
        className: s,
        ...o
      }
    );
  }
);
Cb.id = "InputRightElement";
Cb.displayName = "InputRightElement";
const Hj = M(function(t, n) {
  const r = Ct("Kbd", t), { className: o, ...s } = Ae(t);
  return /* @__PURE__ */ h.jsx(
    E.kbd,
    {
      ref: n,
      className: W("chakra-kbd", o),
      ...s,
      __css: {
        fontFamily: "mono",
        ...r
      }
    }
  );
});
Hj.displayName = "Kbd";
const Uj = M(function(t, n) {
  const r = Ct("Link", t), { className: o, isExternal: s, ...i } = Ae(t);
  return /* @__PURE__ */ h.jsx(
    E.a,
    {
      target: s ? "_blank" : void 0,
      rel: s ? "noopener" : void 0,
      ref: n,
      className: W("chakra-link", o),
      ...i,
      __css: r
    }
  );
});
Uj.displayName = "Link";
const jL = M(
  function(t, n) {
    const { isExternal: r, target: o, rel: s, className: i, ...a } = t;
    return /* @__PURE__ */ h.jsx(
      E.a,
      {
        ...a,
        ref: n,
        className: W("chakra-linkbox__overlay", i),
        rel: r ? "noopener noreferrer" : s,
        target: r ? "_blank" : o,
        __css: {
          position: "static",
          "&::before": {
            content: "''",
            cursor: "inherit",
            display: "block",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 0,
            width: "100%",
            height: "100%"
          }
        }
      }
    );
  }
), DL = M(
  function(t, n) {
    const { className: r, ...o } = t;
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ref: n,
        position: "relative",
        ...o,
        className: W("chakra-linkbox", r),
        __css: {
          /* Elevate the links and abbreviations up */
          "a[href]:not(.chakra-linkbox__overlay), abbr[title]": {
            position: "relative",
            zIndex: 1
          }
        }
      }
    );
  }
), [Gj, _b] = Ee({
  name: "ListStylesContext",
  errorMessage: `useListStyles returned is 'undefined'. Seems you forgot to wrap the components in "<List />" `
}), td = M(function(t, n) {
  const r = Je("List", t), {
    children: o,
    styleType: s = "none",
    stylePosition: i,
    spacing: a,
    ...c
  } = Ae(t), l = Yn(o), d = a ? { ["& > *:not(style) ~ *:not(style)"]: { mt: a } } : {};
  return /* @__PURE__ */ h.jsx(Gj, { value: r, children: /* @__PURE__ */ h.jsx(
    E.ul,
    {
      ref: n,
      listStyleType: s,
      listStylePosition: i,
      role: "list",
      __css: { ...r.container, ...d },
      ...c,
      children: l
    }
  ) });
});
td.displayName = "List";
const qj = M((e, t) => {
  const { as: n, ...r } = e;
  return /* @__PURE__ */ h.jsx(td, { ref: t, as: "ol", styleType: "decimal", marginStart: "1em", ...r });
});
qj.displayName = "OrderedList";
const Kj = M(
  function(t, n) {
    const { as: r, ...o } = t;
    return /* @__PURE__ */ h.jsx(td, { ref: n, as: "ul", styleType: "initial", marginStart: "1em", ...o });
  }
);
Kj.displayName = "UnorderedList";
const Yj = M(
  function(t, n) {
    const r = _b();
    return /* @__PURE__ */ h.jsx(E.li, { ref: n, ...t, __css: r.item });
  }
);
Yj.displayName = "ListItem";
const Xj = M(
  function(t, n) {
    const r = _b();
    return /* @__PURE__ */ h.jsx($t, { ref: n, role: "presentation", ...t, __css: r.icon });
  }
);
Xj.displayName = "ListIcon";
const Fp = (e, t) => {
  var n;
  return ((n = e == null ? void 0 : e.breakpoints) == null ? void 0 : n[t]) ?? t;
};
function Tb(e) {
  const { breakpoint: t = "", below: n, above: r } = e, o = fn(), s = Fp(o, n), i = Fp(o, r);
  let a = t;
  return s ? a = `(max-width: ${s})` : i && (a = `(min-width: ${i})`), a;
}
function Ta(e, t = {}) {
  const { ssr: n = !0, fallback: r } = t, { getWindow: o } = cT(), s = Array.isArray(e) ? e : [e];
  let i = Array.isArray(r) ? r : [r];
  i = i.filter((l) => l != null);
  const [a, c] = he(() => s.map((l, u) => ({
    media: l,
    matches: n ? !!i[u] : o().matchMedia(l).matches
  })));
  return xe(() => {
    const l = o();
    c(
      s.map((f) => ({
        media: f,
        matches: l.matchMedia(f).matches
      }))
    );
    const u = s.map((f) => l.matchMedia(f)), d = (f) => {
      c((p) => p.slice().map((m) => m.media === f.media ? { ...m, matches: f.matches } : m));
    };
    return u.forEach((f) => {
      typeof f.addListener == "function" ? f.addListener(d) : f.addEventListener("change", d);
    }), () => {
      u.forEach((f) => {
        typeof f.removeListener == "function" ? f.removeListener(d) : f.removeEventListener("change", d);
      });
    };
  }, [o]), a.map((l) => l.matches);
}
function Eb(e) {
  const { breakpoint: t, hide: n, children: r, ssr: o } = e, [s] = Ta(t, { ssr: o });
  return (n ? !s : s) ? r : null;
}
function Zj(e) {
  const { children: t, ssr: n } = e, r = Tb(e);
  return /* @__PURE__ */ h.jsx(Eb, { breakpoint: r, hide: !0, ssr: n, children: t });
}
Zj.displayName = "Hide";
function OL(e) {
  const [t] = Ta(
    "(prefers-reduced-motion: reduce)",
    e
  );
  return t;
}
function FL(e) {
  const [t, n] = Ta(
    ["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"],
    e
  );
  if (t)
    return "light";
  if (n)
    return "dark";
}
function Jj(e) {
  const { children: t, ssr: n } = e, r = Tb(e);
  return /* @__PURE__ */ h.jsx(Eb, { breakpoint: r, ssr: n, children: t });
}
Jj.displayName = "Show";
function Qj(e) {
  var a;
  const t = lt(e) ? e : { fallback: e ?? "base" }, r = fn().__breakpoints.details.map(
    ({ minMaxQuery: c, breakpoint: l }) => ({
      breakpoint: l,
      query: c.replace("@media screen and ", "")
    })
  ), o = r.map((c) => c.breakpoint === t.fallback), i = Ta(
    r.map((c) => c.query),
    { fallback: o, ssr: t.ssr }
  ).findIndex((c) => c == !0);
  return ((a = r[i]) == null ? void 0 : a.breakpoint) ?? t.fallback;
}
function eD(e, t, n = Lh) {
  let r = Object.keys(e).indexOf(t);
  if (r !== -1)
    return e[t];
  let o = n.indexOf(t);
  for (; o >= 0; ) {
    const s = n[o];
    if (e.hasOwnProperty(s)) {
      r = o;
      break;
    }
    o -= 1;
  }
  if (r !== -1) {
    const s = n[r];
    return e[s];
  }
}
function tD(e, t) {
  var a;
  const n = lt(t) ? t : { fallback: t ?? "base" }, r = Qj(n), o = fn();
  if (!r)
    return;
  const s = Array.from(((a = o.__breakpoints) == null ? void 0 : a.keys) || []), i = Array.isArray(e) ? Object.fromEntries(
    Object.entries(F0(e, s)).map(
      ([c, l]) => [c, l]
    )
  ) : e;
  return eD(i, r, s);
}
function nD(e, t, n, r) {
  if (t == null)
    return r;
  if (!r)
    return e.find(
      (i) => n(i).toLowerCase().startsWith(t.toLowerCase())
    );
  const o = e.filter(
    (s) => n(s).toLowerCase().startsWith(t.toLowerCase())
  );
  if (o.length > 0) {
    let s;
    return o.includes(r) ? (s = o.indexOf(r) + 1, s === o.length && (s = 0), o[s]) : (s = e.indexOf(o[0]), e[s]);
  }
  return r;
}
function rD(e) {
  const { key: t } = e;
  return t.length === 1 || t.length > 1 && /[^a-zA-Z0-9]/.test(t);
}
function oD(e = {}) {
  const { timeout: t = 300, preventDefault: n = () => !0 } = e, [r, o] = he([]), s = ae(void 0), i = () => {
    s.current && (clearTimeout(s.current), s.current = null);
  }, a = () => {
    i(), s.current = setTimeout(() => {
      o([]), s.current = null;
    }, t);
  };
  xe(() => i, []);
  function c(l) {
    return (u) => {
      if (u.key === "Backspace") {
        const d = [...r];
        d.pop(), o(d);
        return;
      }
      if (rD(u)) {
        const d = r.concat(u.key);
        n(u) && (u.preventDefault(), u.stopPropagation()), o(d), l(d.join("")), a();
      }
    };
  }
  return c;
}
var Ht = "top", un = "bottom", dn = "right", Ut = "left", nd = "auto", Hs = [Ht, un, dn, Ut], _o = "start", Es = "end", sD = "clippingParents", Ab = "viewport", Ko = "popper", iD = "reference", Bp = /* @__PURE__ */ Hs.reduce(function(e, t) {
  return e.concat([t + "-" + _o, t + "-" + Es]);
}, []), Ib = /* @__PURE__ */ [].concat(Hs, [nd]).reduce(function(e, t) {
  return e.concat([t, t + "-" + _o, t + "-" + Es]);
}, []), aD = "beforeRead", cD = "read", lD = "afterRead", uD = "beforeMain", dD = "main", fD = "afterMain", pD = "beforeWrite", hD = "write", mD = "afterWrite", gD = [aD, cD, lD, uD, dD, fD, pD, hD, mD];
function Rn(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Jt(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Dr(e) {
  var t = Jt(e).Element;
  return e instanceof t || e instanceof Element;
}
function cn(e) {
  var t = Jt(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function rd(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Jt(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function yD(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, o = t.attributes[n] || {}, s = t.elements[n];
    !cn(s) || !Rn(s) || (Object.assign(s.style, r), Object.keys(o).forEach(function(i) {
      var a = o[i];
      a === !1 ? s.removeAttribute(i) : s.setAttribute(i, a === !0 ? "" : a);
    }));
  });
}
function bD(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var o = t.elements[r], s = t.attributes[r] || {}, i = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), a = i.reduce(function(c, l) {
        return c[l] = "", c;
      }, {});
      !cn(o) || !Rn(o) || (Object.assign(o.style, a), Object.keys(s).forEach(function(c) {
        o.removeAttribute(c);
      }));
    });
  };
}
const vD = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: yD,
  effect: bD,
  requires: ["computeStyles"]
};
function In(e) {
  return e.split("-")[0];
}
var $r = Math.max, ra = Math.min, To = Math.round;
function jl() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Rb() {
  return !/^((?!chrome|android).)*safari/i.test(jl());
}
function Eo(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), o = 1, s = 1;
  t && cn(e) && (o = e.offsetWidth > 0 && To(r.width) / e.offsetWidth || 1, s = e.offsetHeight > 0 && To(r.height) / e.offsetHeight || 1);
  var i = Dr(e) ? Jt(e) : window, a = i.visualViewport, c = !Rb() && n, l = (r.left + (c && a ? a.offsetLeft : 0)) / o, u = (r.top + (c && a ? a.offsetTop : 0)) / s, d = r.width / o, f = r.height / s;
  return {
    width: d,
    height: f,
    top: u,
    right: l + d,
    bottom: u + f,
    left: l,
    x: l,
    y: u
  };
}
function od(e) {
  var t = Eo(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function $b(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && rd(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Kn(e) {
  return Jt(e).getComputedStyle(e);
}
function xD(e) {
  return ["table", "td", "th"].indexOf(Rn(e)) >= 0;
}
function hr(e) {
  return ((Dr(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Ea(e) {
  return Rn(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (rd(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    hr(e)
  );
}
function Lp(e) {
  return !cn(e) || // https://github.com/popperjs/popper-core/issues/837
  Kn(e).position === "fixed" ? null : e.offsetParent;
}
function SD(e) {
  var t = /firefox/i.test(jl()), n = /Trident/i.test(jl());
  if (n && cn(e)) {
    var r = Kn(e);
    if (r.position === "fixed")
      return null;
  }
  var o = Ea(e);
  for (rd(o) && (o = o.host); cn(o) && ["html", "body"].indexOf(Rn(o)) < 0; ) {
    var s = Kn(o);
    if (s.transform !== "none" || s.perspective !== "none" || s.contain === "paint" || ["transform", "perspective"].indexOf(s.willChange) !== -1 || t && s.willChange === "filter" || t && s.filter && s.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Us(e) {
  for (var t = Jt(e), n = Lp(e); n && xD(n) && Kn(n).position === "static"; )
    n = Lp(n);
  return n && (Rn(n) === "html" || Rn(n) === "body" && Kn(n).position === "static") ? t : n || SD(e) || t;
}
function sd(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function hs(e, t, n) {
  return $r(e, ra(t, n));
}
function wD(e, t, n) {
  var r = hs(e, t, n);
  return r > n ? n : r;
}
function Nb() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Mb(e) {
  return Object.assign({}, Nb(), e);
}
function jb(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var kD = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, Mb(typeof t != "number" ? t : jb(t, Hs));
};
function PD(e) {
  var t, n = e.state, r = e.name, o = e.options, s = n.elements.arrow, i = n.modifiersData.popperOffsets, a = In(n.placement), c = sd(a), l = [Ut, dn].indexOf(a) >= 0, u = l ? "height" : "width";
  if (!(!s || !i)) {
    var d = kD(o.padding, n), f = od(s), p = c === "y" ? Ht : Ut, m = c === "y" ? un : dn, g = n.rects.reference[u] + n.rects.reference[c] - i[c] - n.rects.popper[u], y = i[c] - n.rects.reference[c], S = Us(s), b = S ? c === "y" ? S.clientHeight || 0 : S.clientWidth || 0 : 0, v = g / 2 - y / 2, k = d[p], w = b - f[u] - d[m], _ = b / 2 - f[u] / 2 + v, C = hs(k, _, w), I = c;
    n.modifiersData[r] = (t = {}, t[I] = C, t.centerOffset = C - _, t);
  }
}
function CD(e) {
  var t = e.state, n = e.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || $b(t.elements.popper, o) && (t.elements.arrow = o));
}
const _D = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: PD,
  effect: CD,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Ao(e) {
  return e.split("-")[1];
}
var TD = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function ED(e, t) {
  var n = e.x, r = e.y, o = t.devicePixelRatio || 1;
  return {
    x: To(n * o) / o || 0,
    y: To(r * o) / o || 0
  };
}
function Vp(e) {
  var t, n = e.popper, r = e.popperRect, o = e.placement, s = e.variation, i = e.offsets, a = e.position, c = e.gpuAcceleration, l = e.adaptive, u = e.roundOffsets, d = e.isFixed, f = i.x, p = f === void 0 ? 0 : f, m = i.y, g = m === void 0 ? 0 : m, y = typeof u == "function" ? u({
    x: p,
    y: g
  }) : {
    x: p,
    y: g
  };
  p = y.x, g = y.y;
  var S = i.hasOwnProperty("x"), b = i.hasOwnProperty("y"), v = Ut, k = Ht, w = window;
  if (l) {
    var _ = Us(n), C = "clientHeight", I = "clientWidth";
    if (_ === Jt(n) && (_ = hr(n), Kn(_).position !== "static" && a === "absolute" && (C = "scrollHeight", I = "scrollWidth")), _ = _, o === Ht || (o === Ut || o === dn) && s === Es) {
      k = un;
      var $ = d && _ === w && w.visualViewport ? w.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        _[C]
      );
      g -= $ - r.height, g *= c ? 1 : -1;
    }
    if (o === Ut || (o === Ht || o === un) && s === Es) {
      v = dn;
      var N = d && _ === w && w.visualViewport ? w.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        _[I]
      );
      p -= N - r.width, p *= c ? 1 : -1;
    }
  }
  var z = Object.assign({
    position: a
  }, l && TD), Q = u === !0 ? ED({
    x: p,
    y: g
  }, Jt(n)) : {
    x: p,
    y: g
  };
  if (p = Q.x, g = Q.y, c) {
    var U;
    return Object.assign({}, z, (U = {}, U[k] = b ? "0" : "", U[v] = S ? "0" : "", U.transform = (w.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + g + "px)" : "translate3d(" + p + "px, " + g + "px, 0)", U));
  }
  return Object.assign({}, z, (t = {}, t[k] = b ? g + "px" : "", t[v] = S ? p + "px" : "", t.transform = "", t));
}
function AD(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, s = n.adaptive, i = s === void 0 ? !0 : s, a = n.roundOffsets, c = a === void 0 ? !0 : a, l = {
    placement: In(t.placement),
    variation: Ao(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Vp(Object.assign({}, l, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: i,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Vp(Object.assign({}, l, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const ID = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: AD,
  data: {}
};
var yi = {
  passive: !0
};
function RD(e) {
  var t = e.state, n = e.instance, r = e.options, o = r.scroll, s = o === void 0 ? !0 : o, i = r.resize, a = i === void 0 ? !0 : i, c = Jt(t.elements.popper), l = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return s && l.forEach(function(u) {
    u.addEventListener("scroll", n.update, yi);
  }), a && c.addEventListener("resize", n.update, yi), function() {
    s && l.forEach(function(u) {
      u.removeEventListener("scroll", n.update, yi);
    }), a && c.removeEventListener("resize", n.update, yi);
  };
}
const $D = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: RD,
  data: {}
};
var ND = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Di(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return ND[t];
  });
}
var MD = {
  start: "end",
  end: "start"
};
function zp(e) {
  return e.replace(/start|end/g, function(t) {
    return MD[t];
  });
}
function id(e) {
  var t = Jt(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function ad(e) {
  return Eo(hr(e)).left + id(e).scrollLeft;
}
function jD(e, t) {
  var n = Jt(e), r = hr(e), o = n.visualViewport, s = r.clientWidth, i = r.clientHeight, a = 0, c = 0;
  if (o) {
    s = o.width, i = o.height;
    var l = Rb();
    (l || !l && t === "fixed") && (a = o.offsetLeft, c = o.offsetTop);
  }
  return {
    width: s,
    height: i,
    x: a + ad(e),
    y: c
  };
}
function DD(e) {
  var t, n = hr(e), r = id(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, s = $r(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), i = $r(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), a = -r.scrollLeft + ad(e), c = -r.scrollTop;
  return Kn(o || n).direction === "rtl" && (a += $r(n.clientWidth, o ? o.clientWidth : 0) - s), {
    width: s,
    height: i,
    x: a,
    y: c
  };
}
function cd(e) {
  var t = Kn(e), n = t.overflow, r = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function Db(e) {
  return ["html", "body", "#document"].indexOf(Rn(e)) >= 0 ? e.ownerDocument.body : cn(e) && cd(e) ? e : Db(Ea(e));
}
function ms(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = Db(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), s = Jt(r), i = o ? [s].concat(s.visualViewport || [], cd(r) ? r : []) : r, a = t.concat(i);
  return o ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(ms(Ea(i)))
  );
}
function Dl(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function OD(e, t) {
  var n = Eo(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Wp(e, t, n) {
  return t === Ab ? Dl(jD(e, n)) : Dr(t) ? OD(t, n) : Dl(DD(hr(e)));
}
function FD(e) {
  var t = ms(Ea(e)), n = ["absolute", "fixed"].indexOf(Kn(e).position) >= 0, r = n && cn(e) ? Us(e) : e;
  return Dr(r) ? t.filter(function(o) {
    return Dr(o) && $b(o, r) && Rn(o) !== "body";
  }) : [];
}
function BD(e, t, n, r) {
  var o = t === "clippingParents" ? FD(e) : [].concat(t), s = [].concat(o, [n]), i = s[0], a = s.reduce(function(c, l) {
    var u = Wp(e, l, r);
    return c.top = $r(u.top, c.top), c.right = ra(u.right, c.right), c.bottom = ra(u.bottom, c.bottom), c.left = $r(u.left, c.left), c;
  }, Wp(e, i, r));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function Ob(e) {
  var t = e.reference, n = e.element, r = e.placement, o = r ? In(r) : null, s = r ? Ao(r) : null, i = t.x + t.width / 2 - n.width / 2, a = t.y + t.height / 2 - n.height / 2, c;
  switch (o) {
    case Ht:
      c = {
        x: i,
        y: t.y - n.height
      };
      break;
    case un:
      c = {
        x: i,
        y: t.y + t.height
      };
      break;
    case dn:
      c = {
        x: t.x + t.width,
        y: a
      };
      break;
    case Ut:
      c = {
        x: t.x - n.width,
        y: a
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var l = o ? sd(o) : null;
  if (l != null) {
    var u = l === "y" ? "height" : "width";
    switch (s) {
      case _o:
        c[l] = c[l] - (t[u] / 2 - n[u] / 2);
        break;
      case Es:
        c[l] = c[l] + (t[u] / 2 - n[u] / 2);
        break;
    }
  }
  return c;
}
function As(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = r === void 0 ? e.placement : r, s = n.strategy, i = s === void 0 ? e.strategy : s, a = n.boundary, c = a === void 0 ? sD : a, l = n.rootBoundary, u = l === void 0 ? Ab : l, d = n.elementContext, f = d === void 0 ? Ko : d, p = n.altBoundary, m = p === void 0 ? !1 : p, g = n.padding, y = g === void 0 ? 0 : g, S = Mb(typeof y != "number" ? y : jb(y, Hs)), b = f === Ko ? iD : Ko, v = e.rects.popper, k = e.elements[m ? b : f], w = BD(Dr(k) ? k : k.contextElement || hr(e.elements.popper), c, u, i), _ = Eo(e.elements.reference), C = Ob({
    reference: _,
    element: v,
    strategy: "absolute",
    placement: o
  }), I = Dl(Object.assign({}, v, C)), $ = f === Ko ? I : _, N = {
    top: w.top - $.top + S.top,
    bottom: $.bottom - w.bottom + S.bottom,
    left: w.left - $.left + S.left,
    right: $.right - w.right + S.right
  }, z = e.modifiersData.offset;
  if (f === Ko && z) {
    var Q = z[o];
    Object.keys(N).forEach(function(U) {
      var q = [dn, un].indexOf(U) >= 0 ? 1 : -1, le = [Ht, un].indexOf(U) >= 0 ? "y" : "x";
      N[U] += Q[le] * q;
    });
  }
  return N;
}
function LD(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = n.boundary, s = n.rootBoundary, i = n.padding, a = n.flipVariations, c = n.allowedAutoPlacements, l = c === void 0 ? Ib : c, u = Ao(r), d = u ? a ? Bp : Bp.filter(function(m) {
    return Ao(m) === u;
  }) : Hs, f = d.filter(function(m) {
    return l.indexOf(m) >= 0;
  });
  f.length === 0 && (f = d);
  var p = f.reduce(function(m, g) {
    return m[g] = As(e, {
      placement: g,
      boundary: o,
      rootBoundary: s,
      padding: i
    })[In(g)], m;
  }, {});
  return Object.keys(p).sort(function(m, g) {
    return p[m] - p[g];
  });
}
function VD(e) {
  if (In(e) === nd)
    return [];
  var t = Di(e);
  return [zp(e), t, zp(t)];
}
function zD(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var o = n.mainAxis, s = o === void 0 ? !0 : o, i = n.altAxis, a = i === void 0 ? !0 : i, c = n.fallbackPlacements, l = n.padding, u = n.boundary, d = n.rootBoundary, f = n.altBoundary, p = n.flipVariations, m = p === void 0 ? !0 : p, g = n.allowedAutoPlacements, y = t.options.placement, S = In(y), b = S === y, v = c || (b || !m ? [Di(y)] : VD(y)), k = [y].concat(v).reduce(function(V, Y) {
      return V.concat(In(Y) === nd ? LD(t, {
        placement: Y,
        boundary: u,
        rootBoundary: d,
        padding: l,
        flipVariations: m,
        allowedAutoPlacements: g
      }) : Y);
    }, []), w = t.rects.reference, _ = t.rects.popper, C = /* @__PURE__ */ new Map(), I = !0, $ = k[0], N = 0; N < k.length; N++) {
      var z = k[N], Q = In(z), U = Ao(z) === _o, q = [Ht, un].indexOf(Q) >= 0, le = q ? "width" : "height", Z = As(t, {
        placement: z,
        boundary: u,
        rootBoundary: d,
        altBoundary: f,
        padding: l
      }), j = q ? U ? dn : Ut : U ? un : Ht;
      w[le] > _[le] && (j = Di(j));
      var K = Di(j), ne = [];
      if (s && ne.push(Z[Q] <= 0), a && ne.push(Z[j] <= 0, Z[K] <= 0), ne.every(function(V) {
        return V;
      })) {
        $ = z, I = !1;
        break;
      }
      C.set(z, ne);
    }
    if (I)
      for (var B = m ? 3 : 1, O = function(Y) {
        var J = k.find(function(se) {
          var ue = C.get(se);
          if (ue)
            return ue.slice(0, Y).every(function(G) {
              return G;
            });
        });
        if (J)
          return $ = J, "break";
      }, ee = B; ee > 0; ee--) {
        var D = O(ee);
        if (D === "break")
          break;
      }
    t.placement !== $ && (t.modifiersData[r]._skip = !0, t.placement = $, t.reset = !0);
  }
}
const WD = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: zD,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Hp(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function Up(e) {
  return [Ht, dn, un, Ut].some(function(t) {
    return e[t] >= 0;
  });
}
function HD(e) {
  var t = e.state, n = e.name, r = t.rects.reference, o = t.rects.popper, s = t.modifiersData.preventOverflow, i = As(t, {
    elementContext: "reference"
  }), a = As(t, {
    altBoundary: !0
  }), c = Hp(i, r), l = Hp(a, o, s), u = Up(c), d = Up(l);
  t.modifiersData[n] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: l,
    isReferenceHidden: u,
    hasPopperEscaped: d
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": d
  });
}
const UD = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: HD
};
function GD(e, t, n) {
  var r = In(e), o = [Ut, Ht].indexOf(r) >= 0 ? -1 : 1, s = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, i = s[0], a = s[1];
  return i = i || 0, a = (a || 0) * o, [Ut, dn].indexOf(r) >= 0 ? {
    x: a,
    y: i
  } : {
    x: i,
    y: a
  };
}
function qD(e) {
  var t = e.state, n = e.options, r = e.name, o = n.offset, s = o === void 0 ? [0, 0] : o, i = Ib.reduce(function(u, d) {
    return u[d] = GD(d, t.rects, s), u;
  }, {}), a = i[t.placement], c = a.x, l = a.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += l), t.modifiersData[r] = i;
}
const KD = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: qD
};
function YD(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = Ob({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const XD = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: YD,
  data: {}
};
function ZD(e) {
  return e === "x" ? "y" : "x";
}
function JD(e) {
  var t = e.state, n = e.options, r = e.name, o = n.mainAxis, s = o === void 0 ? !0 : o, i = n.altAxis, a = i === void 0 ? !1 : i, c = n.boundary, l = n.rootBoundary, u = n.altBoundary, d = n.padding, f = n.tether, p = f === void 0 ? !0 : f, m = n.tetherOffset, g = m === void 0 ? 0 : m, y = As(t, {
    boundary: c,
    rootBoundary: l,
    padding: d,
    altBoundary: u
  }), S = In(t.placement), b = Ao(t.placement), v = !b, k = sd(S), w = ZD(k), _ = t.modifiersData.popperOffsets, C = t.rects.reference, I = t.rects.popper, $ = typeof g == "function" ? g(Object.assign({}, t.rects, {
    placement: t.placement
  })) : g, N = typeof $ == "number" ? {
    mainAxis: $,
    altAxis: $
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, $), z = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, Q = {
    x: 0,
    y: 0
  };
  if (_) {
    if (s) {
      var U, q = k === "y" ? Ht : Ut, le = k === "y" ? un : dn, Z = k === "y" ? "height" : "width", j = _[k], K = j + y[q], ne = j - y[le], B = p ? -I[Z] / 2 : 0, O = b === _o ? C[Z] : I[Z], ee = b === _o ? -I[Z] : -C[Z], D = t.elements.arrow, V = p && D ? od(D) : {
        width: 0,
        height: 0
      }, Y = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Nb(), J = Y[q], se = Y[le], ue = hs(0, C[Z], V[Z]), G = v ? C[Z] / 2 - B - ue - J - N.mainAxis : O - ue - J - N.mainAxis, H = v ? -C[Z] / 2 + B + ue + se + N.mainAxis : ee + ue + se + N.mainAxis, de = t.elements.arrow && Us(t.elements.arrow), L = de ? k === "y" ? de.clientTop || 0 : de.clientLeft || 0 : 0, me = (U = z == null ? void 0 : z[k]) != null ? U : 0, oe = j + G - me - L, $e = j + H - me, Oe = hs(p ? ra(K, oe) : K, j, p ? $r(ne, $e) : ne);
      _[k] = Oe, Q[k] = Oe - j;
    }
    if (a) {
      var ce, Ne = k === "x" ? Ht : Ut, Ie = k === "x" ? un : dn, Re = _[w], Xe = w === "y" ? "height" : "width", tt = Re + y[Ne], it = Re - y[Ie], At = [Ht, Ut].indexOf(S) !== -1, Vt = (ce = z == null ? void 0 : z[w]) != null ? ce : 0, qt = At ? tt : Re - C[Xe] - I[Xe] - Vt + N.altAxis, Nt = At ? Re + C[Xe] + I[Xe] - Vt - N.altAxis : it, te = p && At ? wD(qt, Re, Nt) : hs(p ? qt : tt, Re, p ? Nt : it);
      _[w] = te, Q[w] = te - Re;
    }
    t.modifiersData[r] = Q;
  }
}
const QD = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: JD,
  requiresIfExists: ["offset"]
};
function eO(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function tO(e) {
  return e === Jt(e) || !cn(e) ? id(e) : eO(e);
}
function nO(e) {
  var t = e.getBoundingClientRect(), n = To(t.width) / e.offsetWidth || 1, r = To(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function rO(e, t, n) {
  n === void 0 && (n = !1);
  var r = cn(t), o = cn(t) && nO(t), s = hr(t), i = Eo(e, o, n), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((Rn(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  cd(s)) && (a = tO(t)), cn(t) ? (c = Eo(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : s && (c.x = ad(s))), {
    x: i.left + a.scrollLeft - c.x,
    y: i.top + a.scrollTop - c.y,
    width: i.width,
    height: i.height
  };
}
function oO(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(s) {
    t.set(s.name, s);
  });
  function o(s) {
    n.add(s.name);
    var i = [].concat(s.requires || [], s.requiresIfExists || []);
    i.forEach(function(a) {
      if (!n.has(a)) {
        var c = t.get(a);
        c && o(c);
      }
    }), r.push(s);
  }
  return e.forEach(function(s) {
    n.has(s.name) || o(s);
  }), r;
}
function sO(e) {
  var t = oO(e);
  return gD.reduce(function(n, r) {
    return n.concat(t.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function iO(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function aO(e) {
  var t = e.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var Gp = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function qp() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function cO(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, o = t.defaultOptions, s = o === void 0 ? Gp : o;
  return function(a, c, l) {
    l === void 0 && (l = s);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Gp, s),
      modifiersData: {},
      elements: {
        reference: a,
        popper: c
      },
      attributes: {},
      styles: {}
    }, d = [], f = !1, p = {
      state: u,
      setOptions: function(S) {
        var b = typeof S == "function" ? S(u.options) : S;
        g(), u.options = Object.assign({}, s, u.options, b), u.scrollParents = {
          reference: Dr(a) ? ms(a) : a.contextElement ? ms(a.contextElement) : [],
          popper: ms(c)
        };
        var v = sO(aO([].concat(r, u.options.modifiers)));
        return u.orderedModifiers = v.filter(function(k) {
          return k.enabled;
        }), m(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var S = u.elements, b = S.reference, v = S.popper;
          if (qp(b, v)) {
            u.rects = {
              reference: rO(b, Us(v), u.options.strategy === "fixed"),
              popper: od(v)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(N) {
              return u.modifiersData[N.name] = Object.assign({}, N.data);
            });
            for (var k = 0; k < u.orderedModifiers.length; k++) {
              if (u.reset === !0) {
                u.reset = !1, k = -1;
                continue;
              }
              var w = u.orderedModifiers[k], _ = w.fn, C = w.options, I = C === void 0 ? {} : C, $ = w.name;
              typeof _ == "function" && (u = _({
                state: u,
                options: I,
                name: $,
                instance: p
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: iO(function() {
        return new Promise(function(y) {
          p.forceUpdate(), y(u);
        });
      }),
      destroy: function() {
        g(), f = !0;
      }
    };
    if (!qp(a, c))
      return p;
    p.setOptions(l).then(function(y) {
      !f && l.onFirstUpdate && l.onFirstUpdate(y);
    });
    function m() {
      u.orderedModifiers.forEach(function(y) {
        var S = y.name, b = y.options, v = b === void 0 ? {} : b, k = y.effect;
        if (typeof k == "function") {
          var w = k({
            state: u,
            name: S,
            instance: p,
            options: v
          }), _ = function() {
          };
          d.push(w || _);
        }
      });
    }
    function g() {
      d.forEach(function(y) {
        return y();
      }), d = [];
    }
    return p;
  };
}
var lO = [$D, XD, ID, vD, KD, WD, QD, _D, UD], uO = /* @__PURE__ */ cO({
  defaultModifiers: lO
});
const qr = (e, t) => ({
  var: e,
  varRef: t ? `var(${e}, ${t})` : `var(${e})`
}), bt = {
  arrowShadowColor: qr("--popper-arrow-shadow-color"),
  arrowSize: qr("--popper-arrow-size", "8px"),
  arrowSizeHalf: qr("--popper-arrow-size-half"),
  arrowBg: qr("--popper-arrow-bg"),
  transformOrigin: qr("--popper-transform-origin"),
  arrowOffset: qr("--popper-arrow-offset")
};
function dO(e) {
  if (e.includes("top"))
    return "1px 1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("bottom"))
    return "-1px -1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("right"))
    return "-1px 1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("left"))
    return "1px -1px 0px 0 var(--popper-arrow-shadow-color)";
}
const fO = {
  top: "bottom center",
  "top-start": "bottom left",
  "top-end": "bottom right",
  bottom: "top center",
  "bottom-start": "top left",
  "bottom-end": "top right",
  left: "right center",
  "left-start": "right top",
  "left-end": "right bottom",
  right: "left center",
  "right-start": "left top",
  "right-end": "left bottom"
}, pO = (e) => fO[e], Kp = {
  scroll: !0,
  resize: !0
};
function hO(e) {
  let t;
  return typeof e == "object" ? t = {
    enabled: !0,
    options: { ...Kp, ...e }
  } : t = {
    enabled: e,
    options: Kp
  }, t;
}
const mO = {
  name: "matchWidth",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state: e }) => {
    e.styles.popper.width = `${e.rects.reference.width}px`;
  },
  effect: ({ state: e }) => () => {
    const t = e.elements.reference;
    e.elements.popper.style.width = `${t.offsetWidth}px`;
  }
}, gO = {
  name: "transformOrigin",
  enabled: !0,
  phase: "write",
  fn: ({ state: e }) => {
    Yp(e);
  },
  effect: ({ state: e }) => () => {
    Yp(e);
  }
}, Yp = (e) => {
  e.elements.popper.style.setProperty(
    bt.transformOrigin.var,
    pO(e.placement)
  );
}, yO = {
  name: "positionArrow",
  enabled: !0,
  phase: "afterWrite",
  fn: ({ state: e }) => {
    bO(e);
  }
}, bO = (e) => {
  var n;
  if (!e.placement)
    return;
  const t = vO(e.placement);
  if ((n = e.elements) != null && n.arrow && t) {
    Object.assign(e.elements.arrow.style, {
      [t.property]: t.value,
      width: bt.arrowSize.varRef,
      height: bt.arrowSize.varRef,
      zIndex: -1
    });
    const r = {
      [bt.arrowSizeHalf.var]: `calc(${bt.arrowSize.varRef} / 2 - 1px)`,
      [bt.arrowOffset.var]: `calc(${bt.arrowSizeHalf.varRef} * -1)`
    };
    for (const o in r)
      e.elements.arrow.style.setProperty(o, r[o]);
  }
}, vO = (e) => {
  if (e.startsWith("top"))
    return { property: "bottom", value: bt.arrowOffset.varRef };
  if (e.startsWith("bottom"))
    return { property: "top", value: bt.arrowOffset.varRef };
  if (e.startsWith("left"))
    return { property: "right", value: bt.arrowOffset.varRef };
  if (e.startsWith("right"))
    return { property: "left", value: bt.arrowOffset.varRef };
}, xO = {
  name: "innerArrow",
  enabled: !0,
  phase: "main",
  requires: ["arrow"],
  fn: ({ state: e }) => {
    Xp(e);
  },
  effect: ({ state: e }) => () => {
    Xp(e);
  }
}, Xp = (e) => {
  if (!e.elements.arrow)
    return;
  const t = e.elements.arrow.querySelector(
    "[data-popper-arrow-inner]"
  );
  if (!t)
    return;
  const n = dO(e.placement);
  n && t.style.setProperty("--popper-arrow-default-shadow", n), Object.assign(t.style, {
    transform: "rotate(45deg)",
    background: bt.arrowBg.varRef,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    zIndex: "inherit",
    boxShadow: "var(--popper-arrow-shadow, var(--popper-arrow-default-shadow))"
  });
}, SO = {
  "start-start": { ltr: "left-start", rtl: "right-start" },
  "start-end": { ltr: "left-end", rtl: "right-end" },
  "end-start": { ltr: "right-start", rtl: "left-start" },
  "end-end": { ltr: "right-end", rtl: "left-end" },
  start: { ltr: "left", rtl: "right" },
  end: { ltr: "right", rtl: "left" }
}, wO = {
  "auto-start": "auto-end",
  "auto-end": "auto-start",
  "top-start": "top-end",
  "top-end": "top-start",
  "bottom-start": "bottom-end",
  "bottom-end": "bottom-start"
};
function kO(e, t = "ltr") {
  var r;
  const n = ((r = SO[e]) == null ? void 0 : r[t]) || e;
  return t === "ltr" ? n : wO[e] ?? n;
}
function ld(e = {}) {
  const {
    enabled: t = !0,
    modifiers: n,
    placement: r = "bottom",
    strategy: o = "absolute",
    arrowPadding: s = 8,
    eventListeners: i = !0,
    offset: a,
    gutter: c = 8,
    flip: l = !0,
    boundary: u = "clippingParents",
    preventOverflow: d = !0,
    matchWidth: f,
    direction: p = "ltr"
  } = e, m = ae(null), g = ae(null), y = ae(null), S = kO(r, p), b = ae(() => {
  }), v = R(() => {
    var N;
    !t || !m.current || !g.current || ((N = b.current) == null || N.call(b), y.current = uO(m.current, g.current, {
      placement: S,
      modifiers: [
        xO,
        yO,
        gO,
        {
          ...mO,
          enabled: !!f
        },
        {
          name: "eventListeners",
          ...hO(i)
        },
        {
          name: "arrow",
          options: { padding: s }
        },
        {
          name: "offset",
          options: {
            offset: a ?? [0, c]
          }
        },
        {
          name: "flip",
          enabled: !!l,
          options: { padding: 8 }
        },
        {
          name: "preventOverflow",
          enabled: !!d,
          options: { boundary: u }
        },
        // allow users override internal modifiers
        ...n ?? []
      ],
      strategy: o
    }), y.current.forceUpdate(), b.current = y.current.destroy);
  }, [
    S,
    t,
    n,
    f,
    i,
    s,
    a,
    c,
    l,
    d,
    u,
    o
  ]);
  xe(() => () => {
    var N;
    !m.current && !g.current && ((N = y.current) == null || N.destroy(), y.current = null);
  }, []);
  const k = R(
    (N) => {
      m.current = N, v();
    },
    [v]
  ), w = R(
    (N = {}, z = null) => ({
      ...N,
      ref: De(k, z)
    }),
    [k]
  ), _ = R(
    (N) => {
      g.current = N, v();
    },
    [v]
  ), C = R(
    (N = {}, z = null) => ({
      ...N,
      ref: De(_, z),
      style: {
        ...N.style,
        position: o,
        minWidth: f ? void 0 : "max-content",
        inset: "0 auto auto 0"
      }
    }),
    [o, _, f]
  ), I = R((N = {}, z = null) => {
    const { size: Q, shadowColor: U, bg: q, style: le, ...Z } = N;
    return {
      ...Z,
      ref: z,
      "data-popper-arrow": "",
      style: PO(N)
    };
  }, []), $ = R(
    (N = {}, z = null) => ({
      ...N,
      ref: z,
      "data-popper-arrow-inner": ""
    }),
    []
  );
  return {
    update() {
      var N;
      (N = y.current) == null || N.update();
    },
    forceUpdate() {
      var N;
      (N = y.current) == null || N.forceUpdate();
    },
    transformOrigin: bt.transformOrigin.varRef,
    referenceRef: k,
    popperRef: _,
    getPopperProps: C,
    getArrowProps: I,
    getArrowInnerProps: $,
    getReferenceProps: w
  };
}
function PO(e) {
  const { size: t, shadowColor: n, bg: r, style: o } = e, s = { ...o, position: "absolute" };
  return t && (s["--popper-arrow-size"] = t), n && (s["--popper-arrow-shadow-color"] = n), r && (s["--popper-arrow-bg"] = r), s;
}
function CO() {
  const e = ae(/* @__PURE__ */ new Map()), t = e.current, n = R((o, s, i, a) => {
    e.current.set(i, { type: s, el: o, options: a }), o.addEventListener(s, i, a);
  }, []), r = R(
    (o, s, i, a) => {
      o.removeEventListener(s, i, a), e.current.delete(i);
    },
    []
  );
  return xe(
    () => () => {
      t.forEach((o, s) => {
        r(o.el, o.type, s, o.options);
      });
    },
    [r, t]
  ), { add: n, remove: r };
}
function Wc(e) {
  var o, s;
  const t = ((s = (o = e.composedPath) == null ? void 0 : o.call(e)) == null ? void 0 : s[0]) ?? e.target, { tagName: n, isContentEditable: r } = t;
  return n !== "INPUT" && n !== "TEXTAREA" && r !== !0;
}
function Fb(e = {}) {
  const {
    ref: t,
    isDisabled: n,
    isFocusable: r,
    clickOnEnter: o = !0,
    clickOnSpace: s = !0,
    onMouseDown: i,
    onMouseUp: a,
    onClick: c,
    onKeyDown: l,
    onKeyUp: u,
    tabIndex: d,
    onMouseOver: f,
    onMouseLeave: p,
    ...m
  } = e, [g, y] = he(!0), [S, b] = he(!1), v = CO(), k = (j) => {
    j && j.tagName !== "BUTTON" && y(!1);
  }, w = g ? d : d || 0, _ = n && !r, C = R(
    (j) => {
      if (n) {
        j.stopPropagation(), j.preventDefault();
        return;
      }
      j.currentTarget.focus(), c == null || c(j);
    },
    [n, c]
  ), I = R(
    (j) => {
      S && Wc(j) && (j.preventDefault(), j.stopPropagation(), b(!1), v.remove(document, "keyup", I, !1));
    },
    [S, v]
  ), $ = R(
    (j) => {
      if (l == null || l(j), n || j.defaultPrevented || j.metaKey || !Wc(j.nativeEvent) || g)
        return;
      const K = o && j.key === "Enter";
      s && j.key === " " && (j.preventDefault(), b(!0)), K && (j.preventDefault(), j.currentTarget.click()), v.add(document, "keyup", I, !1);
    },
    [
      n,
      g,
      l,
      o,
      s,
      v,
      I
    ]
  ), N = R(
    (j) => {
      if (u == null || u(j), n || j.defaultPrevented || j.metaKey || !Wc(j.nativeEvent) || g)
        return;
      s && j.key === " " && (j.preventDefault(), b(!1), j.currentTarget.click());
    },
    [s, g, n, u]
  ), z = R(
    (j) => {
      j.button === 0 && (b(!1), v.remove(document, "mouseup", z, !1));
    },
    [v]
  ), Q = R(
    (j) => {
      if (j.button !== 0)
        return;
      if (n) {
        j.stopPropagation(), j.preventDefault();
        return;
      }
      g || b(!0), j.currentTarget.focus({ preventScroll: !0 }), v.add(document, "mouseup", z, !1), i == null || i(j);
    },
    [n, g, i, v, z]
  ), U = R(
    (j) => {
      j.button === 0 && (g || b(!1), a == null || a(j));
    },
    [a, g]
  ), q = R(
    (j) => {
      if (n) {
        j.preventDefault();
        return;
      }
      f == null || f(j);
    },
    [n, f]
  ), le = R(
    (j) => {
      S && (j.preventDefault(), b(!1)), p == null || p(j);
    },
    [S, p]
  ), Z = De(t, k);
  return g ? {
    ...m,
    ref: Z,
    type: "button",
    "aria-disabled": _ ? void 0 : n,
    disabled: _,
    onClick: C,
    onMouseDown: i,
    onMouseUp: a,
    onKeyUp: u,
    onKeyDown: l,
    onMouseOver: f,
    onMouseLeave: p
  } : {
    ...m,
    ref: Z,
    role: "button",
    "data-active": ye(S),
    "aria-disabled": n ? "true" : void 0,
    tabIndex: _ ? void 0 : w,
    onClick: C,
    onMouseDown: Q,
    onMouseUp: U,
    onKeyUp: N,
    onKeyDown: $,
    onMouseOver: q,
    onMouseLeave: le
  };
}
const [
  _O,
  TO,
  EO,
  AO
] = wa(), [IO, No] = Ee({
  strict: !1,
  name: "MenuContext"
});
function Bb(e) {
  return (e == null ? void 0 : e.ownerDocument) ?? document;
}
function RO(e) {
  return Bb(e).activeElement === e;
}
function $O(e = {}) {
  const {
    id: t,
    closeOnSelect: n = !0,
    closeOnBlur: r = !0,
    initialFocusRef: o,
    autoSelect: s = !0,
    isLazy: i,
    isOpen: a,
    defaultIsOpen: c,
    onClose: l,
    onOpen: u,
    placement: d = "bottom-start",
    lazyBehavior: f = "unmount",
    direction: p,
    computePositionOnMount: m = !1,
    ...g
  } = e, y = ae(null), S = ae(null), b = ae(!0), v = EO(), k = R(() => {
    requestAnimationFrame(() => {
      var D;
      (D = y.current) == null || D.focus({ preventScroll: !1 });
    });
  }, []), w = R(() => {
    const D = setTimeout(() => {
      var V, Y;
      if (o)
        (V = o.current) == null || V.focus();
      else if (!v.count())
        (Y = y.current) == null || Y.focus({ preventScroll: !1 });
      else {
        const J = v.firstEnabled();
        J && q(J.index);
      }
    });
    ne.current.add(D);
  }, [v, o]), _ = R(() => {
    const D = setTimeout(() => {
      var V;
      if (!v.count())
        (V = y.current) == null || V.focus({ preventScroll: !1 });
      else {
        const Y = v.lastEnabled();
        Y && q(Y.index);
      }
    });
    ne.current.add(D);
  }, [v]), C = R(() => {
    u == null || u(), s ? w() : k();
  }, [s, w, k, u]), { isOpen: I, onOpen: $, onClose: N, onToggle: z } = Yl({
    isOpen: a,
    defaultIsOpen: c,
    onClose: l,
    onOpen: C
  });
  Yh({
    enabled: I && r,
    ref: y,
    handler: (D) => {
      var Y, J, se;
      const V = ((J = (Y = D.composedPath) == null ? void 0 : Y.call(D)) == null ? void 0 : J[0]) ?? D.target;
      (se = S.current) != null && se.contains(V) || N();
    }
  });
  const Q = ld({
    ...g,
    enabled: I || m,
    placement: d,
    direction: p
  }), [U, q] = he(-1);
  Uh(y, {
    focusRef: S,
    visible: I,
    shouldFocus: !0
  });
  const le = Wh({ isOpen: I, ref: y }), [Z, j] = cx(t, "menu-button", "menu-list"), K = R(() => {
    $(), k();
  }, [$, k]), ne = ae(/* @__PURE__ */ new Set([]));
  xe(() => {
    const D = ne.current;
    return () => {
      D.forEach((V) => clearTimeout(V)), D.clear();
    };
  }, []), bn(() => {
    var D;
    I || (q(-1), (D = y.current) == null || D.scrollTo(0, 0));
  }, [I]), bn(() => {
    I && U === -1 && k();
  }, [U, I]), xe(() => {
    var V;
    if (!I)
      return;
    const D = v.item(U);
    (V = D == null ? void 0 : D.node) == null || V.focus({ preventScroll: !b.current });
  }, [v, U, I]);
  const B = R(() => {
    $(), w();
  }, [w, $]), O = R(() => {
    b.current = !0, $(), _();
  }, [$, _]), ee = R(() => {
    var se, ue;
    const D = Bb(y.current), V = (se = y.current) == null ? void 0 : se.contains(D.activeElement);
    if (!(I && !V))
      return;
    const J = (ue = v.item(U)) == null ? void 0 : ue.node;
    J == null || J.focus({ preventScroll: !b.current });
  }, [I, U, v]);
  return {
    openAndFocusMenu: K,
    openAndFocusFirstItem: B,
    openAndFocusLastItem: O,
    onTransitionEnd: ee,
    unstable__animationState: le,
    descendants: v,
    popper: Q,
    buttonId: Z,
    menuId: j,
    forceUpdate: Q.forceUpdate,
    orientation: "vertical",
    isOpen: I,
    onToggle: z,
    onOpen: $,
    onClose: N,
    menuRef: y,
    buttonRef: S,
    focusedIndex: U,
    closeOnSelect: n,
    closeOnBlur: r,
    autoSelect: s,
    setFocusedIndex: q,
    isLazy: i,
    lazyBehavior: f,
    initialFocusRef: o,
    scrollIntoViewRef: b
  };
}
function NO(e = {}, t = null) {
  const n = No(), {
    onToggle: r,
    popper: o,
    openAndFocusFirstItem: s,
    openAndFocusLastItem: i,
    scrollIntoViewRef: a
  } = n, c = R(
    (l) => {
      const u = l.key, f = {
        Enter: s,
        ArrowDown: s,
        ArrowUp: i
      }[u];
      f && (a.current = !0, l.preventDefault(), l.stopPropagation(), f(l));
    },
    [s, i, a]
  );
  return {
    ...e,
    ref: De(n.buttonRef, t, o.referenceRef),
    id: n.buttonId,
    "data-active": ye(n.isOpen),
    "aria-expanded": n.isOpen,
    "aria-haspopup": "menu",
    "aria-controls": n.menuId,
    onClick: re(e.onClick, r),
    onKeyDown: re(e.onKeyDown, c)
  };
}
function Ol(e) {
  var t;
  return FO(e) && !!((t = e == null ? void 0 : e.getAttribute("role")) != null && t.startsWith("menuitem"));
}
function MO(e = {}, t = null) {
  const n = No();
  if (!n)
    throw new Error(
      "useMenuContext: context is undefined. Seems you forgot to wrap component within <Menu>"
    );
  const {
    focusedIndex: r,
    setFocusedIndex: o,
    menuRef: s,
    isOpen: i,
    onClose: a,
    menuId: c,
    isLazy: l,
    lazyBehavior: u,
    scrollIntoViewRef: d,
    unstable__animationState: f
  } = n, p = TO(), m = oD({
    preventDefault: (b) => b.key !== " " && Ol(b.target)
  }), g = R(
    (b) => {
      if (!b.currentTarget.contains(b.target))
        return;
      const v = b.key, w = {
        Tab: (C) => C.preventDefault(),
        Escape: (C) => {
          C.stopPropagation(), a();
        },
        ArrowDown: () => {
          d.current = !0;
          const C = p.nextEnabled(r) ?? p.firstEnabled();
          C && o(C.index);
        },
        ArrowUp: () => {
          d.current = !0;
          const C = p.prevEnabled(r) ?? p.firstEnabled();
          C && o(C.index);
        }
      }[v];
      if (w) {
        b.preventDefault(), w(b);
        return;
      }
      const _ = m((C) => {
        const I = nD(
          p.values(),
          C,
          ($) => {
            var N;
            return ((N = $ == null ? void 0 : $.node) == null ? void 0 : N.textContent) ?? "";
          },
          p.item(r)
        );
        if (I) {
          const $ = p.indexOf(I.node);
          o($);
        }
      });
      Ol(b.target) && _(b);
    },
    [
      p,
      r,
      m,
      a,
      o,
      d
    ]
  ), y = ae(!1);
  i && (y.current = !0);
  const S = ql({
    wasSelected: y.current,
    enabled: l,
    mode: u,
    isSelected: f.present
  });
  return {
    ...e,
    ref: De(s, t),
    children: S ? e.children : null,
    tabIndex: -1,
    role: "menu",
    id: c,
    style: {
      ...e.style,
      transformOrigin: "var(--popper-transform-origin)"
    },
    "aria-orientation": "vertical",
    onKeyDown: re(e.onKeyDown, g)
  };
}
function jO(e = {}) {
  const { popper: t, isOpen: n } = No();
  return t.getPopperProps({
    ...e,
    style: {
      visibility: n ? "visible" : "hidden",
      ...e.style
    }
  });
}
function Lb(e = {}, t = null) {
  const {
    onMouseEnter: n,
    onMouseMove: r,
    onMouseLeave: o,
    onClick: s,
    onFocus: i,
    isDisabled: a,
    isFocusable: c,
    closeOnSelect: l,
    type: u,
    ...d
  } = e, f = No(), {
    setFocusedIndex: p,
    focusedIndex: m,
    closeOnSelect: g,
    onClose: y,
    menuId: S,
    scrollIntoViewRef: b
  } = f, v = ae(null), k = `${S}-menuitem-${Rt()}`, { index: w, register: _ } = AO({
    disabled: a && !c
  }), C = R(
    (q) => {
      n == null || n(q), !a && (b.current = !1, p(w));
    },
    [p, w, a, n, b]
  ), I = R(
    (q) => {
      r == null || r(q), v.current && !RO(v.current) && C(q);
    },
    [C, r]
  ), $ = R(
    (q) => {
      o == null || o(q), !a && p(-1);
    },
    [p, a, o]
  ), N = R(
    (q) => {
      s == null || s(q), Ol(q.currentTarget) && (l ?? g) && y();
    },
    [y, s, g, l]
  ), z = R(
    (q) => {
      i == null || i(q), p(w);
    },
    [p, i, w]
  ), Q = w === m, U = Fb({
    onClick: N,
    onFocus: z,
    onMouseEnter: C,
    onMouseMove: I,
    onMouseLeave: $,
    ref: De(_, v, t),
    isDisabled: a,
    isFocusable: c
  });
  return {
    ...d,
    ...U,
    type: u ?? U.type,
    id: k,
    role: "menuitem",
    tabIndex: Q ? 0 : -1
  };
}
function DO(e = {}, t = null) {
  const { type: n = "radio", isChecked: r, ...o } = e;
  return {
    ...Lb(o, t),
    role: `menuitem${n}`,
    "aria-checked": r
  };
}
function OO(e = {}) {
  const {
    children: t,
    type: n = "radio",
    value: r,
    defaultValue: o,
    onChange: s,
    ...i
  } = e, c = n === "radio" ? "" : [], [l, u] = dr({
    defaultValue: o ?? c,
    value: r,
    onChange: s
  }), d = R(
    (m) => {
      if (n === "radio" && typeof l == "string" && u(m), n === "checkbox" && Array.isArray(l)) {
        const g = l.includes(m) ? l.filter((y) => y !== m) : l.concat(m);
        u(g);
      }
    },
    [l, u, n]
  ), p = Yn(t).map((m) => {
    if (m.type.id !== "MenuItemOption")
      return m;
    const g = (S) => {
      var b, v;
      d(m.props.value), (v = (b = m.props).onClick) == null || v.call(b, S);
    }, y = n === "radio" ? m.props.value === l : l.includes(m.props.value);
    return kt(m, {
      type: n,
      onClick: g,
      isChecked: y
    });
  });
  return {
    ...i,
    children: p
  };
}
function BL() {
  const { isOpen: e, onClose: t } = No();
  return { isOpen: e, onClose: t };
}
function FO(e) {
  if (!BO(e))
    return !1;
  const t = e.ownerDocument.defaultView ?? window;
  return e instanceof t.HTMLElement;
}
function BO(e) {
  return e != null && typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
}
const [LO, Lr] = Ee({
  name: "MenuStylesContext",
  errorMessage: `useMenuStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Menu />" `
}), VO = (e) => {
  const { children: t } = e, n = Je("Menu", e), r = Ae(e), { direction: o } = fn(), { descendants: s, ...i } = $O({ ...r, direction: o }), a = _e(() => i, [i]), { isOpen: c, onClose: l, forceUpdate: u } = a;
  return /* @__PURE__ */ h.jsx(_O, { value: s, children: /* @__PURE__ */ h.jsx(IO, { value: a, children: /* @__PURE__ */ h.jsx(LO, { value: n, children: Et(t, { isOpen: c, onClose: l, forceUpdate: u }) }) }) });
};
VO.displayName = "Menu";
const zO = M((e, t) => {
  const n = Lr();
  return /* @__PURE__ */ h.jsx(
    E.button,
    {
      ref: t,
      ...e,
      __css: {
        display: "inline-flex",
        appearance: "none",
        alignItems: "center",
        outline: 0,
        ...n.button
      }
    }
  );
}), WO = M(
  (e, t) => {
    const { children: n, as: r, ...o } = e, s = NO(o, t), i = r || zO;
    return /* @__PURE__ */ h.jsx(
      i,
      {
        ...s,
        className: W("chakra-menu__menu-button", e.className),
        children: /* @__PURE__ */ h.jsx(
          E.span,
          {
            __css: { pointerEvents: "none", flex: "1 1 auto", minW: 0 },
            children: e.children
          }
        )
      }
    );
  }
);
WO.displayName = "MenuButton";
const Vb = M(
  (e, t) => {
    const n = Lr();
    return /* @__PURE__ */ h.jsx(
      E.span,
      {
        ref: t,
        ...e,
        __css: n.command,
        className: "chakra-menu__command"
      }
    );
  }
);
Vb.displayName = "MenuCommand";
const HO = (e) => {
  const { className: t, ...n } = e, r = Lr();
  return /* @__PURE__ */ h.jsx(
    E.hr,
    {
      "aria-orientation": "horizontal",
      className: W("chakra-menu__divider", t),
      ...n,
      __css: r.divider
    }
  );
};
HO.displayName = "MenuDivider";
const zb = M((e, t) => {
  const { title: n, children: r, className: o, ...s } = e, i = W("chakra-menu__group__title", o), a = Lr();
  return /* @__PURE__ */ h.jsxs("div", { ref: t, className: "chakra-menu__group", role: "group", children: [
    n && /* @__PURE__ */ h.jsx(E.p, { className: i, ...s, __css: a.groupTitle, children: n }),
    r
  ] });
});
zb.displayName = "MenuGroup";
const oa = (e) => {
  const { className: t, children: n, ...r } = e, o = Lr(), s = $n.only(n), i = ur(s) ? kt(s, {
    focusable: "false",
    "aria-hidden": !0,
    className: W("chakra-menu__icon", s.props.className)
  }) : null, a = W("chakra-menu__icon-wrapper", t);
  return /* @__PURE__ */ h.jsx(E.span, { className: a, ...r, __css: o.icon, children: i });
};
oa.displayName = "MenuIcon";
const Wb = M(
  (e, t) => {
    const { type: n, ...r } = e, o = Lr(), s = r.as || n ? n ?? void 0 : "button", i = _e(
      () => ({
        textDecoration: "none",
        color: "inherit",
        userSelect: "none",
        display: "flex",
        width: "100%",
        alignItems: "center",
        textAlign: "start",
        flex: "0 0 auto",
        outline: 0,
        ...o.item
      }),
      [o.item]
    );
    return /* @__PURE__ */ h.jsx(E.button, { ref: t, type: s, ...r, __css: i });
  }
), UO = M((e, t) => {
  const {
    icon: n,
    iconSpacing: r = "0.75rem",
    command: o,
    commandSpacing: s = "0.75rem",
    children: i,
    ...a
  } = e, c = Lb(a, t), u = n || o ? /* @__PURE__ */ h.jsx("span", { style: { pointerEvents: "none", flex: 1 }, children: i }) : i;
  return /* @__PURE__ */ h.jsxs(
    Wb,
    {
      ...c,
      className: W("chakra-menu__menuitem", c.className),
      children: [
        n && /* @__PURE__ */ h.jsx(oa, { fontSize: "0.8em", marginEnd: r, children: n }),
        u,
        o && /* @__PURE__ */ h.jsx(Vb, { marginStart: s, children: o })
      ]
    }
  );
});
UO.displayName = "MenuItem";
const Zp = (e) => /* @__PURE__ */ h.jsx("svg", { viewBox: "0 0 14 14", width: "1em", height: "1em", ...e, children: /* @__PURE__ */ h.jsx(
  "polygon",
  {
    fill: "currentColor",
    points: "5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039"
  }
) }), Hb = M(
  (e, t) => {
    const {
      icon: n,
      iconSpacing: r = "0.75rem",
      iconPlacement: o = "start",
      ...s
    } = e, i = DO(s, t);
    return /* @__PURE__ */ h.jsxs(
      Wb,
      {
        ...i,
        className: W("chakra-menu__menuitem-option", s.className),
        children: [
          n !== null && o === "start" && /* @__PURE__ */ h.jsx(
            oa,
            {
              fontSize: "0.8em",
              marginEnd: r,
              opacity: e.isChecked ? 1 : 0,
              children: n || /* @__PURE__ */ h.jsx(Zp, {})
            }
          ),
          /* @__PURE__ */ h.jsx("span", { style: { flex: 1 }, children: i.children }),
          n !== null && o === "end" && /* @__PURE__ */ h.jsx(
            oa,
            {
              fontSize: "0.8em",
              marginStart: r,
              opacity: e.isChecked ? 1 : 0,
              children: n || /* @__PURE__ */ h.jsx(Zp, {})
            }
          )
        ]
      }
    );
  }
);
Hb.id = "MenuItemOption";
Hb.displayName = "MenuItemOption";
const GO = {
  enter: {
    visibility: "visible",
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    transitionEnd: {
      visibility: "hidden"
    },
    opacity: 0,
    scale: 0.8,
    transition: {
      duration: 0.1,
      easings: "easeOut"
    }
  }
}, qO = E(xn.div), KO = M(
  function(t, n) {
    var f;
    const { rootProps: r, motionProps: o, ...s } = t, {
      isOpen: i,
      onTransitionEnd: a,
      unstable__animationState: c
    } = No(), l = MO(s, n), u = jO(r), d = Lr();
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ...u,
        __css: { zIndex: t.zIndex ?? ((f = d.list) == null ? void 0 : f.zIndex) },
        children: /* @__PURE__ */ h.jsx(
          qO,
          {
            variants: GO,
            initial: !1,
            animate: i ? "enter" : "exit",
            __css: { outline: 0, ...d.list },
            ...o,
            ...l,
            className: W("chakra-menu__menu-list", l.className),
            onUpdate: a,
            onAnimationComplete: aa(
              c.onComplete,
              l.onAnimationComplete
            )
          }
        )
      }
    );
  }
);
KO.displayName = "MenuList";
const YO = (e) => {
  const { className: t, title: n, ...r } = e, o = OO(r);
  return /* @__PURE__ */ h.jsx(
    zb,
    {
      title: n,
      className: W("chakra-menu__option-group", t),
      ...o
    }
  );
};
YO.displayName = "MenuOptionGroup";
var XO = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Kr = /* @__PURE__ */ new WeakMap(), bi = /* @__PURE__ */ new WeakMap(), vi = {}, Hc = 0, Ub = function(e) {
  return e && (e.host || Ub(e.parentNode));
}, ZO = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Ub(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, JO = function(e, t, n, r) {
  var o = ZO(t, Array.isArray(e) ? e : [e]);
  vi[n] || (vi[n] = /* @__PURE__ */ new WeakMap());
  var s = vi[n], i = [], a = /* @__PURE__ */ new Set(), c = new Set(o), l = function(d) {
    !d || a.has(d) || (a.add(d), l(d.parentNode));
  };
  o.forEach(l);
  var u = function(d) {
    !d || c.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (a.has(f))
        u(f);
      else
        try {
          var p = f.getAttribute(r), m = p !== null && p !== "false", g = (Kr.get(f) || 0) + 1, y = (s.get(f) || 0) + 1;
          Kr.set(f, g), s.set(f, y), i.push(f), g === 1 && m && bi.set(f, !0), y === 1 && f.setAttribute(n, "true"), m || f.setAttribute(r, "true");
        } catch (S) {
          console.error("aria-hidden: cannot operate on ", f, S);
        }
    });
  };
  return u(t), a.clear(), Hc++, function() {
    i.forEach(function(d) {
      var f = Kr.get(d) - 1, p = s.get(d) - 1;
      Kr.set(d, f), s.set(d, p), f || (bi.has(d) || d.removeAttribute(r), bi.delete(d)), p || d.removeAttribute(n);
    }), Hc--, Hc || (Kr = /* @__PURE__ */ new WeakMap(), Kr = /* @__PURE__ */ new WeakMap(), bi = /* @__PURE__ */ new WeakMap(), vi = {});
  };
}, QO = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = t || XO(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live], script"))), JO(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, eF = Object.defineProperty, tF = (e, t, n) => t in e ? eF(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, nF = (e, t, n) => (tF(e, typeof t != "symbol" ? t + "" : t, n), n);
class rF {
  constructor() {
    nF(this, "modals"), this.modals = /* @__PURE__ */ new Set();
  }
  add(t) {
    return this.modals.add(t), this.modals.size;
  }
  remove(t) {
    this.modals.delete(t);
  }
  isTopModal(t) {
    if (!t)
      return !1;
    const n = Array.from(this.modals)[this.modals.size - 1];
    return t === n;
  }
}
const Fl = new rF();
function Gb(e, t) {
  const [n, r] = he(0);
  return xe(() => {
    const o = e.current;
    if (o) {
      if (t) {
        const s = Fl.add(o);
        r(s);
      }
      return () => {
        Fl.remove(o), r(0);
      };
    }
  }, [t, e]), n;
}
function oF(e) {
  const {
    isOpen: t,
    onClose: n,
    id: r,
    closeOnOverlayClick: o = !0,
    closeOnEsc: s = !0,
    useInert: i = !0,
    onOverlayClick: a,
    onEsc: c
  } = e, l = ae(null), u = ae(null), [d, f, p] = iF(
    r,
    "chakra-modal",
    "chakra-modal--header",
    "chakra-modal--body"
  );
  sF(l, t && i);
  const m = Gb(l, t), g = ae(null), y = R(($) => {
    g.current = $.target;
  }, []), S = R(
    ($) => {
      $.key === "Escape" && ($.stopPropagation(), s && (n == null || n()), c == null || c());
    },
    [s, n, c]
  ), [b, v] = he(!1), [k, w] = he(!1), _ = R(
    ($ = {}, N = null) => ({
      role: "dialog",
      ...$,
      ref: De(N, l),
      id: d,
      tabIndex: -1,
      "aria-modal": !0,
      "aria-labelledby": b ? f : void 0,
      "aria-describedby": k ? p : void 0,
      onClick: re(
        $.onClick,
        (z) => z.stopPropagation()
      )
    }),
    [p, k, d, f, b]
  ), C = R(
    ($) => {
      $.stopPropagation(), g.current === $.target && Fl.isTopModal(l.current) && (o && (n == null || n()), a == null || a());
    },
    [n, o, a]
  ), I = R(
    ($ = {}, N = null) => ({
      ...$,
      ref: De(N, u),
      onClick: re($.onClick, C),
      onKeyDown: re($.onKeyDown, S),
      onMouseDown: re($.onMouseDown, y)
    }),
    [S, y, C]
  );
  return {
    isOpen: t,
    onClose: n,
    headerId: f,
    bodyId: p,
    setBodyMounted: w,
    setHeaderMounted: v,
    dialogRef: l,
    overlayRef: u,
    getDialogProps: _,
    getDialogContainerProps: I,
    index: m
  };
}
function sF(e, t) {
  const n = e.current;
  xe(() => {
    if (!(!e.current || !t))
      return QO(e.current);
  }, [t, e, n]);
}
function iF(e, ...t) {
  const n = Rt(), r = e || n;
  return _e(() => t.map((o) => `${o}-${r}`), [r, t]);
}
const [aF, Vr] = Ee({
  name: "ModalStylesContext",
  errorMessage: `useModalStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Modal />" `
}), [cF, lr] = Ee({
  strict: !0,
  name: "ModalContext",
  errorMessage: "useModalContext: `context` is undefined. Seems you forgot to wrap modal components in `<Modal />`"
}), ud = (e) => {
  const t = {
    scrollBehavior: "outside",
    autoFocus: !0,
    trapFocus: !0,
    returnFocusOnClose: !0,
    blockScrollOnMount: !0,
    allowPinchZoom: !1,
    preserveScrollBarGap: !0,
    motionPreset: "scale",
    ...e,
    lockFocusAcrossFrames: e.lockFocusAcrossFrames ?? !0
  }, {
    portalProps: n,
    children: r,
    autoFocus: o,
    trapFocus: s,
    initialFocusRef: i,
    finalFocusRef: a,
    returnFocusOnClose: c,
    blockScrollOnMount: l,
    allowPinchZoom: u,
    preserveScrollBarGap: d,
    motionPreset: f,
    lockFocusAcrossFrames: p,
    animatePresenceProps: m,
    onCloseComplete: g
  } = t, y = Je("Modal", t), b = {
    ...oF(t),
    autoFocus: o,
    trapFocus: s,
    initialFocusRef: i,
    finalFocusRef: a,
    returnFocusOnClose: c,
    blockScrollOnMount: l,
    allowPinchZoom: u,
    preserveScrollBarGap: d,
    motionPreset: f,
    lockFocusAcrossFrames: p
  };
  return /* @__PURE__ */ h.jsx(cF, { value: b, children: /* @__PURE__ */ h.jsx(aF, { value: y, children: /* @__PURE__ */ h.jsx(
    pr,
    {
      ...m,
      onExitComplete: g,
      children: b.isOpen && /* @__PURE__ */ h.jsx($o, { ...n, children: r })
    }
  ) }) });
};
ud.displayName = "Modal";
var Oi = "right-scroll-bar-position", Fi = "width-before-scroll-bar", lF = "with-scroll-bars-hidden", uF = "--removed-body-scroll-bar-size", qb = Vy(), Uc = function() {
}, Aa = we.forwardRef(function(e, t) {
  var n = we.useRef(null), r = we.useState({
    onScrollCapture: Uc,
    onWheelCapture: Uc,
    onTouchMoveCapture: Uc
  }), o = r[0], s = r[1], i = e.forwardProps, a = e.children, c = e.className, l = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, p = e.noRelative, m = e.noIsolation, g = e.inert, y = e.allowPinchZoom, S = e.as, b = S === void 0 ? "div" : S, v = e.gapMode, k = Fy(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), w = f, _ = Oy([n, t]), C = Tn(Tn({}, k), o);
  return we.createElement(
    we.Fragment,
    null,
    u && we.createElement(w, { sideCar: qb, removeScrollBar: l, shards: d, noRelative: p, noIsolation: m, inert: g, setCallbacks: s, allowPinchZoom: !!y, lockRef: n, gapMode: v }),
    i ? we.cloneElement(we.Children.only(a), Tn(Tn({}, C), { ref: _ })) : we.createElement(b, Tn({}, C, { className: c, ref: _ }), a)
  );
});
Aa.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Aa.classNames = {
  fullWidth: Fi,
  zeroRight: Oi
};
var Jp, dF = function() {
  if (Jp)
    return Jp;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function fF() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = dF();
  return t && e.setAttribute("nonce", t), e;
}
function pF(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function hF(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var mF = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = fF()) && (pF(t, n), hF(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, gF = function() {
  var e = mF();
  return function(t, n) {
    we.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Kb = function() {
  var e = gF(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, yF = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Gc = function(e) {
  return parseInt(e || "", 10) || 0;
}, bF = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Gc(n), Gc(r), Gc(o)];
}, vF = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return yF;
  var t = bF(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, xF = Kb(), vo = "data-scroll-locked", SF = function(e, t, n, r) {
  var o = e.left, s = e.top, i = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(lF, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body[`).concat(vo, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Oi, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(Fi, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(Oi, " .").concat(Oi, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Fi, " .").concat(Fi, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(vo, `] {
    `).concat(uF, ": ").concat(a, `px;
  }
`);
}, Qp = function() {
  var e = parseInt(document.body.getAttribute(vo) || "0", 10);
  return isFinite(e) ? e : 0;
}, wF = function() {
  we.useEffect(function() {
    return document.body.setAttribute(vo, (Qp() + 1).toString()), function() {
      var e = Qp() - 1;
      e <= 0 ? document.body.removeAttribute(vo) : document.body.setAttribute(vo, e.toString());
    };
  }, []);
}, kF = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  wF();
  var s = we.useMemo(function() {
    return vF(o);
  }, [o]);
  return we.createElement(xF, { styles: SF(s, !t, o, n ? "" : "!important") });
}, Bl = !1;
if (typeof window < "u")
  try {
    var xi = Object.defineProperty({}, "passive", {
      get: function() {
        return Bl = !0, !0;
      }
    });
    window.addEventListener("test", xi, xi), window.removeEventListener("test", xi, xi);
  } catch {
    Bl = !1;
  }
var Yr = Bl ? { passive: !1 } : !1, PF = function(e) {
  return e.tagName === "TEXTAREA";
}, Yb = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !PF(e) && n[t] === "visible")
  );
}, CF = function(e) {
  return Yb(e, "overflowY");
}, _F = function(e) {
  return Yb(e, "overflowX");
}, eh = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = Xb(e, r);
    if (o) {
      var s = Zb(e, r), i = s[1], a = s[2];
      if (i > a)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, TF = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, EF = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Xb = function(e, t) {
  return e === "v" ? CF(t) : _F(t);
}, Zb = function(e, t) {
  return e === "v" ? TF(t) : EF(t);
}, AF = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, IF = function(e, t, n, r, o) {
  var s = AF(e, window.getComputedStyle(t).direction), i = s * r, a = n.target, c = t.contains(a), l = !1, u = i > 0, d = 0, f = 0;
  do {
    if (!a)
      break;
    var p = Zb(e, a), m = p[0], g = p[1], y = p[2], S = g - y - s * m;
    (m || S) && Xb(e, a) && (d += S, f += m);
    var b = a.parentNode;
    a = b && b.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? b.host : b;
  } while (
    // portaled content
    !c && a !== document.body || // self content
    c && (t.contains(a) || t === a)
  );
  return (u && (o && Math.abs(d) < 1 || !o && i > d) || !u && (o && Math.abs(f) < 1 || !o && -i > f)) && (l = !0), l;
}, Si = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, th = function(e) {
  return [e.deltaX, e.deltaY];
}, nh = function(e) {
  return e && "current" in e ? e.current : e;
}, RF = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, $F = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, NF = 0, Xr = [];
function MF(e) {
  var t = we.useRef([]), n = we.useRef([0, 0]), r = we.useRef(), o = we.useState(NF++)[0], s = we.useState(Kb)[0], i = we.useRef(e);
  we.useEffect(function() {
    i.current = e;
  }, [e]), we.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var g = dM([e.lockRef.current], (e.shards || []).map(nh), !0).filter(Boolean);
      return g.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), g.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = we.useCallback(function(g, y) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !i.current.allowPinchZoom;
    var S = Si(g), b = n.current, v = "deltaX" in g ? g.deltaX : b[0] - S[0], k = "deltaY" in g ? g.deltaY : b[1] - S[1], w, _ = g.target, C = Math.abs(v) > Math.abs(k) ? "h" : "v";
    if ("touches" in g && C === "h" && _.type === "range")
      return !1;
    var I = eh(C, _);
    if (!I)
      return !0;
    if (I ? w = C : (w = C === "v" ? "h" : "v", I = eh(C, _)), !I)
      return !1;
    if (!r.current && "changedTouches" in g && (v || k) && (r.current = w), !w)
      return !0;
    var $ = r.current || w;
    return IF($, y, g, $ === "h" ? v : k, !0);
  }, []), c = we.useCallback(function(g) {
    var y = g;
    if (!(!Xr.length || Xr[Xr.length - 1] !== s)) {
      var S = "deltaY" in y ? th(y) : Si(y), b = t.current.filter(function(w) {
        return w.name === y.type && (w.target === y.target || y.target === w.shadowParent) && RF(w.delta, S);
      })[0];
      if (b && b.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!b) {
        var v = (i.current.shards || []).map(nh).filter(Boolean).filter(function(w) {
          return w.contains(y.target);
        }), k = v.length > 0 ? a(y, v[0]) : !i.current.noIsolation;
        k && y.cancelable && y.preventDefault();
      }
    }
  }, []), l = we.useCallback(function(g, y, S, b) {
    var v = { name: g, delta: y, target: S, should: b, shadowParent: jF(S) };
    t.current.push(v), setTimeout(function() {
      t.current = t.current.filter(function(k) {
        return k !== v;
      });
    }, 1);
  }, []), u = we.useCallback(function(g) {
    n.current = Si(g), r.current = void 0;
  }, []), d = we.useCallback(function(g) {
    l(g.type, th(g), g.target, a(g, e.lockRef.current));
  }, []), f = we.useCallback(function(g) {
    l(g.type, Si(g), g.target, a(g, e.lockRef.current));
  }, []);
  we.useEffect(function() {
    return Xr.push(s), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", c, Yr), document.addEventListener("touchmove", c, Yr), document.addEventListener("touchstart", u, Yr), function() {
      Xr = Xr.filter(function(g) {
        return g !== s;
      }), document.removeEventListener("wheel", c, Yr), document.removeEventListener("touchmove", c, Yr), document.removeEventListener("touchstart", u, Yr);
    };
  }, []);
  var p = e.removeScrollBar, m = e.inert;
  return we.createElement(
    we.Fragment,
    null,
    m ? we.createElement(s, { styles: $F(o) }) : null,
    p ? we.createElement(kF, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function jF(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const DF = fM(qb, MF);
var Jb = we.forwardRef(function(e, t) {
  return we.createElement(Aa, Tn({}, e, { ref: t, sideCar: DF }));
});
Jb.classNames = Aa.classNames;
const OF = Jb;
function Qb(e) {
  const {
    autoFocus: t,
    trapFocus: n,
    dialogRef: r,
    initialFocusRef: o,
    blockScrollOnMount: s,
    allowPinchZoom: i,
    finalFocusRef: a,
    returnFocusOnClose: c,
    preserveScrollBarGap: l,
    lockFocusAcrossFrames: u,
    isOpen: d
  } = lr(), [f, p] = Hg();
  xe(() => {
    !f && p && setTimeout(p);
  }, [f, p]);
  const m = Gb(r, d);
  return /* @__PURE__ */ h.jsx(
    yb,
    {
      autoFocus: t,
      isDisabled: !n,
      initialFocusRef: o,
      finalFocusRef: a,
      restoreFocus: c,
      contentRef: r,
      lockFocusAcrossFrames: u,
      children: /* @__PURE__ */ h.jsx(
        OF,
        {
          removeScrollBar: !l,
          allowPinchZoom: i,
          enabled: m === 1 && s,
          forwardProps: !0,
          children: e.children
        }
      )
    }
  );
}
const FF = {
  initial: ({ offsetX: e, offsetY: t, transition: n, transitionEnd: r, delay: o }) => ({
    opacity: 0,
    x: e,
    y: t,
    transition: (n == null ? void 0 : n.exit) ?? yn.exit(Ir.exit, o),
    transitionEnd: r == null ? void 0 : r.exit
  }),
  enter: ({ transition: e, transitionEnd: t, delay: n }) => ({
    opacity: 1,
    x: 0,
    y: 0,
    transition: (e == null ? void 0 : e.enter) ?? yn.enter(Ir.enter, n),
    transitionEnd: t == null ? void 0 : t.enter
  }),
  exit: ({ offsetY: e, offsetX: t, transition: n, transitionEnd: r, reverse: o, delay: s }) => {
    const i = { x: t, y: e };
    return {
      opacity: 0,
      transition: (n == null ? void 0 : n.exit) ?? yn.exit(Ir.exit, s),
      ...o ? { ...i, transitionEnd: r == null ? void 0 : r.exit } : { transitionEnd: { ...i, ...r == null ? void 0 : r.exit } }
    };
  }
}, rs = {
  initial: "initial",
  animate: "enter",
  exit: "exit",
  variants: FF
}, BF = vn(
  function(t, n) {
    const {
      unmountOnExit: r,
      in: o,
      reverse: s = !0,
      className: i,
      offsetX: a = 0,
      offsetY: c = 8,
      transition: l,
      transitionEnd: u,
      delay: d,
      animatePresenceProps: f,
      ...p
    } = t, m = r ? o && r : !0, g = o || r ? "enter" : "exit", y = {
      offsetX: a,
      offsetY: c,
      reverse: s,
      transition: l,
      transitionEnd: u,
      delay: d
    };
    return /* @__PURE__ */ h.jsx(pr, { ...f, custom: y, children: m && /* @__PURE__ */ h.jsx(
      xn.div,
      {
        ref: n,
        className: W("chakra-offset-slide", i),
        custom: y,
        ...rs,
        animate: g,
        ...p
      }
    ) });
  }
);
BF.displayName = "SlideFade";
const LF = {
  exit: ({ reverse: e, initialScale: t, transition: n, transitionEnd: r, delay: o }) => ({
    opacity: 0,
    ...e ? { scale: t, transitionEnd: r == null ? void 0 : r.exit } : { transitionEnd: { scale: t, ...r == null ? void 0 : r.exit } },
    transition: (n == null ? void 0 : n.exit) ?? yn.exit(Ir.exit, o)
  }),
  enter: ({ transitionEnd: e, transition: t, delay: n }) => ({
    opacity: 1,
    scale: 1,
    transition: (t == null ? void 0 : t.enter) ?? yn.enter(Ir.enter, n),
    transitionEnd: e == null ? void 0 : e.enter
  })
}, ev = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: LF
}, VF = vn(
  function(t, n) {
    const {
      unmountOnExit: r,
      in: o,
      reverse: s = !0,
      initialScale: i = 0.95,
      className: a,
      transition: c,
      transitionEnd: l,
      delay: u,
      animatePresenceProps: d,
      ...f
    } = t, p = r ? o && r : !0, m = o || r ? "enter" : "exit", g = { initialScale: i, reverse: s, transition: c, transitionEnd: l, delay: u };
    return /* @__PURE__ */ h.jsx(pr, { ...d, custom: g, children: p && /* @__PURE__ */ h.jsx(
      xn.div,
      {
        ref: n,
        className: W("chakra-offset-slide", a),
        ...ev,
        animate: m,
        custom: g,
        ...f
      }
    ) });
  }
);
VF.displayName = "ScaleFade";
const zF = {
  slideInBottom: {
    ...rs,
    custom: { offsetY: 16, reverse: !0 }
  },
  slideInRight: {
    ...rs,
    custom: { offsetX: 16, reverse: !0 }
  },
  slideInTop: {
    ...rs,
    custom: { offsetY: -16, reverse: !0 }
  },
  slideInLeft: {
    ...rs,
    custom: { offsetX: -16, reverse: !0 }
  },
  scale: {
    ...ev,
    custom: { initialScale: 0.95, reverse: !0 }
  },
  none: {}
}, WF = E(xn.section), HF = (e) => zF[e || "none"], tv = vn(
  (e, t) => {
    const { preset: n, motionProps: r = HF(n), ...o } = e;
    return /* @__PURE__ */ h.jsx(WF, { ref: t, ...r, ...o });
  }
);
tv.displayName = "ModalTransition";
const nv = M(
  (e, t) => {
    const {
      className: n,
      children: r,
      containerProps: o,
      motionProps: s,
      ...i
    } = e, { getDialogProps: a, getDialogContainerProps: c } = lr(), l = a(i, t), u = c(o), d = W("chakra-modal__content", n), f = Vr(), p = {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      width: "100%",
      outline: 0,
      ...f.dialog
    }, m = {
      display: "flex",
      width: "100vw",
      height: "$100vh",
      position: "fixed",
      left: 0,
      top: 0,
      ...f.dialogContainer
    }, { motionPreset: g } = lr();
    return /* @__PURE__ */ h.jsx(Qb, { children: /* @__PURE__ */ h.jsx(
      E.div,
      {
        ...u,
        className: "chakra-modal__content-container",
        tabIndex: -1,
        __css: m,
        children: /* @__PURE__ */ h.jsx(
          tv,
          {
            preset: g,
            motionProps: s,
            className: d,
            ...l,
            __css: p,
            children: r
          }
        )
      }
    ) });
  }
);
nv.displayName = "ModalContent";
const UF = M((e, t) => {
  const { className: n, ...r } = e, { bodyId: o, setBodyMounted: s } = lr();
  xe(() => (s(!0), () => s(!1)), [s]);
  const i = W("chakra-modal__body", n), a = Vr();
  return /* @__PURE__ */ h.jsx(
    E.div,
    {
      ref: t,
      className: i,
      id: o,
      ...r,
      __css: a.body
    }
  );
});
UF.displayName = "ModalBody";
const GF = M(
  (e, t) => {
    const { onClick: n, className: r, ...o } = e, { onClose: s } = lr(), i = W("chakra-modal__close-btn", r), a = Vr();
    return /* @__PURE__ */ h.jsx(
      Sa,
      {
        ref: t,
        __css: a.closeButton,
        className: i,
        onClick: re(n, (c) => {
          c.stopPropagation(), s();
        }),
        ...o
      }
    );
  }
);
GF.displayName = "ModalCloseButton";
const qF = M(
  (e, t) => {
    const { className: n, ...r } = e, o = W("chakra-modal__footer", n), s = Vr(), i = {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      ...s.footer
    };
    return /* @__PURE__ */ h.jsx(
      E.footer,
      {
        ref: t,
        ...r,
        __css: i,
        className: o
      }
    );
  }
);
qF.displayName = "ModalFooter";
const KF = M(
  (e, t) => {
    const { className: n, ...r } = e, { headerId: o, setHeaderMounted: s } = lr();
    xe(() => (s(!0), () => s(!1)), [s]);
    const i = W("chakra-modal__header", n), a = Vr(), c = {
      flex: 0,
      ...a.header
    };
    return /* @__PURE__ */ h.jsx(
      E.header,
      {
        ref: t,
        className: i,
        id: o,
        ...r,
        __css: c
      }
    );
  }
);
KF.displayName = "ModalHeader";
const YF = {
  enter: ({ transition: e, transitionEnd: t, delay: n } = {}) => ({
    opacity: 1,
    transition: (e == null ? void 0 : e.enter) ?? yn.enter(Ir.enter, n),
    transitionEnd: t == null ? void 0 : t.enter
  }),
  exit: ({ transition: e, transitionEnd: t, delay: n } = {}) => ({
    opacity: 0,
    transition: (e == null ? void 0 : e.exit) ?? yn.exit(Ir.exit, n),
    transitionEnd: t == null ? void 0 : t.exit
  })
}, rv = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: YF
}, XF = vn(
  function(t, n) {
    const {
      unmountOnExit: r,
      in: o,
      className: s,
      transition: i,
      transitionEnd: a,
      delay: c,
      animatePresenceProps: l,
      ...u
    } = t, d = o || r ? "enter" : "exit", f = r ? o && r : !0, p = { transition: i, transitionEnd: a, delay: c };
    return /* @__PURE__ */ h.jsx(pr, { ...l, custom: p, children: f && /* @__PURE__ */ h.jsx(
      xn.div,
      {
        ref: n,
        className: W("chakra-fade", s),
        custom: p,
        ...rv,
        animate: d,
        ...u
      }
    ) });
  }
);
XF.displayName = "Fade";
const ZF = E(xn.div), JF = M(
  (e, t) => {
    const { className: n, transition: r, motionProps: o, ...s } = e, i = W("chakra-modal__overlay", n), c = {
      pos: "fixed",
      left: "0",
      top: "0",
      w: "100vw",
      h: "100vh",
      ...Vr().overlay
    }, { motionPreset: l } = lr(), d = o || (l === "none" ? {} : rv);
    return /* @__PURE__ */ h.jsx(
      ZF,
      {
        ...d,
        __css: c,
        ref: t,
        className: i,
        ...s
      }
    );
  }
);
JF.displayName = "ModalOverlay";
function LL(e) {
  const { leastDestructiveRef: t, ...n } = e;
  return /* @__PURE__ */ h.jsx(ud, { ...n, initialFocusRef: t });
}
const VL = M(
  (e, t) => /* @__PURE__ */ h.jsx(nv, { ref: t, role: "alertdialog", ...e })
), [QF, e2] = Ee(), t2 = {
  start: { ltr: "left", rtl: "right" },
  end: { ltr: "right", rtl: "left" }
};
function n2(e, t) {
  var n;
  if (e)
    return ((n = t2[e]) == null ? void 0 : n[t]) ?? e;
}
function zL(e) {
  var l;
  const {
    isOpen: t,
    onClose: n,
    placement: r = "right",
    children: o,
    ...s
  } = e, i = fn(), a = (l = i.components) == null ? void 0 : l.Drawer, c = n2(r, i.direction);
  return /* @__PURE__ */ h.jsx(QF, { value: { placement: c }, children: /* @__PURE__ */ h.jsx(
    ud,
    {
      isOpen: t,
      onClose: n,
      styleConfig: a,
      ...s,
      children: o
    }
  ) });
}
const rh = {
  exit: {
    duration: 0.15,
    ease: Cr.easeInOut
  },
  enter: {
    type: "spring",
    damping: 25,
    stiffness: 180
  }
}, r2 = {
  exit: ({ direction: e, transition: t, transitionEnd: n, delay: r }) => {
    const { exit: o } = Pl({ direction: e });
    return {
      ...o,
      transition: (t == null ? void 0 : t.exit) ?? yn.exit(rh.exit, r),
      transitionEnd: n == null ? void 0 : n.exit
    };
  },
  enter: ({ direction: e, transitionEnd: t, transition: n, delay: r }) => {
    const { enter: o } = Pl({ direction: e });
    return {
      ...o,
      transition: (n == null ? void 0 : n.enter) ?? yn.enter(rh.enter, r),
      transitionEnd: t == null ? void 0 : t.enter
    };
  }
}, ov = vn(
  function(t, n) {
    const {
      direction: r = "right",
      style: o,
      unmountOnExit: s,
      in: i,
      className: a,
      transition: c,
      transitionEnd: l,
      delay: u,
      motionProps: d,
      animatePresenceProps: f,
      ...p
    } = t, m = Pl({ direction: r }), g = Object.assign(
      { position: "fixed" },
      m.position,
      o
    ), y = s ? i && s : !0, S = i || s ? "enter" : "exit", b = { transitionEnd: l, transition: c, direction: r, delay: u };
    return /* @__PURE__ */ h.jsx(pr, { ...f, custom: b, children: y && /* @__PURE__ */ h.jsx(
      xn.div,
      {
        ...p,
        ref: n,
        initial: "exit",
        className: W("chakra-slide", a),
        animate: S,
        exit: "exit",
        custom: b,
        variants: r2,
        style: g,
        ...d
      }
    ) });
  }
);
ov.displayName = "Slide";
const o2 = E(ov), s2 = M(
  (e, t) => {
    const {
      className: n,
      children: r,
      motionProps: o,
      containerProps: s,
      ...i
    } = e, { getDialogProps: a, getDialogContainerProps: c, isOpen: l } = lr(), u = a(i, t), d = c(s), f = W("chakra-modal__content", n), p = Vr(), m = {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      width: "100%",
      outline: 0,
      ...p.dialog
    }, g = {
      display: "flex",
      width: "100vw",
      height: "$100vh",
      position: "fixed",
      left: 0,
      top: 0,
      ...p.dialogContainer
    }, { placement: y } = e2();
    return /* @__PURE__ */ h.jsx(Qb, { children: /* @__PURE__ */ h.jsx(
      E.div,
      {
        ...d,
        className: "chakra-modal__content-container",
        __css: g,
        children: /* @__PURE__ */ h.jsx(
          o2,
          {
            motionProps: o,
            direction: y,
            in: l,
            className: f,
            ...u,
            __css: m,
            children: r
          }
        )
      }
    ) });
  }
);
s2.displayName = "DrawerContent";
const i2 = (e) => /* @__PURE__ */ h.jsx($t, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ h.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M21,5H3C2.621,5,2.275,5.214,2.105,5.553C1.937,5.892,1.973,6.297,2.2,6.6l9,12 c0.188,0.252,0.485,0.4,0.8,0.4s0.611-0.148,0.8-0.4l9-12c0.228-0.303,0.264-0.708,0.095-1.047C21.725,5.214,21.379,5,21,5z"
  }
) }), a2 = (e) => /* @__PURE__ */ h.jsx($t, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ h.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M12.8,5.4c-0.377-0.504-1.223-0.504-1.6,0l-9,12c-0.228,0.303-0.264,0.708-0.095,1.047 C2.275,18.786,2.621,19,3,19h18c0.379,0,0.725-0.214,0.895-0.553c0.169-0.339,0.133-0.744-0.095-1.047L12.8,5.4z"
  }
) });
function oh(e, t, n, r) {
  xe(() => {
    if (!e.current || !r)
      return;
    const o = e.current.ownerDocument.defaultView ?? window, s = Array.isArray(t) ? t : [t], i = new o.MutationObserver((a) => {
      for (const c of a)
        c.type === "attributes" && c.attributeName && s.includes(c.attributeName) && n(c);
    });
    return i.observe(e.current, { attributes: !0, attributeFilter: s }), () => i.disconnect();
  });
}
const c2 = 50, sh = 300;
function l2(e, t) {
  const [n, r] = he(!1), [o, s] = he(null), [i, a] = he(!0), c = ae(null), l = () => clearTimeout(c.current);
  lx(
    () => {
      o === "increment" && e(), o === "decrement" && t();
    },
    n ? c2 : null
  );
  const u = R(() => {
    i && e(), c.current = setTimeout(() => {
      a(!1), r(!0), s("increment");
    }, sh);
  }, [e, i]), d = R(() => {
    i && t(), c.current = setTimeout(() => {
      a(!1), r(!0), s("decrement");
    }, sh);
  }, [t, i]), f = R(() => {
    a(!0), r(!1), l();
  }, []);
  return xe(() => () => l(), []), { up: u, down: d, stop: f, isSpinning: n };
}
const u2 = /^[Ee0-9+\-.]$/;
function d2(e) {
  return u2.test(e);
}
function f2(e, t) {
  if (e.key == null)
    return !0;
  const n = e.ctrlKey || e.altKey || e.metaKey;
  return !(e.key.length === 1) || n ? !0 : t(e.key);
}
function p2(e = {}) {
  const {
    focusInputOnChange: t = !0,
    clampValueOnBlur: n = !0,
    keepWithinRange: r = !0,
    min: o = Number.MIN_SAFE_INTEGER,
    max: s = Number.MAX_SAFE_INTEGER,
    step: i = 1,
    isReadOnly: a,
    isDisabled: c,
    isRequired: l,
    isInvalid: u,
    pattern: d = "[0-9]*(.[0-9]+)?",
    inputMode: f = "decimal",
    allowMouseWheel: p,
    id: m,
    onChange: g,
    precision: y,
    name: S,
    "aria-describedby": b,
    "aria-label": v,
    "aria-labelledby": k,
    onFocus: w,
    onBlur: _,
    onInvalid: C,
    getAriaValueText: I,
    isValidCharacter: $,
    format: N,
    parse: z,
    ...Q
  } = e, U = nt(w), q = nt(_), le = nt(C), Z = nt(
    $ ?? d2
  ), j = nt(I), K = X0(e), {
    update: ne,
    increment: B,
    decrement: O
  } = K, [ee, D] = he(!1), V = !(a || c), Y = ae(null), J = ae(null), se = ae(null), ue = ae(null), G = R(
    (te) => te.split("").filter(Z).join(""),
    [Z]
  ), H = R(
    (te) => (z == null ? void 0 : z(te)) ?? te,
    [z]
  ), de = R(
    (te) => ((N == null ? void 0 : N(te)) ?? te).toString(),
    [N]
  );
  bn(() => {
    (K.valueAsNumber > s || K.valueAsNumber < o) && (le == null || le("rangeOverflow", de(K.value), K.valueAsNumber));
  }, [K.valueAsNumber, K.value, de, le]), an(() => {
    if (!Y.current)
      return;
    if (Y.current.value != K.value) {
      const We = H(Y.current.value);
      K.setValue(G(We));
    }
  }, [H, G]);
  const L = R(
    (te = i) => {
      V && B(te);
    },
    [B, V, i]
  ), me = R(
    (te = i) => {
      V && O(te);
    },
    [O, V, i]
  ), oe = l2(L, me);
  oh(
    se,
    "disabled",
    oe.stop,
    oe.isSpinning
  ), oh(
    ue,
    "disabled",
    oe.stop,
    oe.isSpinning
  );
  const $e = R(
    (te) => {
      if (te.nativeEvent.isComposing)
        return;
      const ie = H(te.currentTarget.value);
      ne(G(ie)), J.current = {
        start: te.currentTarget.selectionStart,
        end: te.currentTarget.selectionEnd
      };
    },
    [ne, G, H]
  ), Oe = R(
    (te) => {
      var We;
      U == null || U(te), J.current && (te.currentTarget.selectionStart = J.current.start ?? ((We = te.currentTarget.value) == null ? void 0 : We.length), te.currentTarget.selectionEnd = J.current.end ?? te.currentTarget.selectionStart);
    },
    [U]
  ), ce = R(
    (te) => {
      if (te.nativeEvent.isComposing)
        return;
      f2(te, Z) || te.preventDefault();
      const We = Ne(te) * i, ie = te.key, gt = {
        ArrowUp: () => L(We),
        ArrowDown: () => me(We),
        Home: () => ne(o),
        End: () => ne(s)
      }[ie];
      gt && (te.preventDefault(), gt(te));
    },
    [Z, i, L, me, ne, o, s]
  ), Ne = (te) => {
    let We = 1;
    return (te.metaKey || te.ctrlKey) && (We = 0.1), te.shiftKey && (We = 10), We;
  }, Ie = _e(() => {
    const te = j == null ? void 0 : j(K.value);
    if (te != null)
      return te;
    const We = K.value.toString();
    return We || void 0;
  }, [K.value, j]), Re = R(() => {
    let te = K.value;
    if (K.value === "")
      return;
    /^[eE]/.test(K.value.toString()) ? K.setValue("") : (K.valueAsNumber < o && (te = o), K.valueAsNumber > s && (te = s), K.cast(te));
  }, [K, s, o]), Xe = R(() => {
    D(!1), n && Re();
  }, [n, D, Re]), tt = R(() => {
    t && requestAnimationFrame(() => {
      var te;
      (te = Y.current) == null || te.focus();
    });
  }, [t]), it = R(
    (te) => {
      te.preventDefault(), oe.up(), tt();
    },
    [tt, oe]
  ), At = R(
    (te) => {
      te.preventDefault(), oe.down(), tt();
    },
    [tt, oe]
  );
  _r(
    () => Y.current,
    "wheel",
    (te) => {
      var Dt;
      const ie = (((Dt = Y.current) == null ? void 0 : Dt.ownerDocument) ?? document).activeElement === Y.current;
      if (!p || !ie)
        return;
      te.preventDefault();
      const be = Ne(te) * i, gt = Math.sign(te.deltaY);
      gt === -1 ? L(be) : gt === 1 && me(be);
    },
    { passive: !1 }
  );
  const Vt = R(
    (te = {}, We = null) => {
      const ie = c || r && K.isAtMax;
      return {
        ...te,
        ref: De(We, se),
        role: "button",
        tabIndex: -1,
        onPointerDown: re(te.onPointerDown, (be) => {
          be.button !== 0 || ie || it(be);
        }),
        onPointerLeave: re(te.onPointerLeave, oe.stop),
        onPointerUp: re(te.onPointerUp, oe.stop),
        disabled: ie,
        "aria-disabled": wt(ie)
      };
    },
    [K.isAtMax, r, it, oe.stop, c]
  ), qt = R(
    (te = {}, We = null) => {
      const ie = c || r && K.isAtMin;
      return {
        ...te,
        ref: De(We, ue),
        role: "button",
        tabIndex: -1,
        onPointerDown: re(te.onPointerDown, (be) => {
          be.button !== 0 || ie || At(be);
        }),
        onPointerLeave: re(te.onPointerLeave, oe.stop),
        onPointerUp: re(te.onPointerUp, oe.stop),
        disabled: ie,
        "aria-disabled": wt(ie)
      };
    },
    [K.isAtMin, r, At, oe.stop, c]
  ), Nt = R(
    (te = {}, We = null) => ({
      name: S,
      inputMode: f,
      type: "text",
      pattern: d,
      "aria-labelledby": k,
      "aria-label": v,
      "aria-describedby": b,
      id: m,
      disabled: c,
      role: "spinbutton",
      ...te,
      readOnly: te.readOnly ?? a,
      "aria-readonly": te.readOnly ?? a,
      "aria-required": te.required ?? l,
      required: te.required ?? l,
      ref: De(Y, We),
      value: de(K.value),
      "aria-valuemin": o,
      "aria-valuemax": s,
      "aria-valuenow": Number.isNaN(K.valueAsNumber) ? void 0 : K.valueAsNumber,
      "aria-invalid": wt(u ?? K.isOutOfRange),
      "aria-valuetext": Ie,
      autoComplete: "off",
      autoCorrect: "off",
      onChange: re(te.onChange, $e),
      onKeyDown: re(te.onKeyDown, ce),
      onFocus: re(
        te.onFocus,
        Oe,
        () => D(!0)
      ),
      onBlur: re(te.onBlur, q, Xe)
    }),
    [
      S,
      f,
      d,
      k,
      v,
      de,
      b,
      m,
      c,
      l,
      a,
      u,
      K.value,
      K.valueAsNumber,
      K.isOutOfRange,
      o,
      s,
      Ie,
      $e,
      ce,
      Oe,
      q,
      Xe
    ]
  );
  return {
    value: de(K.value),
    valueAsNumber: K.valueAsNumber,
    isFocused: ee,
    isDisabled: c,
    isReadOnly: a,
    getIncrementButtonProps: Vt,
    getDecrementButtonProps: qt,
    getInputProps: Nt,
    htmlProps: Q
  };
}
const [h2, Ia] = Ee({
  name: "NumberInputStylesContext",
  errorMessage: `useNumberInputStyles returned is 'undefined'. Seems you forgot to wrap the components in "<NumberInput />" `
}), [m2, dd] = Ee({
  name: "NumberInputContext",
  errorMessage: "useNumberInputContext: `context` is undefined. Seems you forgot to wrap number-input's components within <NumberInput />"
}), g2 = M(
  function(t, n) {
    const r = Je("NumberInput", t), o = Ae(t), s = Fu(o), { htmlProps: i, ...a } = p2(s), c = _e(() => a, [a]);
    return /* @__PURE__ */ h.jsx(m2, { value: c, children: /* @__PURE__ */ h.jsx(h2, { value: r, children: /* @__PURE__ */ h.jsx(
      E.div,
      {
        ...i,
        ref: n,
        className: W("chakra-numberinput", t.className),
        __css: {
          position: "relative",
          zIndex: 0,
          ...r.root
        }
      }
    ) }) });
  }
);
g2.displayName = "NumberInput";
const y2 = M(
  function(t, n) {
    const r = Ia();
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        "aria-hidden": !0,
        ref: n,
        ...t,
        __css: {
          display: "flex",
          flexDirection: "column",
          position: "absolute",
          top: "0",
          insetEnd: "0px",
          margin: "1px",
          height: "calc(100% - 2px)",
          zIndex: 1,
          ...r.stepperGroup
        }
      }
    );
  }
);
y2.displayName = "NumberInputStepper";
const b2 = M(
  function(t, n) {
    const { getInputProps: r } = dd(), o = r(t, n), s = Ia();
    return /* @__PURE__ */ h.jsx(
      E.input,
      {
        ...o,
        className: W("chakra-numberinput__field", t.className),
        __css: {
          width: "100%",
          ...s.field
        }
      }
    );
  }
);
b2.displayName = "NumberInputField";
const sv = E("div", {
  baseStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    transitionProperty: "common",
    transitionDuration: "normal",
    userSelect: "none",
    cursor: "pointer",
    lineHeight: "normal"
  }
}), v2 = M(function(t, n) {
  const r = Ia(), { getDecrementButtonProps: o } = dd(), s = o(t, n);
  return /* @__PURE__ */ h.jsx(sv, { ...s, __css: r.stepper, children: t.children ?? /* @__PURE__ */ h.jsx(i2, {}) });
});
v2.displayName = "NumberDecrementStepper";
const x2 = M(function(t, n) {
  const { getIncrementButtonProps: r } = dd(), o = r(t, n), s = Ia();
  return /* @__PURE__ */ h.jsx(sv, { ...o, __css: s.stepper, children: t.children ?? /* @__PURE__ */ h.jsx(a2, {}) });
});
x2.displayName = "NumberIncrementStepper";
const [
  S2,
  WL,
  w2,
  k2
] = wa(), [P2, C2] = Ee({
  name: "PinInputContext",
  errorMessage: "usePinInputContext: `context` is undefined. Seems you forgot to place all pin input fields within `<PinInput />`"
}), ih = (e) => e == null ? void 0 : e.split("");
function ah(e, t) {
  return (t === "alphanumeric" ? /^[a-zA-Z0-9]+$/i : /^[0-9]+$/).test(e);
}
function _2(e = {}) {
  const {
    autoFocus: t,
    value: n,
    defaultValue: r,
    onChange: o,
    onComplete: s,
    placeholder: i = "○",
    manageFocus: a = !0,
    otp: c = !1,
    id: l,
    isDisabled: u,
    isInvalid: d,
    type: f = "number",
    mask: p
  } = e, m = Rt(), g = l ?? `pin-input-${m}`, y = w2(), [S, b] = he(!0), [v, k] = he(-1), [w, _] = dr({
    defaultValue: ih(r) || [],
    value: ih(n),
    onChange: (Q) => o == null ? void 0 : o(Q.join(""))
  });
  xe(() => {
    if (t) {
      const Q = y.first();
      Q && requestAnimationFrame(() => {
        Q.node.focus();
      });
    }
  }, [y]);
  const C = R(
    (Q) => {
      if (!S || !a)
        return;
      const U = y.next(Q, !1);
      U && requestAnimationFrame(() => {
        U.node.focus();
      });
    },
    [y, S, a]
  ), I = R(
    (Q, U, q = !0) => {
      const le = [...w];
      le[U] = Q, _(le), Q !== "" && le.length === y.count() && le.every(
        (j) => j != null && j !== ""
      ) ? s == null || s(le.join("")) : q && C(U);
    },
    [w, _, C, s, y]
  ), $ = R(() => {
    var q;
    const Q = Array(y.count()).fill("");
    _(Q);
    const U = y.first();
    (q = U == null ? void 0 : U.node) == null || q.focus();
  }, [y, _]), N = R((Q, U) => {
    let q = U;
    return (Q == null ? void 0 : Q.length) > 0 && (Q[0] === U.charAt(0) ? q = U.charAt(1) : Q[0] === U.charAt(1) && (q = U.charAt(0))), q;
  }, []);
  return {
    // prop getter
    getInputProps: R(
      (Q) => {
        const { index: U, ...q } = Q, le = (O) => {
          const ee = O.currentTarget.value, D = w[U], V = N(D, ee);
          if (V === "") {
            I("", U);
            return;
          }
          if (ee.length > 2) {
            if (ah(ee, f)) {
              const Y = ee.split("").filter((J, se) => se < y.count());
              _(Y), Y.length === y.count() && (s == null || s(Y.join("")));
            }
          } else
            ah(V, f) && I(V, U), b(!0);
        }, Z = (O) => {
          var ee;
          if (O.key === "Backspace" && a)
            if (O.currentTarget.value === "") {
              const D = y.prev(U, !1);
              D && (I("", U - 1, !1), (ee = D.node) == null || ee.focus(), b(!0));
            } else
              b(!1);
        }, j = () => {
          k(U);
        }, K = () => {
          k(-1);
        }, ne = v === U;
        return {
          "aria-label": "Please enter your pin code",
          inputMode: f === "number" ? "numeric" : "text",
          type: p ? "password" : f === "number" ? "tel" : "text",
          ...q,
          id: `${g}-${U}`,
          disabled: u,
          "aria-invalid": wt(d),
          onChange: re(q.onChange, le),
          onKeyDown: re(q.onKeyDown, Z),
          onFocus: re(q.onFocus, j),
          onBlur: re(q.onBlur, K),
          value: w[U] || "",
          autoComplete: c ? "one-time-code" : "off",
          placeholder: ne ? "" : i
        };
      },
      [
        y,
        v,
        N,
        g,
        u,
        p,
        d,
        a,
        s,
        c,
        i,
        I,
        _,
        f,
        w
      ]
    ),
    // state
    id: g,
    descendants: y,
    values: w,
    // actions
    setValue: I,
    setValues: _,
    clear: $
  };
}
function T2(e = {}, t = null) {
  const { getInputProps: n } = C2(), { index: r, register: o } = k2();
  return n({
    ...e,
    ref: De(o, t),
    index: e.index ?? r
  });
}
function E2(e) {
  const t = Ct("PinInput", e), { children: n, ...r } = Ae(e), { descendants: o, ...s } = _2(r), i = Yn(n).map(
    (a) => kt(a, { __css: t })
  );
  return /* @__PURE__ */ h.jsx(S2, { value: o, children: /* @__PURE__ */ h.jsx(P2, { value: s, children: i }) });
}
E2.displayName = "PinInput";
const A2 = M(
  function(t, n) {
    const r = T2(t, n);
    return /* @__PURE__ */ h.jsx(
      E.input,
      {
        ...r,
        className: W("chakra-pin-input", t.className)
      }
    );
  }
);
A2.displayName = "PinInputField";
const [I2, mr] = Ee({
  name: "PopoverContext",
  errorMessage: "usePopoverContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Popover />`"
}), [R2, Mo] = Ee({
  name: "PopoverStylesContext",
  errorMessage: `usePopoverStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Popover />" `
}), Zr = {
  click: "click",
  hover: "hover"
};
function $2(e = {}) {
  const {
    closeOnBlur: t = !0,
    closeOnEsc: n = !0,
    initialFocusRef: r,
    id: o,
    returnFocusOnClose: s = !0,
    autoFocus: i = !0,
    arrowSize: a,
    arrowShadowColor: c,
    trigger: l = Zr.click,
    openDelay: u = 200,
    closeDelay: d = 200,
    isLazy: f,
    lazyBehavior: p = "unmount",
    computePositionOnMount: m,
    ...g
  } = e, { isOpen: y, onClose: S, onOpen: b, onToggle: v } = Yl(e), [k, w] = he(s);
  xe(() => w(s), [s]);
  const _ = ae(null), C = ae(null), I = ae(null), $ = ae(!1), N = ae(!1);
  y && (N.current = !0);
  const [z, Q] = he(!1), [U, q] = he(!1), le = Rt(), Z = o ?? le, [j, K, ne, B] = [
    "popover-trigger",
    "popover-content",
    "popover-header",
    "popover-body"
  ].map((ce) => `${ce}-${Z}`), {
    referenceRef: O,
    getArrowProps: ee,
    getPopperProps: D,
    getArrowInnerProps: V,
    forceUpdate: Y
  } = ld({
    ...g,
    enabled: y || !!m
  }), J = Wh({ isOpen: y, ref: I });
  qh({
    enabled: y,
    ref: C
  }), Uh(I, {
    focusRef: C,
    visible: y,
    shouldFocus: k && l === Zr.click
  }), Q0(I, {
    focusRef: r,
    visible: y,
    shouldFocus: i && l === Zr.click
  }), Yh({
    enabled: y && t,
    ref: I,
    handler(ce) {
      var Ie;
      const Ne = ((Ie = ce.composedPath) == null ? void 0 : Ie.call(ce)[0]) ?? [
        ce.target
      ];
      wi(C.current, Ne) || (Ne && w(!Vi(Ne)), S());
    }
  });
  const se = ql({
    wasSelected: N.current,
    enabled: f,
    mode: p,
    isSelected: J.present
  }), ue = R(
    (ce = {}, Ne = null) => {
      const Ie = {
        ...ce,
        style: {
          ...ce.style,
          transformOrigin: bt.transformOrigin.varRef,
          [bt.arrowSize.var]: a ? `${a}px` : void 0,
          [bt.arrowShadowColor.var]: c
        },
        ref: De(I, Ne),
        children: se ? ce.children : null,
        id: K,
        tabIndex: -1,
        role: "dialog",
        onKeyDown: re(ce.onKeyDown, (Re) => {
          Re.nativeEvent.isComposing || n && Re.key === "Escape" && (Re.preventDefault(), Re.stopPropagation(), S());
        }),
        onBlur: re(ce.onBlur, (Re) => {
          const Xe = ch(Re), tt = wi(I.current, Xe), it = wi(C.current, Xe), At = !tt && !it;
          Xe && w(!Vi(Xe)), y && t && At && S();
        }),
        "aria-labelledby": z ? ne : void 0,
        "aria-describedby": U ? B : void 0
      };
      return l === Zr.hover && (Ie.role = "tooltip", Ie.onMouseEnter = re(ce.onMouseEnter, () => {
        $.current = !0;
      }), Ie.onMouseLeave = re(
        ce.onMouseLeave,
        (Re) => {
          Re.nativeEvent.relatedTarget !== null && ($.current = !1, setTimeout(() => S(), d));
        }
      )), Ie;
    },
    [
      se,
      K,
      z,
      ne,
      U,
      B,
      l,
      n,
      S,
      y,
      t,
      d,
      c,
      a
    ]
  ), G = R(
    (ce = {}, Ne = null) => D(
      {
        ...ce,
        style: {
          visibility: y ? "visible" : "hidden",
          ...ce.style
        }
      },
      Ne
    ),
    [y, D]
  ), H = R(
    (ce, Ne = null) => ({
      ...ce,
      // If anchor is rendered, it is used as reference.
      ref: De(Ne, _, O)
    }),
    [_, O]
  ), de = ae(void 0), L = ae(void 0), me = R(
    (ce) => {
      _.current == null && O(ce);
    },
    [O]
  ), oe = R(
    (ce = {}, Ne = null) => {
      const Ie = {
        ...ce,
        ref: De(C, Ne, me),
        id: j,
        "aria-haspopup": "dialog",
        "aria-expanded": y,
        "aria-controls": K
      };
      return l === Zr.click && (Ie.onClick = re(ce.onClick, v)), l === Zr.hover && (Ie.onFocus = re(ce.onFocus, () => {
        de.current === void 0 && b();
      }), Ie.onBlur = re(ce.onBlur, (Re) => {
        const Xe = ch(Re), tt = !wi(I.current, Xe);
        y && t && tt && S();
      }), Ie.onKeyDown = re(ce.onKeyDown, (Re) => {
        Re.key === "Escape" && S();
      }), Ie.onMouseEnter = re(ce.onMouseEnter, () => {
        $.current = !0, de.current = window.setTimeout(() => b(), u);
      }), Ie.onMouseLeave = re(ce.onMouseLeave, () => {
        $.current = !1, de.current && (clearTimeout(de.current), de.current = void 0), L.current = window.setTimeout(() => {
          $.current === !1 && S();
        }, d);
      })), Ie;
    },
    [
      j,
      y,
      K,
      l,
      me,
      v,
      b,
      t,
      S,
      u,
      d
    ]
  );
  xe(() => () => {
    de.current && clearTimeout(de.current), L.current && clearTimeout(L.current);
  }, []);
  const $e = R(
    (ce = {}, Ne = null) => ({
      ...ce,
      id: ne,
      ref: De(Ne, (Ie) => {
        Q(!!Ie);
      })
    }),
    [ne]
  ), Oe = R(
    (ce = {}, Ne = null) => ({
      ...ce,
      id: B,
      ref: De(Ne, (Ie) => {
        q(!!Ie);
      })
    }),
    [B]
  );
  return {
    forceUpdate: Y,
    isOpen: y,
    onAnimationComplete: J.onComplete,
    onClose: S,
    getAnchorProps: H,
    getArrowProps: ee,
    getArrowInnerProps: V,
    getPopoverPositionerProps: G,
    getPopoverProps: ue,
    getTriggerProps: oe,
    getHeaderProps: $e,
    getBodyProps: Oe
  };
}
function wi(e, t) {
  return e === t || (e == null ? void 0 : e.contains(t));
}
function ch(e) {
  const t = e.currentTarget.ownerDocument.activeElement;
  return e.relatedTarget ?? t;
}
function N2(e) {
  const t = Je("Popover", e), { children: n, ...r } = Ae(e), o = fn(), s = $2({ ...r, direction: o.direction });
  return /* @__PURE__ */ h.jsx(I2, { value: s, children: /* @__PURE__ */ h.jsx(R2, { value: t, children: Et(n, {
    isOpen: s.isOpen,
    onClose: s.onClose,
    forceUpdate: s.forceUpdate
  }) }) });
}
N2.displayName = "Popover";
function fd(e) {
  var n;
  const t = we.version;
  return typeof t != "string" || t.startsWith("18.") ? e == null ? void 0 : e.ref : (n = e == null ? void 0 : e.props) == null ? void 0 : n.ref;
}
function M2(e) {
  const t = $n.only(e.children), { getAnchorProps: n } = mr();
  return /* @__PURE__ */ h.jsx(h.Fragment, { children: kt(t, n(t.props, fd(t))) });
}
M2.displayName = "PopoverAnchor";
const qc = (e, t) => t ? `${e}.${t}, ${t}` : void 0;
function j2(e) {
  const {
    bg: t,
    bgColor: n,
    backgroundColor: r,
    shadow: o,
    boxShadow: s,
    shadowColor: i,
    ...a
  } = e, { getArrowProps: c, getArrowInnerProps: l } = mr(), u = Mo(), d = t ?? n ?? r, f = o ?? s;
  return /* @__PURE__ */ h.jsx(
    E.div,
    {
      ...c(),
      className: "chakra-popover__arrow-positioner",
      children: /* @__PURE__ */ h.jsx(
        E.div,
        {
          className: W("chakra-popover__arrow", e.className),
          ...l(a),
          __css: {
            "--popper-arrow-shadow-color": qc("colors", i),
            "--popper-arrow-bg": qc("colors", d),
            "--popper-arrow-shadow": qc("shadows", f),
            ...u.arrow
          }
        }
      )
    }
  );
}
j2.displayName = "PopoverArrow";
const D2 = M(
  function(t, n) {
    const { getBodyProps: r } = mr(), o = Mo();
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ...r(t, n),
        className: W("chakra-popover__body", t.className),
        __css: o.body
      }
    );
  }
);
D2.displayName = "PopoverBody";
const O2 = M(
  function(t, n) {
    const { onClose: r } = mr(), o = Mo();
    return /* @__PURE__ */ h.jsx(
      Sa,
      {
        size: "sm",
        onClick: r,
        className: W("chakra-popover__close-btn", t.className),
        __css: o.closeButton,
        ref: n,
        ...t
      }
    );
  }
);
O2.displayName = "PopoverCloseButton";
function F2(e) {
  if (e)
    return {
      enter: {
        ...e.enter,
        visibility: "visible"
      },
      exit: {
        ...e.exit,
        transitionEnd: {
          visibility: "hidden"
        }
      }
    };
}
const B2 = {
  exit: {
    opacity: 0,
    scale: 0.95,
    transition: {
      duration: 0.1,
      ease: [0.4, 0, 1, 1]
    }
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 0.15,
      ease: [0, 0, 0.2, 1]
    }
  }
}, L2 = E(xn.section), iv = M(function(t, n) {
  const { variants: r = B2, ...o } = t, { isOpen: s } = mr();
  return /* @__PURE__ */ h.jsx(
    L2,
    {
      ref: n,
      variants: F2(r),
      initial: !1,
      animate: s ? "enter" : "exit",
      ...o
    }
  );
});
iv.displayName = "PopoverTransition";
const V2 = M(
  function(t, n) {
    const { rootProps: r, motionProps: o, ...s } = t, { getPopoverProps: i, getPopoverPositionerProps: a, onAnimationComplete: c } = mr(), l = Mo(), u = {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      ...l.content
    };
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ...a(r),
        __css: l.popper,
        className: "chakra-popover__popper",
        children: /* @__PURE__ */ h.jsx(
          iv,
          {
            ...o,
            ...i(s, n),
            onAnimationComplete: aa(
              c,
              s.onAnimationComplete
            ),
            className: W("chakra-popover__content", t.className),
            __css: u
          }
        )
      }
    );
  }
);
V2.displayName = "PopoverContent";
function z2(e) {
  const t = Mo();
  return /* @__PURE__ */ h.jsx(
    E.footer,
    {
      ...e,
      className: W("chakra-popover__footer", e.className),
      __css: t.footer
    }
  );
}
z2.displayName = "PopoverFooter";
const W2 = M(
  function(t, n) {
    const { getHeaderProps: r } = mr(), o = Mo();
    return /* @__PURE__ */ h.jsx(
      E.header,
      {
        ...r(t, n),
        className: W("chakra-popover__header", t.className),
        __css: o.header
      }
    );
  }
);
W2.displayName = "PopoverHeader";
function H2(e) {
  const t = $n.only(e.children), { getTriggerProps: n } = mr();
  return /* @__PURE__ */ h.jsx(h.Fragment, { children: kt(t, n(t.props, fd(t))) });
}
H2.displayName = "PopoverTrigger";
const Ll = (e) => /* @__PURE__ */ h.jsx(E.circle, { cx: 50, cy: 50, r: 42, fill: "transparent", ...e });
Ll.displayName = "Circle";
function U2(e, t, n) {
  return (e - t) * 100 / (n - t);
}
const G2 = Mn({
  "0%": {
    strokeDasharray: "1, 400",
    strokeDashoffset: "0"
  },
  "50%": {
    strokeDasharray: "400, 400",
    strokeDashoffset: "-100"
  },
  "100%": {
    strokeDasharray: "400, 400",
    strokeDashoffset: "-260"
  }
}), q2 = Mn({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
}), K2 = Mn({
  "0%": { left: "-40%" },
  "100%": { left: "100%" }
}), Y2 = Mn({
  from: { backgroundPosition: "1rem 0" },
  to: { backgroundPosition: "0 0" }
});
function av(e) {
  const {
    value: t = 0,
    min: n,
    max: r,
    valueText: o,
    getValueText: s,
    isIndeterminate: i,
    role: a = "progressbar"
  } = e, c = U2(t, n, r);
  return {
    bind: {
      "data-indeterminate": i ? "" : void 0,
      "aria-valuemax": r,
      "aria-valuemin": n,
      "aria-valuenow": i ? void 0 : t,
      "aria-valuetext": (() => {
        if (t != null)
          return typeof s == "function" ? s(t, c) : o;
      })(),
      role: a
    },
    percent: c,
    value: t
  };
}
const cv = (e) => {
  const { size: t, isIndeterminate: n, ...r } = e;
  return /* @__PURE__ */ h.jsx(
    E.svg,
    {
      viewBox: "0 0 100 100",
      __css: {
        width: t,
        height: t,
        animation: n ? `${q2} 2s linear infinite` : void 0
      },
      ...r
    }
  );
};
cv.displayName = "Shape";
const X2 = M(
  (e, t) => {
    const {
      size: n = "48px",
      max: r = 100,
      min: o = 0,
      valueText: s,
      getValueText: i,
      value: a,
      capIsRound: c,
      children: l,
      thickness: u = "10px",
      color: d = "#0078d4",
      trackColor: f = "#edebe9",
      isIndeterminate: p,
      ...m
    } = e, g = av({
      min: o,
      max: r,
      value: a,
      valueText: s,
      getValueText: i,
      isIndeterminate: p
    }), y = p ? void 0 : (g.percent ?? 0) * 2.64, S = y == null ? void 0 : `${y} ${264 - y}`, b = p ? {
      css: { animation: `${G2} 1.5s linear infinite` }
    } : {
      strokeDashoffset: 66,
      strokeDasharray: S,
      transitionProperty: "stroke-dasharray, stroke",
      transitionDuration: "0.6s",
      transitionTimingFunction: "ease"
    }, v = {
      display: "inline-block",
      position: "relative",
      verticalAlign: "middle",
      fontSize: n
    };
    return /* @__PURE__ */ h.jsxs(
      E.div,
      {
        ref: t,
        className: "chakra-progress",
        ...g.bind,
        ...m,
        __css: v,
        children: [
          /* @__PURE__ */ h.jsxs(cv, { size: n, isIndeterminate: p, children: [
            /* @__PURE__ */ h.jsx(
              Ll,
              {
                stroke: f,
                strokeWidth: u,
                className: "chakra-progress__track"
              }
            ),
            /* @__PURE__ */ h.jsx(
              Ll,
              {
                stroke: d,
                strokeWidth: u,
                className: "chakra-progress__indicator",
                strokeLinecap: c ? "round" : void 0,
                opacity: g.value === 0 && !p ? 0 : void 0,
                ...b
              }
            )
          ] }),
          l
        ]
      }
    );
  }
);
X2.displayName = "CircularProgress";
const [Z2, lv] = Ee({
  name: "ProgressStylesContext",
  errorMessage: `useProgressStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Progress />" `
}), J2 = M(
  (e, t) => {
    const { min: n, max: r, value: o, isIndeterminate: s, role: i, ...a } = e, c = av({
      value: o,
      min: n,
      max: r,
      isIndeterminate: s,
      role: i
    }), u = {
      height: "100%",
      ...lv().filledTrack
    };
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ref: t,
        style: { width: `${c.percent}%`, ...a.style },
        ...c.bind,
        ...a,
        __css: u
      }
    );
  }
), Q2 = M((e, t) => {
  var C;
  const {
    value: n,
    min: r = 0,
    max: o = 100,
    hasStripe: s,
    isAnimated: i,
    children: a,
    borderRadius: c,
    isIndeterminate: l,
    "aria-label": u,
    "aria-labelledby": d,
    "aria-valuetext": f,
    title: p,
    role: m,
    ...g
  } = Ae(e), y = Je("Progress", e), S = c ?? ((C = y.track) == null ? void 0 : C.borderRadius), b = { animation: `${Y2} 1s linear infinite` }, w = {
    ...!l && s && i && b,
    ...l && {
      position: "absolute",
      willChange: "left",
      minWidth: "50%",
      animation: `${K2} 1s ease infinite normal none running`
    }
  }, _ = {
    overflow: "hidden",
    position: "relative",
    ...y.track
  };
  return /* @__PURE__ */ h.jsx(
    E.div,
    {
      ref: t,
      borderRadius: S,
      __css: _,
      ...g,
      children: /* @__PURE__ */ h.jsxs(Z2, { value: y, children: [
        /* @__PURE__ */ h.jsx(
          J2,
          {
            "aria-label": u,
            "aria-labelledby": d,
            "aria-valuetext": f,
            min: r,
            max: o,
            value: n,
            isIndeterminate: l,
            css: w,
            borderRadius: S,
            title: p,
            role: m
          }
        ),
        a
      ] })
    }
  );
});
Q2.displayName = "Progress";
const eB = (e) => {
  const t = lv(), n = {
    top: "50%",
    left: "50%",
    width: "100%",
    textAlign: "center",
    position: "absolute",
    transform: "translate(-50%, -50%)",
    ...t.label
  };
  return /* @__PURE__ */ h.jsx(E.div, { ...e, __css: n });
};
eB.displayName = "ProgressLabel";
const tB = E("div", {
  baseStyle: {
    fontSize: "0.24em",
    top: "50%",
    left: "50%",
    width: "100%",
    textAlign: "center",
    position: "absolute",
    transform: "translate(-50%, -50%)"
  }
});
tB.displayName = "CircularProgressLabel";
function nB(e) {
  return e && lt(e) && lt(e.target);
}
function rB(e = {}) {
  const {
    onChange: t,
    value: n,
    defaultValue: r,
    name: o,
    isDisabled: s,
    isFocusable: i,
    isNative: a,
    ...c
  } = e, [l, u] = he(r || ""), d = typeof n < "u", f = d ? n : l, p = ae(null), m = R(() => {
    const w = p.current;
    if (!w)
      return;
    let _ = "input:not(:disabled):checked";
    const C = w.querySelector(
      _
    );
    if (C) {
      C.focus();
      return;
    }
    _ = "input:not(:disabled)";
    const I = w.querySelector(_);
    I == null || I.focus();
  }, []), y = `radio-${Rt()}`, S = o || y, b = R(
    (w) => {
      const _ = nB(w) ? w.target.value : w;
      d || u(_), t == null || t(String(_));
    },
    [t, d]
  ), v = R(
    (w = {}, _ = null) => ({
      ...w,
      ref: De(_, p),
      role: "radiogroup"
    }),
    []
  ), k = R(
    (w = {}, _ = null) => ({
      ...w,
      ref: _,
      name: S,
      [a ? "checked" : "isChecked"]: f != null ? w.value === f : void 0,
      onChange(I) {
        b(I);
      },
      "data-radiogroup": !0
    }),
    [a, S, b, f]
  );
  return {
    getRootProps: v,
    getRadioProps: k,
    name: S,
    ref: p,
    focus: m,
    setValue: u,
    value: f,
    onChange: b,
    isDisabled: s,
    isFocusable: i,
    htmlProps: c
  };
}
const [oB, uv] = Ee({
  name: "RadioGroupContext",
  strict: !1
}), sB = M((e, t) => {
  const {
    colorScheme: n,
    size: r,
    variant: o,
    children: s,
    className: i,
    isDisabled: a,
    isFocusable: c,
    ...l
  } = e, { value: u, onChange: d, getRootProps: f, name: p, htmlProps: m } = rB(l), g = _e(
    () => ({
      name: p,
      size: r,
      onChange: d,
      colorScheme: n,
      value: u,
      variant: o,
      isDisabled: a,
      isFocusable: c
    }),
    [
      p,
      r,
      d,
      n,
      u,
      o,
      a,
      c
    ]
  );
  return /* @__PURE__ */ h.jsx(oB, { value: g, children: /* @__PURE__ */ h.jsx(
    E.div,
    {
      ...f(m, t),
      className: W("chakra-radio-group", i),
      children: s
    }
  ) });
});
sB.displayName = "RadioGroup";
function iB(e = {}) {
  const {
    defaultChecked: t,
    isChecked: n,
    isFocusable: r,
    isDisabled: o,
    isReadOnly: s,
    isRequired: i,
    onChange: a,
    isInvalid: c,
    name: l,
    value: u,
    id: d,
    "data-radiogroup": f,
    "aria-describedby": p,
    ...m
  } = e, g = `radio-${Rt()}`, y = Br(), b = !!uv() || !!f;
  let k = !!y && !b ? y.id : g;
  k = d ?? k;
  const w = o ?? (y == null ? void 0 : y.isDisabled), _ = s ?? (y == null ? void 0 : y.isReadOnly), C = i ?? (y == null ? void 0 : y.isRequired), I = c ?? (y == null ? void 0 : y.isInvalid), [$, N] = he(!1), [z, Q] = he(!1), [U, q] = he(!1), [le, Z] = he(!!t), j = typeof n < "u", K = j ? n : le, ne = ae(!1);
  xe(() => Ey((H) => {
    ne.current = H;
  }), []);
  const B = R(
    (H) => {
      if (_ || w) {
        H.preventDefault();
        return;
      }
      j || Z(H.currentTarget.checked), a == null || a(H);
    },
    [j, w, _, a]
  ), O = R(
    (H) => {
      H.key === " " && q(!0);
    },
    [q]
  ), ee = R(
    (H) => {
      H.key === " " && q(!1);
    },
    [q]
  ), D = R(
    (H = {}, de = null) => ({
      ...H,
      ref: de,
      "data-active": ye(U),
      "data-hover": ye(z),
      "data-disabled": ye(w),
      "data-invalid": ye(I),
      "data-checked": ye(K),
      "data-focus": ye($),
      "data-focus-visible": ye($ && ne.current),
      "data-readonly": ye(_),
      "aria-hidden": !0,
      onMouseDown: re(H.onMouseDown, () => q(!0)),
      onMouseUp: re(H.onMouseUp, () => q(!1)),
      onMouseEnter: re(
        H.onMouseEnter,
        () => Q(!0)
      ),
      onMouseLeave: re(
        H.onMouseLeave,
        () => Q(!1)
      )
    }),
    [
      U,
      z,
      w,
      I,
      K,
      $,
      _
    ]
  ), { onFocus: V, onBlur: Y } = y ?? {}, J = R(
    (H = {}, de = null) => {
      const L = w && !r;
      return {
        ...H,
        id: k,
        ref: de,
        type: "radio",
        name: l,
        value: u,
        onChange: re(H.onChange, B),
        onBlur: re(
          Y,
          H.onBlur,
          () => N(!1)
        ),
        onFocus: re(
          V,
          H.onFocus,
          () => N(!0)
        ),
        onKeyDown: re(H.onKeyDown, O),
        onKeyUp: re(H.onKeyUp, ee),
        checked: K,
        disabled: L,
        readOnly: _,
        required: C,
        "aria-invalid": wt(I),
        "aria-disabled": wt(L),
        "aria-required": wt(C),
        "data-readonly": ye(_),
        "aria-describedby": p,
        style: Ca
      };
    },
    [
      w,
      r,
      k,
      l,
      u,
      B,
      Y,
      V,
      O,
      ee,
      K,
      _,
      C,
      I,
      p
    ]
  );
  return {
    state: {
      isInvalid: I,
      isFocused: $,
      isChecked: K,
      isActive: U,
      isHovered: z,
      isDisabled: w,
      isReadOnly: _,
      isRequired: C
    },
    getRadioProps: D,
    getInputProps: J,
    getLabelProps: (H = {}, de = null) => ({
      ...H,
      ref: de,
      onMouseDown: re(H.onMouseDown, aB),
      "data-disabled": ye(w),
      "data-checked": ye(K),
      "data-invalid": ye(I)
    }),
    getRootProps: (H, de = null) => ({
      htmlFor: k,
      ...H,
      ref: de,
      "data-disabled": ye(w),
      "data-checked": ye(K),
      "data-invalid": ye(I)
    }),
    htmlProps: m
  };
}
function aB(e) {
  e.preventDefault(), e.stopPropagation();
}
const cB = M((e, t) => {
  const n = uv(), { onChange: r, value: o } = e, s = Je("Radio", { ...n, ...e }), i = Ae(e), {
    spacing: a = "0.5rem",
    children: c,
    isDisabled: l = n == null ? void 0 : n.isDisabled,
    isFocusable: u = n == null ? void 0 : n.isFocusable,
    inputProps: d,
    ...f
  } = i;
  let p = e.isChecked;
  (n == null ? void 0 : n.value) != null && o != null && (p = n.value === o);
  let m = r;
  n != null && n.onChange && o != null && (m = aa(n.onChange, r));
  const g = (e == null ? void 0 : e.name) ?? (n == null ? void 0 : n.name), {
    getInputProps: y,
    getRadioProps: S,
    getLabelProps: b,
    getRootProps: v,
    htmlProps: k
  } = iB({
    ...f,
    isChecked: p,
    isFocusable: u,
    isDisabled: l,
    onChange: m,
    name: g
  }), [w, _] = zh(k, sm), C = S(_), I = y(d, t), $ = b(), N = Object.assign({}, w, v()), z = {
    display: "inline-flex",
    alignItems: "center",
    verticalAlign: "top",
    cursor: "pointer",
    position: "relative",
    ...s.container
  }, Q = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    ...s.control
  }, U = {
    userSelect: "none",
    marginStart: a,
    ...s.label
  };
  return /* @__PURE__ */ h.jsxs(E.label, { className: "chakra-radio", ...N, __css: z, children: [
    /* @__PURE__ */ h.jsx("input", { className: "chakra-radio__input", ...I }),
    /* @__PURE__ */ h.jsx(
      E.span,
      {
        className: "chakra-radio__control",
        ...C,
        __css: Q
      }
    ),
    c && /* @__PURE__ */ h.jsx(
      E.span,
      {
        className: "chakra-radio__label",
        ...$,
        __css: U,
        children: c
      }
    )
  ] });
});
cB.displayName = "Radio";
const dv = M(
  function(t, n) {
    const { children: r, placeholder: o, className: s, ...i } = t;
    return /* @__PURE__ */ h.jsxs(
      E.select,
      {
        ...i,
        ref: n,
        className: W("chakra-select", s),
        children: [
          o && /* @__PURE__ */ h.jsx("option", { value: "", children: o }),
          r
        ]
      }
    );
  }
);
dv.displayName = "SelectField";
const lB = M((e, t) => {
  var v;
  const n = Je("Select", e), {
    rootProps: r,
    placeholder: o,
    icon: s,
    color: i,
    height: a,
    h: c,
    minH: l,
    minHeight: u,
    iconColor: d,
    iconSize: f,
    ...p
  } = Ae(e), [m, g] = zh(p, sm), y = Ou(g), S = {
    width: "100%",
    height: "fit-content",
    position: "relative",
    color: i
  }, b = {
    paddingEnd: "2rem",
    ...n.field,
    _focus: {
      zIndex: "unset",
      ...(v = n.field) == null ? void 0 : v._focus
    }
  };
  return /* @__PURE__ */ h.jsxs(
    E.div,
    {
      className: "chakra-select__wrapper",
      __css: S,
      ...m,
      ...r,
      children: [
        /* @__PURE__ */ h.jsx(
          dv,
          {
            ref: t,
            height: c ?? a,
            minH: l ?? u,
            placeholder: o,
            ...y,
            __css: b,
            children: e.children
          }
        ),
        /* @__PURE__ */ h.jsx(
          fv,
          {
            "data-disabled": ye(y.disabled),
            ...(d || i) && { color: d || i },
            __css: n.icon,
            ...f && { fontSize: f },
            children: s
          }
        )
      ]
    }
  );
});
lB.displayName = "Select";
const uB = (e) => /* @__PURE__ */ h.jsx("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ h.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
  }
) }), dB = E("div", {
  baseStyle: {
    position: "absolute",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    top: "50%",
    transform: "translateY(-50%)"
  }
}), fv = (e) => {
  const { children: t = /* @__PURE__ */ h.jsx(uB, {}), ...n } = e, r = kt(t, {
    role: "presentation",
    className: "chakra-select__icon",
    focusable: !1,
    "aria-hidden": !0,
    // force icon to adhere to `IconWrapper` styles
    style: {
      width: "1em",
      height: "1em",
      color: "currentColor"
    }
  });
  return /* @__PURE__ */ h.jsx(dB, { ...n, className: "chakra-select__icon-wrapper", children: ur(t) ? r : null });
};
fv.displayName = "SelectIcon";
function fB() {
  const e = ae(!0);
  return xe(() => {
    e.current = !1;
  }, []), e.current;
}
const pB = E("div", {
  baseStyle: {
    boxShadow: "none",
    backgroundClip: "padding-box",
    cursor: "default",
    color: "transparent",
    pointerEvents: "none",
    userSelect: "none",
    "&::before, &::after, *": {
      visibility: "hidden"
    }
  }
}), Vl = Se("skeleton-start-color"), zl = Se("skeleton-end-color"), hB = Mn({
  from: { opacity: 0 },
  to: { opacity: 1 }
}), mB = Mn({
  from: {
    borderColor: Vl.reference,
    background: Vl.reference
  },
  to: {
    borderColor: zl.reference,
    background: zl.reference
  }
}), pd = M((e, t) => {
  const n = {
    ...e,
    fadeDuration: typeof e.fadeDuration == "number" ? e.fadeDuration : 0.4,
    speed: typeof e.speed == "number" ? e.speed : 0.8
  }, r = Ct("Skeleton", n), o = fB(), {
    startColor: s = "",
    endColor: i = "",
    isLoaded: a,
    fadeDuration: c,
    speed: l,
    className: u,
    fitContent: d,
    animation: f,
    ...p
  } = Ae(n), [m, g] = HR("colors", [
    s,
    i
  ]), y = fx(a), S = W("chakra-skeleton", u), b = {
    ...m && { [Vl.variable]: m },
    ...g && { [zl.variable]: g }
  };
  if (a) {
    const v = o || y ? "none" : `${hB} ${c}s`;
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ref: t,
        className: S,
        __css: { animation: v },
        ...p
      }
    );
  }
  return /* @__PURE__ */ h.jsx(
    pB,
    {
      ref: t,
      className: S,
      ...p,
      __css: {
        width: d ? "fit-content" : void 0,
        ...r,
        ...b,
        _dark: { ...r._dark, ...b },
        animation: f || `${l}s linear infinite alternate ${mB}`
      }
    }
  );
});
pd.displayName = "Skeleton";
function gB(e) {
  return Array(e).fill(1).map((t, n) => n + 1);
}
const lh = 3, yB = (e) => {
  const {
    noOfLines: t = lh,
    spacing: n = "0.5rem",
    skeletonHeight: r = "0.5rem",
    className: o,
    startColor: s,
    endColor: i,
    isLoaded: a,
    fadeDuration: c,
    speed: l,
    variant: u,
    size: d,
    colorScheme: f,
    children: p,
    ...m
  } = e, g = tD(
    typeof t == "number" ? [t] : t
  ) || lh, y = gB(g), S = (v) => g > 1 && v === y.length ? "80%" : "100%", b = W("chakra-skeleton__group", o);
  return /* @__PURE__ */ h.jsx(E.div, { className: b, ...m, children: y.map((v, k) => {
    if (a && k > 0)
      return null;
    const w = a ? null : {
      mb: v === y.length ? "0" : n,
      width: S(v),
      height: r
    };
    return /* @__PURE__ */ h.jsx(
      pd,
      {
        startColor: s,
        endColor: i,
        isLoaded: a,
        fadeDuration: c,
        speed: l,
        variant: u,
        size: d,
        colorScheme: f,
        ...w,
        // allows animating the children
        children: k === 0 ? p : void 0
      },
      y.length.toString() + v
    );
  }) });
};
yB.displayName = "SkeletonText";
const bB = ({
  size: e = "2rem",
  ...t
}) => /* @__PURE__ */ h.jsx(pd, { borderRadius: "full", boxSize: e, ...t });
bB.displayName = "SkeletonCircle";
const pv = "chakra-skip-nav";
function vB(e) {
  return {
    userSelect: "none",
    border: "0",
    height: "1px",
    width: "1px",
    margin: "-1px",
    padding: "0",
    outline: "0",
    overflow: "hidden",
    position: "absolute",
    clip: "rect(0 0 0 0)",
    ...e,
    _focus: {
      clip: "auto",
      width: "auto",
      height: "auto",
      ...e._focus
    }
  };
}
const xB = M(
  function(t, n) {
    const r = Ct("SkipLink", t), { id: o = pv, ...s } = Ae(t);
    return /* @__PURE__ */ h.jsx(E.a, { ...s, ref: n, href: `#${o}`, __css: vB(r) });
  }
);
xB.displayName = "SkipNavLink";
const SB = M(
  function(t, n) {
    const { id: r = pv, ...o } = t;
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ref: n,
        id: r,
        tabIndex: -1,
        style: { outline: 0 },
        ...o
      }
    );
  }
);
SB.displayName = "SkipNavContent";
function wB(e) {
  return {
    root: `slider-root-${e}`,
    getThumb: (t) => `slider-thumb-${e}-${t}`,
    getInput: (t) => `slider-input-${e}-${t}`,
    track: `slider-track-${e}`,
    innerTrack: `slider-filled-track-${e}`,
    getMarker: (t) => `slider-marker-${e}-${t}`,
    output: `slider-output-${e}`
  };
}
function Bi(e) {
  const { orientation: t, vertical: n, horizontal: r } = e;
  return t === "vertical" ? n : r;
}
function hv(e) {
  const { orientation: t, thumbPercents: n, isReversed: r } = e, o = (p) => ({
    position: "absolute",
    userSelect: "none",
    WebkitUserSelect: "none",
    MozUserSelect: "none",
    msUserSelect: "none",
    touchAction: "none",
    ...Bi({
      orientation: t,
      vertical: {
        bottom: `${n[p]}%`,
        transform: "translate(-50%, 50%) scale(var(--slider-thumb-scale, 1))"
      },
      horizontal: {
        left: `${n[p]}%`,
        transform: "translate(-50%, -50%) scale(var(--slider-thumb-scale, 1))"
      }
    })
  }), s = {
    position: "relative",
    touchAction: "none",
    WebkitTapHighlightColor: "rgba(0,0,0,0)",
    userSelect: "none",
    outline: 0
  }, i = {
    position: "absolute",
    ...Bi({
      orientation: t,
      vertical: {
        left: "50%",
        transform: "translateX(-50%)",
        height: "100%"
      },
      horizontal: {
        top: "50%",
        transform: "translateY(-50%)",
        width: "100%"
      }
    })
  }, a = n.length === 1, c = [0, r ? 100 - n[0] : n[0]], l = a ? c : n;
  let u = l[0];
  !a && r && (u = 100 - u);
  const d = Math.abs(l[l.length - 1] - l[0]), f = {
    ...i,
    ...Bi({
      orientation: t,
      vertical: r ? { height: `${d}%`, top: `${u}%` } : { height: `${d}%`, bottom: `${u}%` },
      horizontal: r ? { width: `${d}%`, right: `${u}%` } : { width: `${d}%`, left: `${u}%` }
    })
  };
  return { trackStyle: i, innerTrackStyle: f, rootStyle: s, getThumbStyle: o };
}
function mv(e) {
  const { isReversed: t, direction: n, orientation: r } = e;
  return n === "ltr" || r === "vertical" ? t : !t;
}
function kB(e) {
  const {
    min: t = 0,
    max: n = 100,
    onChange: r,
    value: o,
    defaultValue: s,
    isReversed: i,
    direction: a = "ltr",
    orientation: c = "horizontal",
    id: l,
    isDisabled: u,
    isReadOnly: d,
    onChangeStart: f,
    onChangeEnd: p,
    step: m = 1,
    getAriaValueText: g,
    "aria-valuetext": y,
    "aria-label": S,
    "aria-labelledby": b,
    name: v,
    focusThumbOnChange: k = !0,
    minStepsBetweenThumbs: w = 0,
    ..._
  } = e, C = nt(f), I = nt(p), $ = nt(g), N = mv({
    isReversed: i,
    direction: a,
    orientation: c
  }), [z, Q] = dr({
    value: o,
    defaultValue: s ?? [25, 75],
    onChange: r
  });
  if (!Array.isArray(z))
    throw new TypeError(
      `[range-slider] You passed an invalid value for \`value\` or \`defaultValue\`, expected \`Array\` but got \`${typeof z}\``
    );
  const [U, q] = he(!1), [le, Z] = he(!1), [j, K] = he(-1), ne = !(u || d), B = ae(z), O = z.map((pe) => lo(pe, t, n)), ee = w * m, D = PB(O, t, n, ee), V = ae({
    eventSource: null,
    value: [],
    valueBounds: []
  });
  V.current.value = O, V.current.valueBounds = D;
  const Y = O.map((pe) => n - pe + t), se = (N ? Y : O).map((pe) => zi(pe, t, n)), ue = c === "vertical", G = ae(null), H = ae(null), de = Rt(), me = wB(l ?? de), oe = R(
    (pe) => {
      var _t;
      if (!G.current)
        return;
      V.current.eventSource = "pointer";
      const Pe = G.current.getBoundingClientRect(), { clientX: ve, clientY: Be } = ((_t = pe.touches) == null ? void 0 : _t[0]) ?? pe, He = ue ? Pe.bottom - Be : ve - Pe.left, xt = ue ? Pe.height : Pe.width;
      let Ot = He / xt;
      return N && (Ot = 1 - Ot), Fh(Ot, t, n);
    },
    [ue, N, n, t]
  ), $e = (n - t) / 10, Oe = m || (n - t) / 100, ce = _e(
    () => ({
      setValueAtIndex(pe, Pe) {
        if (!ne)
          return;
        const ve = V.current.valueBounds[pe];
        Pe = parseFloat(Jc(Pe, ve.min, Oe)), Pe = lo(Pe, ve.min, ve.max);
        const Be = [...V.current.value];
        Be[pe] = Pe, Q(Be);
      },
      setActiveIndex: K,
      stepUp(pe, Pe = Oe) {
        const ve = V.current.value[pe], Be = N ? ve - Pe : ve + Pe;
        ce.setValueAtIndex(pe, Be);
      },
      stepDown(pe, Pe = Oe) {
        const ve = V.current.value[pe], Be = N ? ve + Pe : ve - Pe;
        ce.setValueAtIndex(pe, Be);
      },
      reset() {
        Q(B.current);
      }
    }),
    [Oe, N, Q, ne]
  ), Ne = R(
    (pe) => {
      const Pe = pe.key, Be = {
        ArrowRight: () => ce.stepUp(j),
        ArrowUp: () => ce.stepUp(j),
        ArrowLeft: () => ce.stepDown(j),
        ArrowDown: () => ce.stepDown(j),
        PageUp: () => ce.stepUp(j, $e),
        PageDown: () => ce.stepDown(j, $e),
        Home: () => {
          const { min: He } = D[j];
          ce.setValueAtIndex(j, He);
        },
        End: () => {
          const { max: He } = D[j];
          ce.setValueAtIndex(j, He);
        }
      }[Pe];
      Be && (pe.preventDefault(), pe.stopPropagation(), Be(pe), V.current.eventSource = "keyboard");
    },
    [ce, j, $e, D]
  ), { getThumbStyle: Ie, rootStyle: Re, trackStyle: Xe, innerTrackStyle: tt } = _e(
    () => hv({
      isReversed: N,
      orientation: c,
      thumbPercents: se
    }),
    [N, c, se]
  ), it = R(
    (pe) => {
      var ve;
      const Pe = pe ?? j;
      if (Pe !== -1 && k) {
        const Be = me.getThumb(Pe), He = (ve = H.current) == null ? void 0 : ve.ownerDocument.getElementById(Be);
        He && setTimeout(() => He.focus());
      }
    },
    [k, j, me]
  );
  bn(() => {
    V.current.eventSource === "keyboard" && (I == null || I(V.current.value));
  }, [O, I]);
  const At = (pe) => {
    const Pe = oe(pe) || 0, ve = V.current.value.map(
      (_t) => Math.abs(_t - Pe)
    ), Be = Math.min(...ve);
    let He = ve.indexOf(Be);
    const xt = ve.filter(
      (_t) => _t === Be
    );
    xt.length > 1 && Pe > V.current.value[He] && (He = He + xt.length - 1), K(He), ce.setValueAtIndex(He, Pe), it(He);
  }, Vt = (pe) => {
    if (j == -1)
      return;
    const Pe = oe(pe) || 0;
    K(j), ce.setValueAtIndex(j, Pe), it(j);
  };
  em(H, {
    onPanSessionStart(pe) {
      ne && (q(!0), At(pe), C == null || C(V.current.value));
    },
    onPanSessionEnd() {
      ne && (q(!1), I == null || I(V.current.value));
    },
    onPan(pe) {
      ne && Vt(pe);
    }
  });
  const qt = R(
    (pe = {}, Pe = null) => ({
      ...pe,
      ..._,
      id: me.root,
      ref: De(Pe, H),
      tabIndex: -1,
      "aria-disabled": wt(u),
      "data-focused": ye(le),
      style: { ...pe.style, ...Re }
    }),
    [_, u, le, Re, me]
  ), Nt = R(
    (pe = {}, Pe = null) => ({
      ...pe,
      ref: De(Pe, G),
      id: me.track,
      "data-disabled": ye(u),
      style: { ...pe.style, ...Xe }
    }),
    [u, Xe, me]
  ), te = R(
    (pe = {}, Pe = null) => ({
      ...pe,
      ref: Pe,
      id: me.innerTrack,
      style: {
        ...pe.style,
        ...tt
      }
    }),
    [tt, me]
  ), We = R(
    (pe, Pe = null) => {
      const { index: ve, ...Be } = pe, He = O[ve];
      if (He == null)
        throw new TypeError(
          `[range-slider > thumb] Cannot find value at index \`${ve}\`. The \`value\` or \`defaultValue\` length is : ${O.length}`
        );
      const xt = D[ve];
      return {
        ...Be,
        ref: Pe,
        role: "slider",
        tabIndex: ne ? 0 : void 0,
        id: me.getThumb(ve),
        "data-active": ye(U && j === ve),
        "aria-valuetext": ($ == null ? void 0 : $(He)) ?? (y == null ? void 0 : y[ve]),
        "aria-valuemin": xt.min,
        "aria-valuemax": xt.max,
        "aria-valuenow": He,
        "aria-orientation": c,
        "aria-disabled": wt(u),
        "aria-readonly": wt(d),
        "aria-label": S == null ? void 0 : S[ve],
        "aria-labelledby": S != null && S[ve] || b == null ? void 0 : b[ve],
        style: { ...pe.style, ...Ie(ve) },
        onKeyDown: re(pe.onKeyDown, Ne),
        onFocus: re(pe.onFocus, () => {
          Z(!0), K(ve);
        }),
        onBlur: re(pe.onBlur, () => {
          Z(!1), K(-1);
        })
      };
    },
    [
      me,
      O,
      D,
      ne,
      U,
      j,
      $,
      y,
      c,
      u,
      d,
      S,
      b,
      Ie,
      Ne,
      Z
    ]
  ), ie = R(
    (pe = {}, Pe = null) => ({
      ...pe,
      ref: Pe,
      id: me.output,
      htmlFor: O.map((ve, Be) => me.getThumb(Be)).join(" "),
      "aria-live": "off"
    }),
    [me, O]
  ), be = R(
    (pe, Pe = null) => {
      const { value: ve, ...Be } = pe, He = !(ve < t || ve > n), xt = ve >= O[0] && ve <= O[O.length - 1];
      let Ot = zi(ve, t, n);
      Ot = N ? 100 - Ot : Ot;
      const _t = {
        position: "absolute",
        pointerEvents: "none",
        ...Bi({
          orientation: c,
          vertical: { bottom: `${Ot}%` },
          horizontal: { left: `${Ot}%` }
        })
      };
      return {
        ...Be,
        ref: Pe,
        id: me.getMarker(pe.value),
        role: "presentation",
        "aria-hidden": !0,
        "data-disabled": ye(u),
        "data-invalid": ye(!He),
        "data-highlighted": ye(xt),
        style: {
          ...pe.style,
          ..._t
        }
      };
    },
    [u, N, n, t, c, O, me]
  ), gt = R(
    (pe, Pe = null) => {
      const { index: ve, ...Be } = pe;
      return {
        ...Be,
        ref: Pe,
        id: me.getInput(ve),
        type: "hidden",
        value: O[ve],
        name: Array.isArray(v) ? v[ve] : `${v}-${ve}`
      };
    },
    [v, O, me]
  );
  return {
    state: {
      value: O,
      isFocused: le,
      isDragging: U,
      getThumbPercent: (pe) => se[pe],
      getThumbMinValue: (pe) => D[pe].min,
      getThumbMaxValue: (pe) => D[pe].max
    },
    actions: ce,
    getRootProps: qt,
    getTrackProps: Nt,
    getInnerTrackProps: te,
    getThumbProps: We,
    getMarkerProps: be,
    getInputProps: gt,
    getOutputProps: ie
  };
}
function PB(e, t, n, r) {
  return e.map((o, s) => {
    const i = s === 0 ? t : e[s - 1] + r, a = s === e.length - 1 ? n : e[s + 1] - r;
    return { min: i, max: a };
  });
}
const [CB, Ra] = Ee({
  name: "SliderContext",
  errorMessage: "useSliderContext: `context` is undefined. Seems you forgot to wrap all slider components within <RangeSlider />"
}), [_B, $a] = Ee({
  name: "RangeSliderStylesContext",
  errorMessage: `useRangeSliderStyles returned is 'undefined'. Seems you forgot to wrap the components in "<RangeSlider />" `
}), TB = M(
  function(t, n) {
    const r = {
      orientation: "horizontal",
      ...t
    }, o = Je("Slider", r), s = Ae(r), { direction: i } = fn();
    s.direction = i;
    const { getRootProps: a, ...c } = kB(s), l = _e(
      () => ({ ...c, name: r.name }),
      [c, r.name]
    );
    return /* @__PURE__ */ h.jsx(CB, { value: l, children: /* @__PURE__ */ h.jsx(_B, { value: o, children: /* @__PURE__ */ h.jsx(
      E.div,
      {
        ...a({}, n),
        className: "chakra-slider",
        __css: o.container,
        children: r.children
      }
    ) }) });
  }
);
TB.displayName = "RangeSlider";
const EB = M(
  function(t, n) {
    const { getThumbProps: r, getInputProps: o, name: s } = Ra(), i = $a(), a = r(t, n);
    return /* @__PURE__ */ h.jsxs(
      E.div,
      {
        ...a,
        className: W("chakra-slider__thumb", t.className),
        __css: i.thumb,
        children: [
          a.children,
          s && /* @__PURE__ */ h.jsx("input", { ...o({ index: t.index }) })
        ]
      }
    );
  }
);
EB.displayName = "RangeSliderThumb";
const AB = M(
  function(t, n) {
    const { getTrackProps: r } = Ra(), o = $a(), s = r(t, n);
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ...s,
        className: W("chakra-slider__track", t.className),
        __css: o.track,
        "data-testid": "chakra-range-slider-track"
      }
    );
  }
);
AB.displayName = "RangeSliderTrack";
const IB = M(function(t, n) {
  const { getInnerTrackProps: r } = Ra(), o = $a(), s = r(t, n);
  return /* @__PURE__ */ h.jsx(
    E.div,
    {
      ...s,
      className: "chakra-slider__filled-track",
      __css: o.filledTrack
    }
  );
});
IB.displayName = "RangeSliderFilledTrack";
const RB = M(
  function(t, n) {
    const { getMarkerProps: r } = Ra(), o = $a(), s = r(t, n);
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ...s,
        className: W("chakra-slider__marker", t.className),
        __css: o.mark
      }
    );
  }
);
RB.displayName = "RangeSliderMark";
function $B(e) {
  const {
    min: t = 0,
    max: n = 100,
    onChange: r,
    value: o,
    defaultValue: s,
    isReversed: i,
    direction: a = "ltr",
    orientation: c = "horizontal",
    id: l,
    isDisabled: u,
    isReadOnly: d,
    onChangeStart: f,
    onChangeEnd: p,
    step: m = 1,
    getAriaValueText: g,
    "aria-valuetext": y,
    "aria-label": S,
    "aria-labelledby": b,
    name: v,
    focusThumbOnChange: k = !0,
    ...w
  } = e, _ = nt(f), C = nt(p), I = nt(g), $ = mv({
    isReversed: i,
    direction: a,
    orientation: c
  }), [N, z] = dr({
    value: o,
    defaultValue: s ?? MB(t, n),
    onChange: r
  }), [Q, U] = he(!1), [q, le] = he(!1), Z = !(u || d), j = (n - t) / 10, K = m || (n - t) / 100, ne = lo(N, t, n), B = n - ne + t, ee = zi($ ? B : ne, t, n), D = c === "vertical", V = Kh({
    min: t,
    max: n,
    step: m,
    isDisabled: u,
    value: ne,
    isInteractive: Z,
    isReversed: $,
    isVertical: D,
    eventSource: null,
    focusThumbOnChange: k,
    orientation: c
  }), Y = ae(null), J = ae(null), se = ae(null), ue = Rt(), G = l ?? ue, [H, de] = [`slider-thumb-${G}`, `slider-track-${G}`], L = R(
    (ie) => {
      var xt;
      if (!Y.current)
        return;
      const be = V.current;
      be.eventSource = "pointer";
      const gt = Y.current.getBoundingClientRect(), { clientX: Dt, clientY: pe } = ((xt = ie.touches) == null ? void 0 : xt[0]) ?? ie, Pe = D ? gt.bottom - pe : Dt - gt.left, ve = D ? gt.height : gt.width;
      let Be = Pe / ve;
      $ && (Be = 1 - Be);
      let He = Fh(Be, be.min, be.max);
      return be.step && (He = parseFloat(
        Jc(He, be.min, be.step)
      )), He = lo(He, be.min, be.max), He;
    },
    [D, $, V]
  ), me = R(
    (ie) => {
      const be = V.current;
      be.isInteractive && (ie = parseFloat(Jc(ie, be.min, K)), ie = lo(ie, be.min, be.max), z(ie));
    },
    [K, z, V]
  ), oe = _e(
    () => ({
      stepUp(ie = K) {
        const be = $ ? ne - ie : ne + ie;
        me(be);
      },
      stepDown(ie = K) {
        const be = $ ? ne + ie : ne - ie;
        me(be);
      },
      reset() {
        me(s || 0);
      },
      stepTo(ie) {
        me(ie);
      }
    }),
    [me, $, ne, K, s]
  ), $e = R(
    (ie) => {
      const be = V.current, Dt = {
        ArrowRight: () => oe.stepUp(),
        ArrowUp: () => oe.stepUp(),
        ArrowLeft: () => oe.stepDown(),
        ArrowDown: () => oe.stepDown(),
        PageUp: () => oe.stepUp(j),
        PageDown: () => oe.stepDown(j),
        Home: () => me(be.min),
        End: () => me(be.max)
      }[ie.key];
      Dt && (ie.preventDefault(), ie.stopPropagation(), Dt(ie), be.eventSource = "keyboard");
    },
    [oe, me, j, V]
  ), Oe = (I == null ? void 0 : I(ne)) ?? y, { getThumbStyle: ce, rootStyle: Ne, trackStyle: Ie, innerTrackStyle: Re } = _e(() => {
    const ie = V.current;
    return hv({
      isReversed: $,
      orientation: ie.orientation,
      thumbPercents: [ee]
    });
  }, [$, ee, V]), Xe = R(() => {
    V.current.focusThumbOnChange && setTimeout(() => {
      var be;
      return (be = J.current) == null ? void 0 : be.focus();
    });
  }, [V]);
  bn(() => {
    const ie = V.current;
    Xe(), ie.eventSource === "keyboard" && (C == null || C(ie.value));
  }, [ne, C]);
  function tt(ie) {
    const be = L(ie);
    be != null && be !== V.current.value && z(be);
  }
  em(se, {
    onPanSessionStart(ie) {
      const be = V.current;
      be.isInteractive && (U(!0), Xe(), tt(ie), _ == null || _(be.value));
    },
    onPanSessionEnd() {
      const ie = V.current;
      ie.isInteractive && (U(!1), C == null || C(ie.value));
    },
    onPan(ie) {
      V.current.isInteractive && tt(ie);
    }
  });
  const it = R(
    (ie = {}, be = null) => ({
      ...ie,
      ...w,
      ref: De(be, se),
      tabIndex: -1,
      "aria-disabled": wt(u),
      "data-focused": ye(q),
      style: {
        ...ie.style,
        ...Ne
      }
    }),
    [w, u, q, Ne]
  ), At = R(
    (ie = {}, be = null) => ({
      ...ie,
      ref: De(be, Y),
      id: de,
      "data-disabled": ye(u),
      style: {
        ...ie.style,
        ...Ie
      }
    }),
    [u, de, Ie]
  ), Vt = R(
    (ie = {}, be = null) => ({
      ...ie,
      ref: be,
      style: {
        ...ie.style,
        ...Re
      }
    }),
    [Re]
  ), qt = R(
    (ie = {}, be = null) => ({
      ...ie,
      ref: De(be, J),
      role: "slider",
      tabIndex: Z ? 0 : void 0,
      id: H,
      "data-active": ye(Q),
      "aria-valuetext": Oe,
      "aria-valuemin": t,
      "aria-valuemax": n,
      "aria-valuenow": ne,
      "aria-orientation": c,
      "aria-disabled": wt(u),
      "aria-readonly": wt(d),
      "aria-label": S,
      "aria-labelledby": S ? void 0 : b,
      style: {
        ...ie.style,
        ...ce(0)
      },
      onKeyDown: re(ie.onKeyDown, $e),
      onFocus: re(ie.onFocus, () => le(!0)),
      onBlur: re(ie.onBlur, () => le(!1))
    }),
    [
      Z,
      H,
      Q,
      Oe,
      t,
      n,
      ne,
      c,
      u,
      d,
      S,
      b,
      ce,
      $e
    ]
  ), Nt = R(
    (ie, be = null) => {
      const gt = !(ie.value < t || ie.value > n), Dt = ne >= ie.value, pe = zi(ie.value, t, n), Pe = {
        position: "absolute",
        pointerEvents: "none",
        ...NB({
          orientation: c,
          vertical: {
            bottom: $ ? `${100 - pe}%` : `${pe}%`
          },
          horizontal: {
            left: $ ? `${100 - pe}%` : `${pe}%`
          }
        })
      };
      return {
        ...ie,
        ref: be,
        role: "presentation",
        "aria-hidden": !0,
        "data-disabled": ye(u),
        "data-invalid": ye(!gt),
        "data-highlighted": ye(Dt),
        style: {
          ...ie.style,
          ...Pe
        }
      };
    },
    [u, $, n, t, c, ne]
  ), te = R(
    (ie = {}, be = null) => ({
      ...ie,
      ref: be,
      type: "hidden",
      value: ne,
      name: v
    }),
    [v, ne]
  );
  return {
    state: { value: ne, isFocused: q, isDragging: Q },
    actions: oe,
    getRootProps: it,
    getTrackProps: At,
    getInnerTrackProps: Vt,
    getThumbProps: qt,
    getMarkerProps: Nt,
    getInputProps: te
  };
}
function NB(e) {
  const { orientation: t, vertical: n, horizontal: r } = e;
  return t === "vertical" ? n : r;
}
function MB(e, t) {
  return t < e ? e : e + (t - e) / 2;
}
const [jB, Na] = Ee({
  name: "SliderContext",
  hookName: "useSliderContext",
  providerName: "<Slider />"
}), [DB, Ma] = Ee({
  name: "SliderStylesContext",
  hookName: "useSliderStyles",
  providerName: "<Slider />"
}), OB = M((e, t) => {
  const n = {
    ...e,
    orientation: (e == null ? void 0 : e.orientation) ?? "horizontal"
  }, r = Je("Slider", n), o = Ae(n), { direction: s } = fn();
  o.direction = s;
  const { getInputProps: i, getRootProps: a, ...c } = $B(o), l = a(), u = i({}, t);
  return /* @__PURE__ */ h.jsx(jB, { value: c, children: /* @__PURE__ */ h.jsx(DB, { value: r, children: /* @__PURE__ */ h.jsxs(
    E.div,
    {
      ...l,
      className: W("chakra-slider", n.className),
      __css: r.container,
      children: [
        n.children,
        /* @__PURE__ */ h.jsx("input", { ...u })
      ]
    }
  ) }) });
});
OB.displayName = "Slider";
const FB = M((e, t) => {
  const { getThumbProps: n } = Na(), r = Ma(), o = n(e, t);
  return /* @__PURE__ */ h.jsx(
    E.div,
    {
      ...o,
      className: W("chakra-slider__thumb", e.className),
      __css: r.thumb
    }
  );
});
FB.displayName = "SliderThumb";
const BB = M((e, t) => {
  const { getTrackProps: n } = Na(), r = Ma(), o = n(e, t);
  return /* @__PURE__ */ h.jsx(
    E.div,
    {
      ...o,
      className: W("chakra-slider__track", e.className),
      __css: r.track
    }
  );
});
BB.displayName = "SliderTrack";
const LB = M(
  (e, t) => {
    const { getInnerTrackProps: n } = Na(), r = Ma(), o = n(e, t);
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ...o,
        className: W("chakra-slider__filled-track", e.className),
        __css: r.filledTrack
      }
    );
  }
);
LB.displayName = "SliderFilledTrack";
const VB = M((e, t) => {
  const { getMarkerProps: n } = Na(), r = Ma(), o = n(e, t);
  return /* @__PURE__ */ h.jsx(
    E.div,
    {
      ...o,
      className: W("chakra-slider__marker", e.className),
      __css: r.mark
    }
  );
});
VB.displayName = "SliderMark";
const zB = E("div", {
  baseStyle: {
    flex: 1,
    justifySelf: "stretch",
    alignSelf: "stretch"
  }
});
zB.displayName = "Spacer";
const gv = (e) => /* @__PURE__ */ h.jsx(
  E.div,
  {
    className: "chakra-stack__item",
    ...e,
    __css: {
      display: "inline-block",
      flex: "0 0 auto",
      minWidth: 0,
      ...e.__css
    }
  }
);
gv.displayName = "StackItem";
function WB(e) {
  const { spacing: t, direction: n } = e, r = {
    column: {
      my: t,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    "column-reverse": {
      my: t,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    row: {
      mx: t,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    },
    "row-reverse": {
      mx: t,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    }
  };
  return {
    "&": Cn(
      n,
      (o) => r[o]
    )
  };
}
const hd = M((e, t) => {
  const {
    isInline: n,
    direction: r,
    align: o,
    justify: s,
    spacing: i = "0.5rem",
    wrap: a,
    children: c,
    divider: l,
    className: u,
    shouldWrapChildren: d,
    ...f
  } = e, p = n ? "row" : r ?? "column", m = _e(
    () => WB({ spacing: i, direction: p }),
    [i, p]
  ), g = !!l, y = !d && !g, S = _e(() => {
    const v = Yn(c);
    return y ? v : v.map((k, w) => {
      const _ = typeof k.key < "u" ? k.key : w, C = w + 1 === v.length, $ = d ? /* @__PURE__ */ h.jsx(gv, { children: k }, _) : k;
      if (!g)
        return $;
      const N = kt(
        l,
        {
          __css: m
        }
      ), z = C ? null : N;
      return /* @__PURE__ */ h.jsxs(Ul, { children: [
        $,
        z
      ] }, _);
    });
  }, [
    l,
    m,
    g,
    y,
    d,
    c
  ]), b = W("chakra-stack", u);
  return /* @__PURE__ */ h.jsx(
    E.div,
    {
      ref: t,
      display: "flex",
      alignItems: o,
      justifyContent: s,
      flexDirection: p,
      flexWrap: a,
      gap: g ? void 0 : i,
      className: b,
      ...f,
      children: S
    }
  );
});
hd.displayName = "Stack";
const HB = M((e, t) => /* @__PURE__ */ h.jsx(hd, { align: "center", ...e, direction: "row", ref: t }));
HB.displayName = "HStack";
const UB = (e) => /* @__PURE__ */ h.jsx(
  E.div,
  {
    className: "chakra-stack__divider",
    ...e,
    __css: {
      ...e.__css,
      borderWidth: 0,
      alignSelf: "stretch",
      borderColor: "inherit",
      width: "auto",
      height: "auto"
    }
  }
);
UB.displayName = "StackDivider";
const GB = M((e, t) => /* @__PURE__ */ h.jsx(hd, { align: "center", ...e, direction: "column", ref: t }));
GB.displayName = "VStack";
const [qB, ja] = Ee({
  name: "StatStylesContext",
  errorMessage: `useStatStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Stat />" `
}), KB = M(function(t, n) {
  const r = Je("Stat", t), o = {
    position: "relative",
    flex: "1 1 0%",
    ...r.container
  }, { className: s, children: i, ...a } = Ae(t);
  return /* @__PURE__ */ h.jsx(qB, { value: r, children: /* @__PURE__ */ h.jsx(
    E.div,
    {
      ref: n,
      ...a,
      className: W("chakra-stat", s),
      __css: o,
      children: /* @__PURE__ */ h.jsx("dl", { children: i })
    }
  ) });
});
KB.displayName = "Stat";
const yv = (e) => /* @__PURE__ */ h.jsx($t, { color: "red.400", ...e, children: /* @__PURE__ */ h.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M21,5H3C2.621,5,2.275,5.214,2.105,5.553C1.937,5.892,1.973,6.297,2.2,6.6l9,12 c0.188,0.252,0.485,0.4,0.8,0.4s0.611-0.148,0.8-0.4l9-12c0.228-0.303,0.264-0.708,0.095-1.047C21.725,5.214,21.379,5,21,5z"
  }
) });
yv.displayName = "StatDownArrow";
function bv(e) {
  return /* @__PURE__ */ h.jsx($t, { color: "green.400", ...e, children: /* @__PURE__ */ h.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M12.8,5.4c-0.377-0.504-1.223-0.504-1.6,0l-9,12c-0.228,0.303-0.264,0.708-0.095,1.047 C2.275,18.786,2.621,19,3,19h18c0.379,0,0.725-0.214,0.895-0.553c0.169-0.339,0.133-0.744-0.095-1.047L12.8,5.4z"
    }
  ) });
}
bv.displayName = "StatUpArrow";
function YB(e) {
  const { type: t, "aria-label": n, ...r } = e, o = ja(), s = t === "increase" ? bv : yv, a = n || (t === "increase" ? "increased by" : "decreased by");
  return /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    /* @__PURE__ */ h.jsx(E.span, { srOnly: !0, children: a }),
    /* @__PURE__ */ h.jsx(s, { "aria-hidden": !0, ...r, __css: o.icon })
  ] });
}
YB.displayName = "StatArrow";
const XB = M(
  function(t, n) {
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ...t,
        ref: n,
        role: "group",
        className: W("chakra-stat__group", t.className),
        __css: {
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-around",
          alignItems: "flex-start"
        }
      }
    );
  }
);
XB.displayName = "StatGroup";
const ZB = M(
  function(t, n) {
    const r = ja();
    return /* @__PURE__ */ h.jsx(
      E.dd,
      {
        ref: n,
        ...t,
        className: W("chakra-stat__help-text", t.className),
        __css: r.helpText
      }
    );
  }
);
ZB.displayName = "StatHelpText";
const JB = M(
  function(t, n) {
    const r = ja();
    return /* @__PURE__ */ h.jsx(
      E.dt,
      {
        ref: n,
        ...t,
        className: W("chakra-stat__label", t.className),
        __css: r.label
      }
    );
  }
);
JB.displayName = "StatLabel";
const QB = M(
  function(t, n) {
    const r = ja();
    return /* @__PURE__ */ h.jsx(
      E.dd,
      {
        ref: n,
        ...t,
        className: W("chakra-stat__number", t.className),
        __css: {
          ...r.number,
          fontFeatureSettings: "pnum",
          fontVariantNumeric: "proportional-nums"
        }
      }
    );
  }
);
QB.displayName = "StatNumber";
const [e5, gr] = Ee(
  { name: "StepContext" }
), [t5, zr] = $m("Stepper"), HL = M(function(t, n) {
  const { orientation: r, status: o, showLastSeparator: s } = gr(), i = zr();
  return /* @__PURE__ */ h.jsx(
    E.div,
    {
      ref: n,
      "data-status": o,
      "data-orientation": r,
      "data-stretch": ye(s),
      __css: i.step,
      ...t,
      className: W("chakra-step", t.className)
    }
  );
}), UL = M(
  function(t, n) {
    const { status: r } = gr(), o = zr();
    return /* @__PURE__ */ h.jsx(
      E.p,
      {
        ref: n,
        "data-status": r,
        ...t,
        className: W("chakra-step__description", t.className),
        __css: o.description
      }
    );
  }
);
function n5(e) {
  return /* @__PURE__ */ h.jsx(
    "svg",
    {
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0",
      viewBox: "0 0 20 20",
      "aria-hidden": "true",
      height: "1em",
      width: "1em",
      ...e,
      children: /* @__PURE__ */ h.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function r5(e) {
  const { status: t } = gr(), n = zr(), r = t === "complete" ? n5 : void 0;
  return /* @__PURE__ */ h.jsx(
    $t,
    {
      as: r,
      __css: n.icon,
      ...e,
      className: W("chakra-step__icon", e.className)
    }
  );
}
const uh = M(
  function(t, n) {
    const { children: r, ...o } = t, { status: s, index: i } = gr(), a = zr();
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ref: n,
        "data-status": s,
        __css: a.number,
        ...o,
        className: W("chakra-step__number", t.className),
        children: r || i + 1
      }
    );
  }
);
function o5(e) {
  const { complete: t, incomplete: n, active: r } = e, o = gr();
  let s = null;
  switch (o.status) {
    case "complete":
      s = Et(t, o);
      break;
    case "incomplete":
      s = Et(n, o);
      break;
    case "active":
      s = Et(r, o);
      break;
  }
  return s ? /* @__PURE__ */ h.jsx(h.Fragment, { children: s }) : null;
}
const GL = M(
  function(t, n) {
    const { status: r } = gr(), o = zr();
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ref: n,
        "data-status": r,
        ...t,
        __css: o.indicator,
        className: W("chakra-step__indicator", t.className)
      }
    );
  }
);
function qL() {
  return /* @__PURE__ */ h.jsx(
    o5,
    {
      complete: /* @__PURE__ */ h.jsx(r5, {}),
      incomplete: /* @__PURE__ */ h.jsx(uh, {}),
      active: /* @__PURE__ */ h.jsx(uh, {})
    }
  );
}
const KL = M(
  function(t, n) {
    const { orientation: r, status: o, isLast: s, showLastSeparator: i } = gr(), a = zr();
    return s && !i ? null : /* @__PURE__ */ h.jsx(
      E.div,
      {
        ref: n,
        role: "separator",
        "data-orientation": r,
        "data-status": o,
        __css: a.separator,
        ...t,
        className: W("chakra-step__separator", t.className)
      }
    );
  }
), YL = M(function(t, n) {
  const { status: r } = gr(), o = zr();
  return /* @__PURE__ */ h.jsx(
    E.h3,
    {
      ref: n,
      "data-status": r,
      ...t,
      __css: o.title,
      className: W("chakra-step__title", t.className)
    }
  );
}), XL = M(function(t, n) {
  const r = Je("Stepper", t), {
    children: o,
    index: s,
    orientation: i = "horizontal",
    showLastSeparator: a = !1,
    ...c
  } = Ae(t), l = $n.toArray(o), u = l.length;
  function d(f) {
    return f < s ? "complete" : f > s ? "incomplete" : "active";
  }
  return /* @__PURE__ */ h.jsx(
    E.div,
    {
      ref: n,
      "aria-label": "Progress",
      "data-orientation": i,
      ...c,
      __css: r.stepper,
      className: W("chakra-stepper", t.className),
      children: /* @__PURE__ */ h.jsx(t5, { value: r, children: l.map((f, p) => /* @__PURE__ */ h.jsx(
        e5,
        {
          value: {
            index: p,
            status: d(p),
            orientation: i,
            showLastSeparator: a,
            count: u,
            isFirst: p === 0,
            isLast: p === u - 1
          },
          children: f
        },
        p
      )) })
    }
  );
});
function ZL(e = {}) {
  const { index: t = 0, count: n } = e, [r, o] = he(t), s = typeof n == "number" ? n - 1 : 0, i = r / s;
  return {
    activeStep: r,
    setActiveStep: o,
    activeStepPercent: Number.isNaN(i) ? 0 : i,
    isActiveStep(a) {
      return a === r;
    },
    isCompleteStep(a) {
      return a < r;
    },
    isIncompleteStep(a) {
      return a > r;
    },
    getStatus(a) {
      return a < r ? "complete" : a > r ? "incomplete" : "active";
    },
    goToNext() {
      o((a) => typeof n == "number" ? Math.min(n, a + 1) : a + 1);
    },
    goToPrevious() {
      o((a) => Math.max(0, a - 1));
    }
  };
}
const s5 = M(
  function(t, n) {
    const r = Je("Switch", t), {
      spacing: o = "0.5rem",
      children: s,
      ...i
    } = Ae(t), {
      getIndicatorProps: a,
      getInputProps: c,
      getCheckboxProps: l,
      getRootProps: u,
      getLabelProps: d
    } = Iy(i), f = _e(
      () => ({
        display: "inline-block",
        position: "relative",
        verticalAlign: "middle",
        lineHeight: 0,
        ...r.container
      }),
      [r.container]
    ), p = _e(
      () => ({
        display: "inline-flex",
        flexShrink: 0,
        justifyContent: "flex-start",
        boxSizing: "content-box",
        cursor: "pointer",
        ...r.track
      }),
      [r.track]
    ), m = _e(
      () => ({
        userSelect: "none",
        marginStart: o,
        ...r.label
      }),
      [o, r.label]
    );
    return /* @__PURE__ */ h.jsxs(
      E.label,
      {
        ...u(),
        className: W("chakra-switch", t.className),
        __css: f,
        children: [
          /* @__PURE__ */ h.jsx("input", { className: "chakra-switch__input", ...c({}, n) }),
          /* @__PURE__ */ h.jsx(
            E.span,
            {
              ...l(),
              className: "chakra-switch__track",
              __css: p,
              children: /* @__PURE__ */ h.jsx(
                E.span,
                {
                  __css: r.thumb,
                  className: "chakra-switch__thumb",
                  ...a()
                }
              )
            }
          ),
          s && /* @__PURE__ */ h.jsx(
            E.span,
            {
              className: "chakra-switch__label",
              ...d(),
              __css: m,
              children: s
            }
          )
        ]
      }
    );
  }
);
s5.displayName = "Switch";
const [i5, Wr] = Ee({
  name: "TableStylesContext",
  errorMessage: `useTableStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Table />" `
}), a5 = M((e, t) => {
  const n = Je("Table", e), { className: r, layout: o, ...s } = Ae(e);
  return /* @__PURE__ */ h.jsx(i5, { value: n, children: /* @__PURE__ */ h.jsx(
    E.table,
    {
      ref: t,
      __css: { tableLayout: o, ...n.table },
      className: W("chakra-table", r),
      ...s
    }
  ) });
});
a5.displayName = "Table";
const c5 = M(
  (e, t) => {
    const { placement: n = "bottom", ...r } = e, o = Wr();
    return /* @__PURE__ */ h.jsx(
      E.caption,
      {
        ...r,
        ref: t,
        __css: {
          ...o.caption,
          captionSide: n
        }
      }
    );
  }
);
c5.displayName = "TableCaption";
const JL = M(
  (e, t) => {
    const { overflow: n, overflowX: r, className: o, ...s } = e;
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ref: t,
        className: W("chakra-table__container", o),
        ...s,
        __css: {
          display: "block",
          whiteSpace: "nowrap",
          WebkitOverflowScrolling: "touch",
          overflowX: n ?? r ?? "auto",
          overflowY: "hidden",
          maxWidth: "100%"
        }
      }
    );
  }
), QL = M((e, t) => {
  const n = Wr();
  return /* @__PURE__ */ h.jsx(E.tbody, { ...e, ref: t, __css: n.tbody });
}), eV = M(
  ({ isNumeric: e, ...t }, n) => {
    const r = Wr();
    return /* @__PURE__ */ h.jsx(
      E.td,
      {
        ...t,
        ref: n,
        __css: r.td,
        "data-is-numeric": e
      }
    );
  }
), tV = M((e, t) => {
  const n = Wr();
  return /* @__PURE__ */ h.jsx(E.tfoot, { ...e, ref: t, __css: n.tfoot });
}), nV = M(
  ({ isNumeric: e, ...t }, n) => {
    const r = Wr();
    return /* @__PURE__ */ h.jsx(
      E.th,
      {
        ...t,
        ref: n,
        __css: r.th,
        "data-is-numeric": e
      }
    );
  }
), rV = M((e, t) => {
  const n = Wr();
  return /* @__PURE__ */ h.jsx(E.thead, { ...e, ref: t, __css: n.thead });
}), oV = M((e, t) => {
  const n = Wr();
  return /* @__PURE__ */ h.jsx(E.tr, { ...e, ref: t, __css: n.tr });
}), [
  l5,
  vv,
  u5,
  d5
] = wa();
function f5(e) {
  const {
    defaultIndex: t,
    onChange: n,
    index: r,
    isManual: o,
    isLazy: s,
    lazyBehavior: i = "unmount",
    orientation: a = "horizontal",
    direction: c = "ltr",
    ...l
  } = e, [u, d] = he(t ?? 0), [f, p] = dr({
    defaultValue: t ?? 0,
    value: r,
    onChange: n
  });
  xe(() => {
    r != null && d(r);
  }, [r]);
  const m = u5(), g = Rt();
  return {
    id: `tabs-${e.id ?? g}`,
    selectedIndex: f,
    focusedIndex: u,
    setSelectedIndex: p,
    setFocusedIndex: d,
    isManual: o,
    isLazy: s,
    lazyBehavior: i,
    orientation: a,
    descendants: m,
    direction: c,
    htmlProps: l
  };
}
const [p5, Gs] = Ee({
  name: "TabsContext",
  errorMessage: "useTabsContext: `context` is undefined. Seems you forgot to wrap all tabs components within <Tabs />"
});
function h5(e) {
  const { focusedIndex: t, orientation: n, direction: r } = Gs(), o = vv(), s = R(
    (i) => {
      const a = () => {
        var v;
        const b = o.nextEnabled(t);
        b && ((v = b.node) == null || v.focus());
      }, c = () => {
        var v;
        const b = o.prevEnabled(t);
        b && ((v = b.node) == null || v.focus());
      }, l = () => {
        var v;
        const b = o.firstEnabled();
        b && ((v = b.node) == null || v.focus());
      }, u = () => {
        var v;
        const b = o.lastEnabled();
        b && ((v = b.node) == null || v.focus());
      }, d = n === "horizontal", f = n === "vertical", p = i.key, m = r === "ltr" ? "ArrowLeft" : "ArrowRight", g = r === "ltr" ? "ArrowRight" : "ArrowLeft", S = {
        [m]: () => d && c(),
        [g]: () => d && a(),
        ArrowDown: () => f && a(),
        ArrowUp: () => f && c(),
        Home: l,
        End: u
      }[p];
      S && (i.preventDefault(), S(i));
    },
    [o, t, n, r]
  );
  return {
    ...e,
    role: "tablist",
    "aria-orientation": n,
    onKeyDown: re(e.onKeyDown, s)
  };
}
function m5(e) {
  const { isDisabled: t = !1, isFocusable: n = !1, ...r } = e, { setSelectedIndex: o, isManual: s, id: i, setFocusedIndex: a, selectedIndex: c } = Gs(), { index: l, register: u } = d5({
    disabled: t && !n
  }), d = l === c, f = () => {
    o(l);
  }, p = () => {
    a(l), !s && !(t && n) && o(l);
  }, m = Fb({
    ...r,
    ref: De(u, e.ref),
    isDisabled: t,
    isFocusable: n,
    onClick: re(e.onClick, f)
  }), g = "button";
  return {
    ...m,
    id: xv(i, l),
    role: "tab",
    tabIndex: d ? 0 : -1,
    type: g,
    "aria-selected": d,
    "aria-controls": Sv(i, l),
    onFocus: t ? void 0 : re(e.onFocus, p)
  };
}
const [g5, y5] = Ee({});
function b5(e) {
  const t = Gs(), { id: n, selectedIndex: r } = t, s = Yn(e.children).map(
    (i, a) => Hl(
      g5,
      {
        key: i.key ?? a,
        value: {
          isSelected: a === r,
          id: Sv(n, a),
          tabId: xv(n, a),
          selectedIndex: r
        }
      },
      i
    )
  );
  return { ...e, children: s };
}
function v5(e) {
  const { children: t, ...n } = e, { isLazy: r, lazyBehavior: o } = Gs(), { isSelected: s, id: i, tabId: a } = y5(), c = ae(!1);
  s && (c.current = !0);
  const l = ql({
    wasSelected: c.current,
    isSelected: s,
    enabled: r,
    mode: o
  });
  return {
    // Puts the tabpanel in the page `Tab` sequence.
    tabIndex: 0,
    ...n,
    children: l ? t : null,
    role: "tabpanel",
    "aria-labelledby": a,
    hidden: !s,
    id: i
  };
}
function x5() {
  const e = Gs(), t = vv(), { selectedIndex: n, orientation: r } = e, o = r === "horizontal", s = r === "vertical", [i, a] = he(() => {
    if (o)
      return { left: 0, width: 0 };
    if (s)
      return { top: 0, height: 0 };
  }), [c, l] = he(!1);
  return an(() => {
    if (n == null)
      return;
    const u = t.item(n);
    if (u == null)
      return;
    o && a({ left: u.node.offsetLeft, width: u.node.offsetWidth }), s && a({ top: u.node.offsetTop, height: u.node.offsetHeight });
    const d = requestAnimationFrame(() => {
      l(!0);
    });
    return () => {
      d && cancelAnimationFrame(d);
    };
  }, [n, o, s, t]), {
    position: "absolute",
    transitionProperty: "left, right, top, bottom, height, width",
    transitionDuration: c ? "200ms" : "0ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    ...i
  };
}
function xv(e, t) {
  return `${e}--tab-${t}`;
}
function Sv(e, t) {
  return `${e}--tabpanel-${t}`;
}
const [S5, qs] = Ee({
  name: "TabsStylesContext",
  errorMessage: `useTabsStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Tabs />" `
}), w5 = M(function(t, n) {
  const r = Je("Tabs", t), { children: o, className: s, ...i } = Ae(t), { htmlProps: a, descendants: c, ...l } = f5(i), u = _e(() => l, [l]), { isFitted: d, ...f } = a, p = {
    position: "relative",
    ...r.root
  };
  return /* @__PURE__ */ h.jsx(l5, { value: c, children: /* @__PURE__ */ h.jsx(p5, { value: u, children: /* @__PURE__ */ h.jsx(S5, { value: r, children: /* @__PURE__ */ h.jsx(
    E.div,
    {
      className: W("chakra-tabs", s),
      ref: n,
      ...f,
      __css: p,
      children: o
    }
  ) }) }) });
});
w5.displayName = "Tabs";
const k5 = M(function(t, n) {
  const r = qs(), o = m5({ ...t, ref: n }), s = {
    outline: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...r.tab
  };
  return /* @__PURE__ */ h.jsx(
    E.button,
    {
      ...o,
      className: W("chakra-tabs__tab", t.className),
      __css: s
    }
  );
});
k5.displayName = "Tab";
const P5 = M(
  function(t, n) {
    const r = x5(), o = {
      ...t.style,
      ...r
    }, s = qs();
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ref: n,
        ...t,
        className: W("chakra-tabs__tab-indicator", t.className),
        style: o,
        __css: s.indicator
      }
    );
  }
);
P5.displayName = "TabIndicator";
const C5 = M(
  function(t, n) {
    const r = h5({ ...t, ref: n }), o = qs(), s = {
      display: "flex",
      ...o.tablist
    };
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ...r,
        className: W("chakra-tabs__tablist", t.className),
        __css: s
      }
    );
  }
);
C5.displayName = "TabList";
const _5 = M(
  function(t, n) {
    const r = v5({ ...t, ref: n }), o = qs();
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        outline: "0",
        ...r,
        className: W("chakra-tabs__tab-panel", t.className),
        __css: o.tabpanel
      }
    );
  }
);
_5.displayName = "TabPanel";
const T5 = M(
  function(t, n) {
    const r = b5(t), o = qs();
    return /* @__PURE__ */ h.jsx(
      E.div,
      {
        ...r,
        width: "100%",
        ref: n,
        className: W("chakra-tabs__tab-panels", t.className),
        __css: o.tabpanels
      }
    );
  }
);
T5.displayName = "TabPanels";
const [E5, wv] = Ee({
  name: "TagStylesContext",
  errorMessage: `useTagStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Tag />" `
}), A5 = M((e, t) => {
  const n = Je("Tag", e), r = Ae(e), o = {
    display: "inline-flex",
    verticalAlign: "top",
    alignItems: "center",
    maxWidth: "100%",
    ...n.container
  };
  return /* @__PURE__ */ h.jsx(E5, { value: n, children: /* @__PURE__ */ h.jsx(E.span, { ref: t, ...r, __css: o }) });
});
A5.displayName = "Tag";
const I5 = M((e, t) => {
  const n = wv();
  return /* @__PURE__ */ h.jsx(E.span, { ref: t, noOfLines: 1, ...e, __css: n.label });
});
I5.displayName = "TagLabel";
const R5 = M((e, t) => /* @__PURE__ */ h.jsx($t, { ref: t, verticalAlign: "top", marginEnd: "0.5rem", ...e }));
R5.displayName = "TagLeftIcon";
const $5 = M((e, t) => /* @__PURE__ */ h.jsx($t, { ref: t, verticalAlign: "top", marginStart: "0.5rem", ...e }));
$5.displayName = "TagRightIcon";
const kv = (e) => /* @__PURE__ */ h.jsx($t, { verticalAlign: "inherit", viewBox: "0 0 512 512", ...e, children: /* @__PURE__ */ h.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
  }
) });
kv.displayName = "TagCloseIcon";
const N5 = M(
  (e, t) => {
    const { isDisabled: n, children: r, ...o } = e, i = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      outline: "0",
      ...wv().closeButton
    };
    return /* @__PURE__ */ h.jsx(
      E.button,
      {
        ref: t,
        "aria-label": "close",
        ...o,
        type: "button",
        disabled: n,
        __css: i,
        children: r || /* @__PURE__ */ h.jsx(kv, {})
      }
    );
  }
);
N5.displayName = "TagCloseButton";
const M5 = ["h", "minH", "height", "minHeight"], j5 = M((e, t) => {
  const n = Ct("Textarea", e), { className: r, rows: o, ...s } = Ae(e), i = Ou(s), a = o ? Rs(n, M5) : n;
  return /* @__PURE__ */ h.jsx(
    E.textarea,
    {
      ref: t,
      rows: o,
      ...i,
      className: W("chakra-textarea", r),
      __css: a
    }
  );
});
j5.displayName = "Textarea";
function D5(e, t) {
  const n = e ?? "bottom", o = {
    "top-start": { ltr: "top-left", rtl: "top-right" },
    "top-end": { ltr: "top-right", rtl: "top-left" },
    "bottom-start": { ltr: "bottom-left", rtl: "bottom-right" },
    "bottom-end": { ltr: "bottom-right", rtl: "bottom-left" }
  }[n];
  return (o == null ? void 0 : o[t]) ?? n;
}
function Pv(e, t) {
  const n = (o) => ({
    ...t,
    ...o,
    position: D5(
      (o == null ? void 0 : o.position) ?? (t == null ? void 0 : t.position),
      e
    )
  }), r = (o) => {
    const s = n(o), i = hy(s);
    return _n.notify(i, s);
  };
  return r.update = (o, s) => {
    _n.update(o, n(s));
  }, r.promise = (o, s) => {
    const i = r({
      ...s.loading,
      status: "loading",
      duration: null
    });
    o.then(
      (a) => r.update(i, {
        status: "success",
        duration: 5e3,
        ...Et(s.success, a)
      })
    ).catch(
      (a) => r.update(i, {
        status: "error",
        duration: 5e3,
        ...Et(s.error, a)
      })
    );
  }, r.closeAll = _n.closeAll, r.close = _n.close, r.isActive = _n.isActive, r;
}
const O5 = {
  duration: 5e3,
  variant: "solid"
}, Jr = {
  theme: ru,
  colorMode: "light",
  toggleColorMode: () => {
  },
  setColorMode: () => {
  },
  defaultOptions: O5,
  forced: !1
};
function sV({
  theme: e = Jr.theme,
  colorMode: t = Jr.colorMode,
  toggleColorMode: n = Jr.toggleColorMode,
  setColorMode: r = Jr.setColorMode,
  defaultOptions: o = Jr.defaultOptions,
  motionVariants: s,
  toastSpacing: i,
  component: a,
  forced: c
} = Jr) {
  const l = {
    colorMode: t,
    setColorMode: r,
    toggleColorMode: n,
    forced: c
  };
  return {
    ToastContainer: () => /* @__PURE__ */ h.jsx(Rm, { theme: e, children: /* @__PURE__ */ h.jsx(Ro.Provider, { value: l, children: /* @__PURE__ */ h.jsx(
      gy,
      {
        defaultOptions: o,
        motionVariants: s,
        toastSpacing: i,
        component: a
      }
    ) }) }),
    toast: Pv(e.direction, o)
  };
}
function iV(e) {
  const { theme: t } = iy(), n = u$();
  return _e(
    () => Pv(t.direction, {
      ...n,
      ...e
    }),
    [e, t.direction, n]
  );
}
const F5 = {
  exit: {
    scale: 0.85,
    opacity: 0,
    transition: {
      opacity: { duration: 0.15, easings: "easeInOut" },
      scale: { duration: 0.2, easings: "easeInOut" }
    }
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      opacity: { easings: "easeOut", duration: 0.2 },
      scale: { duration: 0.2, ease: [0.175, 0.885, 0.4, 1.1] }
    }
  }
}, Wl = (e) => {
  var t;
  return ((t = e.current) == null ? void 0 : t.ownerDocument) || document;
}, Li = (e) => {
  var t, n;
  return ((n = (t = e.current) == null ? void 0 : t.ownerDocument) == null ? void 0 : n.defaultView) || window;
};
function B5(e = {}) {
  const {
    openDelay: t = 0,
    closeDelay: n = 0,
    closeOnClick: r = !0,
    closeOnMouseDown: o,
    closeOnScroll: s,
    closeOnPointerDown: i = o,
    closeOnEsc: a = !0,
    onOpen: c,
    onClose: l,
    placement: u,
    id: d,
    isOpen: f,
    defaultIsOpen: p,
    arrowSize: m = 10,
    arrowShadowColor: g,
    arrowPadding: y,
    modifiers: S,
    isDisabled: b,
    gutter: v,
    offset: k,
    direction: w,
    ..._
  } = e, { isOpen: C, onOpen: I, onClose: $ } = Yl({
    isOpen: f,
    defaultIsOpen: p,
    onOpen: c,
    onClose: l
  }), { referenceRef: N, getPopperProps: z, getArrowInnerProps: Q, getArrowProps: U } = ld({
    enabled: C,
    placement: u,
    arrowPadding: y,
    modifiers: S,
    gutter: v,
    offset: k,
    direction: w
  }), q = Rt(), Z = `tooltip-${d ?? q}`, j = ae(null), K = ae(void 0), ne = R(() => {
    K.current && (clearTimeout(K.current), K.current = void 0);
  }, []), B = ae(void 0), O = R(() => {
    B.current && (clearTimeout(B.current), B.current = void 0);
  }, []), ee = R(() => {
    O(), $();
  }, [$, O]), D = L5(j, ee), V = R(() => {
    if (!b && !K.current) {
      C && D();
      const L = Li(j);
      K.current = L.setTimeout(I, t);
    }
  }, [D, b, C, I, t]), Y = R(() => {
    ne();
    const L = Li(j);
    B.current = L.setTimeout(ee, n);
  }, [n, ee, ne]), J = R(() => {
    C && r && Y();
  }, [r, Y, C]), se = R(() => {
    C && i && Y();
  }, [i, Y, C]), ue = R(
    (L) => {
      C && L.key === "Escape" && Y();
    },
    [C, Y]
  );
  _r(
    () => Wl(j),
    "keydown",
    a ? ue : void 0
  ), _r(
    () => {
      if (!s)
        return null;
      const L = j.current;
      if (!L)
        return null;
      const me = Vh(L);
      return me.localName === "body" ? Li(j) : me;
    },
    "scroll",
    () => {
      C && s && ee();
    },
    { passive: !0, capture: !0 }
  ), xe(() => {
    b && (ne(), C && $());
  }, [b, C, $, ne]), xe(() => () => {
    ne(), O();
  }, [ne, O]), _r(() => j.current, "pointerleave", Y);
  const G = R(
    (L = {}, me = null) => ({
      ...L,
      ref: De(j, me, N),
      onPointerEnter: re(L.onPointerEnter, ($e) => {
        $e.pointerType !== "touch" && V();
      }),
      onClick: re(L.onClick, J),
      onPointerDown: re(L.onPointerDown, se),
      onFocus: re(L.onFocus, V),
      onBlur: re(L.onBlur, Y),
      "aria-describedby": C ? Z : void 0
    }),
    [
      V,
      Y,
      se,
      C,
      Z,
      J,
      N
    ]
  ), H = R(
    (L = {}, me = null) => z(
      {
        ...L,
        style: {
          ...L.style,
          [bt.arrowSize.var]: m ? `${m}px` : void 0,
          [bt.arrowShadowColor.var]: g
        }
      },
      me
    ),
    [z, m, g]
  ), de = R(
    (L = {}, me = null) => {
      const oe = {
        ...L.style,
        position: "relative",
        transformOrigin: bt.transformOrigin.varRef
      };
      return {
        ref: me,
        ..._,
        ...L,
        id: Z,
        role: "tooltip",
        style: oe
      };
    },
    [_, Z]
  );
  return {
    isOpen: C,
    show: V,
    hide: Y,
    getTriggerProps: G,
    getTooltipProps: de,
    getTooltipPositionerProps: H,
    getArrowProps: U,
    getArrowInnerProps: Q
  };
}
const Kc = "chakra-ui:close-tooltip";
function L5(e, t) {
  return xe(() => {
    const n = Wl(e);
    return n.addEventListener(Kc, t), () => n.removeEventListener(Kc, t);
  }, [t, e]), () => {
    const n = Wl(e), r = Li(e);
    n.dispatchEvent(new r.CustomEvent(Kc));
  };
}
const V5 = E(xn.div), z5 = M((e, t) => {
  const n = Ct("Tooltip", e), r = Ae(e), o = fn(), {
    children: s,
    label: i,
    shouldWrapChildren: a,
    "aria-label": c,
    hasArrow: l,
    bg: u,
    portalProps: d,
    background: f,
    backgroundColor: p,
    bgColor: m,
    motionProps: g,
    animatePresenceProps: y,
    ...S
  } = r, b = f ?? p ?? u ?? m;
  if (b) {
    n.bg = b;
    const N = SS(o, "colors", b);
    n[bt.arrowBg.var] = N;
  }
  const v = B5({ ...S, direction: o.direction }), k = !ur(s) || a;
  let w;
  if (k)
    w = /* @__PURE__ */ h.jsx(
      E.span,
      {
        display: "inline-block",
        tabIndex: 0,
        ...v.getTriggerProps(),
        children: s
      }
    );
  else {
    const N = $n.only(s);
    w = kt(
      N,
      v.getTriggerProps(N.props, fd(N))
    );
  }
  const _ = !!c, C = v.getTooltipProps({}, t), I = _ ? Rs(C, ["role", "id"]) : C, $ = Bh(C, ["role", "id"]);
  return i ? /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    w,
    /* @__PURE__ */ h.jsx(pr, { ...y, children: v.isOpen && /* @__PURE__ */ h.jsx($o, { ...d, children: /* @__PURE__ */ h.jsx(
      E.div,
      {
        ...v.getTooltipPositionerProps(),
        __css: {
          zIndex: n.zIndex,
          pointerEvents: "none"
        },
        children: /* @__PURE__ */ h.jsxs(
          V5,
          {
            variants: F5,
            initial: "exit",
            animate: "enter",
            exit: "exit",
            ...g,
            ...I,
            __css: n,
            children: [
              i,
              _ && /* @__PURE__ */ h.jsx(E.span, { srOnly: !0, ...$, children: c }),
              l && /* @__PURE__ */ h.jsx(
                E.div,
                {
                  "data-popper-arrow": !0,
                  className: "chakra-tooltip__arrow-wrapper",
                  children: /* @__PURE__ */ h.jsx(
                    E.div,
                    {
                      "data-popper-arrow-inner": !0,
                      className: "chakra-tooltip__arrow",
                      __css: { bg: n.bg }
                    }
                  )
                }
              )
            ]
          }
        )
      }
    ) }) })
  ] }) : /* @__PURE__ */ h.jsx(h.Fragment, { children: s });
});
z5.displayName = "Tooltip";
const W5 = M(
  function(t, n) {
    const r = Ct("Heading", t), { className: o, ...s } = Ae(t);
    return /* @__PURE__ */ h.jsx(
      E.h2,
      {
        ref: n,
        className: W("chakra-heading", t.className),
        ...s,
        __css: r
      }
    );
  }
);
W5.displayName = "Heading";
const H5 = M(function(t, n) {
  const r = Ct("Text", t), { className: o, align: s, decoration: i, casing: a, ...c } = Ae(t), l = Io({
    textAlign: t.align,
    textDecoration: t.decoration,
    textTransform: t.casing
  });
  return /* @__PURE__ */ h.jsx(
    E.p,
    {
      ref: n,
      className: W("chakra-text", t.className),
      ...l,
      ...c,
      __css: r
    }
  );
});
H5.displayName = "Text";
const U5 = E("span", {
  baseStyle: Ca
});
U5.displayName = "VisuallyHidden";
const G5 = E("input", {
  baseStyle: Ca
});
G5.displayName = "VisuallyHiddenInput";
const q5 = M(function(t, n) {
  const {
    spacing: r = "0.5rem",
    spacingX: o,
    spacingY: s,
    children: i,
    justify: a,
    direction: c,
    align: l,
    className: u,
    shouldWrapChildren: d,
    ...f
  } = t, p = _e(
    () => d ? $n.map(i, (m, g) => /* @__PURE__ */ h.jsx(Cv, { children: m }, g)) : i,
    [i, d]
  );
  return /* @__PURE__ */ h.jsx(E.div, { ref: n, className: W("chakra-wrap", u), ...f, children: /* @__PURE__ */ h.jsx(
    E.ul,
    {
      className: "chakra-wrap__list",
      __css: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: a,
        alignItems: l,
        flexDirection: c,
        listStyleType: "none",
        gap: r,
        columnGap: o,
        rowGap: s,
        padding: "0"
      },
      children: p
    }
  ) });
});
q5.displayName = "Wrap";
const Cv = M(
  function(t, n) {
    const { className: r, ...o } = t;
    return /* @__PURE__ */ h.jsx(
      E.li,
      {
        ref: n,
        __css: { display: "flex", alignItems: "flex-start" },
        className: W("chakra-wrap__listitem", r),
        ...o
      }
    );
  }
);
Cv.displayName = "WrapItem";
export {
  PL as AbsoluteCenter,
  T$ as Accordion,
  E$ as AccordionButton,
  A$ as AccordionIcon,
  I$ as AccordionItem,
  N$ as AccordionPanel,
  S$ as AccordionProvider,
  uy as Alert,
  py as AlertDescription,
  LL as AlertDialog,
  UF as AlertDialogBody,
  GF as AlertDialogCloseButton,
  VL as AlertDialogContent,
  qF as AlertDialogFooter,
  KF as AlertDialogHeader,
  JF as AlertDialogOverlay,
  dy as AlertIcon,
  fy as AlertTitle,
  M$ as AspectRatio,
  F$ as Avatar,
  L$ as AvatarBadge,
  V$ as AvatarGroup,
  z$ as Badge,
  Nu as Box,
  U$ as Breadcrumb,
  G$ as BreadcrumbItem,
  _y as BreadcrumbLink,
  Cl as BreadcrumbSeparator,
  Ty as Button,
  J$ as ButtonGroup,
  _l as ButtonSpinner,
  nT as CSSPolyfill,
  rT as CSSReset,
  oT as CSSVars,
  xL as Card,
  SL as CardBody,
  wL as CardFooter,
  kL as CardHeader,
  tN as Center,
  gL as ChakraBaseProvider,
  yL as ChakraProvider,
  EN as Checkbox,
  IN as CheckboxGroup,
  aN as CheckboxIcon,
  W$ as Circle,
  X2 as CircularProgress,
  tB as CircularProgressLabel,
  Sa as CloseButton,
  RN as Code,
  by as Collapse,
  Ro as ColorModeContext,
  Em as ColorModeProvider,
  CL as ColorModeScript,
  jN as Container,
  DN as ControlBox,
  eT as DarkMode,
  ON as Divider,
  zL as Drawer,
  UF as DrawerBody,
  GF as DrawerCloseButton,
  s2 as DrawerContent,
  qF as DrawerFooter,
  KF as DrawerHeader,
  JF as DrawerOverlay,
  Cr as EASINGS,
  VN as Editable,
  zN as EditableInput,
  WN as EditablePreview,
  HN as EditableTextarea,
  Mm as EnvironmentProvider,
  XF as Fade,
  XN as Flex,
  yb as FocusLock,
  vN as FormControl,
  _j as FormErrorIcon,
  Cj as FormErrorMessage,
  xN as FormHelperText,
  Tj as FormLabel,
  Sy as GenericAvatarIcon,
  sT as GlobalStyle,
  vb as Grid,
  Ej as GridItem,
  HB as HStack,
  W5 as Heading,
  Zj as Hide,
  RL as Highlight,
  $t as Icon,
  Q$ as IconButton,
  Fj as Image,
  NL as Img,
  ML as Indicator,
  xb as Input,
  ed as InputAddon,
  Lj as InputGroup,
  wb as InputLeftAddon,
  Pb as InputLeftElement,
  kb as InputRightAddon,
  Cb as InputRightElement,
  Hj as Kbd,
  tT as LightMode,
  Uj as Link,
  DL as LinkBox,
  jL as LinkOverlay,
  td as List,
  Xj as ListIcon,
  Yj as ListItem,
  Nj as Mark,
  VO as Menu,
  WO as MenuButton,
  Vb as MenuCommand,
  _O as MenuDescendantsProvider,
  HO as MenuDivider,
  zb as MenuGroup,
  oa as MenuIcon,
  UO as MenuItem,
  Hb as MenuItemOption,
  KO as MenuList,
  YO as MenuOptionGroup,
  IO as MenuProvider,
  ud as Modal,
  UF as ModalBody,
  GF as ModalCloseButton,
  nv as ModalContent,
  cF as ModalContextProvider,
  Qb as ModalFocusScope,
  qF as ModalFooter,
  KF as ModalHeader,
  JF as ModalOverlay,
  v2 as NumberDecrementStepper,
  x2 as NumberIncrementStepper,
  g2 as NumberInput,
  b2 as NumberInputField,
  y2 as NumberInputStepper,
  qj as OrderedList,
  E2 as PinInput,
  S2 as PinInputDescendantsProvider,
  A2 as PinInputField,
  P2 as PinInputProvider,
  N2 as Popover,
  M2 as PopoverAnchor,
  j2 as PopoverArrow,
  D2 as PopoverBody,
  O2 as PopoverCloseButton,
  V2 as PopoverContent,
  z2 as PopoverFooter,
  W2 as PopoverHeader,
  H2 as PopoverTrigger,
  $o as Portal,
  Nm as PortalManager,
  Q2 as Progress,
  eB as ProgressLabel,
  cB as Radio,
  sB as RadioGroup,
  TB as RangeSlider,
  IB as RangeSliderFilledTrack,
  RB as RangeSliderMark,
  CB as RangeSliderProvider,
  EB as RangeSliderThumb,
  AB as RangeSliderTrack,
  bb as RequiredIndicator,
  VF as ScaleFade,
  lB as Select,
  dv as SelectField,
  Jj as Show,
  Aj as SimpleGrid,
  pd as Skeleton,
  bB as SkeletonCircle,
  yB as SkeletonText,
  SB as SkipNavContent,
  xB as SkipNavLink,
  ov as Slide,
  BF as SlideFade,
  OB as Slider,
  LB as SliderFilledTrack,
  VB as SliderMark,
  jB as SliderProvider,
  FB as SliderThumb,
  BB as SliderTrack,
  zB as Spacer,
  Eu as Spinner,
  Cy as Square,
  hd as Stack,
  UB as StackDivider,
  KB as Stat,
  YB as StatArrow,
  yv as StatDownArrow,
  XB as StatGroup,
  ZB as StatHelpText,
  JB as StatLabel,
  QB as StatNumber,
  bv as StatUpArrow,
  HL as Step,
  UL as StepDescription,
  r5 as StepIcon,
  GL as StepIndicator,
  qL as StepIndicatorContent,
  uh as StepNumber,
  KL as StepSeparator,
  o5 as StepStatus,
  YL as StepTitle,
  XL as Stepper,
  pL as StylesProvider,
  s5 as Switch,
  k5 as Tab,
  P5 as TabIndicator,
  C5 as TabList,
  _5 as TabPanel,
  T5 as TabPanels,
  a5 as Table,
  c5 as TableCaption,
  JL as TableContainer,
  w5 as Tabs,
  l5 as TabsDescendantsProvider,
  p5 as TabsProvider,
  A5 as Tag,
  N5 as TagCloseButton,
  I5 as TagLabel,
  R5 as TagLeftIcon,
  $5 as TagRightIcon,
  QL as Tbody,
  eV as Td,
  H5 as Text,
  j5 as Textarea,
  tV as Tfoot,
  nV as Th,
  rV as Thead,
  Rm as ThemeProvider,
  e$ as Toast,
  l$ as ToastOptionProvider,
  gy as ToastProvider,
  z5 as Tooltip,
  oV as Tr,
  Kj as UnorderedList,
  GB as VStack,
  U5 as VisuallyHidden,
  G5 as VisuallyHiddenInput,
  q5 as Wrap,
  Cv as WrapItem,
  VS as accordionAnatomy,
  IS as addPrefix,
  zS as alertAnatomy,
  qe as anatomy,
  WS as avatarAnatomy,
  Pi as background,
  _m as baseTheme,
  Ue as border,
  HS as breadcrumbAnatomy,
  iL as buttonAnatomy,
  Fn as calc,
  dw as cardAnatomy,
  E as chakra,
  US as checkboxAnatomy,
  aL as circularProgressAnatomy,
  Yx as color,
  dL as cookieStorageManager,
  fL as cookieStorageManagerSSR,
  Tm as createCookieStorageManager,
  wa as createDescendantContext,
  Ry as createExtendTheme,
  $L as createIcon,
  Z_ as createLocalStorageManager,
  ot as createMultiStyleConfigHelpers,
  hy as createRenderToast,
  sV as createStandaloneToast,
  $m as createStylesContext,
  Pv as createToastFn,
  im as css,
  Se as cssVar,
  NS as defineCssVars,
  oL as defineStyle,
  sL as defineStyleConfig,
  GS as drawerAnatomy,
  qS as editableAnatomy,
  ol as effect,
  AL as extendBaseTheme,
  EL as extendTheme,
  rv as fadeConfig,
  Xx as filter,
  FS as flattenTokens,
  Hi as flexbox,
  KS as formAnatomy,
  YS as formErrorAnatomy,
  M as forwardRef,
  SS as getCSSVar,
  xS as getCss,
  MN as getScriptSrc,
  Pl as getSlideTransition,
  D5 as getToastPlacement,
  ay as getToken,
  om as grid,
  XS as inputAnatomy,
  Jx as interactivity,
  q_ as isChakraTheme,
  hS as isStyleProp,
  rn as layout,
  sm as layoutPropNames,
  lS as list,
  ZS as listAnatomy,
  J_ as localStorageManager,
  JS as menuAnatomy,
  De as mergeRefs,
  Ws as mergeThemeOverride,
  QS as modalAnatomy,
  ew as numberInputAnatomy,
  Ae as omitThemingProps,
  oS as others,
  cL as pinInputAnatomy,
  tw as popoverAnatomy,
  bt as popperCSSVars,
  os as position,
  nw as progressAnatomy,
  fS as propNames,
  nm as pseudoPropNames,
  fo as pseudoSelectors,
  rw as radioAnatomy,
  G_ as requiredChakraThemeKeys,
  CS as resolveStyleConfig,
  Zx as ring,
  ev as scaleFadeConfig,
  sS as scroll,
  ow as selectAnatomy,
  RR as shouldForwardProp,
  rs as slideFadeConfig,
  sw as sliderAnatomy,
  st as space,
  iw as statAnatomy,
  lL as stepperAnatomy,
  Ic as styled,
  aw as switchAnatomy,
  Zl as systemProps,
  cw as tableAnatomy,
  lw as tabsAnatomy,
  uw as tagAnatomy,
  aS as textDecoration,
  ru as theme,
  NR as toCSSObject,
  LS as toCSSVar,
  $S as toVarDefinition,
  RS as toVarReference,
  _n as toastStore,
  Mx as tokenToCSSVar,
  cS as transform,
  uS as transition,
  iS as typography,
  x$ as useAccordion,
  $u as useAccordionContext,
  w$ as useAccordionItem,
  vL as useAccordionItemState,
  ka as useAccordionStyles,
  Au as useAlertContext,
  Iu as useAlertStyles,
  Wh as useAnimationState,
  vy as useAvatarStyles,
  J5 as useBoolean,
  Mu as useBreadcrumbStyles,
  Qj as useBreakpoint,
  tD as useBreakpointValue,
  K$ as useButtonGroup,
  nt as useCallbackRef,
  ju as useCardStyles,
  iy as useChakra,
  Iy as useCheckbox,
  AN as useCheckboxGroup,
  Q5 as useClipboard,
  pa as useColorMode,
  FL as useColorModePreference,
  uL as useColorModeValue,
  eL as useConst,
  tL as useControllableProp,
  dr as useControllableState,
  X0 as useCounter,
  Yl as useDisclosure,
  e2 as useDrawerContext,
  LN as useEditable,
  zs as useEditableContext,
  _L as useEditableControls,
  TL as useEditableState,
  Bu as useEditableStyles,
  cT as useEnvironment,
  _r as useEventListener,
  Uh as useFocusOnHide,
  qh as useFocusOnPointerDown,
  Q0 as useFocusOnShow,
  Ou as useFormControl,
  Br as useFormControlContext,
  Fu as useFormControlProps,
  Ay as useFormControlStyles,
  Pj as useFormErrorStyles,
  Oj as useHighlight,
  ax as useId,
  cx as useIds,
  wy as useImage,
  Sb as useInputGroupStyles,
  lx as useInterval,
  Kh as useLatestRef,
  _b as useListStyles,
  Ta as useMediaQuery,
  $O as useMenu,
  NO as useMenuButton,
  No as useMenuContext,
  AO as useMenuDescendant,
  EO as useMenuDescendants,
  TO as useMenuDescendantsContext,
  Lb as useMenuItem,
  MO as useMenuList,
  DO as useMenuOption,
  OO as useMenuOptionGroup,
  jO as useMenuPositioner,
  BL as useMenuState,
  Lr as useMenuStyles,
  dx as useMergeRefs,
  oF as useModal,
  lr as useModalContext,
  Gb as useModalManager,
  Vr as useModalStyles,
  Je as useMultiStyleConfig,
  p2 as useNumberInput,
  Ia as useNumberInputStyles,
  nL as useOptionalPart,
  Yh as useOutsideClick,
  em as usePanEvent,
  _2 as usePinInput,
  C2 as usePinInputContext,
  T2 as usePinInputField,
  $2 as usePopover,
  mr as usePopoverContext,
  Mo as usePopoverStyles,
  ld as usePopper,
  aT as usePortalManager,
  OL as usePrefersReducedMotion,
  fx as usePrevious,
  lv as useProgressStyles,
  Tb as useQuery,
  iB as useRadio,
  rB as useRadioGroup,
  uv as useRadioGroupContext,
  kB as useRangeSlider,
  Ra as useRangeSliderContext,
  $a as useRangeSliderStyles,
  an as useSafeLayoutEffect,
  rL as useSize,
  gx as useSizes,
  $B as useSlider,
  Na as useSliderContext,
  Ma as useSliderStyles,
  ja as useStatStyles,
  gr as useStepContext,
  zr as useStepperStyles,
  ZL as useSteps,
  Ct as useStyleConfig,
  hL as useStyles,
  m5 as useTab,
  x5 as useTabIndicator,
  h5 as useTabList,
  v5 as useTabPanel,
  b5 as useTabPanels,
  Wr as useTableStyles,
  f5 as useTabs,
  Gs as useTabsContext,
  d5 as useTabsDescendant,
  u5 as useTabsDescendants,
  vv as useTabsDescendantsContext,
  qs as useTabsStyles,
  wv as useTagStyles,
  fn as useTheme,
  bx as useTimeout,
  iV as useToast,
  HR as useToken,
  B5 as useTooltip,
  bn as useUpdateEffect,
  Ca as visuallyHiddenStyle,
  GN as withDefaultColorScheme,
  IL as withDefaultProps,
  qN as withDefaultSize,
  KN as withDefaultVariant,
  yn as withDelay
};
//# sourceMappingURL=chakra.mjs.map
